
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cP0Yq", function(module, exports) {

$parcel$export(module.exports, "GlobalNav", function () { return (parcelRequire("6NDAm")).GlobalNav; });
$parcel$export(module.exports, "ProductPageSubNav", function () { return (parcelRequire("jPdYj")).ProductPageSubNav; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("6NDAm")).GlobalNav; });

var $6NDAm = parcelRequire("6NDAm");

var $jPdYj = parcelRequire("jPdYj");

var $lu2Dx = parcelRequire("lu2Dx");

});
parcelRegister("6NDAm", function(module, exports) {

$parcel$export(module.exports, "GlobalNav", function () { return $8c3b33c19815b7ec$export$963222cd47bfd015; });
/* nav-global.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("iAJua");
var $gaRIU = parcelRequire("gaRIU");

var $4wGZc = parcelRequire("4wGZc");

var $6KyF0 = parcelRequire("6KyF0");

var $4iLDn = parcelRequire("4iLDn");

var $lu2Dx = parcelRequire("lu2Dx");

var $hbBKK = parcelRequire("hbBKK");

var $83L5e = parcelRequire("83L5e");

var $5vh4Q = parcelRequire("5vh4Q");

var $dAXtI = parcelRequire("dAXtI");

var $4sElO = parcelRequire("4sElO");

var $9xKd9 = parcelRequire("9xKd9");

var $c5tR8 = parcelRequire("c5tR8");

var $eOKmG = parcelRequire("eOKmG");
const $8c3b33c19815b7ec$export$d6a07a1754b0e052 = "68px";
const $8c3b33c19815b7ec$var$navigationBarWrapperCss = null;
const $8c3b33c19815b7ec$var$navigationBarLogoCss = null;
const $8c3b33c19815b7ec$var$navigationBarLogoLink = null;
const $8c3b33c19815b7ec$var$mobileNavCss = null;
const $8c3b33c19815b7ec$var$isStickyNavCss = null;
const $8c3b33c19815b7ec$export$b9a265e5df299ef2 = ({ productKey: productKey, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, globalLinksProps: globalLinksProps, tryNowLinkCtaUrl: tryNowLinkCtaUrl })=>{
    const intl = (0, $f6qj2.default)();
    const [isOpenSearch, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const globalLinksRef = (0, $iSvIT.useRef)(null);
    const searchAndProfileRef = (0, $iSvIT.useRef)(null);
    const hasMounted = (0, $iSvIT.useRef)(false);
    const { showMoreItems: setShowMore, shouldShowMoreItems: showMore, maxItems: maxLinks } = (0, $6KyF0.useMore)({
        leftElementRef: globalLinksRef,
        rightElementRef: searchAndProfileRef,
        initialMaxItems: globalLinksProps.length
    });
    const wacAISearchSummaryExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).wacAISearchSummary);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    (0, $iSvIT.useEffect)(()=>{
        if (hasMounted.current) {
            const searchButton = document.getElementById("global-nav-search-bar-icon-desktop");
            if (searchButton) searchButton.focus();
        } else hasMounted.current = true;
    }, [
        isOpenSearch
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o _1pbyqfx8 _4t3i88uy _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0cglyw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _2lx2vrvc _1pbyouyt _195g1tcg _dm251txw _10jxtfvk _owpuidpf _xtn71wqb"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _1q511b66 _glte1wug"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9xKd9.SkipToContent), {}),
                                /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    "data-testid": "navigation-bar-logo-link",
                                    href: (0, $3FBn4.useLocalizedHref)("/"),
                                    "aria-label": intl.formatMessage({
                                        id: "wacGlobalNavigation.logo-label",
                                        defaultMessage: "Atlassian logo"
                                    }),
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "globalNavWac",
                                    "data-product-key": productKey,
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                                        brand: "atlassian",
                                        type: "logo",
                                        appearance: "brand",
                                        width: "187px"
                                    })
                                })
                            ]
                        }),
                        isOpenSearch ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4sElO.default), {
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            parentType: "GlobalNav",
                            aiEnabled: isAISearchSummaryEnabled
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.default), {
                            globalLinksProps: globalLinksProps,
                            globalLinksRef: globalLinksRef,
                            maxLinks: maxLinks,
                            showMore: showMore,
                            setShowMore: setShowMore
                        })
                    ]
                }),
                !isOpenSearch && isShowSearchBarAndProfileContainer && !showMore && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                    experimentKey: "wac-globalui-team24-globalnav-cta",
                    group: "test",
                    conditions: [
                        !isShowTryNowLink
                    ],
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $83L5e.default), {
                        isShowTryNowLink: isShowTryNowLink,
                        ctaButtonColor: tryNowLinkCtaButtonColor,
                        productKey: productKey,
                        isShowSearchButton: isShowSearchButton,
                        setIsOpenSearch: setIsOpenSearch,
                        searchAndProfileRef: searchAndProfileRef,
                        navigationTrynowCtaUrl: tryNowLinkCtaUrl,
                        aiEnabled: isAISearchSummaryEnabled
                    })
                })
            ]
        })
    });
};
const $8c3b33c19815b7ec$export$963222cd47bfd015 = ({ productKey: productKey = "home", isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, isNavSticky: isNavSticky = true, tryNowLinkCtaUrl: tryNowLinkCtaUrl, compoundNav: compoundNav })=>{
    const intl = (0, $f6qj2.default)();
    const enterpriseHref = (0, $3FBn4.useLocalizedHref)("/enterprise");
    const globalLinksProps = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "products",
                linkText: intl.formatMessage({
                    id: "globalNavigation.Navlink.products",
                    defaultMessage: "Products"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductSubnav), {
                    productKey: productKey
                }),
                layout: (0, $hbBKK.SubnavLayout).Product
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "globalNavigation.Navlink.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c5tR8.SolutionsSubnav), {
                    productKey: productKey
                }),
                layout: (0, $hbBKK.SubnavLayout).Solutions
            },
            {
                globalLinksKey: "why-atlassian",
                linkText: intl.formatMessage({
                    id: "globalNavigation.Navlink.whyAtlassian",
                    defaultMessage: "Why Atlassian?"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eOKmG.WhyAtlassianSubnav), {
                    productKey: productKey
                }),
                layout: (0, $hbBKK.SubnavLayout).WhyAtlassian
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "globalNavigation.Navlink.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dAXtI.ResourcesSubnav), {
                    productKey: productKey
                }),
                layout: (0, $hbBKK.SubnavLayout).Resources
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "globalNavigation.Navlink.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                href: enterpriseHref
            }
        ], // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        enterpriseHref,
        intl
    ]);
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return globalLinksProps.map((globalLink)=>globalLink.globalLinksKey);
    }, [
        globalLinksProps
    ]);
    const navProductRecosResponse = (0, $gaRIU.useGlobalNavProductRecommendations)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "global-nav-v2",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1pbyqfx8 _bfhkcd5j",
                isNavSticky && "_kqsw1if8 _152tidpf"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wGZc.NavProductRecommendationsContext).Provider, {
                value: navProductRecosResponse,
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hbBKK.GlobalNavProvider), {
                    globalNavItemKeys: globalNavItemKeys,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($8c3b33c19815b7ec$export$b9a265e5df299ef2, {
                            productKey: productKey,
                            isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer,
                            isShowTryNowLink: isShowTryNowLink,
                            tryNowLinkCtaUrl: tryNowLinkCtaUrl,
                            isShowSearchButton: isShowSearchButton,
                            tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor,
                            globalLinksProps: globalLinksProps
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0cglyw _1mjb1ule"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4iLDn.MobileGlobalNav), {
                                productKey: productKey,
                                isShowSearchButton: isShowSearchButton
                            })
                        }),
                        compoundNav && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lu2Dx.CompoundSubNav), (0, $7Knp0._)({}, compoundNav))
                    ]
                })
            })
        })
    });
};
$8c3b33c19815b7ec$export$963222cd47bfd015.displayName = "GlobalNav";

});
parcelRegister("iAJua", function(module, exports) {
$parcel$export(module.exports, "GlobalNavProductRecommendations", function () { return (parcelRequire("kxbRO")).GlobalNavProductRecommendations; });
$parcel$export(module.exports, "useGlobalNavProductRecommendations", function () { return (parcelRequire("gaRIU")).useGlobalNavProductRecommendations; });
parcelRequire("kxbRO");
parcelRequire("gaRIU");

});
parcelRegister("kxbRO", function(module, exports) {

$parcel$export(module.exports, "GlobalNavProductRecommendations", function () { return $6e80a3dc75328a74$export$3317373a678672ee; });
/* global-nav-product-recommendations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $fxdfZ = parcelRequire("fxdfZ");

var $hDrV5 = parcelRequire("hDrV5");

var $4wGZc = parcelRequire("4wGZc");

var $aYz37 = parcelRequire("aYz37");

var $7520o = parcelRequire("7520o");

var $3rvyw = parcelRequire("3rvyw");
const $6e80a3dc75328a74$var$GlobalNavProductRecommendationsImplementation = ({ isMobile: isMobile })=>{
    const { recommendations: recommendations, isRecommendationLoading: isRecommendationLoading } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    const recommendedProductIds = recommendations.map((ccpId)=>(0, $hDrV5.ccpKeyToProductId)[ccpId]).filter(Boolean);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulputpp _1tkelti4",
            !isMobile && "_zulpxy5q _1q511jfw _85i51jfw _bozgxy5q _y4ti1jfw"
        ]),
        children: [
            isRecommendationLoading ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $3rvyw.SkeletonGrid), {
                numProducts: (0, $hDrV5.NUM_DISPLAY_RECOMMENDATIONS),
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7520o.ProductRecommendationsContainer), {
                recommendedProductIds: recommendedProductIds,
                isMobile: isMobile
            }),
            isRecommendationLoading ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $3rvyw.SkeletonGrid), {
                numProducts: 3,
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aYz37.NewProductsContainer), {
                excludedProducts: recommendedProductIds,
                isMobile: isMobile
            })
        ]
    });
};
const $6e80a3dc75328a74$export$3317373a678672ee = ({ isMobile: isMobile = false })=>{
    const { onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: null,
        onError: onGlobalNavProductRecommendationsFailed,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($6e80a3dc75328a74$var$GlobalNavProductRecommendationsImplementation, {
            isMobile: isMobile
        })
    });
};

});
parcelRegister("hDrV5", function(module, exports) {

$parcel$export(module.exports, "ccpKeyToProductId", function () { return $4ccb7c6e9c837b9b$export$cab6f2e2bea54493; });
$parcel$export(module.exports, "NUM_DISPLAY_RECOMMENDATIONS", function () { return $4ccb7c6e9c837b9b$export$48153fdb47027133; });
$parcel$export(module.exports, "NUM_DISPLAY_NEW_PRODUCTS", function () { return $4ccb7c6e9c837b9b$export$d5d57039edb427b6; });
const $4ccb7c6e9c837b9b$export$cab6f2e2bea54493 = {
    "d8a847a4-cde4-4c50-8ea1-dc3d4193214f": "jira",
    "6aab3f4e-cc71-474d-8d28-abef8b057808": "confluence",
    "de63a248-1f93-46ed-b6ea-ab8e38af1c88": "jsm",
    "a6f908c8-709c-45f4-9e2d-eca25b93b94a": "jpd"
};
const $4ccb7c6e9c837b9b$export$48153fdb47027133 = 2;
const $4ccb7c6e9c837b9b$export$d5d57039edb427b6 = 4;

});

parcelRegister("4wGZc", function(module, exports) {

$parcel$export(module.exports, "NavProductRecommendationsContext", function () { return $5d9a7e12fd29c775$export$f08ef568e4cd62e3; });

var $iSvIT = parcelRequire("iSvIT");
const $5d9a7e12fd29c775$var$noop = ()=>{
// do nothing
};
const $5d9a7e12fd29c775$export$f08ef568e4cd62e3 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    onGlobalNavProductRecommendationsFailed: $5d9a7e12fd29c775$var$noop,
    shouldShowGlobalNavProductRecommendations: false,
    recommendations: [],
    isRecommendationLoading: false,
    mobileNavPageLabelFeaturedProducts: "",
    fireGlobalNavProductRecoEventsWhenInView: $5d9a7e12fd29c775$var$noop
});

});

parcelRegister("aYz37", function(module, exports) {

$parcel$export(module.exports, "NewProductsContainer", function () { return $faa7e87a51c36a12$export$ad1d3bb1d128b2fe; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $hDrV5 = parcelRequire("hDrV5");

var $7ox2l = parcelRequire("7ox2l");
const $faa7e87a51c36a12$var$title = (0, $6x1qA.defineMessage)({
    id: "globalnav.v2.products.featured.new",
    defaultMessage: "New products"
});
const $faa7e87a51c36a12$export$ad1d3bb1d128b2fe = ({ excludedProducts: excludedProducts, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const products = (0, $iSvIT.useMemo)(()=>productsByTag[(0, $5vh4Q.ProductCategory).Featured].filter((product)=>product.treatment === (0, $5vh4Q.Treatment).New).filter(({ id: id })=>!excludedProducts.includes(id)).slice(0, (0, $hDrV5.NUM_DISPLAY_NEW_PRODUCTS)), [
        productsByTag,
        excludedProducts
    ]);
    if (products.length === 0) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7ox2l.ProductsGrid), {
        products: products,
        title: formatMessage($faa7e87a51c36a12$var$title),
        isMobile: isMobile,
        container: "NewProductsContainer"
    });
};

});
parcelRegister("5vh4Q", function(module, exports) {

$parcel$export(module.exports, "ProductCategory", function () { return $c5fcb4e5892b66ae$export$81fb35662c98d436; });
$parcel$export(module.exports, "Treatment", function () { return $c5fcb4e5892b66ae$export$abc76b16efda437; });
$parcel$export(module.exports, "categories", function () { return $c5fcb4e5892b66ae$export$2c76aca27257bcfa; });
$parcel$export(module.exports, "useProductData", function () { return $c5fcb4e5892b66ae$export$59dc636aee1f545e; });
$parcel$export(module.exports, "Pill", function () { return $c5fcb4e5892b66ae$export$d2cf3038149dd1b5; });
$parcel$export(module.exports, "ProductItem", function () { return $c5fcb4e5892b66ae$export$38dd9abaed3bfffb; });
$parcel$export(module.exports, "ProductGrid", function () { return $c5fcb4e5892b66ae$export$e17b9f4149d989a1; });
$parcel$export(module.exports, "ProductSubnav", function () { return $c5fcb4e5892b66ae$export$14e06e14f1d7e1b8; });
/* product-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $gAJUc = parcelRequire("gAJUc");

var $3XIdt = parcelRequire("3XIdt");

var $i11Zl = parcelRequire("i11Zl");
parcelRequire("iAJua");
var $kxbRO = parcelRequire("kxbRO");

var $4wGZc = parcelRequire("4wGZc");

var $1fsxe = parcelRequire("1fsxe");

var $hbBKK = parcelRequire("hbBKK");

var $aIrXm = parcelRequire("aIrXm");
var $c5fcb4e5892b66ae$export$81fb35662c98d436;
(function(ProductCategory) {
    ProductCategory[ProductCategory["Featured"] = 0] = "Featured";
    ProductCategory[ProductCategory["Developers"] = 1] = "Developers";
    ProductCategory[ProductCategory["ProductManagers"] = 2] = "ProductManagers";
    ProductCategory[ProductCategory["ITProfessionals"] = 3] = "ITProfessionals";
    ProductCategory[ProductCategory["BusinessTeams"] = 4] = "BusinessTeams";
    ProductCategory[ProductCategory["LeadershipTeams"] = 5] = "LeadershipTeams";
})($c5fcb4e5892b66ae$export$81fb35662c98d436 || ($c5fcb4e5892b66ae$export$81fb35662c98d436 = {}));
var $c5fcb4e5892b66ae$export$abc76b16efda437;
(function(Treatment) {
    Treatment[Treatment["New"] = 0] = "New";
    Treatment[Treatment["Pending"] = 1] = "Pending";
})($c5fcb4e5892b66ae$export$abc76b16efda437 || ($c5fcb4e5892b66ae$export$abc76b16efda437 = {}));
const $c5fcb4e5892b66ae$export$2c76aca27257bcfa = {
    [0]: {
        id: 0,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.everyone",
            defaultMessage: "Featured"
        })
    },
    [1]: {
        id: 1,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.developers",
            defaultMessage: "Developers"
        })
    },
    [2]: {
        id: 2,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.product-managers",
            defaultMessage: "Product Managers"
        })
    },
    [3]: {
        id: 3,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.it-professionals",
            defaultMessage: "IT professionals"
        })
    },
    [4]: {
        id: 4,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.business-teams",
            defaultMessage: "Business Teams"
        })
    },
    [5]: {
        id: 5,
        title: (0, $6x1qA.defineMessage)({
            id: "globalnav.v2.products.tabs.leadership-teams",
            defaultMessage: "Leadership Teams"
        })
    }
};
function $c5fcb4e5892b66ae$export$59dc636aee1f545e() {
    const { locale: locale } = (0, $f6qj2.default)();
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const loomUrl = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacProductsLoomURL) ? "/software/loom" : "//loom.com"; // we could move this to top of the module, but expecting this structure will
    // be derived from dynamic data at some point
    const products = (0, $iSvIT.useMemo)(()=>{
        return {
            jira: {
                id: "jira",
                name: "Jira",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.jira.description",
                    defaultMessage: "Flexible project management"
                }),
                href: "/software/jira",
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    1,
                    2,
                    4
                ] : [
                    0,
                    1,
                    2,
                    4,
                    5
                ],
                logo: "jira",
                order: {
                    [1]: 1,
                    [5]: 2,
                    [2]: 1
                }
            },
            confluence: {
                id: "confluence",
                name: "Confluence",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.confluence.description",
                    defaultMessage: "Knowledge, all in one place"
                }),
                href: "/software/confluence",
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    2,
                    4
                ] : [
                    0,
                    2,
                    4,
                    5
                ],
                logo: "confluence",
                order: {
                    [5]: 4,
                    [2]: 2
                }
            },
            jsm: {
                id: "jsm",
                name: "Jira Service Management",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.jsm.description",
                    defaultMessage: "Deliver service at high velocity"
                }),
                href: "/software/jira/service-management",
                tags: [
                    3,
                    4
                ],
                logo: "jiraservicemanagement",
                order: {
                    [4]: 5
                }
            },
            trello: {
                id: "trello",
                name: "Trello",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.trello.description",
                    defaultMessage: "Organized & visualized work"
                }),
                href: "//trello.com/home",
                tags: [
                    4
                ],
                logo: "trello"
            },
            rovo: {
                id: "rovo",
                name: "Rovo",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.rovo.description",
                    defaultMessage: "Transform teamwork with AI"
                }),
                href: `/software/rovo`,
                tags: [],
                logo: "rovo"
            },
            jpd: {
                id: "jpd",
                name: "Jira Product Discovery",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.jpd.description",
                    defaultMessage: "Capture & prioritize ideas"
                }),
                href: "/software/jira/product-discovery",
                tags: [
                    2
                ],
                logo: "jiraproductdiscovery",
                order: {
                    [2]: 3
                }
            },
            compass: {
                id: "compass",
                name: "Compass",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.compass.description",
                    defaultMessage: "Software catalog for teams"
                }),
                href: "/software/compass",
                tags: [
                    1
                ],
                logo: "compass",
                order: {
                    [1]: 2
                }
            },
            guard: {
                id: "guard",
                name: "Guard",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.guard.description",
                    defaultMessage: "Enhanced cloud security"
                }),
                href: "/software/guard",
                tags: [
                    3
                ],
                logo: "guard"
            },
            loom: {
                id: "loom",
                name: "Loom",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.loom.description",
                    defaultMessage: "Quick, async video updates"
                }),
                href: loomUrl,
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    4
                ] : [
                    0,
                    4,
                    5
                ],
                logo: "loom",
                order: {
                    [5]: 6
                }
            },
            bitbucket: {
                id: "bitbucket",
                name: "Bitbucket",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.bitbucket.description",
                    defaultMessage: "Source code and CI/CD"
                }),
                href: "/software/bitbucket",
                tags: [
                    1
                ],
                logo: "bitbucket",
                order: {
                    [1]: 4
                }
            },
            jiraalign: {
                id: "jiraalign",
                name: "Align",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.jiraalign.description",
                    defaultMessage: "Enterprise-wide work planning & value"
                }),
                href: "/software/jira/align",
                tags: [
                    5
                ],
                logo: "jiraalign",
                order: {
                    [5]: 3
                }
            },
            focus: {
                id: "focus",
                logo: "focus",
                href: "/software/focus",
                name: "Focus",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.focus.description",
                    defaultMessage: "Enterprise-scale strategic planning"
                }),
                tags: [
                    5
                ],
                order: {
                    [5]: 1
                }
            },
            talent: {
                id: "talent",
                logo: "talent",
                href: "/software/talent",
                name: "Talent",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.talent.description",
                    defaultMessage: "Knowledge workforce planning"
                }),
                tags: [
                    5
                ],
                order: gwp7850GlobalNavChangesForTeam25Eu ? {
                    [5]: 2
                } : {
                    [5]: 5
                }
            },
            dx: {
                id: "dx",
                logo: "dx",
                href: "/collections/software",
                name: "DX",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.dx.description",
                    defaultMessage: "Measure productivity and AI impact"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    1
                ] : [],
                treatment: 1,
                order: {
                    [1]: 5
                }
            },
            pipelines: {
                id: "pipelines",
                logo: "pipelines",
                href: "/software/bitbucket/features/pipelines",
                name: "Pipelines",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.pipelines.description",
                    defaultMessage: "Scalable CI/CD automation"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    1
                ] : [],
                order: {
                    [1]: 3
                }
            },
            rovodev: {
                id: "rovodev",
                logo: "rovodev",
                href: "/software/rovo-dev",
                name: "Rovo Dev",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.rovodev.description",
                    defaultMessage: "Agentic AI for developers"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    1
                ] : [],
                order: {
                    [1]: 6
                }
            },
            collectionteamwork: {
                id: "collectionteamwork",
                logo: "collectionteamwork",
                href: "/collections/teamwork",
                name: "Teamwork Collection",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.collectionteamwork.description",
                    defaultMessage: "Supercharge teamwork seamlessly"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    0,
                    2,
                    4
                ] : [],
                isCollection: true,
                associatedProducts: [
                    "Jira",
                    "Confluence",
                    "Loom"
                ],
                order: {
                    [2]: 5,
                    [4]: 7
                }
            },
            collectionstrategy: {
                id: "collectionstrategy",
                logo: "collectionstrategy",
                href: "/collections/strategy",
                name: "Strategy Collection",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.collectionstrategy.description",
                    defaultMessage: "Optimize strategy and outcomes confidently"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    0,
                    5
                ] : [],
                isCollection: true,
                associatedProducts: [
                    "Focus",
                    "Talent",
                    "Align"
                ],
                order: {
                    [5]: 5
                }
            },
            collectionservice: {
                id: "collectionservice",
                logo: "collectionservice",
                href: "/collections/service",
                name: "Service Collection",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.collectionservice.description",
                    defaultMessage: "Deliver service at high-velocity"
                }),
                tags: [
                    0
                ],
                isCollection: true,
                associatedProducts: [
                    "Jira Service Management",
                    "Customer Service Management",
                    "Assets"
                ],
                order: {}
            },
            collectionsoftware: {
                id: "collectionsoftware",
                logo: "collectionsoftware",
                href: "/collections/software",
                name: "Software Collection",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.collectionsoftware.description",
                    defaultMessage: "Ship high-quality software fast"
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    0,
                    1
                ] : [],
                isCollection: true,
                associatedProducts: [
                    "Rovo Dev",
                    "DX (pending acquisition)",
                    "Pipelines",
                    "Bitbucket",
                    "Compass"
                ],
                order: {
                    [1]: 7
                }
            },
            blankspace: {
                id: "blankspace",
                name: "",
                logo: "jira",
                href: "",
                description: (0, $6x1qA.defineMessage)({
                    id: "globalnav.v2.products.blankspace.description",
                    defaultMessage: ""
                }),
                tags: gwp7850GlobalNavChangesForTeam25Eu ? [
                    2,
                    4,
                    5
                ] : [],
                isBlankSpace: true,
                order: {
                    [2]: 4,
                    [4]: 6,
                    [5]: 4
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale
    ]);
    const productsByTag = (0, $iSvIT.useMemo)(()=>{
        const productsByTag = Object.values(products).reduce((acc, product)=>{
            product.tags.forEach((tag)=>{
                acc[tag] = acc[tag].concat(product);
            });
            return acc;
        }, {
            [0]: [],
            [1]: [],
            [2]: [],
            [3]: [],
            [4]: [],
            [5]: []
        });
        for(const key in productsByTag)productsByTag[key].sort((a, b)=>{
            const categoryKey = key;
            var _a_order_categoryKey;
            const aOrder = a.order && categoryKey in a.order ? (_a_order_categoryKey = a.order[categoryKey]) !== null && _a_order_categoryKey !== void 0 ? _a_order_categoryKey : 0 : 0;
            var _b_order_categoryKey;
            const bOrder = b.order && categoryKey in b.order ? (_b_order_categoryKey = b.order[categoryKey]) !== null && _b_order_categoryKey !== void 0 ? _b_order_categoryKey : 0 : 0;
            return aOrder - bOrder;
        });
        return productsByTag;
    }, [
        products
    ]);
    return {
        products: products,
        productsByTag: productsByTag
    };
}
const $c5fcb4e5892b66ae$export$f01a785a5ae81e49 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_k48p8ydi _syaz1yg0 _1wyboqnp"
        ]),
        style: {
            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
        },
        children: intl.formatMessage({
            id: "globalnav.treatment.pending",
            defaultMessage: "(Pending acquisition)"
        })
    });
};
const $c5fcb4e5892b66ae$export$d2cf3038149dd1b5 = ({ color: color = (0, $5ohHq.wacToken)("color.secondary.navy"), backgroundColor: backgroundColor = (0, $5ohHq.wacToken)("color.extended.blue200"), children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            color: color,
            backgroundColor: backgroundColor
        },
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _18zri2wt _1rjcyh40 _2rko1tcg"
        ]),
        children: children
    });
};
const $c5fcb4e5892b66ae$var$treatments = {
    [0]: /*#__PURE__*/ (0, $loA2J.jsx)($c5fcb4e5892b66ae$export$d2cf3038149dd1b5, {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_1wyb19bv _k48p1fw0 _1p1dangw"
            ]),
            children: "New"
        })
    }),
    [1]: /*#__PURE__*/ (0, $loA2J.jsx)($c5fcb4e5892b66ae$export$f01a785a5ae81e49, {})
};
const $c5fcb4e5892b66ae$var$productItemCss = null;
const $c5fcb4e5892b66ae$var$associatedProductsCss = null;
const $c5fcb4e5892b66ae$export$38dd9abaed3bfffb = ({ id: id, logo: logo, name: name, treatment: treatment, isCollection: isCollection, description: description, href: href, associatedProducts: associatedProducts, isBlankSpace: isBlankSpace })=>{
    const intl = (0, $f6qj2.default)();
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href);
    const formattedHref = (0, $3FBn4.isLocalizableHref)(href) ? localizedHref : href;
    if (isBlankSpace) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "blank-space",
        children: "\xa0"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _p12feo28 _1q511ejb _85i51ejb _1kav1ady _1tfx1ady _1csa1pz4 _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _q7gq1crf _1adi1nn1 _125x1yg0 _zcqx4jg8 _4e9q1wug _xkllidpf _1ljc1wug _1lwo1wug _1gk1bzd7 _q1y3oxwj _nmeukb7n _1onl1txw _1sxn1q9c _1y4yesu3 _179nidpf _118qidpf _1goeidpf _m45bidpf _fmax1hlo",
            isCollection ? "collection-container" : ""
        ]),
        style: {
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1h6o _1cspjk2v _vlad1rga _1r1p1ejb _i2ip1osq _owkrvwyg _16oj1bp4 _61gx1y6m _1qah1vex _15m28uld _5cs91cd0",
                isCollection ? "collection-link" : ""
            ]),
            href: formattedHref,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": name,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavSubnav",
            "data-product-key": id,
            style: {
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _12l2utpp _2rko1y44 _1wpz1q9y",
                        "logo-container"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                        brand: logo,
                        type: "mark",
                        appearance: "brand",
                        width: isCollection ? undefined : 32,
                        height: isCollection ? undefined : 32
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulp12x7",
                        "product-description-container"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "product-header",
                            children: [
                                !isCollection && /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_12l2i2wt"
                                    ]),
                                    children: name
                                }),
                                typeof treatment !== "undefined" ? $c5fcb4e5892b66ae$var$treatments[treatment] : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: intl.formatMessage(description)
                        }),
                        isCollection && associatedProducts && associatedProducts.length > 0 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1wyboqnp _vwz4nqt0 _ect4bzd7 _syaz1yg0 _1sazb3bt _w5s7nkob _19dh1o8l _5hf0idpf _1o48idpf _1xgi1ssb _qpoiidpf _dzmf14y2 _1buc1y44 _1vfv14y2 _oyket7zv"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                            },
                            children: associatedProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    children: product
                                }, product))
                        })
                    ]
                })
            ]
        })
    });
};
const $c5fcb4e5892b66ae$export$e17b9f4149d989a1 = ({ children: children, isRovoTitle: isRovoTitle })=>{
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _yv0ewxkt _gy1pxy5q _18zr1lqf _1q511jfw _85i51jfw _fsmz1ejb _1mib1ejb _8xgo1nty _tei6idpf _1mjb1txw _na0i1bp4",
                    gwp7850GlobalNavChangesForTeam25Eu ? "rovo-section-enabled" : ""
                ]),
                children: children
            }),
            isRovoTitle && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1p1dangw _1wyboqnp _18s8ergx _17p312pl"
                ]),
                children: intl.formatMessage({
                    id: "GlobalNav.RovoSection.PoweredBy",
                    defaultMessage: "Powered by"
                })
            }),
            gwp7850GlobalNavChangesForTeam25Eu && /*#__PURE__*/ (0, $loA2J.jsx)((0, $i11Zl.RovoSection), {})
        ]
    });
};
const $c5fcb4e5892b66ae$var$FeaturedTemplate = (props)=>{
    if (props.isCollections) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aIrXm.ProductFeaturedCollectionSubnav), {
        isMobile: false
    });
    else if (props.isRecs) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kxbRO.GlobalNavProductRecommendations), {});
    else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
};
const $c5fcb4e5892b66ae$export$14e06e14f1d7e1b8 = ({ productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = $c5fcb4e5892b66ae$export$59dc636aee1f545e();
    const { direction: direction } = (0, $hbBKK.useGlobalNavContext)();
    const { shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations, fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    const featuredProductIndex = (0, $iSvIT.useMemo)(()=>Object.values($c5fcb4e5892b66ae$export$2c76aca27257bcfa).findIndex((category)=>category.id === 0), []);
    const onTabInView = (0, $iSvIT.useCallback)((index)=>{
        if (featuredProductIndex === index) fireGlobalNavProductRecoEventsWhenInView({
            isMobile: false
        });
    }, [
        featuredProductIndex,
        fireGlobalNavProductRecoEventsWhenInView
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
            direction: direction,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1fsxe.SubnavWithSidebarTabs), {
                tabs: Object.values($c5fcb4e5892b66ae$export$2c76aca27257bcfa).map((category)=>{
                    return {
                        id: category.id.toString(),
                        title: intl.formatMessage(category.title),
                        content: category.id === 0 ? /*#__PURE__*/ (0, $loA2J.jsx)($c5fcb4e5892b66ae$var$FeaturedTemplate, {
                            isRecs: shouldShowGlobalNavProductRecommendations,
                            isCollections: true
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)($c5fcb4e5892b66ae$export$e17b9f4149d989a1, {
                            children: productsByTag[category.id].map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)($c5fcb4e5892b66ae$export$38dd9abaed3bfffb, (0, $7Knp0._)({}, product), product.id))
                        })
                    };
                }),
                onTabInView: onTabInView,
                links: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_nd5l1p4q _1e0c1txw _4cvr1h6o _4t3i1ris _bozg1jfw _y4tipxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_bozgpxbi _19tbdlk8"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            href: (0, $3FBn4.useLocalizedHref)("/software"),
                            text: intl.formatMessage({
                                id: "globalnav.v2.subnav.tabs.see-all-apps",
                                defaultMessage: "See all apps"
                            }),
                            ariaLabel: intl.formatMessage({
                                id: "globalnav.v2.subnav.tabs.see-all-apps-arialabel",
                                defaultMessage: "See all apps link"
                            }),
                            dataEventProps: {
                                "data-product-key": productKey,
                                "data-event-component": "linkButton",
                                "data-event-container": "navbarDropdown",
                                "data-label": "See all products",
                                "data-event": "clicked"
                            },
                            type: "primary"
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("i11Zl", function(module, exports) {

$parcel$export(module.exports, "RovoSection", function () { return $e5949b4138fc5362$export$58f6a9c112528b0e; });
/* rovo-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $e5949b4138fc5362$var$rovoSectionStyles = null;
const $e5949b4138fc5362$var$rovoTitleStyles = null;
const $e5949b4138fc5362$var$rovoDescriptionStyles = null;
const $e5949b4138fc5362$var$rovoLogoContainerStyles = null;
const $e5949b4138fc5362$export$58f6a9c112528b0e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $3FBn4.useLocalizedHref)("/software/rovo"),
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt41lhf _18s8ppv5 _2rkovwyg _19it1k0a _16qs1vex _v5648uld _1dbz1cd0 _15paidpf _qwozidpf _8fz6eo28 _6ssj2ex7"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulppxbi _2osn1crf _wkq4xy5q _rulpxy5q _19ekxy5q"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                        brand: "rovo",
                        type: "mark",
                        appearance: "brand",
                        width: 36,
                        height: 36
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_nk1ipxbi _10yykb7n _1548idpf _1fgpidpf _lg2qidpf _pnsridpf _1ywu1hlo",
                            "rovo-title"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: "Rovo"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_12qgidpf _sk0uidpf _18m0idpf _1h2iidpf _1tna1yg0 _15kooxwj _qhbnnqt0",
                            "rovo-description"
                        ]),
                        style: {
                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "GlobalNav.RovoSection.Title",
                            defaultMessage: "AI-powered apps \u2013 driven by your team's knowledge."
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("1fsxe", function(module, exports) {

$parcel$export(module.exports, "SubnavWithSidebarTabs", function () { return $8f3ca1e39070462d$export$1908a6b6f2723c34; });
/* subnav-with-sidebar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $8f3ca1e39070462d$var$useSafeLayoutEffect = typeof window !== "undefined" ? (0, $iSvIT.useLayoutEffect) : (0, $iSvIT.useEffect);
const $8f3ca1e39070462d$var$tabContainerStyles = null;
const $8f3ca1e39070462d$var$tablistWrapperStyle = null;
const $8f3ca1e39070462d$var$tablistStyles = null;
const $8f3ca1e39070462d$var$tabpanelStyles = null;
function $8f3ca1e39070462d$var$isValidTab(tabs, index) {
    return Array.isArray(tabs) && index > -1 && index < tabs.length;
}
function $8f3ca1e39070462d$var$noop() {
    return false;
}
function $8f3ca1e39070462d$var$useEventHandler({ previous: previous = $8f3ca1e39070462d$var$noop, next: next = $8f3ca1e39070462d$var$noop, select: select = $8f3ca1e39070462d$var$noop, deleteFocus: deleteFocus = $8f3ca1e39070462d$var$noop }) {
    const keyMap = {
        ArrowUp: (start)=>previous(start),
        ArrowDown: (start)=>next(start),
        Delete: (panel)=>deleteFocus(panel)
    };
    return {
        createOnClick: (index)=>(_evt)=>select(index),
        createOnKeyDown: (index)=>{
            return (evt)=>{
                const moveAction = keyMap[evt.key];
                if (!moveAction) return;
                const next = moveAction(index);
                if (next === false) return;
                evt.preventDefault();
                if (typeof next !== "undefined" && typeof next !== "boolean") select(next);
            };
        }
    };
}
const $8f3ca1e39070462d$var$tabStyle = null;
const $8f3ca1e39070462d$var$activeTabStyle = null;
const $8f3ca1e39070462d$var$Tab = ({ tab: tab, onClick: onClick, onKeyDown: onKeyDown, isActive: isActive, isFocused: isFocused })=>{
    const { id: id, title: title } = tab;
    const tabRef = (0, $iSvIT.useRef)(null);
    $8f3ca1e39070462d$var$useSafeLayoutEffect(()=>{
        if (isFocused && tabRef.current) tabRef.current.focus();
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: `tab-${id}`,
        ref: tabRef,
        role: "tab",
        onClick: onClick,
        onKeyDown: onKeyDown,
        "aria-selected": isActive,
        "aria-controls": `panel-${id}`,
        tabIndex: isActive ? 0 : -1,
        className: (0, $esG4f.default)([
            "_bfhk1kw7 _syaz1hlo _1e0c1txw _bozgpxbi _y4tixy5q _1q51utpp _85i5utpp _1wybdlk8 _k48p1fw0 _ojc9cd5j _80omtlke _2rkodjii _1bsbntd2",
            isActive && "_bfhkcd5j _syaz17la"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            children: title
        })
    });
}; // TODO we should refactor out the Tab primitive into WPL or use an
const $8f3ca1e39070462d$export$1908a6b6f2723c34 = ({ tabs: tabs, links: links, defaultTab: defaultTab = 0, onTabInView: onTabInView })=>{
    const intl = (0, $f6qj2.default)();
    const containerRef = (0, $iSvIT.useRef)(null);
    const [activeTabIndex, setActiveTabIndex] = (0, $iSvIT.useState)(()=>{
        if ($8f3ca1e39070462d$var$isValidTab(tabs, defaultTab)) return defaultTab;
        return 0;
    });
    const [focusTab, setFocusTab] = (0, $iSvIT.useState)();
    const selectFocusableTab = (tab)=>{
        let nextTab = 0;
        if (tab < tabs.length) nextTab = tab;
        else if (tab - 2 >= 0) nextTab = tab - 2;
        setActiveTabIndex(nextTab);
        setFocusTab(nextTab);
    };
    const { createOnClick: createOnClick, createOnKeyDown: createOnKeyDown } = $8f3ca1e39070462d$var$useEventHandler({
        previous: (start)=>{
            const nextIndex = start - 1;
            return $8f3ca1e39070462d$var$isValidTab(tabs, nextIndex) ? nextIndex : tabs.length - 1;
        },
        next: (start)=>{
            const nextIndex = start + 1;
            return $8f3ca1e39070462d$var$isValidTab(tabs, nextIndex) ? nextIndex : 0;
        },
        select: selectFocusableTab
    });
    const handleBackspace = (event)=>{
        if (event.key == "Backspace") {
            const nextTabIndex = activeTabIndex == tabs.length - 1 ? activeTabIndex - 1 : activeTabIndex + 1;
            setActiveTabIndex(nextTabIndex);
            setFocusTab(nextTabIndex);
        }
    }; // Observes the tab container to determine when a tab is in view
    (0, $iSvIT.useLayoutEffect)(()=>{
        // Check if IntersectionObserver is supported
        if (typeof IntersectionObserver === "undefined") return;
        if (!onTabInView) return;
        const currentContainer = containerRef.current;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) onTabInView(activeTabIndex);
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        });
        if (currentContainer) observer.observe(currentContainer);
        return ()=>{
            if (currentContainer) observer.unobserve(currentContainer);
        };
    }, [
        activeTabIndex,
        onTabInView,
        tabs
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1lmcyf54 _yv0e1ris _bfhk1rga _ect4kipj"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_nd5l1p4q _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1rga _1q511ylp _85i51ylp _4t3i1ris _1bsb194s _zulp1epz"
                ]),
                style: {
                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        role: "tablist",
                        "aria-label": intl.formatMessage({
                            id: "globalnav.v2.subnav.tabs.aria-label-tablist",
                            defaultMessage: "Products by user category"
                        }),
                        "aria-orientation": "vertical",
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _syaz1hlo _bozg1jfw"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: tabs.map((tab, index)=>{
                            const isActive = index === activeTabIndex;
                            const isFocused = index === focusTab;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($8f3ca1e39070462d$var$Tab, {
                                isActive: isActive,
                                isFocused: isFocused,
                                tab: tab,
                                onClick: createOnClick(index),
                                onKeyDown: createOnKeyDown(activeTabIndex)
                            }, `key-${tab.id}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        onKeyDown: handleBackspace,
                        children: links !== null && links !== void 0 ? links : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tabpanel",
                className: (0, $esG4f.default)([
                    "_nd5l15ve _bfhkcd5j _kqswh2mm"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: tabs.map((tab, index)=>{
                    return(// Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        style: {
                            position: activeTabIndex == index ? "static" : "absolute",
                            insetBlockStart: "0",
                            height: "100%",
                            visibility: activeTabIndex == index ? "visible" : "hidden"
                        },
                        onKeyDown: handleBackspace,
                        children: tab.content
                    }, index));
                })
            })
        ]
    });
};

});

parcelRegister("aIrXm", function(module, exports) {

$parcel$export(module.exports, "ProductFeaturedCollectionSubnav", function () { return $b7285cf91de537a1$export$ae84f9fa7b9a83d2; });
/* product-featured-collection-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("8Wj8Y");
var $6MYyL = parcelRequire("6MYyL");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");

var $jomHK = parcelRequire("jomHK");

var $cuuol = parcelRequire("cuuol");

var $5vh4Q = parcelRequire("5vh4Q");
const $b7285cf91de537a1$export$ae84f9fa7b9a83d2 = ({ isMobile: isMobile })=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const CollectionsContainerHeaderText = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "GlobalNav.collections.Title",
        defaultMessage: "Atlassian Collections <span>new</span>",
        values: (0, $3FBn4.DEFAULT_VALUES)
    });
    const CollectionsMobileLabel = intl.formatMessage({
        id: "GlobalNav.collections.cloudplatform.mobilelabel",
        defaultMessage: "Featured"
    });
    const CollectionsContaineTagline = intl.formatMessage({
        id: "GlobalNav.collections.tagline",
        defaultMessage: "A curated set of apps designed to solve your specific challenges"
    });
    const CloudPlatformHeading = intl.formatMessage({
        id: "GlobalNav.collections.cloudplatform.heading",
        defaultMessage: "Atlassian Cloud Platform"
    });
    const CloudPlatformTagline = intl.formatMessage({
        id: "GlobalNav.collections.cloudplatform.tagline",
        defaultMessage: "The connected foundation of your system of work"
    });
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    if (gwp7850GlobalNavChangesForTeam25Eu) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "collections-container-with-rovo",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5vh4Q.ProductGrid), {
            isRovoTitle: true,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    style: {
                        gridColumn: "span 2"
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cuuol.GlobalNavProductRecommendationsSimple), {
                            isMobile: isMobile
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_hbu3oqnp _1ldiidpf _skt2idpf _emr2idpf _r1lidpf _14waangw _jwbz1hlo _1aky1nn1 _1d1f1n44 _1rnfgktf",
                                "collections-four"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: intl.formatMessage({
                                id: "GlobalNav.collections.featured.atlassiancollections.title",
                                defaultMessage: "Atlassian Collections"
                            })
                        })
                    ]
                }),
                productsByTag[(0, $5vh4Q.ProductCategory).Featured].map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            ]
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "collections-container",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1yt41te9 _kqswh2mm _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _12rrp2n4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _ect41pz4 _1wyboqnp _1p1dangw _18s81hxf _1mjb1ule",
                        "mobile-label"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: CollectionsMobileLabel
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                    className: (0, $esG4f.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _so7d1cby _1b941o8l _z8gb17td _nzz5ud5o _kgm1jjoz _1kd3ni7l _13t3kb7n _v4pr1b66 _1tjq18q9 _1hbu6kkz _jr2uangw _e4kmnkob"
                    ]),
                    style: {
                        "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill")),
                        "--_nmjf06": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.navy")),
                        "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200"))
                    },
                    children: CollectionsContainerHeaderText
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_14aboxwj _1ey71km1",
                        "collections-tagline"
                    ]),
                    children: CollectionsContaineTagline
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _yv0ewxkt _zulp1ejb _1yt41km1 _1ph4hkll"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $jomHK.CollectionTeamwork), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $jomHK.CollectionStrategy), {})
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1dqonqa1 _189e1w78 _1yt4gx6n _1h6du4vp _19tboxwj _58krbzd7"
                    ]),
                    style: {
                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                            className: (0, $esG4f.default)([
                                "_nz0ckb7n _ngnbidpf _zap3idpf _1ie3idpf _1nv7idpf _so7d1j6v",
                                "cloud-platform"
                            ]),
                            children: CloudPlatformHeading
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1j7eoxwj _1fn51yg0 _194l1h4g",
                                "cloud-platform"
                            ]),
                            style: {
                                "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                            },
                            children: CloudPlatformTagline
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6MYyL.Link), {
                            href: "/platform",
                            text: intl.formatMessage({
                                id: "GlobalNav.collections.products.atlassiancloudplatform.cta",
                                defaultMessage: "Learn more"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1yt41hp3 _adexangw _ha0voqnp _16sdu2gc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cuuol.GlobalNavProductRecommendationsSimple), {
                        isMobile: isMobile
                    })
                })
            ]
        })
    });
};
const $b7285cf91de537a1$var$CollectionsContainerStyle = null;
const $b7285cf91de537a1$var$CollectionsMobileLabelCSS = null;
const $b7285cf91de537a1$var$CollectionH5 = null;
const $b7285cf91de537a1$var$CollectionsP = null;
const $b7285cf91de537a1$var$CollectionsTitle = null;
const $b7285cf91de537a1$var$CollectionsGrid = null;
const $b7285cf91de537a1$var$CloudPlatformSection = null;
const $b7285cf91de537a1$var$CloudPlatformH6 = null;
const $b7285cf91de537a1$var$CloudPlatformP = null;
const $b7285cf91de537a1$var$BottomProductsSection = null;

});
parcelRegister("8Wj8Y", function(module, exports) {
$parcel$export(module.exports, "Link", function () { return (parcelRequire("6MYyL")).Link; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("6MYyL")).Link; });

var $6MYyL = parcelRequire("6MYyL");

});
parcelRegister("6MYyL", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $07aa1b35a6a78168$export$a6c7ac8248d6e38a; });
/* link.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $3FBn4 = parcelRequire("3FBn4");
const $07aa1b35a6a78168$var$linkColors = {
    bgWhite: {
        default: "#1868DB",
        hover: "#0747A6",
        visited: "#403294"
    },
    bgLight: {
        default: "#172B4D",
        hover: "#0747A6",
        visited: "#403294"
    },
    bgDark: {
        default: "#FAFBFC",
        hover: "#4C9AFF",
        visited: "#C0B6F2"
    }
};
//Functions
const $07aa1b35a6a78168$var$Icon = (type)=>{
    if (type === "basic" || type === "basic-underline" || type === "inline-basic") return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_19pk14y2 _2hwxidpf _otyrt94y _18u014y2 _v564x7w3"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
    if (type === "external" || type === "external-icon") return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_19pk14y2 _2hwxidpf _otyryh40 _18u014y2"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.04815 0.5V1.98788H4.46059L0.217983 6.22935C-0.0726609 6.51998 -0.0726609 6.99114 0.217983 7.28178C0.363801 7.4266 0.553265 7.5 0.744713 7.5C0.935169 7.5 1.12463 7.4266 1.27045 7.28178L5.51206 3.04031V5.45168H7V0.5H2.04815Z"
        })
    });
    if (type === "video") return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_12l2ftgi"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.3561 7.10299L4.79449 4.21918V9.78082L10.3561 7.10299Z"
        })
    });
    return;
};
const $07aa1b35a6a78168$var$formatLinkText = (text, type)=>{
    const typeOfLink = type ? type : "basic";
    if (type === "video") return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: [
            $07aa1b35a6a78168$var$Icon(typeOfLink),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: text
            })
        ]
    });
    if (type === "external-icon") return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            children: [
                text,
                $07aa1b35a6a78168$var$Icon(typeOfLink)
            ]
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            children: [
                text,
                $07aa1b35a6a78168$var$Icon(typeOfLink)
            ]
        })
    });
};
const $07aa1b35a6a78168$var$isSignInUrl = (href)=>{
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + "/start/authredirect";
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    return href == signInUrl;
};
const $07aa1b35a6a78168$var$isHyperlinkRef = (href)=>{
    return href.startsWith("#");
};
const $07aa1b35a6a78168$var$isNonSigninOrWacUrl = (href)=>{
    return !(0, $3FBn4.isLocalizableHref)(href) && !$07aa1b35a6a78168$var$isSignInUrl(href) && !$07aa1b35a6a78168$var$isHyperlinkRef(href);
};
const $07aa1b35a6a78168$export$39aecc95f0365819 = (props)=>{
    const children = (0, $iSvIT.Children).toArray(props.children);
    if (props.type === "inline" || props.type === "inline-basic") return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: children.map((child)=>child)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "link-wrapper",
        children: children.map((child)=>child)
    });
}; /**
    * @deprecated - Please use @/libraries/design/components/link instead
    */ 
const $07aa1b35a6a78168$export$a6c7ac8248d6e38a = ({ text: text, href: href, type: type, customLinkColor: customLinkColor, bgColor: bgColor, onClick: onClick, className: className, doesArrowAnimate: doesArrowAnimate = false, ariaLabel: ariaLabel, dataEventProps: dataEventProps, isStyleOnly: isStyleOnly = false, anchorProps: anchorProps = {} })=>{
    const bg = bgColor ? bgColor : "bgWhite";
    let colorDefault = $07aa1b35a6a78168$var$linkColors[bg].default;
    let colorHover = $07aa1b35a6a78168$var$linkColors[bg].hover;
    let colorVisited = $07aa1b35a6a78168$var$linkColors[bg].visited;
    if (customLinkColor) colorDefault = colorHover = colorVisited = customLinkColor;
    const linkStyles = [
        customLinkColor && null,
        !customLinkColor && null,
        type === "basic-underline" && null,
        type === "modal" && null,
        (type === "inline" || type === "inline-basic") && null,
        type !== "modal" && type !== "inline" && type !== "inline-basic" && null,
        doesArrowAnimate && (type === "basic" || type === "basic-underline" || type === "inline-basic") && null,
        null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)($07aa1b35a6a78168$export$39aecc95f0365819, {
        type: type,
        text: text,
        href: href,
        children: [
            !isStyleOnly && /*#__PURE__*/ (0, $loA2J.jsx)("a", (0, $6iHNw._)((0, $7Knp0._)({
                className: (0, $esG4f.default)([
                    customLinkColor && "_16bt1q1b _1up41q1b",
                    !customLinkColor && "",
                    type === "basic-underline" && "_9oik1r31 _1bnx8stv _jf4cnqa1",
                    type === "modal" && "_1hms8stv _ajmmgq9o _1kegt94y _l7ed1l7b",
                    (type === "inline" || type === "inline-basic") && "_4bfu1r31 _1hms8stv _ajmmnqa1",
                    type !== "modal" && type !== "inline" && type !== "inline-basic" && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    doesArrowAnimate && (type === "basic" || type === "basic-underline" || type === "inline-basic") && "_1up4glyw _12sv54rc",
                    "_4cvr1h6o _syazaexi _1e0c116y _10531pdu _f8pji0o6 _30l3i0o6 _1axpaexi _aelyaexi _pb8z1pdu _kj55i0o6 _12lvi0o6 _l8kux7w3",
                    className
                ]),
                href: href,
                target: type == "external" || /* redirecting to new tab if the href is not on WAC and not a Signin link */ $07aa1b35a6a78168$var$isNonSigninOrWacUrl(href) ? "_blank" : "",
                rel: type == "external" || $07aa1b35a6a78168$var$isNonSigninOrWacUrl(href) ? "noreferrer" : "",
                "aria-label": ariaLabel,
                onClick: onClick
            }, dataEventProps, anchorProps), {
                style: {
                    "--_1bmh097": (0, $43MIc.default)(colorDefault),
                    "--_d4pjwz": (0, $43MIc.default)(colorVisited),
                    "--_amadh5": (0, $43MIc.default)(colorHover)
                },
                children: $07aa1b35a6a78168$var$formatLinkText(text, type)
            })),
            isStyleOnly && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    customLinkColor && "_16bt1q1b _1up41q1b",
                    !customLinkColor && "",
                    type === "basic-underline" && "_9oik1r31 _1bnx8stv _jf4cnqa1",
                    type === "modal" && "_1hms8stv _ajmmgq9o _1kegt94y _l7ed1l7b",
                    (type === "inline" || type === "inline-basic") && "_4bfu1r31 _1hms8stv _ajmmnqa1",
                    type !== "modal" && type !== "inline" && type !== "inline-basic" && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    doesArrowAnimate && (type === "basic" || type === "basic-underline" || type === "inline-basic") && "_1up4glyw _12sv54rc",
                    "_4cvr1h6o _syazaexi _1e0c116y _10531pdu _f8pji0o6 _30l3i0o6 _1axpaexi _aelyaexi _pb8z1pdu _kj55i0o6 _12lvi0o6 _l8kux7w3",
                    className
                ]),
                style: {
                    "--_1bmh097": (0, $43MIc.default)(colorDefault),
                    "--_d4pjwz": (0, $43MIc.default)(colorVisited),
                    "--_amadh5": (0, $43MIc.default)(colorHover)
                },
                children: $07aa1b35a6a78168$var$formatLinkText(text, type)
            })
        ]
    });
};

});


parcelRegister("jomHK", function(module, exports) {

$parcel$export(module.exports, "CollectionTeamwork", function () { return $1fc2a0152a300b4b$export$276cb335450499dc; });
$parcel$export(module.exports, "CollectionStrategy", function () { return $1fc2a0152a300b4b$export$7d8e5e90f99c489f; });
/* collection-types.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $cUZzr = parcelRequire("cUZzr");
const $1fc2a0152a300b4b$var$AppWrap = ({ children: children, name: name })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1ssb _1e0c1txw _4cvr1h6o _zulp1b66 _6rth12x7"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                className: (0, $esG4f.default)([
                    "_nz9xkb7n _1n78oxwj _44otidpf _ne44idpf _q228idpf _ioknidpf",
                    "app-wrap-name"
                ]),
                children: name
            })
        ]
    });
};
const $1fc2a0152a300b4b$export$276cb335450499dc = ()=>{
    const intl = (0, $f6qj2.default)();
    const CollectionTeamworkTagline = intl.formatMessage({
        id: "GlobalNav.collections.teamwork.tagline",
        defaultMessage: "Apps and agents to supercharge teamwork"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "collections-box-teamwork",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: (0, $3FBn4.useLocalizedHref)("/collections/teamwork"),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_11q71rga _1yt4v47k _kqswh2mm _2rkovwyg _v5648uld _1e0c1txw _1n261g80 _4t3i1osq _1bsbkpet _p12fp2n4 _1dbzjojz _1s4p1wug"
                ]),
                style: {
                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.CollectionTeamworkLockup), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_14aboqnp _1ey71izk _1q6z10nf _1fyh1osq",
                            "collections-tagline"
                        ]),
                        children: CollectionTeamworkTagline
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Jira",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconJira), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Confluence",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconConfluence), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Loom",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconLoom), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Agents",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconAgentsTeamwork), {})
                    })
                ]
            })
        })
    });
};
const $1fc2a0152a300b4b$export$7d8e5e90f99c489f = ()=>{
    const intl = (0, $f6qj2.default)();
    const CollectionStrategyTagline = intl.formatMessage({
        id: "GlobalNav.collections.strategy.tagline",
        defaultMessage: "Powerful apps to optimize strategy"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "collections-box-strategy",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: (0, $3FBn4.useLocalizedHref)("/collections/strategy"),
            className: (0, $esG4f.default)([
                "_1e0c1ule"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_11q71rga _1yt4v47k _kqswh2mm _2rkovwyg _v5648uld _1e0c1txw _1n261g80 _4t3i1osq _1bsbkpet _p12fp2n4 _1dbzjojz _1s4p1wug"
                ]),
                style: {
                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.CollectionStrategyLockup), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_14aboqnp _1ey71izk _1q6z10nf _1fyh1osq",
                            "collections-tagline"
                        ]),
                        children: CollectionStrategyTagline
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Align",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconAlign), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Focus",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconFocus), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Talent",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconTalent), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1fc2a0152a300b4b$var$AppWrap, {
                        name: "Agents",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUZzr.IconAgentsStrategy), {})
                    })
                ]
            })
        })
    });
};
const $1fc2a0152a300b4b$var$CollectionBoxStyle = null;
const $1fc2a0152a300b4b$var$CollectionHrefBlock = null;
const $1fc2a0152a300b4b$var$CollectionP = null;
const $1fc2a0152a300b4b$var$AppWrapCSS = null;
const $1fc2a0152a300b4b$var$AppWrapName = null;

});
parcelRegister("cUZzr", function(module, exports) {

$parcel$export(module.exports, "CollectionTeamworkLockup", function () { return $ed44a97e49e85a92$export$94ca518fef8398dc; });
$parcel$export(module.exports, "CollectionStrategyLockup", function () { return $ed44a97e49e85a92$export$8e25ec14dd0309ac; });
$parcel$export(module.exports, "IconLoom", function () { return $ed44a97e49e85a92$export$ccbb24eed51aea20; });
$parcel$export(module.exports, "IconConfluence", function () { return $ed44a97e49e85a92$export$186416edde476b41; });
$parcel$export(module.exports, "IconJira", function () { return $ed44a97e49e85a92$export$8b7bd45de0a750dd; });
$parcel$export(module.exports, "IconAgentsStrategy", function () { return $ed44a97e49e85a92$export$19dc1180afca11e4; });
$parcel$export(module.exports, "IconAlign", function () { return $ed44a97e49e85a92$export$4fd419e8d6f73ace; });
$parcel$export(module.exports, "IconFocus", function () { return $ed44a97e49e85a92$export$2c347f788745450a; });
$parcel$export(module.exports, "IconTalent", function () { return $ed44a97e49e85a92$export$d211780cbe7b632a; });
$parcel$export(module.exports, "IconAgentsTeamwork", function () { return $ed44a97e49e85a92$export$d8abf0e298feb742; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
const $ed44a97e49e85a92$export$94ca518fef8398dc = ()=>{
    const intl = (0, $f6qj2.default)();
    const TeamworkTitle = intl.formatMessage({
        id: "GlobalNav.collections.teamwork.title",
        defaultMessage: "Teamwork Collection"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "163",
        height: "40",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 789 192",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: TeamworkTitle
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "0.742188",
                y: "40.0486",
                width: "430.593",
                height: "149.89",
                transform: "rotate(-5 0.742188 40.0486)",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M378.903 119.108L364.48 119.108L364.48 65.0063L378.903 65.0063L378.903 97.2844L387.983 79.5811L403.626 79.5811L392.333 98.8869L403.931 119.108L388.059 119.108L378.903 101.405L378.903 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M350.811 99.9553L350.811 119.108L336.313 119.108L336.313 79.5812L350.811 79.5812L350.811 87.0593C352.871 81.7178 356.076 78.7418 361.265 79.047L361.265 93.8507C353.558 93.3165 350.811 94.8427 350.811 99.9553Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M312.235 120.1C299.492 120.1 292.09 111.706 292.09 99.2683C292.09 86.9065 299.492 78.6653 312.235 78.6653C324.826 78.6653 332.075 86.9065 332.075 99.2683C332.075 111.706 324.826 120.1 312.235 120.1ZM312.235 91.0271C308.038 91.0271 306.207 94.3083 306.207 99.2683C306.207 104.305 308.038 107.815 312.235 107.815C316.203 107.815 318.034 104.305 318.034 99.2683C318.034 94.3083 316.203 91.0271 312.235 91.0271Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M283.18 119.108L264.256 119.108L260.898 105.526L258.685 92.3245L256.396 105.526L252.962 119.108L235.03 119.108L225.949 79.5812L240.066 79.5812L245.179 109.799L252.428 79.5812L266.545 79.5812L273.87 109.952L278.907 79.5812L292.26 79.5812L283.18 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M200.528 97.1319L200.528 119.109L186.106 119.109L186.106 95.5295C186.106 92.2483 184.961 90.7221 182.138 90.7221C179.238 90.7221 177.254 92.7061 177.254 97.1319L177.254 119.109L162.832 119.109L162.832 79.5812L177.254 79.5812L177.254 86.6778C179.391 81.5652 183.13 78.7418 188.7 78.7418C194.652 78.7418 198.086 81.7178 199.612 87.212C201.825 81.7941 205.946 78.7418 212.127 78.7418C220.444 78.7418 223.802 84.6175 223.802 95.0716L223.802 119.109L209.38 119.109L209.38 96.0636C209.38 92.4772 208.235 90.7221 205.412 90.7221C202.512 90.7221 200.528 92.7061 200.528 97.1319Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M132.133 99.3447C132.133 104.915 133.964 107.662 137.398 107.662C140.221 107.662 142.663 105.602 142.663 100.871L142.663 97.7423C142.663 92.9349 140.603 90.8746 137.703 90.8746C134.04 90.8746 132.133 93.9269 132.133 99.3447ZM142.663 119.108L142.663 112.088C140.374 117.353 136.253 119.871 131.293 119.871C122.136 119.871 117.939 111.249 117.939 99.3447C117.939 88.1275 122.136 78.818 131.904 78.818C137.093 78.818 140.679 81.8703 142.663 86.3724L142.663 79.5811L157.085 79.5811L157.085 119.108L142.663 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M96.4941 88.7379C92.9077 88.7379 91.0763 91.3323 90.6184 96.4449L102.141 96.4449C101.759 91.1034 99.928 88.7379 96.4941 88.7379ZM113.587 117.506C109.848 118.879 104.735 119.871 99.6227 119.871C83.8271 119.871 76.7305 112.927 76.7305 99.9551C76.7305 87.517 83.5981 78.6653 96.723 78.6653C109.695 78.6653 115.037 87.4406 115.037 99.9551L115.037 102.931L90.9237 102.931C91.8394 106.823 94.5101 108.044 99.928 108.044C104.506 108.044 109.543 107.357 113.587 106.212L113.587 117.506Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M40.5723 68.9745L78.1156 68.9745L78.1156 81.8705L67.2036 81.8705L67.2036 119.109L51.4842 119.109L51.4842 81.8705L40.5723 81.8705L40.5723 68.9745Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M783.629 95.744V118.637H776.909V95.0408C776.909 88.0088 774.096 84.8835 767.689 84.8835C761.439 84.8835 757.141 89.0246 757.141 96.916V118.637H750.422V79.5704H757.141V85.9773C759.642 81.3675 764.252 78.7891 769.486 78.7891C778.472 78.7891 783.629 84.9616 783.629 95.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M724.174 119.418C712.454 119.418 705.578 110.746 705.578 99.0256C705.578 87.3056 712.454 78.7891 724.174 78.7891C735.816 78.7891 742.613 87.3056 742.613 99.0256C742.613 110.746 735.816 119.418 724.174 119.418ZM724.174 85.0397C715.814 85.0397 712.141 91.603 712.141 99.0256C712.141 106.448 715.814 113.168 724.174 113.168C732.456 113.168 736.05 106.448 736.05 99.0256C736.05 91.603 732.456 85.0397 724.174 85.0397Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M689.811 69.2569C689.811 66.2878 691.764 64.5688 694.499 64.5688C697.233 64.5688 699.187 66.2878 699.187 69.2569C699.187 72.2259 697.233 73.9449 694.499 73.9449C691.764 73.9449 689.811 72.2259 689.811 69.2569ZM691.061 118.637V79.5705H697.78V118.637H691.061Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M672.05 106.526C672.05 109.964 674.082 112.308 678.223 112.308C679.785 112.308 681.27 111.996 682.442 111.761V118.246C681.27 118.559 679.942 118.871 677.91 118.871C669.55 118.871 665.487 113.949 665.487 106.683V85.821H659.158V79.5704H665.487V71.2882H672.05V79.5704H682.442V85.821H672.05V106.526Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M655.081 111.605V117.621C652.737 118.872 649.143 119.418 645.549 119.418C631.641 119.418 625.156 110.98 625.156 99.0256C625.156 87.2275 631.641 78.7891 645.549 78.7891C649.065 78.7891 651.8 79.2579 654.847 80.6643V86.9149C652.347 85.7429 649.69 85.0397 646.018 85.0397C635.861 85.0397 631.719 91.4467 631.719 99.0256C631.719 106.605 635.939 113.012 646.174 113.012C650.159 113.012 652.659 112.465 655.081 111.605Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M602.307 84.8835C595.197 84.8835 591.602 89.4933 590.899 96.291H612.698C612.308 89.0245 609.026 84.8835 602.307 84.8835ZM617.308 117.074C614.105 118.793 609.182 119.418 605.198 119.418C590.587 119.418 584.18 110.98 584.18 99.0256C584.18 87.2275 590.743 78.7891 602.619 78.7891C614.652 78.7891 619.496 87.1493 619.496 99.0256V102.073H590.977C591.915 108.714 596.212 113.012 605.432 113.012C609.964 113.012 613.792 112.152 617.308 110.902V117.074Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M580.443 118.559C579.896 118.715 578.724 118.872 577.005 118.872C570.598 118.872 566.535 115.824 566.535 108.636V63.2405H573.255V107.855C573.255 111.371 575.599 112.621 578.49 112.621C579.193 112.621 579.662 112.621 580.443 112.543V118.559Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M560.074 118.559C559.527 118.715 558.355 118.872 556.636 118.872C550.229 118.872 546.166 115.824 546.166 108.636V63.2405H552.885V107.855C552.885 111.371 555.23 112.621 558.12 112.621C558.824 112.621 559.292 112.621 560.074 112.543V118.559Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M519.916 119.418C508.196 119.418 501.32 110.746 501.32 99.0256C501.32 87.3056 508.196 78.7891 519.916 78.7891C531.558 78.7891 538.356 87.3056 538.356 99.0256C538.356 110.746 531.558 119.418 519.916 119.418ZM519.916 85.0397C511.556 85.0397 507.884 91.603 507.884 99.0256C507.884 106.448 511.556 113.168 519.916 113.168C528.198 113.168 531.792 106.448 531.792 99.0256C531.792 91.603 528.198 85.0397 519.916 85.0397Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M496.389 109.574V116.371C493.186 118.481 488.107 119.418 482.794 119.418C465.917 119.418 456.385 109.261 456.385 93.0874C456.385 77.4607 465.917 66.522 482.638 66.522C487.638 66.522 492.639 67.4596 496.311 70.1161V76.9137C492.639 74.5697 488.576 73.3196 482.638 73.3196C470.605 73.3196 463.417 81.2892 463.417 93.0874C463.417 104.886 470.839 112.699 483.028 112.699C488.419 112.699 492.639 111.449 496.389 109.574Z",
                fill: "#101214"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$8e25ec14dd0309ac = ()=>{
    const intl = (0, $f6qj2.default)();
    const StrategyTitle = intl.formatMessage({
        id: "GlobalNav.collections.strategy.title",
        defaultMessage: "Strategy Collection"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "150",
        height: "40",
        viewBox: "0 0 150 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: StrategyTitle
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                y: "4.95129",
                width: "76",
                height: "31.4286",
                transform: "rotate(-1 0 4.95129)",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M63.0338 28.073C61.8818 28.073 61.4338 28.025 60.9858 27.833L60.9858 25.209C61.5458 25.353 62.0418 25.401 62.6818 25.401C63.8498 25.401 64.2658 24.937 64.4898 24.105L62.6178 24.105L60.6338 16.569L63.5778 16.569L64.9378 22.281L66.3138 16.569L69.2578 16.569L67.0818 24.569C66.4418 26.921 65.1138 28.073 63.0338 28.073Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M57.092 23.8331L57.092 22.8891C56.612 24.0091 55.748 24.5371 54.692 24.5371C52.788 24.5371 51.908 22.8091 51.908 20.4571C51.908 18.2491 52.788 16.4091 54.836 16.4091C55.924 16.4091 56.676 17.0651 57.092 18.0251L57.092 16.5691L60.1 16.5691L60.1 23.7211C60.1 26.3291 58.804 28.0731 55.396 28.0731C54.292 28.0731 53.124 27.9131 52.212 27.6571L52.212 24.9691C53.14 25.3371 54.1 25.4971 55.108 25.4971C56.58 25.4971 57.092 24.7931 57.092 23.8331ZM54.884 20.4571C54.884 21.5291 55.268 22.0731 55.988 22.0731C56.628 22.0731 57.092 21.6251 57.092 20.5691L57.092 20.2811C57.092 19.3371 56.644 18.9211 56.036 18.9211C55.268 18.9211 54.884 19.4811 54.884 20.4571Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47.4113 18.4891C46.6593 18.4891 46.2753 19.0331 46.1793 20.1051L48.5953 20.1051C48.5153 18.9851 48.1313 18.4891 47.4113 18.4891ZM50.9953 24.5211C50.2113 24.8091 49.1393 25.0171 48.0673 25.0171C44.7553 25.0171 43.2673 23.5611 43.2673 20.8411C43.2673 18.2331 44.7073 16.3771 47.4593 16.3771C50.1793 16.3771 51.2993 18.2171 51.2993 20.8411L51.2993 21.4651L46.2433 21.4651C46.4353 22.2811 46.9953 22.5371 48.1313 22.5371C49.0913 22.5371 50.1473 22.3931 50.9953 22.1531L50.9953 24.5211Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.1967 21.545C41.1967 22.057 41.4527 22.313 41.9487 22.313C42.1887 22.313 42.4127 22.265 42.5887 22.233L42.5887 24.809C42.1727 24.905 41.7087 24.985 40.9887 24.985C38.9087 24.985 38.1887 23.753 38.1887 21.961L38.1887 19.017L37.4207 19.017L37.4207 16.569L38.1887 16.569L38.1887 14.889L41.1967 14.889L41.1967 16.569L42.5887 16.569L42.5887 19.017L41.1967 19.017L41.1967 21.545Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.4152 20.7131C31.4152 21.8811 31.7992 22.4571 32.5192 22.4571C33.1112 22.4571 33.6232 22.0251 33.6232 21.0331L33.6232 20.3771C33.6232 19.3691 33.1912 18.9371 32.5832 18.9371C31.8152 18.9371 31.4152 19.5771 31.4152 20.7131ZM33.6232 24.8571L33.6232 23.3851C33.1432 24.4891 32.2792 25.0171 31.2392 25.0171C29.3192 25.0171 28.4392 23.2091 28.4392 20.7131C28.4392 18.3611 29.3192 16.4091 31.3672 16.4091C32.4552 16.4091 33.2072 17.0491 33.6232 17.9931L33.6232 16.5691L36.6472 16.5691L36.6472 24.8571L33.6232 24.8571Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.9238 20.8411L25.9238 24.8571L22.8838 24.8571L22.8838 16.5691L25.9238 16.5691L25.9238 18.1371C26.3558 17.0171 27.0278 16.3931 28.1158 16.4571L28.1158 19.5611C26.4998 19.4491 25.9238 19.7691 25.9238 20.8411Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.431 21.545C20.431 22.057 20.687 22.313 21.183 22.313C21.423 22.313 21.647 22.265 21.823 22.233L21.823 24.809C21.407 24.905 20.943 24.985 20.223 24.985C18.143 24.985 17.423 23.753 17.423 21.961L17.423 19.017L16.655 19.017L16.655 16.569L17.423 16.569L17.423 14.889L20.431 14.889L20.431 16.569L21.823 16.569L21.823 19.017L20.431 19.017L20.431 21.545Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.1703 21.5611C16.1703 23.7371 14.9383 25.0331 11.8983 25.0331C10.0423 25.0331 8.6983 24.6171 7.8343 24.1531L7.8343 21.2731C8.8103 21.7211 10.6503 22.2171 11.8663 22.2171C12.6023 22.2171 12.8743 21.9771 12.8743 21.5931C12.8743 21.1931 12.5543 20.9691 11.7223 20.8091C8.6023 20.2971 7.7063 19.0651 7.7063 17.4651C7.7063 15.4011 9.2263 14.1691 12.0103 14.1691C13.4823 14.1691 14.8743 14.4891 15.7703 14.9691L15.7703 17.7531C14.4103 17.2411 12.8423 16.9051 11.9303 16.9051C11.2423 16.9051 10.8903 17.1131 10.8903 17.5131C10.8903 17.9131 11.2583 18.1051 12.3623 18.3131C15.4343 18.8091 16.1703 19.9931 16.1703 21.5611Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M148.01 20.2439V25.044H146.601V20.0964C146.601 18.622 146.012 17.9666 144.668 17.9666C143.358 17.9666 142.457 18.8349 142.457 20.4896V25.044H141.048V16.8526H142.457V18.196C142.981 17.2294 143.947 16.6888 145.045 16.6888C146.929 16.6888 148.01 17.983 148.01 20.2439Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M135.544 25.2079C133.086 25.2079 131.645 23.3894 131.645 20.9319C131.645 18.4745 133.086 16.6888 135.544 16.6888C137.985 16.6888 139.41 18.4745 139.41 20.9319C139.41 23.3894 137.985 25.2079 135.544 25.2079ZM135.544 17.9994C133.791 17.9994 133.021 19.3756 133.021 20.9319C133.021 22.4883 133.791 23.8972 135.544 23.8972C137.28 23.8972 138.034 22.4883 138.034 20.9319C138.034 19.3756 137.28 17.9994 135.544 17.9994Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M128.338 14.6901C128.338 14.0675 128.748 13.7071 129.321 13.7071C129.895 13.7071 130.304 14.0675 130.304 14.6901C130.304 15.3126 129.895 15.673 129.321 15.673C128.748 15.673 128.338 15.3126 128.338 14.6901ZM128.601 25.044V16.8526H130.009V25.044H128.601Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M124.615 22.5047C124.615 23.2255 125.041 23.717 125.909 23.717C126.236 23.717 126.548 23.6515 126.793 23.6023V24.9621C126.548 25.0277 126.269 25.0932 125.843 25.0932C124.09 25.0932 123.238 24.0611 123.238 22.5375V18.1632H121.911V16.8526H123.238V15.116H124.615V16.8526H126.793V18.1632H124.615V22.5047Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M121.057 23.5696V24.8311C120.565 25.0932 119.812 25.2079 119.058 25.2079C116.142 25.2079 114.782 23.4385 114.782 20.9319C114.782 18.4581 116.142 16.6888 119.058 16.6888C119.795 16.6888 120.369 16.7871 121.007 17.082V18.3926C120.483 18.1469 119.926 17.9994 119.156 17.9994C117.026 17.9994 116.158 19.3428 116.158 20.9319C116.158 22.5211 117.043 23.8645 119.189 23.8645C120.024 23.8645 120.549 23.7498 121.057 23.5696Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M109.991 17.9666C108.5 17.9666 107.747 18.9332 107.599 20.3585H112.17C112.088 18.8349 111.4 17.9666 109.991 17.9666ZM113.137 24.7164C112.465 25.0768 111.433 25.2079 110.597 25.2079C107.534 25.2079 106.19 23.4385 106.19 20.9319C106.19 18.4581 107.567 16.6888 110.057 16.6888C112.58 16.6888 113.595 18.4417 113.595 20.9319V21.5709H107.616C107.812 22.9634 108.713 23.8645 110.647 23.8645C111.597 23.8645 112.4 23.6843 113.137 23.4221V24.7164Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M105.406 25.0277C105.292 25.0604 105.046 25.0932 104.686 25.0932C103.342 25.0932 102.49 24.4543 102.49 22.947V13.4286H103.899V22.7832C103.899 23.5204 104.391 23.7826 104.997 23.7826C105.144 23.7826 105.243 23.7826 105.406 23.7662V25.0277Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M101.135 25.0277C101.02 25.0604 100.774 25.0932 100.414 25.0932C99.0704 25.0932 98.2185 24.4543 98.2185 22.947V13.4286H99.6274V22.7832C99.6274 23.5204 100.119 23.7826 100.725 23.7826C100.873 23.7826 100.971 23.7826 101.135 23.7662V25.0277Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M92.7148 25.2079C90.2574 25.2079 88.8157 23.3894 88.8157 20.9319C88.8157 18.4745 90.2574 16.6888 92.7148 16.6888C95.1558 16.6888 96.5811 18.4745 96.5811 20.9319C96.5811 23.3894 95.1558 25.2079 92.7148 25.2079ZM92.7148 17.9994C90.9618 17.9994 90.1918 19.3756 90.1918 20.9319C90.1918 22.4883 90.9618 23.8972 92.7148 23.8972C94.4514 23.8972 95.205 22.4883 95.205 20.9319C95.205 19.3756 94.4514 17.9994 92.7148 17.9994Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M87.7823 23.1436V24.5689C87.1106 25.0112 86.0457 25.2078 84.9317 25.2078C81.393 25.2078 79.3943 23.0781 79.3943 19.6868C79.3943 16.4102 81.393 14.1166 84.8989 14.1166C85.9474 14.1166 86.9959 14.3132 87.7659 14.8702V16.2956C86.9959 15.8041 86.144 15.5419 84.8989 15.5419C82.376 15.5419 80.8687 17.213 80.8687 19.6868C80.8687 22.1606 82.4251 23.7989 84.9808 23.7989C86.1113 23.7989 86.9959 23.5368 87.7823 23.1436Z",
                fill: "#101214"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$ccbb24eed51aea20 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.472 4.375H7.52802C5.57955 4.375 4 5.95455 4 7.90302V18.847C4 20.7955 5.57955 22.375 7.52802 22.375H18.472C20.4205 22.375 22 20.7955 22 18.847V7.90302C22 5.95455 20.4205 4.375 18.472 4.375Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.5691 12.7555H15.3121L18.1328 11.127L17.5134 10.0537L14.6926 11.6823L16.3208 8.86177L15.2476 8.24194L13.6194 11.0625V7.80566H12.3804V11.0628L10.7516 8.24194L9.67868 8.86145L11.3072 11.682L8.48642 10.0537L7.86693 11.1267L10.6877 12.7552H7.43066V13.9943H10.6874L7.86693 15.6228L8.48642 16.6961L11.3069 15.0678L9.67836 17.8883L10.7516 18.5078L12.3801 15.687V18.9441H13.6191V15.6873L15.2473 18.5078L16.3205 17.8883L14.692 15.0675L17.5127 16.6961L18.1322 15.6228L15.3118 13.9946H18.5685L18.5691 12.7555ZM12.9999 15.06C12.0657 15.06 11.3084 14.3028 11.3084 13.3685C11.3084 12.4343 12.0657 11.677 12.9999 11.677C13.9341 11.677 14.6913 12.4343 14.6913 13.3685C14.6913 14.3028 13.9341 15.06 12.9999 15.06Z",
                fill: "white"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$186416edde476b41 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.472 4.375H7.52802C5.57955 4.375 4 5.95455 4 7.90302V18.847C4 20.7955 5.57955 22.375 7.52802 22.375H18.472C20.4205 22.375 22 20.7955 22 18.847V7.90302C22 5.95455 20.4205 4.375 18.472 4.375Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.8001 15.3538C14.5648 13.7895 13.6197 13.5557 12.2565 13.5557C10.6571 13.5557 9.2939 14.221 8.07613 16.091L7.8762 16.3967C7.71262 16.6485 7.67627 16.7384 7.67627 16.8462C7.67627 16.9541 7.7308 17.044 7.93073 17.1699L9.98457 18.4466C10.0936 18.5185 10.1845 18.5544 10.2754 18.5544C10.3844 18.5544 10.4571 18.5005 10.5662 18.3387L10.8933 17.8352C11.4023 17.062 11.8567 16.8103 12.4383 16.8103C12.9472 16.8103 13.547 16.9541 14.2922 17.3138L16.4369 18.3207C16.655 18.4286 16.8913 18.3746 17.0003 18.1229L18.0182 15.8932C18.1272 15.6415 18.0545 15.4797 17.8001 15.3538ZM8.36694 11.416C11.6022 12.9803 12.5473 13.2141 13.9105 13.2141C15.5099 13.2141 16.8731 12.5488 18.0909 10.6787L18.2908 10.3731C18.4544 10.1213 18.4907 10.0314 18.4907 9.92353C18.4907 9.81565 18.4362 9.72574 18.2363 9.59987L16.1824 8.32322C16.0734 8.25129 15.9825 8.21533 15.8916 8.21533C15.7826 8.21533 15.7099 8.26928 15.6008 8.4311L15.2737 8.93457C14.7647 9.70776 14.3104 9.9595 13.7287 9.9595C13.2198 9.9595 12.62 9.81565 11.8748 9.45603L9.73011 8.44909C9.512 8.3412 9.27572 8.39514 9.16667 8.64688L8.14883 10.8765C8.03978 11.1283 8.11248 11.2901 8.36694 11.416Z",
                fill: "white"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$8b7bd45de0a750dd = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.472 4.375H7.52802C5.57955 4.375 4 5.95455 4 7.90302V18.847C4 20.7955 5.57955 22.375 7.52802 22.375H18.472C20.4205 22.375 22 20.7955 22 18.847V7.90302C22 5.95455 20.4205 4.375 18.472 4.375Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.5596 16.2167H9.46912C7.82442 16.2167 6.64453 15.2093 6.64453 13.7342H12.5082C12.8121 13.7342 13.0088 13.9501 13.0088 14.2559V20.1564C11.5429 20.1564 10.5596 18.9691 10.5596 17.3141V16.2167ZM13.4557 13.2845H12.3652C10.7205 13.2845 9.54062 12.2951 9.54062 10.8199H15.4043C15.7082 10.8199 15.9228 11.0178 15.9228 11.3236V17.2241C14.4568 17.2241 13.4557 16.0368 13.4557 14.3818V13.2845ZM16.3697 10.3702H15.2792C13.6345 10.3702 12.4546 9.36282 12.4546 7.8877H18.3183C18.6222 7.8877 18.8188 8.10357 18.8188 8.3914V14.2919C17.3529 14.2919 16.3697 13.1046 16.3697 11.4496V10.3702Z",
                fill: "white"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$19dc1180afca11e4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                opacity: "0.5",
                d: "M12.8603 1.3006C12.1624 0.8998 11.3078 0.8998 10.6027 1.3006L3.1608 5.53041C2.44153 5.93836 2 6.70416 2 7.53438V15.9368C2 16.767 2.44153 17.5328 3.1608 17.9407L10.6027 22.1705C11.3007 22.5713 12.1552 22.5713 12.8603 22.1705L20.3022 17.9407C21.0215 17.5328 21.463 16.767 21.463 15.9368V7.53438C21.463 6.70416 21.0215 5.93836 20.3022 5.53041L12.8603 1.3006Z",
                fill: "#FB9700",
                stroke: "#F8F8F8",
                strokeWidth: "0.895613"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.1638 6.8915L14.908 2.78796C14.2275 2.39913 13.3943 2.39913 12.7069 2.78796L5.45111 6.8915C4.74983 7.28727 4.31934 8.03022 4.31934 8.83565V16.9872C4.31934 17.7926 4.74983 18.5356 5.45111 18.9313L12.7069 23.0349C13.3874 23.4237 14.2206 23.4237 14.908 23.0349L22.1638 18.9313C22.8651 18.5356 23.2956 17.7926 23.2956 16.9872V8.83565C23.2956 8.03022 22.8651 7.28727 22.1638 6.8915Z",
                fill: "#FB9700",
                stroke: "#F8F8F8",
                strokeWidth: "0.895613"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20 8.15771H8V15.8925H20V8.15771Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.223 16.9514V18.2663H10.7764V16.9514H12.9238V14.5923H15.0756V16.9514H17.223Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M15.0756 14.5923H12.9238V15.8945H15.0756V14.5923Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M14.0007 13.8609C15.0302 13.8609 15.8647 13.0394 15.8647 12.026C15.8647 11.0127 15.0302 10.1912 14.0007 10.1912C12.9713 10.1912 12.1367 11.0127 12.1367 12.026C12.1367 13.0394 12.9713 13.8609 14.0007 13.8609Z",
                fill: "#FCA700"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$4fd419e8d6f73ace = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.472 4H7.52802C5.57955 4 4 5.57955 4 7.52802V18.472C4 20.4205 5.57955 22 7.52802 22H18.472C20.4205 22 22 20.4205 22 18.472V7.52802C22 5.57955 20.4205 4 18.472 4Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.6781 17.6783C17.6781 15.9072 16.229 14.4761 14.4758 14.4761H11.524V11.7747H8.32178V17.088C8.32178 17.4994 8.50067 17.6783 8.91214 17.6783H17.6781ZM8.32178 8.32202C8.32178 10.0931 9.73506 11.5243 11.5061 11.5243H14.4758V14.2256H17.6781V8.91238C17.6781 8.51881 17.4813 8.32202 17.0877 8.32202H8.32178Z",
                fill: "#101214"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$2c347f788745450a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.472 4H7.52802C5.57955 4 4 5.57955 4 7.52802V18.472C4 20.4205 5.57955 22 7.52802 22H18.472C20.4205 22 22 20.4205 22 18.472V7.52802C22 5.57955 20.4205 4 18.472 4Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.0195 13.1643C18.7036 11.8484 16.5648 11.8624 15.2628 13.1643L14.1672 14.26C13.5623 14.8649 12.5797 14.8649 11.9748 14.26L11.0644 13.3497L8.68553 15.7286L9.59584 16.6389C11.5144 18.5574 14.6264 18.5574 16.5449 16.6389L20.0195 13.1643ZM6.12012 12.8367C7.43604 14.1527 9.54805 14.1655 10.864 12.8496L11.9736 11.7399C12.5785 11.135 13.5611 11.135 14.166 11.7399L15.0763 12.6502L17.4552 10.2713L16.5449 9.36101C14.6264 7.44249 11.5144 7.44249 9.59584 9.36101L6.12128 12.8356L6.12012 12.8367Z",
                fill: "#101214"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$d211780cbe7b632a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4 9.22424C4 6.73896 6.01472 4.72424 8.5 4.72424H17.5C19.9853 4.72424 22 6.73896 22 9.22424V18.2242C22 20.7095 19.9853 22.7242 17.5 22.7242H8.5C6.01472 22.7242 4 20.7095 4 18.2242V9.22424Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.9723 11.2891L12.68 7.48425H13.324L15.0316 11.2891L19.178 11.7374L19.377 12.3499L16.2861 15.1498L17.1409 19.2317L16.6199 19.6102L13.002 17.5358L9.38399 19.6102L8.86298 19.2317L9.71786 15.1498L6.62695 12.3499L6.82596 11.7374L10.9723 11.2891ZM11.5555 16.1006V15.5917C11.5555 14.8224 12.1791 14.1988 12.9484 14.1988C13.7176 14.1988 14.3412 14.8224 14.3412 15.5917V16.0512C13.9308 16.3084 13.4464 16.4585 12.9272 16.4622H12.8877C12.4026 16.4588 11.9479 16.3275 11.5555 16.1006ZM12.9484 13.7499C13.5253 13.7499 13.993 13.2822 13.993 12.7052C13.993 12.1283 13.5253 11.6606 12.9484 11.6606C12.3714 11.6606 11.9037 12.1283 11.9037 12.7052C11.9037 13.2822 12.3714 13.7499 12.9484 13.7499Z",
                fill: "#101214"
            })
        ]
    });
};
const $ed44a97e49e85a92$export$d8abf0e298feb742 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M10.928 16.068C11.1274 16.0537 13.7623 15.4167 13.0715 15.2807C12.8152 15.3523 12.6158 15.2807 12.4876 15.474C12.452 15.245 11.9463 15.61 11.868 15.6243C11.8324 15.4525 11.0419 15.8963 11.163 15.7388C10.8069 15.7388 10.3583 15.8676 9.89536 16.0108C9.66747 15.8605 10.6431 14.7654 10.2301 15.0016C10.2586 14.9372 10.3654 14.6724 10.3511 14.8513C10.4793 14.701 11.8894 12.3893 11.2983 12.7829C10.9066 13.2625 10.6075 14.0569 10.2728 14.4505C9.94521 14.5865 9.72444 15.7245 9.36125 15.61C9.1476 15.3523 8.60637 12.2032 8.22181 12.4823C8.2859 12.7257 8.22181 12.9475 8.41409 13.0621C8.1862 13.0978 8.5494 13.5988 8.56364 13.6776C8.39273 13.7134 8.83426 14.5006 8.67759 14.379C8.67759 14.6008 8.72744 14.8585 8.80577 15.1304C8.70607 15.0589 8.60637 14.8871 8.54228 14.8656C7.89422 14.6008 7.39572 13.9996 6.71918 13.6704C6.14946 14.3933 11.1915 16.2183 8.06514 16.4903C7.47406 16.8696 6.69781 16.9269 6.04264 17.299C5.98567 18.0935 9.72444 15.9034 8.6491 17.163C8.47818 17.6927 8.22893 18.2939 7.8871 18.8163C7.66634 20.8203 9.53216 15.3809 9.46095 17.4565C9.71732 17.9503 9.96657 18.5515 10.0948 19.167C11.0063 20.4982 9.76005 16.977 9.63186 16.476C10.1232 16.2684 12.0389 18.6446 12.3879 18.2724C12.4021 18.2223 12.1315 17.9217 12.046 17.8931C11.9891 17.9217 11.9606 17.9432 11.925 17.8931C12.0959 17.7356 11.5048 17.5281 11.4478 17.4708C11.5689 17.3491 10.7499 16.9483 10.9493 16.9555C10.7927 16.7408 10.5648 16.5261 10.2942 16.3114C10.7642 16.2183 10.9707 15.8891 10.928 16.0609V16.068Z",
                    fill: "#CFE1FD"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M17.7143 15.1089L17.4793 16.297H14.6022L14.3672 15.1089H17.7143Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: "0.5",
                    d: "M12.8603 1.6756C12.1624 1.2748 11.3078 1.2748 10.6027 1.6756L3.1608 5.90541C2.44153 6.31336 2 7.07916 2 7.90938V16.3118C2 17.142 2.44153 17.9078 3.1608 18.3157L10.6027 22.5455C11.3007 22.9463 12.1552 22.9463 12.8603 22.5455L20.3022 18.3157C21.0215 17.9078 21.463 17.142 21.463 16.3118V7.90938C21.463 7.07916 21.0215 6.31336 20.3022 5.90541L12.8603 1.6756Z",
                    fill: "#1868DB",
                    stroke: "#F8F8F8",
                    strokeWidth: "0.895613"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M13.4081 15.1086L13.1731 16.2967H10.296L10.061 15.1086H13.4081Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M22.1638 7.2665L14.908 3.16296C14.2275 2.77413 13.3943 2.77413 12.7069 3.16296L5.45111 7.2665C4.74983 7.66227 4.31934 8.40522 4.31934 9.21065V17.3622C4.31934 18.1676 4.74983 18.9106 5.45111 19.3063L12.7069 23.4099C13.3874 23.7987 14.2206 23.7987 14.908 23.4099L22.1638 19.3063C22.8651 18.9106 23.2956 18.1676 23.2956 17.3622V9.21065C23.2956 8.40522 22.8651 7.66227 22.1638 7.2665Z",
                    fill: "#1868DB",
                    stroke: "#F8F8F8",
                    strokeWidth: "0.895613"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M18.0608 9.09204H9.55518V18.7225H18.0608V9.09204Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M12.3252 16.7793C12.3252 15.9391 13.0126 15.2656 13.8666 15.2656C14.7207 15.2656 15.4081 15.9461 15.4081 16.7793V18.7234H12.3321V16.7793H12.3252Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M15.1863 13.3201C15.1863 14.0353 14.5962 14.6186 13.8671 14.6186C13.138 14.6186 12.5479 14.0353 12.5479 13.3201C12.5479 12.605 13.138 12.0217 13.8671 12.0217C14.5962 12.0217 15.1863 12.605 15.1863 13.3201Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M16.4493 8.02276V10.2794H11.1445V8.02276H12.7068C12.7068 7.42563 13.1928 6.94653 13.8038 6.94653C14.4149 6.94653 14.894 7.42563 14.894 8.02276H16.4562H16.4493Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M16.4493 9.23169H11.1445V10.6967H16.4493V9.23169Z",
                    fill: "#1868DB"
                })
            ]
        })
    });
};

});


parcelRegister("cuuol", function(module, exports) {

$parcel$export(module.exports, "GlobalNavProductRecommendationsSimple", function () { return $b6d12220045b94f0$export$9eb7aff5460bd308; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $fxdfZ = parcelRequire("fxdfZ");

var $gAJUc = parcelRequire("gAJUc");

var $hDrV5 = parcelRequire("hDrV5");

var $4wGZc = parcelRequire("4wGZc");

var $7520o = parcelRequire("7520o");

var $3rvyw = parcelRequire("3rvyw");
const $b6d12220045b94f0$var$GlobalNavProductRecommendationsSimpleImplementation = ({ isMobile: isMobile = false })=>{
    const intl = (0, $f6qj2.default)();
    const { recommendations: recommendations, isRecommendationLoading: isRecommendationLoading } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    const rawRecommendedProductIds = recommendations.map((ccpId)=>(0, $hDrV5.ccpKeyToProductId)[ccpId]).filter(Boolean);
    const recommendedTitle = intl.formatMessage({
        id: "GlobalNav.collections.featured.recommended.apps",
        defaultMessage: "Recommended based on your existing Atlassian apps"
    });
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    let recommendedProductIds = rawRecommendedProductIds;
    let fallbackIds = [
        "jira",
        "confluence",
        "jsm",
        "rovo"
    ];
    if (gwp7850GlobalNavChangesForTeam25Eu) {
        recommendedProductIds = rawRecommendedProductIds.slice(0, 3);
        fallbackIds = [
            "jira",
            "confluence",
            "jsm"
        ];
    }
    const fallbackTitle = intl.formatMessage({
        id: "GlobalNav.collections.featured.featuredapps",
        defaultMessage: "Featured apps"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "global-nav-product-recommendations-3-max",
        children: isRecommendationLoading ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $3rvyw.SkeletonGrid), {
            numProducts: (0, $hDrV5.NUM_DISPLAY_RECOMMENDATIONS)
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7520o.ProductRecommendationsContainer), {
            recommendedProductIds: recommendedProductIds.length > 0 ? recommendedProductIds : fallbackIds,
            isMobile: isMobile,
            customTitle: recommendedProductIds.length > 0 ? recommendedTitle : fallbackTitle
        })
    });
};
const $b6d12220045b94f0$export$9eb7aff5460bd308 = ({ isMobile: isMobile = false })=>{
    const { onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: null,
        onError: onGlobalNavProductRecommendationsFailed,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($b6d12220045b94f0$var$GlobalNavProductRecommendationsSimpleImplementation, {
            isMobile: isMobile
        })
    });
};

});
parcelRegister("7520o", function(module, exports) {

$parcel$export(module.exports, "ProductRecommendationsContainer", function () { return $9e26781aa3e88c00$export$7e176c4401e77096; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $7ox2l = parcelRequire("7ox2l");
const $9e26781aa3e88c00$var$title = (0, $6x1qA.defineMessage)({
    id: "globalnav.v2.products.featured.recommendations",
    defaultMessage: "Recommended based on your existing Atlassian apps"
});
const $9e26781aa3e88c00$export$7e176c4401e77096 = ({ recommendedProductIds: recommendedProductIds, isMobile: isMobile, customTitle: customTitle })=>{
    const intl = (0, $f6qj2.default)();
    const { products: products } = (0, $5vh4Q.useProductData)();
    if (recommendedProductIds.length === 0) return null;
    const productsToRender = recommendedProductIds.map((id)=>products[id]).filter((product)=>product !== undefined);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7ox2l.ProductsGrid), {
        products: productsToRender,
        title: customTitle ? customTitle : intl.formatMessage($9e26781aa3e88c00$var$title),
        isMobile: isMobile,
        container: "ProductsRecommendationsContainer"
    });
};

});
parcelRegister("7ox2l", function(module, exports) {

$parcel$export(module.exports, "ProductsGrid", function () { return $cc88e1b4e46b9ec6$export$710ab4b4285b1a69; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $QFBkP = parcelRequire("QFBkP");

var $5vh4Q = parcelRequire("5vh4Q");

var $gT02p = parcelRequire("gT02p");

var $8xSgC = parcelRequire("8xSgC");
const $cc88e1b4e46b9ec6$export$710ab4b4285b1a69 = ({ products: products, title: title, isMobile: isMobile, container: container })=>{
    const intl = (0, $f6qj2.default)();
    const { fireCardClicked: fireCardClicked } = (0, $gT02p.useAnalytics)();
    const handleCardClick = (product)=>{
        fireCardClicked({
            container: container,
            product: product,
            isMobile: isMobile
        });
    };
    const productItems = products.map((product)=>{
        return(// This is just a wrapper that doesn't affect user interactivity. Okay to ignore these a11y rules.
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            onClick: ()=>handleCardClick(product),
            children: isMobile ? // @ts-ignore
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavCard), (0, $6iHNw._)((0, $7Knp0._)({}, product), {
                description: intl.formatMessage(product.description),
                isNew: product.treatment === (0, $5vh4Q.Treatment).New,
                productKey: "home"
            })) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product))
        }, product.id));
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSgC.BaseGrid), {
        products: productItems,
        title: title,
        isMobile: isMobile
    });
};

});
parcelRegister("QFBkP", function(module, exports) {

$parcel$export(module.exports, "MobileNavTitle", function () { return $2ac583c70abd4cba$export$9282cbc99a667022; });
$parcel$export(module.exports, "MobileNavCard", function () { return $2ac583c70abd4cba$export$76722d91c2a9f074; });
/* mobile-nav-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $2ac583c70abd4cba$var$mobileTitleCss = null;
const $2ac583c70abd4cba$export$9282cbc99a667022 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1wyboqnp _vwz44jg8 _1p1dangw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4zu5n _syaz1hlo"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: title
    });
};
const $2ac583c70abd4cba$var$containerCss = null;
const $2ac583c70abd4cba$var$logoCss = null;
const $2ac583c70abd4cba$var$textContainerCss = null;
const $2ac583c70abd4cba$var$nameCss = null;
const $2ac583c70abd4cba$var$descriptionCss = null;
const $2ac583c70abd4cba$var$basicLinkCss = null;
const $2ac583c70abd4cba$var$pillContainerCss = null;
const $2ac583c70abd4cba$var$pillTextCss = null;
const $2ac583c70abd4cba$export$d2cf3038149dd1b5 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_syaz18q9 _bfhk6kkz _1e0c1txw _4cvr1h6o _18zr14y2 _2rko1tcg _ahbqi2wt"
        ]),
        style: {
            "--_nmjf06": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.navy")),
            "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_1wybud5o _k48p1fw0 _1p1dangw"
            ]),
            children: intl.formatMessage({
                id: "globalnav.v2.pill",
                defaultMessage: "New"
            })
        })
    });
};
const $2ac583c70abd4cba$export$76722d91c2a9f074 = ({ logo: logo, href: href, name: name, description: description, isNew: isNew, productKey: productKey = "home" })=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href);
    const formattedHref = (0, $3FBn4.isLocalizableHref)(href) ? localizedHref : href;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: description ? /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: formattedHref,
            "aria-label": name,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "navbarDropdown",
            "data-product-key": productKey,
            className: (0, $esG4f.default)([
                "_1rjc1tcg _1e0c1txw _4cvr1h6o _zulputpp"
            ]),
            children: [
                logo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bsb1ady _4t3i1ady _1bah1h6o _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                        brand: logo,
                        type: "mark",
                        appearance: "brand",
                        width: 32,
                        height: 32
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1yt4ze3t _2lx21bp4 _1bah1h6o _4cvr1y6m _16jlkb7n _1o9zidpf _i0dlf1ug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("h5", {
                            className: (0, $esG4f.default)([
                                "_ggmhoxwj _r8nt1fw0 _1axicjiy _syaz1hlo _ect4kipj _1yt4ze3t _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    children: name
                                }),
                                isNew && /*#__PURE__*/ (0, $loA2J.jsx)($2ac583c70abd4cba$export$d2cf3038149dd1b5, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_syaz1yg0 _ect48q0o _1wyboqnp _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            style: {
                                "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                            },
                            children: description
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            text: name,
            href: formattedHref,
            type: "primary",
            ariaLabel: name,
            dataEventProps: {
                "data-product-key": productKey,
                "data-event-component": "linkButton",
                "data-event-container": "navbarDropdown",
                "data-label": name,
                "data-event": "clicked"
            },
            className: (0, $esG4f.default)([
                "_ect48q0o _1wyb7vkz _vwz4gktf _1rjc1tcg"
            ])
        })
    });
};

});

parcelRegister("gT02p", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", function () { return $396f70a4de66ce58$export$e955abb82869dc84; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");
function $396f70a4de66ce58$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const commonProps = (0, $iSvIT.useMemo)(()=>({
            product: "marketing"
        }), []);
    const fireCardClicked = (0, $iSvIT.useCallback)(({ container: container, product: product, isMobile: isMobile })=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, commonProps), {
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "recommendedProduct",
            attributes: {
                productKey: product.id,
                eventContainer: container,
                isMobile: isMobile
            }
        })).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireGlobalNavProductRecommendationsViewed = (0, $iSvIT.useCallback)(({ recommendations: recommendations, isMobile: isMobile })=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, commonProps), {
            eventType: "screen",
            name: "productNavRecommendation",
            attributes: {
                recommendedProductKeys: recommendations,
                isMobile: isMobile
            }
        })).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireFetchGrowthRecommendationSucceeded = (0, $iSvIT.useCallback)((recommendedProductIds, elapsedTimeMiliseconds)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, commonProps), {
            eventType: "operational",
            actionSubject: "fetchGrowthRecommendation",
            action: "succeeded",
            attributes: {
                recommendedProductIds: recommendedProductIds,
                elapsedTime: elapsedTimeMiliseconds / 1000
            }
        })).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireFetchGrowthRecommendationFailed = (0, $iSvIT.useCallback)((error, elapsedTimeMiliseconds)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, commonProps), {
            eventType: "operational",
            actionSubject: "fetchGrowthRecommendation",
            action: "failed",
            attributes: {
                errorMessage: error,
                elapsedTime: elapsedTimeMiliseconds / 1000
            }
        })).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireRenderGlobalNavProductRecommendationsFailed = (0, $iSvIT.useCallback)((error, errorInfo)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, commonProps), {
            eventType: "operational",
            actionSubject: "renderGlobalNavProductRecommendations",
            action: "failed",
            attributes: {
                errorMessage: error.message,
                stackTrace: errorInfo.componentStack
            }
        })).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    return {
        fireCardClicked: fireCardClicked,
        fireGlobalNavProductRecommendationsViewed: fireGlobalNavProductRecommendationsViewed,
        fireFetchGrowthRecommendationSucceeded: fireFetchGrowthRecommendationSucceeded,
        fireFetchGrowthRecommendationFailed: fireFetchGrowthRecommendationFailed,
        fireRenderGlobalNavProductRecommendationsFailed: fireRenderGlobalNavProductRecommendationsFailed
    };
}

});

parcelRegister("8xSgC", function(module, exports) {

$parcel$export(module.exports, "BaseGrid", function () { return $0e3e8a257ed39bc9$export$194584af1cd4d0df; });
/* base-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");
const $0e3e8a257ed39bc9$export$194584af1cd4d0df = ({ products: products, title: title, isMobile: isMobile })=>{
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    let columns = "1fr 1fr";
    if (gwp7850GlobalNavChangesForTeam25Eu) columns = "1fr 1fr 1fr";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_j6qusb0t _1fqfidpf _1igvidpf _9703idpf _hpnpidpf _15xeidpf _aa9fidpf _1wayidpf _ldybidpf _19vu1hlo _13a6dlk8 _1yuq1nn1 _stho1n44 _24ktgktf _scn3angw _1tkroqnp"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $iSvIT.isValidElement)(title) ? title : /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: `base-products-grid-title ${gwp7850GlobalNavChangesForTeam25Eu ? "base-products-grid-title-3-max" : ""}`,
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _yv0e1mgf _gy1pxy5q _lwlj19bv _d865xy5q _17pfxy5q _llpou2gc _1wm6v77o _3867hkll",
                    `base-products-grid ${gwp7850GlobalNavChangesForTeam25Eu ? "base-products-grid-3-max" : ""}`
                ]),
                "data-testid": "product-grid",
                style: {
                    "--_18l766z": (0, $43MIc.default)(isMobile ? "1fr" : columns)
                },
                children: products
            })
        ]
    });
};

});



parcelRegister("3rvyw", function(module, exports) {

$parcel$export(module.exports, "SkeletonGrid", function () { return $e8a7015eb3b77c75$export$5e6fdfe27f754986; });
/* skeleton-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $8xSgC = parcelRequire("8xSgC");
const $e8a7015eb3b77c75$var$shimmer = null;
const $e8a7015eb3b77c75$var$LoadingSkeleton = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { borderRadius: borderRadius, marginRightPx: marginRightPx, marginTopPx: marginTopPx, marginBottomPx: marginBottomPx, marginLeftPx: marginLeftPx } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "borderRadius",
        "marginRightPx",
        "marginTopPx",
        "marginBottomPx",
        "marginLeftPx"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_10sf6bt": (0, $43MIc.default)(__cmplp.borderRadius),
            "--_10ib6lf": (0, $43MIc.default)(__cmplp.height),
            "--_1vcp0mh": (0, $43MIc.default)(__cmplp.width),
            "--_rd4u3e": (0, $43MIc.default)(__cmplp.marginRightPx, "px"),
            "--_1ukeoag": (0, $43MIc.default)(__cmplp.marginTopPx, "px"),
            "--_998uhw": (0, $43MIc.default)(__cmplp.marginBottomPx, "px"),
            "--_tmcb3z": (0, $43MIc.default)(__cmplp.marginLeftPx, "px")
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_5sag126j _1o51q7pw _tip812c5 _j7hq13pv _1pglp3kn _12vemgnk _bfhk1ezx _1itkjeoh",
            __cmplp.borderRadius ? "_2rko1fbf" : "_2rko1l7b",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1crf",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.marginRightPx ? "_2hwxh3nu" : "_2hwxidpf",
            __cmplp.marginTopPx ? "_19pk4aab" : "_19pkidpf",
            __cmplp.marginBottomPx ? "_otyrfz3k" : "_otyridpf",
            __cmplp.marginLeftPx ? "_18u0g7qm" : "_18u0idpf",
            __cmplp.className
        ])
    }));
});
const $e8a7015eb3b77c75$var$SkeletonTitle = ()=>/*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$LoadingSkeleton, {
        width: "328px",
        height: "16px",
        borderRadius: "3px",
        "data-testid": "skeleton-title"
    });
const $e8a7015eb3b77c75$var$SkeletonItem = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "skeleton-item",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _zulppxbi _1q51xy5q _85i5v47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$LoadingSkeleton, {
                width: "44px",
                height: "44px",
                borderRadius: "3px"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulputpp _1q51u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$LoadingSkeleton, {
                        width: "80px",
                        height: "8px",
                        borderRadius: "3px"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$LoadingSkeleton, {
                        width: "160px",
                        height: "8px",
                        borderRadius: "3px"
                    })
                ]
            })
        ]
    });
const $e8a7015eb3b77c75$export$5e6fdfe27f754986 = ({ numProducts: numProducts, isMobile: isMobile })=>{
    const skeletonProducts = (0, $iSvIT.useMemo)(()=>{
        const products = [];
        for(let i = 0; i < numProducts; i++)products.push(/*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$SkeletonItem, {}, i));
        return products;
    }, [
        numProducts
    ]);
    if (!numProducts) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSgC.BaseGrid), {
        products: skeletonProducts,
        title: /*#__PURE__*/ (0, $loA2J.jsx)($e8a7015eb3b77c75$var$SkeletonTitle, {}),
        isMobile: isMobile
    });
};

});






parcelRegister("gaRIU", function(module, exports) {

$parcel$export(module.exports, "useGlobalNavProductRecommendations", function () { return $1e879137bbbfd431$export$8b2dae449a6aff29; });

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $5wOn9 = parcelRequire("5wOn9");

var $gT02p = parcelRequire("gT02p");

var $hGVCx = parcelRequire("hGVCx");

var $7aVav = parcelRequire("7aVav");
function $1e879137bbbfd431$export$8b2dae449a6aff29() {
    const [isGlobalNavProductRecommendationsExperimentFailed, setIsGlobalNavProductRecommendationsExperimentFailed] = (0, $iSvIT.useState)(false);
    const { isUserLoggedIn: isUserLoggedIn } = (0, $5wOn9.useLoggedInUser)();
    const intl = (0, $f6qj2.default)();
    const hasEnterpriseEdition = (0, $7aVav.useHasEnterpriseEdition)();
    const { getProductRecommendations: getProductRecommendations, isRecommendationLoading: isRecommendationLoading, recommendations: recommendations } = (0, $hGVCx.useFetchRecommendations)();
    const { fireRenderGlobalNavProductRecommendationsFailed: fireRenderGlobalNavProductRecommendationsFailed, fireGlobalNavProductRecommendationsViewed: fireGlobalNavProductRecommendationsViewed } = (0, $gT02p.useAnalytics)();
    const onGlobalNavProductRecommendationsFailed = (0, $iSvIT.useCallback)((error, errorInfo)=>{
        fireRenderGlobalNavProductRecommendationsFailed(error, errorInfo);
        setIsGlobalNavProductRecommendationsExperimentFailed(true);
    }, [
        fireRenderGlobalNavProductRecommendationsFailed
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (isUserLoggedIn && !hasEnterpriseEdition) getProductRecommendations({
            setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed
        });
    }, [
        hasEnterpriseEdition,
        getProductRecommendations,
        isUserLoggedIn
    ]);
    const fireGlobalNavProductRecoEventsWhenInView = (0, $iSvIT.useCallback)(({ isMobile: isMobile })=>{
        try {
            if (isUserLoggedIn && !hasEnterpriseEdition && recommendations.length > 0) fireGlobalNavProductRecommendationsViewed({
                recommendations: recommendations,
                isMobile: isMobile
            });
        } catch (_) {
        // Do nothing
        }
    }, [
        recommendations,
        hasEnterpriseEdition,
        isUserLoggedIn,
        fireGlobalNavProductRecommendationsViewed
    ]);
    /**
   * Show the Global Nav Product Recommendations if the user is eligible, and the recommendations are loaded.
   */ const shouldShowGlobalNavProductRecommendations = (0, $iSvIT.useMemo)(()=>{
        const nonEmptyRecosLoaded = !isRecommendationLoading && recommendations.length > 0;
        const shouldShowByRecommendationState = isRecommendationLoading || nonEmptyRecosLoaded;
        return isUserLoggedIn && shouldShowByRecommendationState && !isGlobalNavProductRecommendationsExperimentFailed && !hasEnterpriseEdition;
    }, [
        hasEnterpriseEdition,
        isGlobalNavProductRecommendationsExperimentFailed,
        isRecommendationLoading,
        isUserLoggedIn,
        recommendations.length
    ]);
    const mobileNavPageLabelFeaturedProducts = (0, $iSvIT.useMemo)(()=>{
        return intl.formatMessage((0, $6x1qA.defineMessage)({
            id: "globalnav.v2.productseveryone.title",
            defaultMessage: "Featured Products"
        }));
    }, [
        intl
    ]);
    return {
        onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed,
        shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations,
        recommendations: recommendations,
        isRecommendationLoading: isRecommendationLoading,
        mobileNavPageLabelFeaturedProducts: mobileNavPageLabelFeaturedProducts,
        fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView
    };
}

});
parcelRegister("hGVCx", function(module, exports) {

$parcel$export(module.exports, "useFetchRecommendations", function () { return $df46a5cc02397299$export$6501da23a2770fc; });

var $iSvIT = parcelRequire("iSvIT");

var $d785O = parcelRequire("d785O");

var $hDrV5 = parcelRequire("hDrV5");

var $gT02p = parcelRequire("gT02p");
const $df46a5cc02397299$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE = "WACGlobalNavProductRecommendation";
function $df46a5cc02397299$export$6501da23a2770fc() {
    const [isRecommendationLoading, setIsRecommendationLoading] = (0, $iSvIT.useState)(false);
    const isRecommendationLoadedRef = (0, $iSvIT.useRef)(false);
    const [recommendations, setRecommendations] = (0, $iSvIT.useState)([]);
    const { fireFetchGrowthRecommendationSucceeded: fireFetchGrowthRecommendationSucceeded, fireFetchGrowthRecommendationFailed: fireFetchGrowthRecommendationFailed } = (0, $gT02p.useAnalytics)();
    const { getRecommendations: getRecommendations } = (0, $d785O.default)({
        endpoint: undefined,
        // use default endpoint
        contextResolver: {
            product: "marketing",
            useCase: $df46a5cc02397299$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE
        }
    });
    const getProductRecommendations = (0, $iSvIT.useCallback)(async ({ setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed })=>{
        if (isRecommendationLoading || isRecommendationLoadedRef.current) return;
        const startTime = performance.now();
        try {
            setIsRecommendationLoading(true);
            const result = await getRecommendations({
                first: (0, $hDrV5.NUM_DISPLAY_RECOMMENDATIONS),
                rerank: $df46a5cc02397299$export$e15fc74c2b3bb267((0, $hDrV5.ccpKeyToProductId)),
                config: {
                    cacheConfig: {
                        ttl: 60
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            if ($df46a5cc02397299$var$isValidResponse(data)) {
                const recommendedProductIds = data.map(({ entityId: entityId })=>entityId);
                setRecommendations(recommendedProductIds);
                const elapsedTime = performance.now() - startTime;
                fireFetchGrowthRecommendationSucceeded(recommendedProductIds, elapsedTime);
                setIsRecommendationLoading(false);
                isRecommendationLoadedRef.current = true;
            } else throw new Error("Invalid response from App Recommendations API");
        } catch (error) {
            const elapsedTime = performance.now() - startTime;
            const errorMessage = error instanceof Error ? error.message : String(error);
            fireFetchGrowthRecommendationFailed(errorMessage, elapsedTime);
            setIsGlobalNavProductRecommendationsExperimentFailed(true);
            setIsRecommendationLoading(false);
            isRecommendationLoadedRef.current = true;
        }
    }, [
        fireFetchGrowthRecommendationFailed,
        fireFetchGrowthRecommendationSucceeded,
        getRecommendations,
        isRecommendationLoading
    ]);
    return {
        getProductRecommendations: getProductRecommendations,
        isRecommendationLoading: isRecommendationLoading,
        recommendations: recommendations
    };
}
const $df46a5cc02397299$export$e15fc74c2b3bb267 = (entities)=>Object.keys(entities).map((key)=>({
            entityId: key
        }));
/**
 * Ensure the response is valid type
 */ const $df46a5cc02397299$var$isValidResponse = (data)=>{
    return Array.isArray(data);
};

});
parcelRegister("d785O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98c234e0638c5ca4$export$2e2bcd8739ae039; });

var $7Rja2 = parcelRequire("7Rja2");

var $iSvIT = parcelRequire("iSvIT");

var $cm1wJ = parcelRequire("cm1wJ");

var $34FOj = parcelRequire("34FOj");

var $4VyWb = parcelRequire("4VyWb");

var $1b2BD = parcelRequire("1b2BD");

var $b5hTF = parcelRequire("b5hTF");
function $98c234e0638c5ca4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98c234e0638c5ca4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98c234e0638c5ca4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7Rja2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98c234e0638c5ca4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98c234e0638c5ca4$var$useRecommendations = function useRecommendations(_ref) {
    var _ref$endpoint = _ref.endpoint, endpoint = _ref$endpoint === void 0 ? "/gateway/api/graphql" : _ref$endpoint, contextResolver = _ref.contextResolver;
    /**
   * Fetch recommendations for a given context
   */ var getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useCallback(function(args) {
        var deprecatedRerank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        var _ref2 = typeof args === "number" ? {
            first: args,
            rerank: deprecatedRerank
        } : args, first = _ref2.first, rerank = _ref2.rerank, _ref2$config = _ref2.config, _ref2$config2 = _ref2$config === void 0 ? {
            cacheConfig: undefined
        } : _ref2$config, cacheConfig = _ref2$config2.cacheConfig;
        var recommendationRequestMaker = new (0, $4VyWb.default)(endpoint);
        var requester = new (0, $b5hTF.default)(new (0, $1b2BD.RecommendationsRequestBroker)());
        var context = (0, $34FOj.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? $98c234e0638c5ca4$var$_objectSpread($98c234e0638c5ca4$var$_objectSpread({}, cacheConfig), {}, {
                cacheName: (0, $cm1wJ.CACHE_NAME),
                useCase: context.useCase
            }) : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $98c234e0638c5ca4$export$2e2bcd8739ae039 = $98c234e0638c5ca4$var$useRecommendations;

});
parcelRegister("7Rja2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b8c58959174adf9$export$2e2bcd8739ae039; });

var $eGLf6 = parcelRequire("eGLf6");
function $5b8c58959174adf9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $eGLf6.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("eGLf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab19a259ff1985ec$export$2e2bcd8739ae039; });

var $3Ccsu = parcelRequire("3Ccsu");

var $Dtm18 = parcelRequire("Dtm18");
function $ab19a259ff1985ec$export$2e2bcd8739ae039(t) {
    var i = (0, $Dtm18.default)(t, "string");
    return "symbol" == (0, $3Ccsu.default)(i) ? i : i + "";
}

});
parcelRegister("3Ccsu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a1e95b05917384c$export$2e2bcd8739ae039; });
function $2a1e95b05917384c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2a1e95b05917384c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a1e95b05917384c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("Dtm18", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $076a69bfd44171e2$export$2e2bcd8739ae039; });

var $3Ccsu = parcelRequire("3Ccsu");
function $076a69bfd44171e2$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $3Ccsu.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $3Ccsu.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cm1wJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_NAME", function () { return $8fe8b94dc86b1bd8$export$14b7e2c312f27acd; });
// Events
var $8fe8b94dc86b1bd8$export$38f20466f22f45f0 = "CLICK_PRIVACY_POLICY_LINK";
var $8fe8b94dc86b1bd8$export$836f30b3a88d4259 = "UNDO_DISMISSAL_STARTED";
var $8fe8b94dc86b1bd8$export$5ee3f53555c01a95 = "UNDO_DISMISSAL_SUCCEEDED";
var $8fe8b94dc86b1bd8$export$eebf6a2671000e28 = "UNDO_DISMISSAL_FAILED";
var $8fe8b94dc86b1bd8$export$14b7e2c312f27acd = "atlassian-growth-recos";

});

parcelRegister("34FOj", function(module, exports) {

$parcel$export(module.exports, "getContext", function () { return $23d22d83fa1c3001$export$31553aaa555c1514; });

var $3Ccsu = parcelRequire("3Ccsu");
function $23d22d83fa1c3001$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === "") return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if ((0, $3Ccsu.default)(value) === "object" && Object.keys(value).length === 0) return false;
    return true;
}
function $23d22d83fa1c3001$export$31553aaa555c1514(contextResolver) {
    var checkUseCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var context = typeof contextResolver === "function" ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof (context === null || context === void 0 ? void 0 : context.useCase) !== "string" || (context === null || context === void 0 ? void 0 : context.useCase.trim().length) === 0)) throw new Error("useCase is required");
    return context;
}

});

parcelRegister("4VyWb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39679626d3bdce9c$export$2e2bcd8739ae039; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $jHJ7u = parcelRequire("jHJ7u");

var $4oXuQ = parcelRequire("4oXuQ");

var $3Ge7Y = parcelRequire("3Ge7Y");

var $c43iU = parcelRequire("c43iU");
function $39679626d3bdce9c$var$_callSuper(t, o, e) {
    return o = (0, $4oXuQ.default)(o), (0, $jHJ7u.default)(t, $39679626d3bdce9c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4oXuQ.default)(t).constructor) : o.apply(t, e));
}
function $39679626d3bdce9c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($39679626d3bdce9c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $39679626d3bdce9c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_RequestMaker) {
    function RecommendationsRequestMaker() {
        (0, $kVo9i.default)(this, RecommendationsRequestMaker);
        return $39679626d3bdce9c$var$_callSuper(this, RecommendationsRequestMaker, arguments);
    }
    (0, $3Ge7Y.default)(RecommendationsRequestMaker, _RequestMaker);
    return (0, $cmLzG.default)(RecommendationsRequestMaker, [
        {
            key: "makeRequest",
            value: function makeRequest(makeRequestParams) {
                var contextResolver = makeRequestParams.contextResolver, first = makeRequestParams.first, rerank = makeRequestParams.rerank;
                return new Request(this.endpoint, {
                    method: "POST",
                    credentials: "include",
                    mode: "cors",
                    headers: this.getHeaders(),
                    body: JSON.stringify({
                        query: $39679626d3bdce9c$var$recommendationsQuery,
                        variables: {
                            first: first,
                            context: this.getContext(contextResolver),
                            rerank: rerank
                        }
                    })
                });
            }
        }
    ]);
}((0, $c43iU.default));
var $39679626d3bdce9c$var$recommendationsQuery = "\nquery GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {\n  growthRecommendations {\n    recommendations(context: $context, first: $first, rerank: $rerank) {\n      ... on GrowthRecRecommendations {\n        __typename\n        data {\n          __typename\n          entityId\n          reasons\n        }\n      }\n      ... on QueryError {\n        __typename\n        identifier\n        message\n        extensions {\n          __typename\n          statusCode\n          errorType\n        }\n      }\n    }\n  }\n}\n";

});
parcelRegister("kVo9i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3bbdd032f8ad709$export$2e2bcd8739ae039; });
function $f3bbdd032f8ad709$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cmLzG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $900c71663491b5b9$export$2e2bcd8739ae039; });

var $eGLf6 = parcelRequire("eGLf6");
function $900c71663491b5b9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $eGLf6.default)(o.key), o);
    }
}
function $900c71663491b5b9$export$2e2bcd8739ae039(e, r, t) {
    return r && $900c71663491b5b9$var$_defineProperties(e.prototype, r), t && $900c71663491b5b9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("jHJ7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e585084e04ff904c$export$2e2bcd8739ae039; });

var $3Ccsu = parcelRequire("3Ccsu");

var $6CShY = parcelRequire("6CShY");
function $e585084e04ff904c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $3Ccsu.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $6CShY.default)(t);
}

});
parcelRegister("6CShY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d306751d5c12d79$export$2e2bcd8739ae039; });
function $4d306751d5c12d79$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("4oXuQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33478e0eb8b219af$export$2e2bcd8739ae039; });
function $33478e0eb8b219af$export$2e2bcd8739ae039(t) {
    return $33478e0eb8b219af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $33478e0eb8b219af$export$2e2bcd8739ae039(t);
}

});

parcelRegister("3Ge7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae040c9307b7a3b$export$2e2bcd8739ae039; });

var $l7Fku = parcelRequire("l7Fku");
function $2ae040c9307b7a3b$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $l7Fku.default)(t, e);
}

});
parcelRegister("l7Fku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60a4f96d251237a$export$2e2bcd8739ae039; });
function $f60a4f96d251237a$export$2e2bcd8739ae039(t, e) {
    return $f60a4f96d251237a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f60a4f96d251237a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("c43iU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c886bd902982406$export$2e2bcd8739ae039; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $34FOj = parcelRequire("34FOj");
var $8c886bd902982406$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RequestMaker(endpoint) {
        (0, $kVo9i.default)(this, RequestMaker);
        this.endpoint = endpoint;
    }
    return (0, $cmLzG.default)(RequestMaker, [
        {
            key: "getHeaders",
            value: function getHeaders() {
                var headers = new Headers();
                headers.append("Content-Type", "application/json");
                return headers;
            }
        },
        {
            key: "getContext",
            value: function getContext(contextResolver) {
                return (0, $34FOj.getContext)(contextResolver);
            }
        }
    ]);
}();

});


parcelRegister("1b2BD", function(module, exports) {

$parcel$export(module.exports, "RecommendationsRequestBroker", function () { return $0db8d700714bd26f$export$7f19312509e0d2c0; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $1qPQ2 = parcelRequire("1qPQ2");
var $0db8d700714bd26f$export$7f19312509e0d2c0 = /*#__PURE__*/ function() {
    function RecommendationsRequestBroker() {
        (0, $kVo9i.default)(this, RecommendationsRequestBroker);
    }
    return (0, $cmLzG.default)(RecommendationsRequestBroker, [
        {
            key: "extract",
            value: function extract(response) {
                var _response$recommendat, _response$recommendat2;
                return (_response$recommendat = response === null || response === void 0 || (_response$recommendat2 = response.recommendations) === null || _response$recommendat2 === void 0 ? void 0 : _response$recommendat2.data) !== null && _response$recommendat !== void 0 ? _response$recommendat : [];
            }
        },
        {
            key: "getSuccessResultCreator",
            value: function getSuccessResultCreator(response, result) {
                return new (0, $1qPQ2.RecommendationSuccessResultCreator)(response, result);
            }
        }
    ]);
}();

});
parcelRegister("1qPQ2", function(module, exports) {

$parcel$export(module.exports, "RecommendationSuccessResultCreator", function () { return $10b06e2542c337a1$export$c02f0b31b3b527a3; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $jHJ7u = parcelRequire("jHJ7u");

var $4oXuQ = parcelRequire("4oXuQ");

var $3Ge7Y = parcelRequire("3Ge7Y");

var $8UIky = parcelRequire("8UIky");
function $10b06e2542c337a1$var$_callSuper(t, o, e) {
    return o = (0, $4oXuQ.default)(o), (0, $jHJ7u.default)(t, $10b06e2542c337a1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4oXuQ.default)(t).constructor) : o.apply(t, e));
}
function $10b06e2542c337a1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($10b06e2542c337a1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $10b06e2542c337a1$export$c02f0b31b3b527a3 = /*#__PURE__*/ function(_QuerySuccessResultCr) {
    function RecommendationSuccessResultCreator(response, data) {
        var _this;
        (0, $kVo9i.default)(this, RecommendationSuccessResultCreator);
        _this = $10b06e2542c337a1$var$_callSuper(this, RecommendationSuccessResultCreator, [
            response,
            data
        ]);
        _this.response = response;
        return _this;
    }
    (0, $3Ge7Y.default)(RecommendationSuccessResultCreator, _QuerySuccessResultCr);
    return (0, $cmLzG.default)(RecommendationSuccessResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new (0, $8UIky.GraphQlQueryResult)(this.response.status, this.response.statusText, {
                    data: this.data
                });
            }
        }
    ]);
}((0, $8UIky.QuerySuccessResultCreator));

});
parcelRegister("8UIky", function(module, exports) {

$parcel$export(module.exports, "GraphQlQueryResult", function () { return $67d5f0d4a45bea0c$export$d0a1abfd57dc5018; });
$parcel$export(module.exports, "NonOkQueryResultCreator", function () { return $67d5f0d4a45bea0c$export$ad7cb7f4450dd7c4; });
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", function () { return $67d5f0d4a45bea0c$export$553722ecbbe27276; });
$parcel$export(module.exports, "MissingQueryDataResultCreator", function () { return $67d5f0d4a45bea0c$export$ff264bfdc9a404eb; });
$parcel$export(module.exports, "QuerySuccessResultCreator", function () { return $67d5f0d4a45bea0c$export$6b16771e962990ff; });

var $eoEAu = parcelRequire("eoEAu");

var $jHJ7u = parcelRequire("jHJ7u");

var $4oXuQ = parcelRequire("4oXuQ");

var $3Ge7Y = parcelRequire("3Ge7Y");

var $cmLzG = parcelRequire("cmLzG");

var $kVo9i = parcelRequire("kVo9i");
function $67d5f0d4a45bea0c$var$_callSuper(t, o, e) {
    return o = (0, $4oXuQ.default)(o), (0, $jHJ7u.default)(t, $67d5f0d4a45bea0c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4oXuQ.default)(t).constructor) : o.apply(t, e));
}
function $67d5f0d4a45bea0c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($67d5f0d4a45bea0c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $67d5f0d4a45bea0c$export$d0a1abfd57dc5018 = /*#__PURE__*/ (0, $cmLzG.default)(function GraphQlQueryResult(code, reason, response) {
    (0, $kVo9i.default)(this, GraphQlQueryResult);
    this.code = code;
    this.reason = reason;
    this.response = response;
});
var $67d5f0d4a45bea0c$var$QueryResultCreator = /*#__PURE__*/ (0, $cmLzG.default)(function QueryResultCreator() {
    (0, $kVo9i.default)(this, QueryResultCreator);
});
var $67d5f0d4a45bea0c$export$ad7cb7f4450dd7c4 = /*#__PURE__*/ function(_QueryResultCreator) {
    function NonOkQueryResultCreator(fetchResponse) {
        var _this;
        (0, $kVo9i.default)(this, NonOkQueryResultCreator);
        _this = $67d5f0d4a45bea0c$var$_callSuper(this, NonOkQueryResultCreator);
        _this.fetchResponse = fetchResponse;
        return _this;
    }
    (0, $3Ge7Y.default)(NonOkQueryResultCreator, _QueryResultCreator);
    return (0, $cmLzG.default)(NonOkQueryResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $67d5f0d4a45bea0c$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
            }
        }
    ]);
}($67d5f0d4a45bea0c$var$QueryResultCreator);
var $67d5f0d4a45bea0c$export$553722ecbbe27276 = /*#__PURE__*/ function(_QueryResultCreator2) {
    function GeneralQueryErrorResultCreator(errors) {
        var _this2;
        (0, $kVo9i.default)(this, GeneralQueryErrorResultCreator);
        _this2 = $67d5f0d4a45bea0c$var$_callSuper(this, GeneralQueryErrorResultCreator);
        _this2.errors = errors;
        return _this2;
    }
    (0, $3Ge7Y.default)(GeneralQueryErrorResultCreator, _QueryResultCreator2);
    return (0, $cmLzG.default)(GeneralQueryErrorResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                var _this$errors = (0, $eoEAu.default)(this.errors, 1), extensions = _this$errors[0].extensions;
                var _ref = Array.isArray(extensions) ? extensions : [
                    extensions
                ], _ref2 = (0, $eoEAu.default)(_ref, 1), _ref2$ = _ref2[0], statusCode = _ref2$.statusCode, errorType = _ref2$.errorType;
                return new $67d5f0d4a45bea0c$export$d0a1abfd57dc5018(statusCode, errorType, {
                    errors: this.errors.map(function(error) {
                        return error.message;
                    })
                });
            }
        }
    ]);
}($67d5f0d4a45bea0c$var$QueryResultCreator);
var $67d5f0d4a45bea0c$export$ff264bfdc9a404eb = /*#__PURE__*/ function(_QueryResultCreator3) {
    function MissingQueryDataResultCreator(fetchResponse) {
        var _this3;
        (0, $kVo9i.default)(this, MissingQueryDataResultCreator);
        _this3 = $67d5f0d4a45bea0c$var$_callSuper(this, MissingQueryDataResultCreator);
        _this3.fetchResponse = fetchResponse;
        return _this3;
    }
    (0, $3Ge7Y.default)(MissingQueryDataResultCreator, _QueryResultCreator3);
    return (0, $cmLzG.default)(MissingQueryDataResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $67d5f0d4a45bea0c$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
                    errors: [
                        "Received data has missing attributes"
                    ]
                });
            }
        }
    ]);
}($67d5f0d4a45bea0c$var$QueryResultCreator);
var $67d5f0d4a45bea0c$export$6b16771e962990ff = /*#__PURE__*/ function(_QueryResultCreator4) {
    function QuerySuccessResultCreator(response, data) {
        var _this4;
        (0, $kVo9i.default)(this, QuerySuccessResultCreator);
        _this4 = $67d5f0d4a45bea0c$var$_callSuper(this, QuerySuccessResultCreator);
        _this4.response = response;
        _this4.data = data;
        return _this4;
    }
    (0, $3Ge7Y.default)(QuerySuccessResultCreator, _QueryResultCreator4);
    return (0, $cmLzG.default)(QuerySuccessResultCreator);
}($67d5f0d4a45bea0c$var$QueryResultCreator);

});
parcelRegister("eoEAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7b2ca69fc40048c$export$2e2bcd8739ae039; });

var $bqYqb = parcelRequire("bqYqb");

var $1kHl6 = parcelRequire("1kHl6");

var $j3Enl = parcelRequire("j3Enl");

var $9TUPA = parcelRequire("9TUPA");
function $a7b2ca69fc40048c$export$2e2bcd8739ae039(r, e) {
    return (0, $bqYqb.default)(r) || (0, $1kHl6.default)(r, e) || (0, $j3Enl.default)(r, e) || (0, $9TUPA.default)();
}

});
parcelRegister("bqYqb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8530fdd6927addf7$export$2e2bcd8739ae039; });
function $8530fdd6927addf7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("1kHl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f8946ff1b546edf$export$2e2bcd8739ae039; });
function $0f8946ff1b546edf$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("j3Enl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddfd9dde27709a7d$export$2e2bcd8739ae039; });

var $ijxMZ = parcelRequire("ijxMZ");
function $ddfd9dde27709a7d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $ijxMZ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $ijxMZ.default)(r, a) : void 0;
    }
}

});
parcelRegister("ijxMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5543630e0f93658$export$2e2bcd8739ae039; });
function $d5543630e0f93658$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9TUPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7355558e6c0eb14d$export$2e2bcd8739ae039; });
function $7355558e6c0eb14d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});





parcelRegister("b5hTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $811e0b4bc19e18d9$export$2e2bcd8739ae039; });

var $7BOMl = parcelRequire("7BOMl");

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $7Bj2z = parcelRequire("7Bj2z");

var $8UIky = parcelRequire("8UIky");

var $aEgw7 = parcelRequire("aEgw7");
/** The requester to make query operation to App Recommendations API via AGG
 *
 * Currently, App Recommendations Service has only a single query (and we only use a single query), which doesn't return any Query errors
 * @see {@link https://developer.atlassian.com/platform/graphql-gateway/standards/query-error/} for more about query errors
 * The query error checking is skipped for now, but it can be added in the future if needed
 */ var $811e0b4bc19e18d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Requester(broker) {
        (0, $kVo9i.default)(this, Requester);
        this.broker = broker;
    }
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ return (0, $cmLzG.default)(Requester, [
        {
            key: "fetch",
            value: function fetch1(request) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, cacheConfig = _ref.cacheConfig;
                return new Promise(/*#__PURE__*/ function() {
                    var _ref2 = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee(resolve, reject) {
                        var _json$data;
                        var response, json, schemaResponse, queryRes;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return _this.getResponse(request, cacheConfig);
                                case 2:
                                    response = _context.sent;
                                    if (response.ok) {
                                        _context.next = 5;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $8UIky.NonOkQueryResultCreator)(response).makeQueryResult()));
                                case 5:
                                    _context.next = 7;
                                    return response.json();
                                case 7:
                                    json = _context.sent;
                                    if (!json.errors) {
                                        _context.next = 10;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $8UIky.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult()));
                                case 10:
                                    schemaResponse = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.growthRecommendations;
                                    queryRes = _this.broker.extract(schemaResponse); // Undefined is not expected as a valid response from GraphQL
                                    if (!(queryRes === undefined)) {
                                        _context.next = 14;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $8UIky.MissingQueryDataResultCreator)(response).makeQueryResult()));
                                case 14:
                                    return _context.abrupt("return", resolve(_this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult()));
                                case 15:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return function(_x, _x2) {
                        return _ref2.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "getResponse",
            value: function() {
                var _getResponse = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee2(request, cacheConfig) {
                    var cacheProvider, cachedResponse, clonedRequest;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                cacheProvider = (0, $aEgw7.default).resolve(cacheConfig);
                                _context2.next = 3;
                                return cacheProvider.get(request);
                            case 3:
                                cachedResponse = _context2.sent;
                                if (!cachedResponse) {
                                    _context2.next = 6;
                                    break;
                                }
                                return _context2.abrupt("return", cachedResponse);
                            case 6:
                                // Clone the request before it being used to be able to use it multiple times
                                clonedRequest = request.clone();
                                return _context2.abrupt("return", fetch(request).then(function(response) {
                                    // Cache response only if the response is ok
                                    if (response.ok) cacheProvider.set(clonedRequest, response.clone());
                                    return response;
                                }));
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getResponse(_x3, _x4) {
                    return _getResponse.apply(this, arguments);
                }
                return getResponse;
            }()
        }
    ]);
}();

});
parcelRegister("7BOMl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58a360b9a51f91ef$export$2e2bcd8739ae039; });
function $58a360b9a51f91ef$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $58a360b9a51f91ef$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $58a360b9a51f91ef$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $58a360b9a51f91ef$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("7Bj2z", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $588ac220f1e81e1b$var$runtime = (parcelRequire("18Ufu"))();
module.exports = $588ac220f1e81e1b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $588ac220f1e81e1b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $588ac220f1e81e1b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($588ac220f1e81e1b$var$runtime);
}

});
parcelRegister("18Ufu", function(module, exports) {

var $2g2QZ = parcelRequire("2g2QZ");

var $9t0aT = parcelRequire("9t0aT");

var $fcP5k = parcelRequire("fcP5k");

var $1bLHZ = parcelRequire("1bLHZ");

var $7tSpt = parcelRequire("7tSpt");

var $lH1lj = parcelRequire("lH1lj");

var $389KB = parcelRequire("389KB");
function $0d522ba8b520f27b$var$_regeneratorRuntime() {
    "use strict";
    var r = $9t0aT(), e = r.m($0d522ba8b520f27b$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $389KB(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $0d522ba8b520f27b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $2g2QZ(r, e);
            },
            AsyncIterator: $7tSpt,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $1bLHZ : $fcP5k)(a(r), e, t, o, u);
            },
            keys: $lH1lj,
            values: $389KB
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $0d522ba8b520f27b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2g2QZ", function(module, exports) {
function $1a4f4a171bc85315$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $1a4f4a171bc85315$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9t0aT", function(module, exports) {

var $94X9i = parcelRequire("94X9i");
function $6e46f534ba2de5f4$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $94X9i(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($94X9i(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $94X9i(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $94X9i(u, "constructor", GeneratorFunctionPrototype), $94X9i(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $94X9i(GeneratorFunctionPrototype, o, "GeneratorFunction"), $94X9i(u), $94X9i(u, o, "Generator"), $94X9i(u, n, function() {
        return this;
    }), $94X9i(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $6e46f534ba2de5f4$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $6e46f534ba2de5f4$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("94X9i", function(module, exports) {
function $69c25e880bb673f4$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $69c25e880bb673f4$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $69c25e880bb673f4$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $69c25e880bb673f4$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $69c25e880bb673f4$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fcP5k", function(module, exports) {

var $1bLHZ = parcelRequire("1bLHZ");
function $b11f9a6998a16ffd$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $1bLHZ(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $b11f9a6998a16ffd$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1bLHZ", function(module, exports) {

var $9t0aT = parcelRequire("9t0aT");

var $7tSpt = parcelRequire("7tSpt");
function $0ddbd3766ddaaf79$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $7tSpt($9t0aT().w(r, e, t, o), n || Promise);
}
module.exports = $0ddbd3766ddaaf79$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7tSpt", function(module, exports) {

var $2g2QZ = parcelRequire("2g2QZ");

var $94X9i = parcelRequire("94X9i");
function $57257280a7573697$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $2g2QZ ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($94X9i($57257280a7573697$var$AsyncIterator.prototype), $94X9i($57257280a7573697$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $94X9i(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $57257280a7573697$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("lH1lj", function(module, exports) {
function $fcaea7c7e3cde630$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $fcaea7c7e3cde630$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("389KB", function(module, exports) {

var $5cJ9D = parcelRequire("5cJ9D");
var $2479aebed8480ff2$var$_typeof = $5cJ9D.default;
function $2479aebed8480ff2$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($2479aebed8480ff2$var$_typeof(e) + " is not iterable");
}
module.exports = $2479aebed8480ff2$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5cJ9D", function(module, exports) {
function $3ca1197a0eacb563$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3ca1197a0eacb563$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3ca1197a0eacb563$var$_typeof(o);
}
module.exports = $3ca1197a0eacb563$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("aEgw7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c0a73c47b7bb42f$export$2e2bcd8739ae039; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $gfUut = parcelRequire("gfUut");

var $3UQY2 = parcelRequire("3UQY2");
var $7c0a73c47b7bb42f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ResponseCacheProviderResolver() {
        (0, $kVo9i.default)(this, ResponseCacheProviderResolver);
    }
    return (0, $cmLzG.default)(ResponseCacheProviderResolver, null, [
        {
            key: "resolve",
            value: /**
     * Returns the cache provider based on the given cache configuration
     *
     * @param cacheConfig The cache configuration to use
     * @returns The cache provider
     */ function resolve(cacheConfig) {
                if (cacheConfig) return new (0, $3UQY2.default)(cacheConfig);
                return new (0, $gfUut.default)();
            }
        }
    ]);
}();

});
parcelRegister("gfUut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd59dde882b8a708$export$2e2bcd8739ae039; });

var $7BOMl = parcelRequire("7BOMl");

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $7Bj2z = parcelRequire("7Bj2z");
var $bd59dde882b8a708$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NoCache() {
        (0, $kVo9i.default)(this, NoCache);
    }
    return (0, $cmLzG.default)(NoCache, [
        {
            key: "get",
            value: function() {
                var _get = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", undefined);
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee2(request, response) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return");
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee3(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", true);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        }
    ]);
}();

});

parcelRegister("3UQY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d9fb044c55aef7b$export$2e2bcd8739ae039; });

var $7BOMl = parcelRequire("7BOMl");

var $3Ccsu = parcelRequire("3Ccsu");

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $7Bj2z = parcelRequire("7Bj2z");

var $e9H8v = parcelRequire("e9H8v");

var $adY3h = parcelRequire("adY3h");
var $2d9fb044c55aef7b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Whether the Cache API is supported
   */ /**
   * Expiry storage
   */ /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ function WebCacheStorage(cacheProviderConfig) {
        (0, $kVo9i.default)(this, WebCacheStorage);
        this.supported = (typeof caches === "undefined" ? "undefined" : (0, $3Ccsu.default)(caches)) === "object" && typeof caches.open === "function";
        this.cacheConfig = new (0, $e9H8v.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $adY3h.default)(this.cacheConfig);
    }
    /**
   * Get cached response
   */ return (0, $cmLzG.default)(WebCacheStorage, [
        {
            key: "get",
            value: function() {
                var _get = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee(request) {
                    var cache, expired;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.supported) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", undefined);
                            case 2:
                                _context.prev = 2;
                                _context.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context.sent;
                                _context.next = 8;
                                return this.isExpired(request);
                            case 8:
                                expired = _context.sent;
                                if (!expired) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 12;
                                return this.delete(request);
                            case 12:
                                return _context.abrupt("return", undefined);
                            case 13:
                                return _context.abrupt("return", cache.match(this.getCacheKey(request)));
                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](2);
                                this.cacheConfig.onError(_context.t0);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            16
                        ]
                    ]);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee2(request, response) {
                    var cache, expiryDate;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.supported) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return");
                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context2.sent;
                                expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
                                _context2.next = 9;
                                return this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
                            case 9:
                                _context2.next = 11;
                                return cache.put(this.getCacheKey(request), response);
                            case 11:
                                _context2.next = 16;
                                break;
                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2["catch"](2);
                                this.cacheConfig.onError(_context2.t0);
                            case 16:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            2,
                            13
                        ]
                    ]);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee4(request) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (this.supported) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt("return", true);
                            case 2:
                                _context4.prev = 2;
                                return _context4.abrupt("return", caches.open(this.cacheConfig.cacheName).then(/*#__PURE__*/ function() {
                                    var _ref = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee3(cache) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee3$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    _context3.next = 2;
                                                    return cache.delete(_this.getCacheKey(request));
                                                case 2:
                                                    _context3.next = 4;
                                                    return _this.expiryStorage.deleteExpiry(_this.getStoreKey(request));
                                                case 4:
                                                    return _context3.abrupt("return", true);
                                                case 5:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _callee3);
                                    }));
                                    return function(_x5) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 6:
                                _context4.prev = 6;
                                _context4.t0 = _context4["catch"](2);
                                this.cacheConfig.onError(_context4.t0);
                                return _context4.abrupt("return", false);
                            case 10:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            2,
                            6
                        ]
                    ]);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        },
        {
            key: "isExpired",
            value: function() {
                var _isExpired = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee5(request) {
                    var key, expiry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                key = this.getStoreKey(request);
                                _context5.next = 4;
                                return this.expiryStorage.getExpiry(key);
                            case 4:
                                expiry = _context5.sent;
                                return _context5.abrupt("return", Date.now() > (expiry !== null && expiry !== void 0 ? expiry : 0));
                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5["catch"](0);
                                this.cacheConfig.onError(_context5.t0 instanceof Error ? _context5.t0 : new Error("Error checking expiry"));
                                return _context5.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function isExpired(_x6) {
                    return _isExpired.apply(this, arguments);
                }
                return isExpired;
            }()
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(request) {
                var url = new URL(request.url);
                url.searchParams.set("useCase", this.cacheConfig.useCase);
                return url;
            }
        },
        {
            key: "getStoreKey",
            value: function getStoreKey(request) {
                return this.getCacheKey(request).toString();
            }
        }
    ]);
}();

});
parcelRegister("e9H8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e35de48a6319a8$export$2e2bcd8739ae039; });

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");
var $a4e35de48a6319a8$var$DEFAULT_TTL = 60;
var $a4e35de48a6319a8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CacheConfig(cacheProviderConfig) {
        (0, $kVo9i.default)(this, CacheConfig);
        this.cacheProviderConfig = cacheProviderConfig;
    }
    return (0, $cmLzG.default)(CacheConfig, [
        {
            key: "cacheName",
            get: function get() {
                return this.cacheProviderConfig.cacheName;
            }
        },
        {
            key: "useCase",
            get: function get() {
                return this.cacheProviderConfig.useCase;
            }
        },
        {
            key: "ttl",
            get: function get() {
                var _this$cacheProviderCo;
                return (_this$cacheProviderCo = this.cacheProviderConfig.ttl) !== null && _this$cacheProviderCo !== void 0 ? _this$cacheProviderCo : $a4e35de48a6319a8$var$DEFAULT_TTL;
            }
        },
        {
            key: "onError",
            get: function get() {
                var _this$cacheProviderCo2;
                return (_this$cacheProviderCo2 = this.cacheProviderConfig.onError) !== null && _this$cacheProviderCo2 !== void 0 ? _this$cacheProviderCo2 : function() {};
            }
        }
    ]);
}();

});

parcelRegister("adY3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7719b357ef4cdeac$export$2e2bcd8739ae039; });

var $7BOMl = parcelRequire("7BOMl");

var $kVo9i = parcelRequire("kVo9i");

var $cmLzG = parcelRequire("cmLzG");

var $7Rja2 = parcelRequire("7Rja2");

var $7Bj2z = parcelRequire("7Bj2z");
/**
 * Expiry storage that stores the expiry date of the cached response
 */ var $7719b357ef4cdeac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Initialise the ExpiryStorage
   */ function ExpiryStorage(cacheConfig) {
        (0, $kVo9i.default)(this, ExpiryStorage);
        (0, $7Rja2.default)(this, "expiryStoreName", "expiries");
        this.cacheConfig = cacheConfig;
    }
    /**
   * Set the expiry date of the cached response
   */ return (0, $cmLzG.default)(ExpiryStorage, [
        {
            key: "setExpiry",
            value: function() {
                var _setExpiry = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee(key, expireAt) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this.getObjectStore(dbRequest, "readwrite");
                                        store.put(expireAt, key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function setExpiry(_x, _x2) {
                    return _setExpiry.apply(this, arguments);
                }
                return setExpiry;
            }()
        },
        {
            key: "getExpiry",
            value: function() {
                var _getExpiry = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee2(key) {
                    var _this2 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this2.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this2.getObjectStore(dbRequest, "readonly");
                                        var storeRequest = store.get(key);
                                        storeRequest.onsuccess = function() {
                                            var _storeRequest$result;
                                            resolve(Number((_storeRequest$result = storeRequest.result) !== null && _storeRequest$result !== void 0 ? _storeRequest$result : 0));
                                        };
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getExpiry(_x3) {
                    return _getExpiry.apply(this, arguments);
                }
                return getExpiry;
            }()
        },
        {
            key: "deleteExpiry",
            value: function() {
                var _deleteExpiry = (0, $7BOMl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).mark(function _callee3(key) {
                    var _this3 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Bj2z))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this3.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this3.getObjectStore(dbRequest, "readwrite");
                                        store.delete(key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function deleteExpiry(_x4) {
                    return _deleteExpiry.apply(this, arguments);
                }
                return deleteExpiry;
            }()
        },
        {
            key: "initDb",
            value: function initDb() {
                var _this4 = this;
                var dbRequest = indexedDB.open("".concat(this.cacheConfig.cacheName, "-expiry"));
                dbRequest.onupgradeneeded = function() {
                    var db = dbRequest.result;
                    db.createObjectStore(_this4.expiryStoreName);
                };
                return dbRequest;
            }
        },
        {
            key: "getObjectStore",
            value: function getObjectStore(dbRequest) {
                var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "readwrite";
                var db = dbRequest.result;
                return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
            }
        }
    ]);
}();

});






parcelRegister("7aVav", function(module, exports) {

$parcel$export(module.exports, "useHasEnterpriseEdition", function () { return $c869d8f5646118bc$export$d412e290bea9bfac; });

var $iSvIT = parcelRequire("iSvIT");

var $4himv = parcelRequire("4himv");
function $c869d8f5646118bc$export$d412e290bea9bfac() {
    const { sites: sites = [] } = (0, $4himv.useSitesContext)();
    const hasEnterpriseEdition = (0, $iSvIT.useMemo)(()=>sites.some((site)=>{
            var _site_edition;
            return ((_site_edition = site.edition) === null || _site_edition === void 0 ? void 0 : _site_edition.toLowerCase()) === "enterprise";
        }), [
        sites
    ]);
    return hasEnterpriseEdition;
}

});



parcelRegister("6KyF0", function(module, exports) {

$parcel$export(module.exports, "useMore", function () { return $4e30be277edd2fe5$export$d4ac5645cddd37f3; });

var $iSvIT = parcelRequire("iSvIT");
function $4e30be277edd2fe5$var$isElementNode(node) {
    return node.nodeType === 1;
}
/**
 * @description Calculates the max number of links can live in the global nav before having to render the 'show more' button
 *
 * It calculates the available width by comparing the distance between the 2 refs:
 * Left: <GlobalNavLinksContainer />
 * Right: <SearchAndProfile />
 *
 * It steps through all the children of the global nav links containers (children being the links).
 * On each loop it checks if the sum is greater than the availableWidth.
 *
 * If it is greater than the available width, then spit out the previous count as max children
 *
 * @param left Right element of global nav (<GlobalNavLinksContainer />)
 * @param right Right element of global nav (<SearchAndProfile />)
 * @param currentMaxChildren
 * @param buffer number of pixels to shrink available width by
 * @returns number of links that can be displayed in global nav bar
 */ // eslint-disable-next-line complexity
function $4e30be277edd2fe5$var$calculateMaxChildren(left, right, currentMaxChildren, buffer) {
    if (!left.current || !right.current) return 0;
    // with rewrite of global nav (JFIND-1024) it no longer uses gap but padding so this uses the default of 0px
    // if padding is changed so will the fallback number for it to accurately calculate maxChildren
    const unparsedGap = getComputedStyle(left.current).gap;
    const gap = unparsedGap.endsWith("px") ? parseInt(unparsedGap) : unparsedGap.endsWith("rem") ? parseInt(unparsedGap) * 16 : 0;
    // remove the More/Less button
    const totalChildren = left.current.childNodes.length - 1;
    const { right: leftElRight, left: leftElLeft } = left.current.getBoundingClientRect();
    const { left: rightElLeft } = right.current.getBoundingClientRect();
    // the more/less element is always the last element child
    const moreOrLessElement = left.current.lastElementChild;
    // if the current max is less than the total possible children,
    // we're hiding some and showing More+
    const moreOrLessVisible = currentMaxChildren < totalChildren;
    // skip calculation if the screen is large enough to hold both
    // sections plus the buffer
    if (rightElLeft - leftElRight >= buffer && !moreOrLessVisible) return totalChildren;
    // how large can the UList be for the links
    const availableWidth = rightElLeft - leftElLeft - buffer;
    let currentMaxWidth = 0;
    let maxChildren = 0;
    for (const [index, node] of left.current.childNodes.entries()){
        var _node_nextElementSibling;
        // skip non-element children; we shouldn't need this
        if (!$4e30be277edd2fe5$var$isElementNode(node)) continue;
        // this is the More/Less button; don't try to place it, because we'll insert based on other elements
        if (index === left.current.childNodes.length - 1) continue;
        // skip last link element because we accounted for it in the previous element,
        // as there can't be fewer than two items in More menu
        if (index === left.current.childNodes.length - 2) continue;
        // look at the second-to-last link element, because More+ must always
        // include 2 or more items
        const isSecondToLastLinkElement = index === left.current.childNodes.length - 3;
        var _node_nextElementSibling_clientWidth;
        const lastTwoElementsWidth = node.clientWidth + ((_node_nextElementSibling_clientWidth = (_node_nextElementSibling = node.nextElementSibling) === null || _node_nextElementSibling === void 0 ? void 0 : _node_nextElementSibling.clientWidth) !== null && _node_nextElementSibling_clientWidth !== void 0 ? _node_nextElementSibling_clientWidth : 0);
        const nextWidth = currentMaxWidth + (isSecondToLastLinkElement ? lastTwoElementsWidth : node.clientWidth) + gap;
        var _moreOrLessElement_clientWidth;
        if (maxChildren === 0 || nextWidth + (!isSecondToLastLinkElement ? (_moreOrLessElement_clientWidth = moreOrLessElement === null || moreOrLessElement === void 0 ? void 0 : moreOrLessElement.clientWidth) !== null && _moreOrLessElement_clientWidth !== void 0 ? _moreOrLessElement_clientWidth : 0 : 0) < availableWidth) {
            currentMaxWidth = nextWidth;
            if (isSecondToLastLinkElement) maxChildren += 2;
            else maxChildren += 1;
            continue;
        } else break;
    }
    return maxChildren;
}
function $4e30be277edd2fe5$var$useResizeObserver(ref) {
    const [observer, setObserver] = (0, $iSvIT.useState)();
    const [rect, setRect] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        const obs = new ResizeObserver((entries)=>{
            requestAnimationFrame(()=>{
                if (entries[0]) setRect(entries[0].contentRect);
            });
        });
        setObserver(obs);
    }, [
        ref
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (ref.current) observer === null || observer === void 0 ? void 0 : observer.observe(ref.current);
        return ()=>observer && observer.disconnect();
    }, [
        observer,
        ref
    ]);
    return rect;
}
function $4e30be277edd2fe5$export$d4ac5645cddd37f3({ leftElementRef: leftElementRef, rightElementRef: rightElementRef, buffer: buffer = 16, initialMaxItems: initialMaxItems = 0 }) {
    var _leftElementRef_current;
    const [maxLinks, setMaxLinks] = (0, $iSvIT.useState)(initialMaxItems);
    const [showMore, setShowMore] = (0, $iSvIT.useState)(false);
    const parentElRef = (0, $iSvIT.useRef)((_leftElementRef_current = leftElementRef.current) === null || _leftElementRef_current === void 0 ? void 0 : _leftElementRef_current.parentElement);
    (0, $iSvIT.useEffect)(()=>{
        var _leftElementRef_current_closest, _leftElementRef_current, _leftElementRef_current_parentElement;
        var _leftElementRef_current_closest1;
        if (leftElementRef.current) // This is the full left side that includes the logo, nav links and space before the search+profile component
        parentElRef.current = (_leftElementRef_current_closest1 = (_leftElementRef_current_closest = (_leftElementRef_current = leftElementRef.current).closest) === null || _leftElementRef_current_closest === void 0 ? void 0 : _leftElementRef_current_closest.call(_leftElementRef_current, "nav")) !== null && _leftElementRef_current_closest1 !== void 0 ? _leftElementRef_current_closest1 : (_leftElementRef_current_parentElement = leftElementRef.current.parentElement) === null || _leftElementRef_current_parentElement === void 0 ? void 0 : _leftElementRef_current_parentElement.parentElement;
    }, [
        leftElementRef
    ]);
    const rect = $4e30be277edd2fe5$var$useResizeObserver(parentElRef);
    (0, $iSvIT.useLayoutEffect)(()=>{
        if (rect === null || rect === void 0 ? void 0 : rect.right) {
            const maxChildren = $4e30be277edd2fe5$var$calculateMaxChildren(leftElementRef, rightElementRef, maxLinks, buffer);
            setMaxLinks(maxChildren);
        }
    }, [
        maxLinks,
        leftElementRef,
        rightElementRef,
        rect === null || rect === void 0 ? void 0 : rect.right,
        buffer
    ]);
    const output = (0, $iSvIT.useMemo)(()=>({
            maxItems: maxLinks,
            shouldShowMoreItems: showMore,
            showMoreItems: setShowMore
        }), [
        showMore,
        maxLinks
    ]);
    return output;
}

});

parcelRegister("4iLDn", function(module, exports) {

$parcel$export(module.exports, "MobileGlobalNav", function () { return $b313819f89c44ea9$export$95a43f3acd65a1b2; });
/* mobile-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $d0cJX = parcelRequire("d0cJX");

var $cdfGl = parcelRequire("cdfGl");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $aOuDE = parcelRequire("aOuDE");

var $cLl4w = parcelRequire("cLl4w");

var $9gWFG = parcelRequire("9gWFG");

var $aoDWS = parcelRequire("aoDWS");

var $aIrXm = parcelRequire("aIrXm");

var $9xKd9 = parcelRequire("9xKd9");

var $c5tR8 = parcelRequire("c5tR8");

var $kQQu6 = parcelRequire("kQQu6");

var $4w2cS = parcelRequire("4w2cS");

var $66jxs = parcelRequire("66jxs");

var $9aBMY = parcelRequire("9aBMY");

var $iLuov = parcelRequire("iLuov");

var $vuw44 = parcelRequire("vuw44");

var $ey4yR = parcelRequire("ey4yR");

var $hEweY = parcelRequire("hEweY");

var $lzGov = parcelRequire("lzGov");

var $bxxMG = parcelRequire("bxxMG");
const $b313819f89c44ea9$var$containerCss = null;
const $b313819f89c44ea9$var$shownInnerMobileDropdownMenuStyle = null;
const $b313819f89c44ea9$var$hiddenInnerMobileDropdownMenuStyle = null;
const $b313819f89c44ea9$var$menuContentStyle = null;
const $b313819f89c44ea9$var$containerClosedCss = null;
const $b313819f89c44ea9$var$containerOpenCss = null;
const $b313819f89c44ea9$var$navBarClosedCss = null;
const $b313819f89c44ea9$var$navBarOpenCss = null;
const $b313819f89c44ea9$var$slideInLeftKeyframes = null;
const $b313819f89c44ea9$var$slideInDown = null;
const $b313819f89c44ea9$var$slideInUp = null;
const $b313819f89c44ea9$var$slideInRight = null;
const $b313819f89c44ea9$var$defaultInnerMenuCss = null;
const $b313819f89c44ea9$var$slideInLeftCss = null;
const $b313819f89c44ea9$var$slideInDownCss = null;
const $b313819f89c44ea9$var$slideInUpCss = null;
const $b313819f89c44ea9$var$slideInRightCss = null;
const $b313819f89c44ea9$export$b801fd525c04bf12 = ({ isUserLoggedIn: isUserLoggedIn, menuPage: menuPage = "default", firstOpen: firstOpen, mobileLinksSections: mobileLinksSections, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const isNavigatingBackRef = (0, $iSvIT.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const isMobile = (0, $aOuDE.useIsMobile)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            menuPage === "default" && isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1q511tcg",
                    isNavigatingBackRef.current && "",
                    isNavigatingBackRef.current && "_tzy4idpf _y44v1ia3"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cLl4w.default), {
                    isMobileView: true,
                    readOnly: true,
                    parentType: "GlobalNav",
                    menuPage: menuPage,
                    fullWidth: true,
                    onFocus: ()=>{
                        if (!isNavigatingBackRef.current) handleMenuPage("search");
                        createAnalyticsEvent({
                            eventName: "searchOpen",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "searchButtonMobileV2",
                            source: "globalNav",
                            attributes: {
                                product: "marketing",
                                pageUrl: window.location.href,
                                pagePath: window.location.pathname
                            }
                        }).fire();
                    }
                }, "default-search-bar")
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {}),
            (menuPage === "resources" || menuPage === "product-everyone" || menuPage === "product-developer" || menuPage === "product-product-managers" || menuPage === "product-it-professionals" || menuPage === "product-business-teams" || menuPage === "product-leadership-teams" || menuPage === "solutions" || menuPage === "why-atlassian") && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    style: {
                        all: "unset",
                        width: "fit-content"
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        isNavigatingBackRef.current = true;
                        handleFirstOpen(false);
                        handleMenuPage("default"); // reset the flag after navigation
                        setTimeout(()=>{
                            isNavigatingBackRef.current = false;
                        }, 100);
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_y44v1uwk",
                            "_syazaqb7 _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1mou1pzu"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: intl.formatMessage({
                                    id: "globalnavv2.menu-back",
                                    defaultMessage: "Back"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_tzy4idpf _v564g4i2 _15qekb7n _1uewkb7n",
                    !firstOpen && "",
                    !firstOpen && "_y44v1n2u",
                    !firstOpen && "",
                    !firstOpen && "_y44v1uwk",
                    menuPage === "default" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    `firstopen inner-mobile-dropdown-menu ${firstOpen ? "fade-in" : "slide-in-left"}`
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gWFG.ContactSalesCta), {
                        isFullWidth: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kQQu6.MobileNavLinks), {
                        isLoggedIn: isUserLoggedIn,
                        handleMenuPage: handleMenuPage,
                        mobileLinksSections: mobileLinksSections,
                        productKey: productKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-everyone" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-everyone-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aIrXm.ProductFeaturedCollectionSubnav), {
                    isMobile: true
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-developer" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-developer-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9aBMY.MobileNavProductDevelopers), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-product-managers" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-managers-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ey4yR.MobileNavProductProductManagers), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-it-professionals" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iLuov.MobileNavProductITProfessionals), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-business-teams" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $66jxs.MobileNavProductBusinessTeams), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "product-leadership-teams" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $vuw44.MobileNavProductLeadershipTeams), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "teams" || menuPage === "solutions" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c5tR8.SolutionsSubnav), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "why-atlassian" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bxxMG.MobileNavWhyAtlassian), {
                    productKey: productKey
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y44v1n2u",
                    menuPage === "resources" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hEweY.MobileNavResources), {
                    productKey: productKey
                })
            }),
            menuPage === "search" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    menuPage === "search" ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "searchpageinnermenuinner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            style: {
                                all: "unset",
                                width: "fit-content"
                            },
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                isNavigatingBackRef.current = true;
                                handleFirstOpen(false);
                                handleMenuPage("default"); // reset the flag after navigation
                                setTimeout(()=>{
                                    isNavigatingBackRef.current = false;
                                }, 100);
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_y44v1uwk",
                                    "_syazaqb7 _1e0c1txw _4cvr1h6o _1q517vkz"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1mou1pzu"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                            label: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: intl.formatMessage({
                                            id: "globalnavv2.menu-back",
                                            defaultMessage: "Back"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_tzy4idpf _y44v1e70"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cLl4w.default), {
                                isMobileView: true,
                                parentType: "GlobalNav",
                                menuPage: menuPage,
                                fullWidth: true
                            }, "search-page-search-bar")
                        })
                    ]
                })
            }, "search-page")
        ]
    });
};
const $b313819f89c44ea9$export$95a43f3acd65a1b2 = ({ productKey: productKey, isShowSearchButton: isShowSearchButton })=>{
    const intl = (0, $f6qj2.default)();
    const [isOpenSearch, setIsOpenSearch] = (0, $iSvIT.useState)(false);
    const teamsText = intl.formatMessage({
        id: "globalNavigation.Navlink.solutions",
        defaultMessage: "Solutions"
    });
    const teamsKeyAndDropdownType = "solutions";
    const { userInfo: userInfo, showMenu: showMenu, isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage, handleClickAvatar: handleClickAvatar } = (0, $aoDWS.useMobileNavDisplay)(isOpenSearch);
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick } = (0, $cdfGl.useGlobalNavUserProfileClickActions)({
        email: userInfo.email
    });
    const mobileLinksSections = [
        {
            mobileLinkKey: "product-nav-links",
            mobileLinksProps: [
                {
                    globalLinksKey: "products",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.products",
                        defaultMessage: "Products"
                    }),
                    hasSubnav: false
                },
                {
                    globalLinksKey: "everyone",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.featured",
                        defaultMessage: "Featured"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-everyone"
                },
                {
                    globalLinksKey: "developers",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.developers",
                        defaultMessage: "Developers"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-developer"
                },
                {
                    globalLinksKey: "productmanagers",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.productmanagers",
                        defaultMessage: "Product Managers"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-product-managers"
                },
                {
                    globalLinksKey: "itprofessionals",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.itprofessionals",
                        defaultMessage: "IT professionals"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-it-professionals"
                },
                {
                    globalLinksKey: "businessteams",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.businessteams",
                        defaultMessage: "Business Teams"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-business-teams"
                },
                {
                    globalLinksKey: "leadershipteams",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.leadershipteams",
                        defaultMessage: "Leadership Teams"
                    }),
                    hasSubnav: true,
                    dropdownType: "product-leadership-teams"
                }
            ]
        },
        {
            mobileLinkKey: "other-nav-links",
            mobileLinksProps: [
                {
                    globalLinksKey: teamsKeyAndDropdownType,
                    linkText: teamsText,
                    hasSubnav: true,
                    dropdownType: teamsKeyAndDropdownType
                },
                {
                    globalLinksKey: "why-atlassian",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.whyAtlassian",
                        defaultMessage: "Why Atlassian?"
                    }),
                    hasSubnav: true,
                    dropdownType: "why-atlassian"
                },
                {
                    globalLinksKey: "resources",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.resources",
                        defaultMessage: "Resources"
                    }),
                    hasSubnav: true,
                    dropdownType: "resources"
                },
                {
                    globalLinksKey: "enterprise",
                    linkText: intl.formatMessage({
                        id: "globalnavv2.navlink.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    hasSubnav: false,
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise")
                }
            ]
        }
    ];
    const atlassianLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "atlassian",
        type: "logo",
        appearance: "brand",
        height: 20,
        width: 156
    });
    const mobileGlobalNavDropdownMenu = ()=>/*#__PURE__*/ (0, $loA2J.jsx)($b313819f89c44ea9$export$b801fd525c04bf12, {
            showMenu: showMenu,
            isUserLoggedIn: userInfo.isUserLoggedIn,
            menuPage: menuPage,
            firstOpen: firstOpen,
            mobileLinksSections: mobileLinksSections,
            handleToggleMenu: handleToggleMenu,
            handleMenuPage: handleMenuPage,
            handleFirstOpen: handleFirstOpen,
            productKey: productKey
        });
    var _userInfo_name, _userInfo_picture;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
        className: (0, $esG4f.default)([
            "_11q7cd5j _1e0c1txw _2lx21bp4 _zulputpp",
            showMenu ? "_ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _tnru1kxc _1rfm1osq _1o831wug _98bk1wug _13zm1n9t _xaejidpf _1kmx1tcg _1ggm1tcg _1ykz1tcg _1mae1tcg _2rfoqfx8" : "_ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    showMenu ? "_su07pxbi _1e0c1txw _4cvr1h6o _1bah1yb4" : "_18zrpxbi _1e0c1txw _1bah1yb4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lzGov.MobileNavTop), {
                        productKey: productKey,
                        isLoggedIn: userInfo.isUserLoggedIn,
                        userName: (_userInfo_name = userInfo.name) !== null && _userInfo_name !== void 0 ? _userInfo_name : "",
                        picture: (_userInfo_picture = userInfo.picture) !== null && _userInfo_picture !== void 0 ? _userInfo_picture : "",
                        handleClickAvatar: handleClickAvatar,
                        showMenu: showMenu,
                        handleToggleMenu: handleToggleMenu,
                        menuPage: menuPage,
                        handleMenuPage: handleMenuPage,
                        handleFirstOpen: handleFirstOpen,
                        mobileLogo: atlassianLogo,
                        mobileLogoAriaLabel: intl.formatMessage({
                            id: "globalnavv2.logo-label",
                            defaultMessage: "Atlassian logo"
                        }),
                        mobileLogoHref: "/",
                        mobileLogoDataEventContainer: "globalNavWacV2",
                        isShowSearchButton: isShowSearchButton,
                        isOpenSearch: isOpenSearch,
                        setIsOpenSearch: setIsOpenSearch,
                        tabletDropdownMenu: mobileGlobalNavDropdownMenu()
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9xKd9.SkipToContent), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $esG4f.default)([
                    "_1e0cglyw _1bsb1wug _181nglyw",
                    showMenu && "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {}),
                    isDisplayLoggedInUseDropdown ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4w2cS.default), {
                        userInfo: {
                            displayName: userInfo.name || "",
                            email: userInfo.email || "",
                            avatar: userInfo.picture || ""
                        },
                        onLogOutClick: onLogOutClick,
                        onManageLicensesClick: onManageLicensesClick,
                        onManageProfileClick: onManageProfileClick,
                        onSwitchAccountClick: onSwitchAccountClick
                    }) : mobileGlobalNavDropdownMenu()
                ]
            })
        ]
    });
};

});
parcelRegister("cLl4w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90b8e67ebbb415e1$export$2e2bcd8739ae039; });
/* auto-complete-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $2YVsr = parcelRequire("2YVsr");

var $fKhJX = parcelRequire("fKhJX");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $4XrxY = parcelRequire("4XrxY");

var $1MbAx = parcelRequire("1MbAx");

var $gAJUc = parcelRequire("gAJUc");

var $f7hB9 = parcelRequire("f7hB9");

var $cQk7Y = parcelRequire("cQk7Y");

var $bExxu = parcelRequire("bExxu");

var $fwafs = parcelRequire("fwafs");

var $gzewo = parcelRequire("gzewo");
const $90b8e67ebbb415e1$var$aaAutoCompContainerPanelStyle = null;
const $90b8e67ebbb415e1$var$aaFormStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperPrefixStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperPrefixStyleWithFeatureFlag = null;
const $90b8e67ebbb415e1$var$aaLabelStyle = null;
const $90b8e67ebbb415e1$var$aaSubmitButtonStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperStyleWithFeatureFlag = null;
const $90b8e67ebbb415e1$var$aaInputStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperSuffixStyle = null;
const $90b8e67ebbb415e1$var$aaInputWrapperSuffixStyleWithFeatureFlag = null;
const $90b8e67ebbb415e1$var$aaCrossIconStyle = null;
const $90b8e67ebbb415e1$var$aaClearButtonStyle = null;
const $90b8e67ebbb415e1$var$aaPanelLayoutStyle = null;
const $90b8e67ebbb415e1$var$aaSourceStyle = null;
const $90b8e67ebbb415e1$var$aaListStyle = null;
const $90b8e67ebbb415e1$var$SearchBaraaFormaaFormFocusStyle = null;
const $90b8e67ebbb415e1$var$searchBarInputWrapperStyle = null;
const $90b8e67ebbb415e1$var$searchBarInputWrapperStyleWithFeatureFlag = null;
const $90b8e67ebbb415e1$var$searchBarStyle = null;
const $90b8e67ebbb415e1$var$searchBarMobileStyle = null;
const $90b8e67ebbb415e1$var$searchBarMobileFullWidthStyle = null;
const $90b8e67ebbb415e1$var$searchBarMobileProductNavStyle = null;
const $90b8e67ebbb415e1$var$searchBarMobileProductNavButtonMatchStyle = null;
const $90b8e67ebbb415e1$var$seeAllButtonStyle = null;
const $90b8e67ebbb415e1$var$aiEnabledSearchIconCss = null;
const $90b8e67ebbb415e1$var$aiEnabledSearchIconFocusCss = null;
const $90b8e67ebbb415e1$var$aiEnabledClearButtonCss = null;
const $90b8e67ebbb415e1$var$AutoCompleteSearchBar = ({ isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, isMobileView: isMobileView = false, aiEnabled: aiEnabled = false, onFocus: onFocus, readOnly: readOnly = false, parentType: parentType = "GlobalNav", menuPage: menuPage, fullWidth: fullWidth = false, matchButtonSize: matchButtonSize = false })=>{
    const intl = (0, $f6qj2.default)();
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(null);
    const formRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(null);
    const lastTrackedQueryRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef("");
    const [isInputFocused, setIsInputFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $1MbAx.useFeatureExposed)("wac-search-indexv3", "Test");
    const isSearchIndexV3_2Enabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacSearchIndexV3_2);
    const hitsPerPageObject = {
        hitsPerPage: 7
    };
    const isAnalyticsEnabled = (0, $cQk7Y.shouldEnableAlgoliaAnalytics)();
    var _intl_locale;
    const queryParams = (0, $7Knp0._)({
        facetFilters: [
            `locale:${(_intl_locale = intl.locale) !== null && _intl_locale !== void 0 ? _intl_locale : "en"}`
        ],
        clickAnalytics: isAnalyticsEnabled,
        // enables click analytics
        attributesToRetrieve: [
            "url",
            "title",
            "description",
            "locale",
            "category",
            "objectID"
        ]
    }, hitsPerPageObject, aiEnabled ? {
        restrictSearchableAttributes: [
            "title"
        ],
        minProximity: 2
    } : {});
    const { autocompleteState: autocompleteState, autocomplete: autocomplete } = (0, $gzewo.default)({
        searchIndex: isSearchIndexV3_2Enabled ? (0, $cQk7Y.activeSearchIndexV3_2) : (0, $cQk7Y.activeSearchIndexV3),
        ALGOLIA_FACET_KEY: $cQk7Y.ALGOLIA_FACET_KEY,
        ALGOLIA_APP_ID: $cQk7Y.ALGOLIA_APP_ID,
        ALGOLIA_SEARCH_API_KEY: $cQk7Y.ALGOLIA_SEARCH_API_KEY,
        queryParams: queryParams,
        aiEnabled: aiEnabled
    });
    const { getEnvironmentProps: getEnvironmentProps } = autocomplete;
    (0, $iSvIT.useEffect)(()=>{
        if (isOpenSearch) {
            if (inputRef.current) inputRef.current.focus();
        }
    }, [
        isOpenSearch
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!formRef.current || !panelRef.current || !inputRef.current) return undefined;
        const { onTouchStart: onTouchStart, onTouchMove: onTouchMove, onMouseDown: onMouseDown } = getEnvironmentProps({
            formElement: formRef.current,
            inputElement: inputRef.current,
            panelElement: panelRef.current
        });
        window.addEventListener("mousedown", onMouseDown);
        window.addEventListener("touchstart", onTouchStart);
        window.addEventListener("touchmove", onTouchMove);
        return ()=>{
            window.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("touchstart", onTouchStart);
            window.removeEventListener("touchmove", onTouchMove);
        };
    }, [
        getEnvironmentProps,
        autocompleteState.isOpen
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        if (!readOnly && inputRef.current) inputRef.current.focus();
    }, [
        readOnly
    ]);
    const isNotEmptyQuery = (searchQuery)=>searchQuery.length > 0;
    const searchPagePath = (0, $3FBn4.useLocalizedHref)(`/search?q=${autocompleteState.query || ""}`);
    const handleSearchFormSubmit = (event)=>{
        event.preventDefault();
        if (isNotEmptyQuery(autocompleteState.query)) {
            createAnalyticsEvent({
                eventName: "submitSearchForm",
                eventType: "ui",
                action: "submitted",
                actionSubject: "search",
                actionSubjectId: "globalNavSearchBar",
                eventContainer: "globalNavSearchBar",
                source: "globalNav",
                attributes: {
                    product: "search",
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname
                }
            }).fire();
            window.location.assign(searchPagePath);
        }
    };
    const handleRenderAutocompleteResult = (item, source)=>{
        // check if any product landing pages have the same url
        // as the result from Algolia.
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fwafs.DefaultAutocompleteResult), {
            item: item,
            source: source,
            autocomplete: autocomplete,
            isMobileView: isMobileView
        });
    };
    const { dropdownAnnouncement: dropdownAnnouncement } = (0, $cQk7Y.useA11yDropdownAnnouncement)({
        resultsCount: autocompleteState.collections.filter((collection)=>collection.source.sourceId !== "ai-assistant").reduce((total, collection)=>total + collection.items.length, 0),
        searchTerm: autocompleteState.query
    });
    (0, $iSvIT.useEffect)(()=>{
        var _autocompleteState_collections__items_, _autocompleteState_collections_;
        if (!autocompleteState.query) {
            lastTrackedQueryRef.current = "";
            return;
        }
        if (lastTrackedQueryRef.current === autocompleteState.query) return;
         // Debounce the analytics event to prevent firing until the user has stopped typing
        const queryId = ((_autocompleteState_collections_ = autocompleteState.collections[0]) === null || _autocompleteState_collections_ === void 0 ? void 0 : (_autocompleteState_collections__items_ = _autocompleteState_collections_.items[0]) === null || _autocompleteState_collections__items_ === void 0 ? void 0 : _autocompleteState_collections__items_.queryID) || null;
        const timeoutId = setTimeout(()=>{
            createAnalyticsEvent({
                eventName: "displayAutocompleteSearchResults",
                eventType: "ui",
                action: "displayed",
                actionSubject: "search",
                actionSubjectId: "globalNavAutoCompleteResults",
                eventContainer: "globalNavSearchBar",
                source: "globalNav",
                attributes: {
                    product: "search",
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname,
                    resultsCount: autocompleteState.collections.reduce((total, collection)=>total + collection.items.length, 0),
                    queryId: queryId,
                    searchQuery: autocompleteState.query,
                    searchIndex: "v3"
                }
            }).fire();
            lastTrackedQueryRef.current = autocompleteState.query;
        }, 500);
        return ()=>clearTimeout(timeoutId);
    }, [
        autocompleteState.query,
        autocompleteState.collections,
        createAnalyticsEvent
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (autocompleteState.isOpen && aiEnabled) (0, $fKhJX.Tracking).autoTrackLinks(true);
    }, [
        autocompleteState.isOpen,
        aiEnabled
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_syaz5k8o _ect41kw7 _1wyb7vkz _k48p1nn1 _vwz41x4e _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h",
                isMobileView && (parentType === "ProductNav" || parentType === "GlobalNav") ? matchButtonSize ? "_1bsb1osq _1bah1h6o _kqswh2mm _1pfhftgi _6rthftgi" : fullWidth ? parentType === "ProductNav" ? "_1bsb1osq _1bah1h6o _kqswh2mm _1q511tcg _85i51tcg _y4tiidpf _bozgidpf" : "_1bsb1osq _1bah1h6o _kqswh2mm" : "_1bsb1osq _1bah1h6o _85i51tcg" : "_kqswh2mm _u7coidpf _ahbqgktf _12l2gktf _1bsb1wug _p12f1osq _1pbyqfx8 _1e0c1ule _1bah1h6o",
                "aa-Autocomplete"
            ]),
            "data-testid": "aa-Autocomplete",
            style: {
                "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({
                    ref: formRef,
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _bfhkcd5j _19it1baz _2rko1l7b _1e0c1txw _vwz41x4e _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _1bsb1osq _858uxxzy _7ehiqzde",
                        "_19itglyw _1h6d1j28 _12ji1j28 _1qu2nqa1 _12y31o36 _16qsglyw",
                        isMobileView && (parentType === "GlobalNav" || parentType === "ProductNav") && menuPage === "search" && "_85i51tcg",
                        isMobileView && parentType === "ProductNav" && (fullWidth || matchButtonSize) && "_4t3i14no",
                        "aa-Form"
                    ])
                }, autocomplete.getFormProps({
                    inputElement: inputRef.current
                })), {
                    onSubmit: handleSearchFormSubmit,
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                isMobileView ? "_4cvr1h6o _1e0c1txw _1o9zidpf _4t3ickbl _1f49kb7n" : "_4cvr1h6o _1e0c1txw _1o9zidpf _4t3ior1b _1f49kb7n",
                                isMobileView && parentType === "ProductNav" && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapperPrefix"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                isMobileView ? "_1f4911wp _kqswh2mm _1bsb1osq _4t3ickbl" : "_1f4911wp _kqswh2mm _1bsb1osq _4t3ior1b",
                                isMobileView ? "_kqswh2mm _1e0c1txw _s7n4nkob _4cvr1h6o _4t3iyn4p _1dqonqa1 _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _2rko16uj _1h6d1rga _bfhk1rga" : "_kqswh2mm _1e0c1txw _s7n4nkob _4cvr1h6o _4t3iahaf _189et94y _1dqonqa1 _2rko16uj _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1h6d1rga _bfhk1rga",
                                isMobileView && parentType === "ProductNav" && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapper"
                            ]),
                            style: {
                                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("input", (0, $6iHNw._)((0, $7Knp0._)({
                                    className: (0, $esG4f.default)([
                                        "_r06hglyw _11q7glyw _19itidpf _syaz1hlo _11c81kw7 _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1n5djk2v _858uglyw _7ehiglyw _nt751r31 _49pcglyw _1hvw1o36 _1idr1io3 _1wfakb7n _lu7aglyw _q1fpglyw _1av4glyw _14jrglyw",
                                        "aa-Input"
                                    ]),
                                    "aria-label": "Search by Keywords",
                                    "data-testid": "aa-Input",
                                    ref: inputRef,
                                    readOnly: readOnly
                                }, autocomplete.getRootProps({}), autocomplete.getInputProps({
                                    inputElement: inputRef.current,
                                    onFocus: ()=>{
                                        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
                                        setIsInputFocused(true);
                                    },
                                    onBlur: ()=>{
                                        setIsInputFocused(false);
                                    }
                                })), {
                                    style: {
                                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                        "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                                        "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                                    }
                                })),
                                /*#__PURE__*/ (0, $loA2J.jsx)("label", (0, $6iHNw._)((0, $7Knp0._)({
                                    className: (0, $esG4f.default)([
                                        "_80om1wug _1o9zidpf _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h",
                                        "aa-Label"
                                    ])
                                }, autocomplete.getLabelProps({})), {
                                    htmlFor: "autocomplete"
                                })),
                                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                    className: (0, $esG4f.default)([
                                        "_4t3i1osq _bozg1skh _y4tiftgi _1bsbfhn8 _19itglyw _11q7glyw",
                                        aiEnabled && "_vwz419bv _d4ksxv17 _riauwv0y",
                                        aiEnabled && isInputFocused && "_d4ks1hlo",
                                        "aa-SubmitButton"
                                    ]),
                                    "data-testid": "search-submit-button",
                                    "aria-label": intl.formatMessage({
                                        id: "globalnav.search.submit-button",
                                        defaultMessage: "Submit search"
                                    }),
                                    type: "submit",
                                    title: "Submit",
                                    disabled: !isNotEmptyQuery(autocompleteState.query),
                                    style: {
                                        "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                    },
                                    children: aiEnabled ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $f7hB9.default), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
                                        label: "search label"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                isMobileView ? "_4cvr1h6o _1e0c1txw _4t3ickbl _1f49egat" : "_4cvr1h6o _1e0c1txw _4t3ior1b _1f49egat",
                                isMobileView && parentType === "ProductNav" && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapperSuffix"
                            ]),
                            children: !isMobileView ? /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: (0, $esG4f.default)([
                                    "_4cvr1h6o _11q7glyw _19itidpf _80omtlke _1e0c1txw _4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvzwfg _xqg4glyw",
                                    aiEnabled && "_d4ks1hlo",
                                    "aa-ClearButton"
                                ]),
                                "data-testid": "search-close-button",
                                "aria-label": intl.formatMessage({
                                    id: "globalnav.search.clear-button",
                                    defaultMessage: "Clear search input"
                                }),
                                title: "Clear",
                                type: "reset",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    if (setIsOpenSearch) {
                                        setIsOpenSearch(false);
                                        lastTrackedQueryRef.current = "";
                                        createAnalyticsEvent({
                                            eventName: "searchClose",
                                            eventType: "ui",
                                            action: "clicked",
                                            actionSubject: "button",
                                            actionSubjectId: "searchCloseButtonDesktop",
                                            source: "globalNav",
                                            attributes: {
                                                product: "search",
                                                pageUrl: window.location.href,
                                                pagePath: window.location.pathname
                                            }
                                        }).fire();
                                    }
                                },
                                style: {
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                                    size: "20",
                                    className: (0, $esG4f.default)([
                                        "_syazf7gx _f8pj5k8o _30l35k8o"
                                    ]),
                                    style: {
                                        "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                                    }
                                })
                            }) : null
                        })
                    ]
                })),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cQk7Y.HiddenAriaLiveAnnouncement), {
                    children: dropdownAnnouncement
                }),
                autocompleteState.isOpen && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fwafs.AutoCompleteResultsDropdown), {
                    isMobileView: isMobileView,
                    panelRef: panelRef,
                    autocompleteState: autocompleteState,
                    autocomplete: autocomplete,
                    aiEnabled: aiEnabled,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _c71lstmo _18m91wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _y3gn1e5h _fiawglyw",
                                "aa-PanelLayout"
                            ]),
                            "data-testid": "aa-PanelLayout",
                            children: autocompleteState.collections.map((collection, index)=>{
                                const { source: source, items: items } = collection;
                                return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1bsb1osq _fiawglyw",
                                        "aa-Source"
                                    ]),
                                    children: items.length > 0 && /*#__PURE__*/ (0, $iSvIT.createElement)("ul", (0, $6iHNw._)((0, $7Knp0._)({
                                        className: (0, $esG4f.default)([
                                            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                                            "aa-List"
                                        ])
                                    }, autocomplete.getListProps()), {
                                        key: `list-${items.length}`
                                    }), items.slice(0, isMobileView ? 5 : items.length).map((item)=>{
                                        if (source.sourceId === "ai-assistant") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bExxu.default), {
                                            query: autocompleteState.query,
                                            autocomplete: autocomplete,
                                            source: source,
                                            item: item
                                        }, item.objectID);
                                        return handleRenderAutocompleteResult(item, source);
                                    }))
                                }, `source-${index}`);
                            })
                        }),
                        aiEnabled && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            onMouseEnter: ()=>{
                                autocomplete.setActiveItemId(null);
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: intl.formatMessage({
                                    id: "globalnav.searchresult.see-all",
                                    defaultMessage: "See all"
                                }),
                                href: "/search?q=" + autocompleteState.query,
                                type: "primary",
                                dataEventProps: {
                                    "data-product-key": "search",
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "globalNavSearchResult",
                                    "data-label-english": "See all"
                                },
                                className: (0, $esG4f.default)([
                                    "_bozgftgi"
                                ])
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $90b8e67ebbb415e1$export$2e2bcd8739ae039 = $90b8e67ebbb415e1$var$AutoCompleteSearchBar;

});
parcelRegister("f7hB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad24eeccc793e8c9$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $ad24eeccc793e8c9$var$AiEnabledSearchIcon = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.5791 1.40137C11.0624 1.40137 11.5369 1.43876 12 1.51074V3.79688C11.5414 3.70127 11.0661 3.65137 10.5791 3.65137C6.75308 3.65137 3.65137 6.75308 3.65137 10.5791C3.65142 14.4051 6.75311 17.5068 10.5791 17.5068C13.918 17.5068 16.7048 15.1444 17.3604 12H19.6455C19.3606 13.8297 18.5363 15.4804 17.3389 16.7842C17.5076 16.8513 17.6653 16.9534 17.8018 17.0898L20.959 20.248C21.496 20.785 21.496 21.6554 20.959 22.1924C20.422 22.729 19.5515 22.7292 19.0146 22.1924L15.8564 19.0352C15.6577 18.8364 15.5331 18.5914 15.4814 18.335C14.0628 19.2336 12.3826 19.7568 10.5791 19.7568C5.51047 19.7568 1.40142 15.6477 1.40137 10.5791C1.40137 5.51044 5.51044 1.40137 10.5791 1.40137Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.166 0.0136719C17.5469 0.0790991 17.8718 0.368165 18.0068 0.775391L18.8848 3.4248L21.2959 4.3916C21.7187 4.56135 22 5.00492 22 5.5L21.9873 5.68262C21.9278 6.10149 21.666 6.45981 21.2959 6.6084L18.8848 7.57324L18.0068 10.2246C17.8718 10.6318 17.5469 10.9209 17.166 10.9863L17 11C16.5498 11 16.1474 10.6898 15.9932 10.2246L15.1143 7.57324L12.7041 6.6084C12.334 6.45981 12.0722 6.10149 12.0127 5.68262L12 5.5C12 5.00492 12.2813 4.56135 12.7041 4.3916L15.1143 3.4248L15.9932 0.775391C16.1282 0.368165 16.4531 0.0790991 16.834 0.0136719L17 0L17.166 0.0136719Z",
                fill: "#292A2E"
            })
        ]
    }));
};
var $ad24eeccc793e8c9$export$2e2bcd8739ae039 = $ad24eeccc793e8c9$var$AiEnabledSearchIcon;

});

parcelRegister("bExxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af2d63ffdafdddf0$export$2e2bcd8739ae039; });
/* auto-complete-search-ai-result.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $g9kzu = parcelRequire("g9kzu");

var $15syu = parcelRequire("15syu");

var $5ohHq = parcelRequire("5ohHq");
const $af2d63ffdafdddf0$var$aiResultContainerStyle = null;
const $af2d63ffdafdddf0$var$queryStyle = null;
const $af2d63ffdafdddf0$var$AutoCompleteSearchAIResult = ({ query: query, autocomplete: autocomplete, source: source, item: item })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const href = `/search?q=${query}`;
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", (0, $6iHNw._)((0, $7Knp0._)({
        className: "aa-Item"
    }, autocomplete.getItemProps({
        item: item,
        source: source
    })), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: href,
            onClick: (event)=>{
                event.preventDefault();
                createAnalyticsEvent({
                    eventName: "clickAutocompleteSearchResult",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "globalNavSearchResults",
                    source: "globalNav",
                    attributes: {
                        product: "search",
                        queryId: item.queryID,
                        objectId: item.objectID,
                        linkUrl: href,
                        pageUrl: window.location.href,
                        pagePath: window.location.pathname,
                        rank: 0
                    }
                }).fire();
                window.location.href = href;
            },
            className: (0, $esG4f.default)([
                "_4cvr1h6o _2rko1l7b _80omtlke _1e0c11p5 _yv0e5bpd _zulp19bv _1tke1ylp _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _6rthc4v4 _1ka1idpf _1yegidpf _lz8gewfl _1fpi150w _d4ksnqye _irr3150w"
            ]),
            style: {
                "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                "--_1a8xanm": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light600"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15syu))), {
                    label: "Search AI Result"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_k48pni7l"
                    ]),
                    children: query
                })
            ]
        })
    }));
};
var $af2d63ffdafdddf0$export$2e2bcd8739ae039 = $af2d63ffdafdddf0$var$AutoCompleteSearchAIResult;

});
parcelRegister("15syu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0cac689217588a71$var$_react = $0cac689217588a71$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0cac689217588a71$var$_baseNew = $0cac689217588a71$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $0cac689217588a71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0cac689217588a71$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $0cac689217588a71$var$_react.default.createElement($0cac689217588a71$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$0cac689217588a71$var$GenerativeIndicatorIcon.displayName = "GenerativeIndicatorIcon";
var $0cac689217588a71$var$_default = module.exports.default = $0cac689217588a71$var$GenerativeIndicatorIcon;

});
parcelRegister("bTGUY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("xFOGR")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("xFOGR")).Icon; });

var $xFOGR = parcelRequire("xFOGR");

});
parcelRegister("xFOGR", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $06538515cdf8ff21$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $06538515cdf8ff21$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $9SEIG = parcelRequire("9SEIG");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $06538515cdf8ff21$var$svgStyles = null;
var $06538515cdf8ff21$var$iconStyles = null;
var $06538515cdf8ff21$var$utilityIconStyles = null;
var $06538515cdf8ff21$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $06538515cdf8ff21$var$baseHcmStyles = null;
var $06538515cdf8ff21$var$scaleSize = null;
var $06538515cdf8ff21$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $06538515cdf8ff21$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $06538515cdf8ff21$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $06538515cdf8ff21$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $06538515cdf8ff21$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $06538515cdf8ff21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $06538515cdf8ff21$var$baseSizeMap[type];
    var viewBoxPadding = $06538515cdf8ff21$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $9SEIG.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $9SEIG.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $06538515cdf8ff21$var$utilSizes[spacing] : size === "small" ? $06538515cdf8ff21$var$coreSizeSmall[spacing] : $06538515cdf8ff21$var$coreSizeMedium[spacing]
        ])
    }));
});
var $06538515cdf8ff21$export$2e2bcd8739ae039 = $06538515cdf8ff21$export$f04a61298a47a40f;

});
parcelRegister("9SEIG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7318be4ee0d947c3$export$2e2bcd8739ae039; });
const $7318be4ee0d947c3$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7318be4ee0d947c3$var$ATOMIC_GROUP_LENGTH = 5;
function $7318be4ee0d947c3$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $7318be4ee0d947c3$var$UNDERSCORE_UNICODE ? $7318be4ee0d947c3$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});





parcelRegister("fwafs", function(module, exports) {

$parcel$export(module.exports, "AutoCompleteResultsDropdown", function () { return $17880f040cec54f4$export$47dfd164a9ccfb8b; });
$parcel$export(module.exports, "DefaultAutocompleteResult", function () { return $17880f040cec54f4$export$44851d96ff92d93f; });
/* auto-complete-search-results.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $4xsre = parcelRequire("4xsre");

var $g9kzu = parcelRequire("g9kzu");

var $2YVsr = parcelRequire("2YVsr");

var $cRwVc = parcelRequire("cRwVc");

var $9iWJ8 = parcelRequire("9iWJ8");

var $cQk7Y = parcelRequire("cQk7Y");
const $17880f040cec54f4$var$aaPanel = null;
const $17880f040cec54f4$var$aaPanelAI = null;
const $17880f040cec54f4$var$aaPanelStalled = null;
const $17880f040cec54f4$var$aaItem = null;
const $17880f040cec54f4$var$aaItemAI = null;
const $17880f040cec54f4$var$aaItemContent = null;
const $17880f040cec54f4$var$aaItemContentAI = null;
const $17880f040cec54f4$var$aaItemContentBodyAI = null;
const $17880f040cec54f4$var$aaItemContentTitle = null;
const $17880f040cec54f4$var$aaItemContentTitleAI = null;
const $17880f040cec54f4$var$aaItemWrapper = null;
const $17880f040cec54f4$var$aaItemLink = null;
const $17880f040cec54f4$var$decodeHtml = (html)=>{
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
};
const $17880f040cec54f4$export$fd660bdfc5e2a1ce = ({ hit: hit })=>{
    return /*#__PURE__*/ (0, $iSvIT.createElement)((0, $iSvIT.Fragment), {}, (0, $4xsre.parseAlgoliaHitHighlight)({
        hit: hit,
        attribute: "title"
    }).map(({ value: value, isHighlighted: isHighlighted }, index)=>{
        const decodedValue = $17880f040cec54f4$var$decodeHtml(value);
        if (isHighlighted) return /*#__PURE__*/ (0, $iSvIT.createElement)("mark", {
            key: index,
            style: {
                color: (0, $cRwVc.default)("color.neutral.dark200"),
                fontStyle: "normal",
                fontWeight: "600",
                backgroundColor: "transparent"
            }
        }, decodedValue);
        return decodedValue;
    }));
};
const $17880f040cec54f4$export$47dfd164a9ccfb8b = ({ isMobileView: isMobileView = false, panelRef: panelRef, autocompleteState: autocompleteState, autocomplete: autocomplete, children: children, aiEnabled: aiEnabled })=>{
    if (!isMobileView) return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({
        ref: panelRef,
        className: (0, $esG4f.default)([
            "_bfhkcd5j _16qs1m9f _19pkftgi _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _kqswstnw _v5641vzh _2rko3i6a _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsb1y37 _1kmxftgi _1ggmftgi _1ykzftgi _1maeftgi _1rfm1osq",
            aiEnabled && "_ca0q1tcg _u5f37vkz _n3td1tcg _19bv7vkz",
            autocompleteState.status === "stalled" && "_kdam1r8n _tzy4txnc",
            [
                "aa-Panel",
                "aa-Panel--desktop",
                autocompleteState.status === "stalled" && "aa-Panel--stalled"
            ].filter(Boolean).join(" ")
        ])
    }, autocomplete.getPanelProps({})), {
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light0")),
            "--_1lmj1bv": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light300"))
        },
        children: children
    }));
    else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
};
const $17880f040cec54f4$export$44851d96ff92d93f = ({ item: item, source: source, autocomplete: autocomplete, isMobileView: isMobileView = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const wacAISearchSummaryExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).wacAISearchSummary);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    const handleSearchResultClick = (item)=>{
        (0, $cQk7Y.handleAlgoliaConversionMetrics)(item);
        createAnalyticsEvent({
            eventName: "clickAutocompleteSearchResult",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "globalNavSearchResults",
            source: "globalNav",
            attributes: {
                product: "search",
                queryId: item.queryID,
                objectId: item.objectID,
                linkUrl: item.url,
                pageUrl: window.location.href,
                pagePath: window.location.pathname,
                rank: item.position
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", (0, $6iHNw._)((0, $7Knp0._)({
        className: (0, $esG4f.default)([
            "_4cvr1h6o _2rko1l7b _80omtlke _1e0c11p5 _1tke1ylp _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _1pfhftgi _6rthftgi _1ka1idpf _lz8gewfl _1fpi150w",
            isAISearchSummaryEnabled && "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi",
            "aa-Item"
        ])
    }, autocomplete.getItemProps({
        item: item,
        source: source
    })), {
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light200"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _syaz1kw7 _1e0c11p5 _zulp1y44 _727q1y44 _wij21bp4 _1bah1yb4 _1bsb1osq _4bfu1r31 _1hmsglyw _ajmmnqa1",
                "aa-ItemLink"
            ]),
            "aria-label": item.title,
            href: item.url,
            onClick: (event)=>{
                var _item_url;
                event.preventDefault();
                const relativeUrlPath = (item === null || item === void 0 ? void 0 : (_item_url = item.url) === null || _item_url === void 0 ? void 0 : _item_url.split("https://www.atlassian.com")[1]) || (item === null || item === void 0 ? void 0 : item.url);
                handleSearchResultClick(item);
                window.location.href = relativeUrlPath;
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _syaz1kw7 _1e0c11p5 _zulp1y44 _727q1y44 _wij21bp4 _1bah1yb4 _1bsb1osq",
                    "aa-ItemWrapper"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _80omtlke _1e0c11p5 _zulpftgi _727qftgi _wij21bp4 _vwz41xfb _1reo15vq _18m915vq _fiawglyw",
                        isAISearchSummaryEnabled && "_zulp19bv _727q19bv",
                        "aa-ItemContent"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            isAISearchSummaryEnabled && "_1e0c11p5 _yv0e5bpd _zulp19bv _727q19bv _ny56yh40",
                            "aa-ItemContentBody"
                        ]),
                        children: [
                            isAISearchSummaryEnabled && !isMobileView && /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
                                label: "Search result",
                                size: "small",
                                primaryColor: (0, $cRwVc.default)("color.neutral.dark500")
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvr1c0l _zulpftgi _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_idjs5a": (0, $43MIc.default)(isMobileView ? "flex-start" : "center")
                                },
                                children: [
                                    isMobileView && /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
                                        label: "Search result",
                                        size: "small",
                                        primaryColor: (0, $cRwVc.default)("color.neutral.dark500")
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1o8l _19pkidpf _2hwxhage _otyridpf _18u0idpf _p12f1osq _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _o5724jg8",
                                            isAISearchSummaryEnabled && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1ul9idpf",
                                            "aa-ItemContentTitle"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)($17880f040cec54f4$export$fd660bdfc5e2a1ce, {
                                            hit: item
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    }), item.objectID);
};

});
parcelRegister("4xsre", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitHighlight", function () { return $34e04db7e78f5488$export$8d253e1eb996c525; });

var $gwdM4 = parcelRequire("gwdM4");

var $icSrZ = parcelRequire("icSrZ");
function $34e04db7e78f5488$var$_toConsumableArray(arr) {
    return $34e04db7e78f5488$var$_arrayWithoutHoles(arr) || $34e04db7e78f5488$var$_iterableToArray(arr) || $34e04db7e78f5488$var$_unsupportedIterableToArray(arr) || $34e04db7e78f5488$var$_nonIterableSpread();
}
function $34e04db7e78f5488$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $34e04db7e78f5488$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $34e04db7e78f5488$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $34e04db7e78f5488$var$_arrayLikeToArray(o, minLen);
}
function $34e04db7e78f5488$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $34e04db7e78f5488$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $34e04db7e78f5488$var$_arrayLikeToArray(arr);
}
function $34e04db7e78f5488$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $34e04db7e78f5488$export$8d253e1eb996c525(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $gwdM4.getAttributeValueByPath)(hit, [
        "_highlightResult"
    ].concat($34e04db7e78f5488$var$_toConsumableArray(path), [
        "value"
    ]));
    if (typeof highlightedValue !== "string") highlightedValue = (0, $gwdM4.getAttributeValueByPath)(hit, path) || "";
    return (0, $icSrZ.parseAttribute)({
        highlightedValue: highlightedValue
    });
}

});
parcelRegister("gwdM4", function(module, exports) {

$parcel$export(module.exports, "getAttributeValueByPath", function () { return $c06a51c561e6808a$export$3219add52b18c0d7; });
function $c06a51c561e6808a$export$3219add52b18c0d7(record, path) {
    return path.reduce(function(current, key) {
        return current && current[key];
    }, record);
}

});

parcelRegister("icSrZ", function(module, exports) {

$parcel$export(module.exports, "parseAttribute", function () { return $d41395b3b41f54db$export$dd369bc78e81a241; });

var $4Xtx9Y = parcelRequire("4Xtx9Y");
/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */ function $d41395b3b41f54db$var$createAttributeSet() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = initialValue;
    return {
        get: function get() {
            return value;
        },
        add: function add(part) {
            var lastPart = value[value.length - 1];
            if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) value[value.length - 1] = {
                value: lastPart.value + part.value,
                isHighlighted: lastPart.isHighlighted
            };
            else value.push(part);
        }
    };
}
function $d41395b3b41f54db$export$dd369bc78e81a241(_ref) {
    var highlightedValue = _ref.highlightedValue;
    var preTagParts = highlightedValue.split((0, $4Xtx9Y.HIGHLIGHT_PRE_TAG));
    var firstValue = preTagParts.shift();
    var parts = $d41395b3b41f54db$var$createAttributeSet(firstValue ? [
        {
            value: firstValue,
            isHighlighted: false
        }
    ] : []);
    preTagParts.forEach(function(part) {
        var postTagParts = part.split((0, $4Xtx9Y.HIGHLIGHT_POST_TAG));
        parts.add({
            value: postTagParts[0],
            isHighlighted: true
        });
        if (postTagParts[1] !== "") parts.add({
            value: postTagParts[1],
            isHighlighted: false
        });
    });
    return parts.get();
}

});
parcelRegister("4Xtx9Y", function(module, exports) {

$parcel$export(module.exports, "HIGHLIGHT_PRE_TAG", function () { return $39c394e9c1e99175$export$2df5424f792538bd; });
$parcel$export(module.exports, "HIGHLIGHT_POST_TAG", function () { return $39c394e9c1e99175$export$2681d4c6a4ae86; });
var $39c394e9c1e99175$export$2df5424f792538bd = "__aa-highlight__";
var $39c394e9c1e99175$export$2681d4c6a4ae86 = "__/aa-highlight__";

});




parcelRegister("gzewo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c6d1b17b139536$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $3QNZB = parcelRequire("3QNZB");

var $l2iop = parcelRequire("l2iop");

var $fpzRv = parcelRequire("fpzRv");

var $f6qj2 = parcelRequire("f6qj2");
const $b0c6d1b17b139536$var$useAlogoliaAutoComplete = ({ searchIndex: searchIndex, ALGOLIA_FACET_KEY: ALGOLIA_FACET_KEY, ALGOLIA_APP_ID: ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY: ALGOLIA_SEARCH_API_KEY, queryParams: queryParams, aiEnabled: aiEnabled = false })=>{
    const intl = (0, $f6qj2.default)();
    const algoliaSearchClient = (0, $fpzRv.default)(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
    const [autocompleteState, setAutocompleteState] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: "",
        activeItemId: null,
        status: "idle"
    });
    let placeholder = intl.formatMessage({
        id: "globalnav.v2.search-bar.placeholder",
        defaultMessage: "Search Keywords"
    });
    if (aiEnabled) placeholder = intl.formatMessage({
        id: "globalnav.v2.search-bar.ai-enabled.placeholder",
        defaultMessage: "Search or ask anything like \u201CHow much does Jira cost?\u201D"
    });
    const autocomplete = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useMemo(()=>(0, $3QNZB.createAutocomplete)({
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            onStateChange ({ state: state }) {
                setAutocompleteState(state);
            },
            insights: true,
            getSources () {
                const sources = [];
                // Add AI source if enabled
                if (aiEnabled) sources.push({
                    sourceId: "ai-assistant",
                    getItems ({ query: query }) {
                        // Only show AI result if there's a query
                        if (!(query === null || query === void 0 ? void 0 : query.trim())) return [];
                        return [
                            {
                                objectID: "ai-assistant",
                                title: `${query}`,
                                url: "#",
                                queryID: "ai-assistant",
                                position: 0
                            }
                        ];
                    },
                    getItemUrl () {
                        return "#";
                    }
                });
                // Add regular Algolia source
                sources.push({
                    sourceId: ALGOLIA_FACET_KEY,
                    getItems ({ query: query }) {
                        return (0, $l2iop.getAlgoliaResults)({
                            searchClient: algoliaSearchClient,
                            queries: [
                                {
                                    indexName: searchIndex,
                                    query: query,
                                    params: queryParams
                                }
                            ],
                            transformResponse ({ results: results, hits: hits }) {
                                // tranform response so that each hit also contains its position and queryID for analytics purposes
                                const [result] = results;
                                const queryID = result === null || result === void 0 ? void 0 : result.queryID;
                                const [originalHits] = hits;
                                return originalHits === null || originalHits === void 0 ? void 0 : originalHits.map((hit, index)=>(0, $6iHNw._)((0, $7Knp0._)({}, hit), {
                                        queryID: queryID,
                                        position: index + 1
                                    }));
                            }
                        });
                    },
                    getItemUrl ({ item: item }) {
                        return item.url;
                    }
                });
                return sources;
            },
            placeholder: placeholder,
            openOnFocus: false,
            stallThreshold: 500
        }), [
        aiEnabled
    ]);
    return {
        autocompleteState: autocompleteState,
        autocomplete: autocomplete
    };
};
var $b0c6d1b17b139536$export$2e2bcd8739ae039 = $b0c6d1b17b139536$var$useAlogoliaAutoComplete;

});
parcelRegister("3QNZB", function(module, exports) {

$parcel$export(module.exports, "createAutocomplete", function () { return $2cdd01ee5c2d203b$export$b00b86c416695282; });

var $a1VWk = parcelRequire("a1VWk");

var $1dMYn = parcelRequire("1dMYn");

var $ekhNQ = parcelRequire("ekhNQ");

var $25bgk = parcelRequire("25bgk");

var $3se9r = parcelRequire("3se9r");

var $dQrVz = parcelRequire("dQrVz");

var $laf3I = parcelRequire("laf3I");

var $jD7hK = parcelRequire("jD7hK");

var $garUZ = parcelRequire("garUZ");
function $2cdd01ee5c2d203b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2cdd01ee5c2d203b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2cdd01ee5c2d203b$var$_typeof(obj);
}
function $2cdd01ee5c2d203b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2cdd01ee5c2d203b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2cdd01ee5c2d203b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2cdd01ee5c2d203b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2cdd01ee5c2d203b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2cdd01ee5c2d203b$var$_defineProperty(obj, key, value) {
    key = $2cdd01ee5c2d203b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2cdd01ee5c2d203b$var$_toPropertyKey(arg) {
    var key = $2cdd01ee5c2d203b$var$_toPrimitive(arg, "string");
    return $2cdd01ee5c2d203b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2cdd01ee5c2d203b$var$_toPrimitive(input, hint) {
    if ($2cdd01ee5c2d203b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2cdd01ee5c2d203b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2cdd01ee5c2d203b$export$b00b86c416695282(options) {
    (0, $1dMYn.checkOptions)(options);
    var subscribers = [];
    var props = (0, $3se9r.getDefaultProps)(options, subscribers);
    var store = (0, $ekhNQ.createStore)((0, $garUZ.stateReducer), props, onStoreStateChange);
    var setters = (0, $25bgk.getAutocompleteSetters)({
        store: store
    });
    var propGetters = (0, $dQrVz.getPropGetters)($2cdd01ee5c2d203b$var$_objectSpread({
        props: props,
        refresh: refresh,
        store: store,
        navigator: props.navigator
    }, setters));
    function onStoreStateChange(_ref) {
        var _state$context, _state$context$algoli;
        var prevState = _ref.prevState, state = _ref.state;
        props.onStateChange($2cdd01ee5c2d203b$var$_objectSpread({
            prevState: prevState,
            state: state,
            refresh: refresh,
            navigator: props.navigator
        }, setters));
        if (!isAlgoliaInsightsPluginEnabled() && (_state$context = state.context) !== null && _state$context !== void 0 && (_state$context$algoli = _state$context.algoliaInsightsPlugin) !== null && _state$context$algoli !== void 0 && _state$context$algoli.__automaticInsights && props.insights !== false) {
            var plugin = (0, $a1VWk.createAlgoliaInsightsPlugin)({
                __autocomplete_clickAnalytics: false
            });
            props.plugins.push(plugin);
            subscribePlugins([
                plugin
            ]);
        }
    }
    function refresh() {
        return (0, $jD7hK.onInput)($2cdd01ee5c2d203b$var$_objectSpread({
            event: new Event("input"),
            nextState: {
                isOpen: store.getState().isOpen
            },
            props: props,
            navigator: props.navigator,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters));
    }
    function subscribePlugins(plugins) {
        plugins.forEach(function(plugin) {
            var _plugin$subscribe;
            return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, $2cdd01ee5c2d203b$var$_objectSpread($2cdd01ee5c2d203b$var$_objectSpread({}, setters), {}, {
                navigator: props.navigator,
                refresh: refresh,
                onSelect: function onSelect(fn) {
                    subscribers.push({
                        onSelect: fn
                    });
                },
                onActive: function onActive(fn) {
                    subscribers.push({
                        onActive: fn
                    });
                },
                onResolve: function onResolve(fn) {
                    subscribers.push({
                        onResolve: fn
                    });
                }
            }));
        });
    }
    function isAlgoliaInsightsPluginEnabled() {
        return props.plugins.some(function(plugin) {
            return plugin.name === "aa.algoliaInsightsPlugin";
        });
    }
    if (props.insights && !isAlgoliaInsightsPluginEnabled()) {
        var insightsParams = typeof props.insights === "boolean" ? {} : props.insights;
        props.plugins.push((0, $a1VWk.createAlgoliaInsightsPlugin)(insightsParams));
    }
    subscribePlugins(props.plugins);
    (0, $laf3I.injectMetadata)({
        metadata: (0, $laf3I.getMetadata)({
            plugins: props.plugins,
            options: options
        }),
        environment: props.environment
    });
    return $2cdd01ee5c2d203b$var$_objectSpread($2cdd01ee5c2d203b$var$_objectSpread({
        refresh: refresh,
        navigator: props.navigator
    }, propGetters), setters);
}

});
parcelRegister("a1VWk", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaInsightsPlugin", function () { return $74d6f1016810474c$export$89ab4208990a3782; });

var $01wNs = parcelRequire("01wNs");
var $bdFA0 = parcelRequire("bdFA0");
var $aQa8M = parcelRequire("aQa8M");
var $3aBnI = parcelRequire("3aBnI");
var $29cdb = parcelRequire("29cdb");

var $fAgBT = parcelRequire("fAgBT");

var $kaN0d = parcelRequire("kaN0d");

var $ksEwt = parcelRequire("ksEwt");

var $imisf = parcelRequire("imisf");
function $74d6f1016810474c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $74d6f1016810474c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $74d6f1016810474c$var$_typeof(obj);
}
function $74d6f1016810474c$var$_toConsumableArray(arr) {
    return $74d6f1016810474c$var$_arrayWithoutHoles(arr) || $74d6f1016810474c$var$_iterableToArray(arr) || $74d6f1016810474c$var$_unsupportedIterableToArray(arr) || $74d6f1016810474c$var$_nonIterableSpread();
}
function $74d6f1016810474c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $74d6f1016810474c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $74d6f1016810474c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $74d6f1016810474c$var$_arrayLikeToArray(o, minLen);
}
function $74d6f1016810474c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $74d6f1016810474c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $74d6f1016810474c$var$_arrayLikeToArray(arr);
}
function $74d6f1016810474c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $74d6f1016810474c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74d6f1016810474c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $74d6f1016810474c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $74d6f1016810474c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $74d6f1016810474c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $74d6f1016810474c$var$_defineProperty(obj, key, value) {
    key = $74d6f1016810474c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $74d6f1016810474c$var$_toPropertyKey(arg) {
    var key = $74d6f1016810474c$var$_toPrimitive(arg, "string");
    return $74d6f1016810474c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $74d6f1016810474c$var$_toPrimitive(input, hint) {
    if ($74d6f1016810474c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($74d6f1016810474c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $74d6f1016810474c$var$VIEW_EVENT_DELAY = 400;
var $74d6f1016810474c$var$ALGOLIA_INSIGHTS_VERSION = "2.15.0";
var $74d6f1016810474c$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($74d6f1016810474c$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
var $74d6f1016810474c$var$sendViewedObjectIDs = (0, $bdFA0.debounce)(function(_ref) {
    var onItemsChange = _ref.onItemsChange, items = _ref.items, insights = _ref.insights, state = _ref.state;
    onItemsChange({
        insights: insights,
        insightsEvents: (0, $ksEwt.createViewedEvents)({
            items: items
        }).map(function(event) {
            return $74d6f1016810474c$var$_objectSpread({
                eventName: "Items Viewed"
            }, event);
        }),
        state: state
    });
}, $74d6f1016810474c$var$VIEW_EVENT_DELAY);
function $74d6f1016810474c$export$89ab4208990a3782(options) {
    var _getOptions = $74d6f1016810474c$var$getOptions(options), providedInsightsClient = _getOptions.insightsClient, insightsInitParams = _getOptions.insightsInitParams, onItemsChange = _getOptions.onItemsChange, onSelectEvent = _getOptions.onSelect, onActiveEvent = _getOptions.onActive, __autocomplete_clickAnalytics = _getOptions.__autocomplete_clickAnalytics;
    var insightsClient = providedInsightsClient;
    if (!providedInsightsClient) (0, $29cdb.safelyRunOnBrowser)(function(_ref2) {
        var window = _ref2.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") insightsClient = window[pointer];
        if (!insightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) window[pointer] = function() {
                if (!window[pointer].queue) window[pointer].queue = [];
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                window[pointer].queue.push(args);
            };
            window[pointer].version = $74d6f1016810474c$var$ALGOLIA_INSIGHTS_VERSION;
            insightsClient = window[pointer];
            $74d6f1016810474c$var$loadInsights(window);
        }
    });
    // We return an empty plugin if `insightsClient` is still undefined at
    // this stage, which can happen in server environments.
    if (!insightsClient) return {};
    if (insightsInitParams) insightsClient("init", $74d6f1016810474c$var$_objectSpread({
        partial: true
    }, insightsInitParams));
    var insights = (0, $kaN0d.createSearchInsightsApi)(insightsClient);
    var previousItems = (0, $01wNs.createRef)([]);
    var debouncedOnStateChange = (0, $bdFA0.debounce)(function(_ref3) {
        var state = _ref3.state;
        if (!state.isOpen) return;
        var items = state.collections.reduce(function(acc, current) {
            return [].concat($74d6f1016810474c$var$_toConsumableArray(acc), $74d6f1016810474c$var$_toConsumableArray(current.items));
        }, []).filter((0, $imisf.isAlgoliaInsightsHit));
        if (!(0, $aQa8M.isEqual)(previousItems.current.map(function(x) {
            return x.objectID;
        }), items.map(function(x) {
            return x.objectID;
        }))) {
            previousItems.current = items;
            if (items.length > 0) $74d6f1016810474c$var$sendViewedObjectIDs({
                onItemsChange: onItemsChange,
                items: items,
                insights: insights,
                state: state
            });
        }
    }, 0);
    return {
        name: "aa.algoliaInsightsPlugin",
        subscribe: function subscribe(_ref4) {
            var setContext = _ref4.setContext, onSelect = _ref4.onSelect, onActive = _ref4.onActive;
            function setInsightsContext(userToken) {
                setContext({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: $74d6f1016810474c$var$_objectSpread($74d6f1016810474c$var$_objectSpread({}, __autocomplete_clickAnalytics ? {
                            clickAnalytics: true
                        } : {}), userToken ? {
                            userToken: $74d6f1016810474c$var$normalizeUserToken(userToken)
                        } : {}),
                        insights: insights
                    }
                });
            }
            insightsClient("addAlgoliaAgent", "insights-plugin");
            setInsightsContext();
            // Handles user token changes
            insightsClient("onUserTokenChange", function(userToken) {
                setInsightsContext(userToken);
            });
            insightsClient("getUserToken", null, function(_error, userToken) {
                setInsightsContext(userToken);
            });
            onSelect(function(_ref5) {
                var item = _ref5.item, state = _ref5.state, event = _ref5.event, source = _ref5.source;
                if (!(0, $imisf.isAlgoliaInsightsHit)(item)) return;
                onSelectEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $74d6f1016810474c$var$_objectSpread({
                            eventName: "Item Selected"
                        }, (0, $fAgBT.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $imisf.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
            onActive(function(_ref6) {
                var item = _ref6.item, source = _ref6.source, state = _ref6.state, event = _ref6.event;
                if (!(0, $imisf.isAlgoliaInsightsHit)(item)) return;
                onActiveEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $74d6f1016810474c$var$_objectSpread({
                            eventName: "Item Active"
                        }, (0, $fAgBT.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $imisf.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
        },
        onStateChange: function onStateChange(_ref7) {
            var state = _ref7.state;
            debouncedOnStateChange({
                state: state
            });
        },
        __autocomplete_pluginOptions: options
    };
}
function $74d6f1016810474c$var$getAlgoliaSources() {
    var _context$algoliaInsig;
    var algoliaSourceBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var context = arguments.length > 1 ? arguments[1] : undefined;
    return [].concat($74d6f1016810474c$var$_toConsumableArray(algoliaSourceBase), [
        "autocomplete-internal"
    ], $74d6f1016810474c$var$_toConsumableArray((_context$algoliaInsig = context.algoliaInsightsPlugin) !== null && _context$algoliaInsig !== void 0 && _context$algoliaInsig.__automaticInsights ? [
        "autocomplete-automatic"
    ] : []));
}
function $74d6f1016810474c$var$getOptions(options) {
    return $74d6f1016810474c$var$_objectSpread({
        onItemsChange: function onItemsChange(_ref8) {
            var insights = _ref8.insights, insightsEvents = _ref8.insightsEvents, state = _ref8.state;
            insights.viewedObjectIDs.apply(insights, $74d6f1016810474c$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $74d6f1016810474c$var$_objectSpread($74d6f1016810474c$var$_objectSpread({}, event), {}, {
                    algoliaSource: $74d6f1016810474c$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onSelect: function onSelect(_ref9) {
            var insights = _ref9.insights, insightsEvents = _ref9.insightsEvents, state = _ref9.state;
            insights.clickedObjectIDsAfterSearch.apply(insights, $74d6f1016810474c$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $74d6f1016810474c$var$_objectSpread($74d6f1016810474c$var$_objectSpread({}, event), {}, {
                    algoliaSource: $74d6f1016810474c$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onActive: (0, $3aBnI.noop),
        __autocomplete_clickAnalytics: true
    }, options);
}
function $74d6f1016810474c$var$loadInsights(environment) {
    var errorMessage = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
    try {
        var script = environment.document.createElement("script");
        script.async = true;
        script.src = $74d6f1016810474c$var$ALGOLIA_INSIGHTS_SRC;
        script.onerror = function() {
            // eslint-disable-next-line no-console
            console.error(errorMessage);
        };
        document.body.appendChild(script);
    } catch (cause) {
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $74d6f1016810474c$var$normalizeUserToken(userToken) {
    return typeof userToken === "number" ? userToken.toString() : userToken;
}

});
parcelRegister("01wNs", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $004988db353016ec$export$7d1e3a5e95ceca43; });
function $004988db353016ec$export$7d1e3a5e95ceca43(initialValue) {
    return {
        current: initialValue
    };
}

});

parcelRegister("bdFA0", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $82b1297e26808ee6$export$61fc7d43ac8f84b0; });
function $82b1297e26808ee6$export$61fc7d43ac8f84b0(fn, time) {
    var timerId = undefined;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            return fn.apply(void 0, args);
        }, time);
    };
}

});

parcelRegister("aQa8M", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $7e46a06b790a6f1b$export$248d38f6296296c5; });
function $7e46a06b790a6f1b$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $7e46a06b790a6f1b$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($7e46a06b790a6f1b$var$isPrimitive(first) || $7e46a06b790a6f1b$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$7e46a06b790a6f1b$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("3aBnI", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $24ef4d72c9c3ff10$export$8793edee2d425525; });
var $24ef4d72c9c3ff10$export$8793edee2d425525 = function noop() {};

});

parcelRegister("29cdb", function(module, exports) {

$parcel$export(module.exports, "safelyRunOnBrowser", function () { return $1905e50855fa3285$export$39f19eed34acd2f1; });
/**
 * Safely runs code meant for browser environments only.
 */ function $1905e50855fa3285$export$39f19eed34acd2f1(callback) {
    if (typeof window !== "undefined") return callback({
        window: window
    });
    return undefined;
}

});

parcelRegister("fAgBT", function(module, exports) {

$parcel$export(module.exports, "createClickedEvent", function () { return $b5871a37af060e77$export$285269928260a84d; });
function $b5871a37af060e77$export$285269928260a84d(_ref) {
    var item = _ref.item, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items;
    return {
        index: item.__autocomplete_indexName,
        items: [
            item
        ],
        positions: [
            1 + items.findIndex(function(x) {
                return x.objectID === item.objectID;
            })
        ],
        queryID: item.__autocomplete_queryID,
        algoliaSource: [
            "autocomplete"
        ]
    };
}

});

parcelRegister("kaN0d", function(module, exports) {

$parcel$export(module.exports, "createSearchInsightsApi", function () { return $eafac0b65efc74f2$export$96bc93a891c6f784; });

var $9nAIn = parcelRequire("9nAIn");
var $eafac0b65efc74f2$var$_excluded = [
    "items"
], $eafac0b65efc74f2$var$_excluded2 = [
    "items"
];
function $eafac0b65efc74f2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $eafac0b65efc74f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $eafac0b65efc74f2$var$_typeof(obj);
}
function $eafac0b65efc74f2$var$_toConsumableArray(arr) {
    return $eafac0b65efc74f2$var$_arrayWithoutHoles(arr) || $eafac0b65efc74f2$var$_iterableToArray(arr) || $eafac0b65efc74f2$var$_unsupportedIterableToArray(arr) || $eafac0b65efc74f2$var$_nonIterableSpread();
}
function $eafac0b65efc74f2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eafac0b65efc74f2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eafac0b65efc74f2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eafac0b65efc74f2$var$_arrayLikeToArray(o, minLen);
}
function $eafac0b65efc74f2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $eafac0b65efc74f2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $eafac0b65efc74f2$var$_arrayLikeToArray(arr);
}
function $eafac0b65efc74f2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eafac0b65efc74f2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eafac0b65efc74f2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eafac0b65efc74f2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $eafac0b65efc74f2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eafac0b65efc74f2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eafac0b65efc74f2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $eafac0b65efc74f2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eafac0b65efc74f2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eafac0b65efc74f2$var$_defineProperty(obj, key, value) {
    key = $eafac0b65efc74f2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eafac0b65efc74f2$var$_toPropertyKey(arg) {
    var key = $eafac0b65efc74f2$var$_toPrimitive(arg, "string");
    return $eafac0b65efc74f2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $eafac0b65efc74f2$var$_toPrimitive(input, hint) {
    if ($eafac0b65efc74f2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($eafac0b65efc74f2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $eafac0b65efc74f2$var$chunk(item) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < item.objectIDs.length; i += chunkSize)chunks.push($eafac0b65efc74f2$var$_objectSpread($eafac0b65efc74f2$var$_objectSpread({}, item), {}, {
        objectIDs: item.objectIDs.slice(i, i + chunkSize)
    }));
    return chunks;
}
function $eafac0b65efc74f2$var$mapToInsightsParamsApi(params) {
    return params.map(function(_ref) {
        var items = _ref.items, param = $eafac0b65efc74f2$var$_objectWithoutProperties(_ref, $eafac0b65efc74f2$var$_excluded);
        return $eafac0b65efc74f2$var$_objectSpread($eafac0b65efc74f2$var$_objectSpread({}, param), {}, {
            objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref2) {
                var objectID = _ref2.objectID;
                return objectID;
            })) || param.objectIDs
        });
    });
}
function $eafac0b65efc74f2$export$96bc93a891c6f784(searchInsights) {
    var canSendHeaders = (0, $9nAIn.isModernInsightsClient)(searchInsights);
    function sendToInsights(method, payloads, items) {
        if (canSendHeaders && typeof items !== "undefined") {
            var _items$0$__autocomple = items[0].__autocomplete_algoliaCredentials, appId = _items$0$__autocomple.appId, apiKey = _items$0$__autocomple.apiKey;
            var headers = {
                "X-Algolia-Application-Id": appId,
                "X-Algolia-API-Key": apiKey
            };
            searchInsights.apply(void 0, [
                method
            ].concat($eafac0b65efc74f2$var$_toConsumableArray(payloads), [
                {
                    headers: headers
                }
            ]));
        } else searchInsights.apply(void 0, [
            method
        ].concat($eafac0b65efc74f2$var$_toConsumableArray(payloads)));
    }
    return {
        /**
     * Initializes Insights with Algolia credentials.
     */ init: function init(appId, apiKey) {
            searchInsights("init", {
                appId: appId,
                apiKey: apiKey
            });
        },
        /**
     * Sets the authenticated user token to attach to events.
     * Unsets the authenticated token by passing `undefined`.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/set-authenticated-user-token/
     */ setAuthenticatedUserToken: function setAuthenticatedUserToken(authenticatedUserToken) {
            searchInsights("setAuthenticatedUserToken", authenticatedUserToken);
        },
        /**
     * Sets the user token to attach to events.
     */ setUserToken: function setUserToken(userToken) {
            searchInsights("setUserToken", userToken);
        },
        /**
     * Sends click events to capture a query and its clicked items and positions.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids-after-search/
     */ clickedObjectIDsAfterSearch: function clickedObjectIDsAfterSearch() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            if (params.length > 0) sendToInsights("clickedObjectIDsAfterSearch", $eafac0b65efc74f2$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids/
     */ clickedObjectIDs: function clickedObjectIDs() {
            for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
            if (params.length > 0) sendToInsights("clickedObjectIDs", $eafac0b65efc74f2$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture the filters a user clicks on.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-filters/
     */ clickedFilters: function clickedFilters() {
            for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
            if (params.length > 0) searchInsights.apply(void 0, [
                "clickedFilters"
            ].concat(params));
        },
        /**
     * Sends conversion events to capture a query and its clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids-after-search/
     */ convertedObjectIDsAfterSearch: function convertedObjectIDsAfterSearch() {
            for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
            if (params.length > 0) sendToInsights("convertedObjectIDsAfterSearch", $eafac0b65efc74f2$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/
     */ convertedObjectIDs: function convertedObjectIDs() {
            for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
            if (params.length > 0) sendToInsights("convertedObjectIDs", $eafac0b65efc74f2$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture the filters a user uses when converting.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-filters/
     */ convertedFilters: function convertedFilters() {
            for(var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)params[_key6] = arguments[_key6];
            if (params.length > 0) searchInsights.apply(void 0, [
                "convertedFilters"
            ].concat(params));
        },
        /**
     * Sends view events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/
     */ viewedObjectIDs: function viewedObjectIDs() {
            for(var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)params[_key7] = arguments[_key7];
            if (params.length > 0) params.reduce(function(acc, _ref3) {
                var items = _ref3.items, param = $eafac0b65efc74f2$var$_objectWithoutProperties(_ref3, $eafac0b65efc74f2$var$_excluded2);
                return [].concat($eafac0b65efc74f2$var$_toConsumableArray(acc), $eafac0b65efc74f2$var$_toConsumableArray($eafac0b65efc74f2$var$chunk($eafac0b65efc74f2$var$_objectSpread($eafac0b65efc74f2$var$_objectSpread({}, param), {}, {
                    objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref4) {
                        var objectID = _ref4.objectID;
                        return objectID;
                    })) || param.objectIDs
                })).map(function(payload) {
                    return {
                        items: items,
                        payload: payload
                    };
                })));
            }, []).forEach(function(_ref5) {
                var items = _ref5.items, payload = _ref5.payload;
                return sendToInsights("viewedObjectIDs", [
                    payload
                ], items);
            });
        },
        /**
     * Sends view events to capture the filters a user uses when viewing.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-filters/
     */ viewedFilters: function viewedFilters() {
            for(var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)params[_key8] = arguments[_key8];
            if (params.length > 0) searchInsights.apply(void 0, [
                "viewedFilters"
            ].concat(params));
        }
    };
}

});
parcelRegister("9nAIn", function(module, exports) {

$parcel$export(module.exports, "isModernInsightsClient", function () { return $6d42bdcc870fc39a$export$5c9cfc0c9d3b5e01; });
function $6d42bdcc870fc39a$var$_slicedToArray(arr, i) {
    return $6d42bdcc870fc39a$var$_arrayWithHoles(arr) || $6d42bdcc870fc39a$var$_iterableToArrayLimit(arr, i) || $6d42bdcc870fc39a$var$_unsupportedIterableToArray(arr, i) || $6d42bdcc870fc39a$var$_nonIterableRest();
}
function $6d42bdcc870fc39a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d42bdcc870fc39a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d42bdcc870fc39a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d42bdcc870fc39a$var$_arrayLikeToArray(o, minLen);
}
function $6d42bdcc870fc39a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d42bdcc870fc39a$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $6d42bdcc870fc39a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6d42bdcc870fc39a$export$5c9cfc0c9d3b5e01(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $6d42bdcc870fc39a$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/camelcase */ var v3 = major >= 3;
    var v2_4 = major === 2 && minor >= 4;
    var v1_10 = major === 1 && minor >= 10;
    return v3 || v2_4 || v1_10;
/* eslint-enable @typescript-eslint/camelcase */ }

});


parcelRegister("ksEwt", function(module, exports) {

$parcel$export(module.exports, "createViewedEvents", function () { return $ee55db21bb7de060$export$8bae0094a47f6972; });
function $ee55db21bb7de060$export$8bae0094a47f6972(_ref) {
    var items = _ref.items;
    var itemsByIndexName = items.reduce(function(acc, current) {
        var _acc$current$__autoco;
        acc[current.__autocomplete_indexName] = ((_acc$current$__autoco = acc[current.__autocomplete_indexName]) !== null && _acc$current$__autoco !== void 0 ? _acc$current$__autoco : []).concat(current);
        return acc;
    }, {});
    return Object.keys(itemsByIndexName).map(function(indexName) {
        var items = itemsByIndexName[indexName];
        return {
            index: indexName,
            items: items,
            algoliaSource: [
                "autocomplete"
            ]
        };
    });
}

});

parcelRegister("imisf", function(module, exports) {

$parcel$export(module.exports, "isAlgoliaInsightsHit", function () { return $d5d898c5b24b471c$export$977f4849b4f88a72; });
function $d5d898c5b24b471c$export$977f4849b4f88a72(hit) {
    return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}

});


parcelRegister("1dMYn", function(module, exports) {

$parcel$export(module.exports, "checkOptions", function () { return $0e3cfe52f848bce9$export$6fe837ce0e0e0cdf; });

function $0e3cfe52f848bce9$export$6fe837ce0e0e0cdf(options) {}

});

parcelRegister("ekhNQ", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $a6e0be3b3bc5331d$export$f51a9068ac82ea43; });

var $k548a = parcelRequire("k548a");
function $a6e0be3b3bc5331d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a6e0be3b3bc5331d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a6e0be3b3bc5331d$var$_typeof(obj);
}
function $a6e0be3b3bc5331d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6e0be3b3bc5331d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a6e0be3b3bc5331d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a6e0be3b3bc5331d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a6e0be3b3bc5331d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a6e0be3b3bc5331d$var$_defineProperty(obj, key, value) {
    key = $a6e0be3b3bc5331d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a6e0be3b3bc5331d$var$_toPropertyKey(arg) {
    var key = $a6e0be3b3bc5331d$var$_toPrimitive(arg, "string");
    return $a6e0be3b3bc5331d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a6e0be3b3bc5331d$var$_toPrimitive(input, hint) {
    if ($a6e0be3b3bc5331d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a6e0be3b3bc5331d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a6e0be3b3bc5331d$export$f51a9068ac82ea43(reducer, props, onStoreStateChange) {
    var state = props.initialState;
    return {
        getState: function getState() {
            return state;
        },
        dispatch: function dispatch(action, payload) {
            var prevState = $a6e0be3b3bc5331d$var$_objectSpread({}, state);
            state = reducer(state, {
                type: action,
                props: props,
                payload: payload
            });
            onStoreStateChange({
                state: state,
                prevState: prevState
            });
        },
        pendingRequests: (0, $k548a.createCancelablePromiseList)()
    };
}

});
parcelRegister("k548a", function(module, exports) {

$parcel$export(module.exports, "createCancelablePromiseList", function () { return $e9e77a8c24db3f9f$export$9661f890aacb4415; });
function $e9e77a8c24db3f9f$export$9661f890aacb4415() {
    var list = [];
    return {
        add: function add(cancelablePromise) {
            list.push(cancelablePromise);
            return cancelablePromise.finally(function() {
                list = list.filter(function(item) {
                    return item !== cancelablePromise;
                });
            });
        },
        cancelAll: function cancelAll() {
            list.forEach(function(promise) {
                return promise.cancel();
            });
        },
        isEmpty: function isEmpty() {
            return list.length === 0;
        }
    };
}

});


parcelRegister("25bgk", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteSetters", function () { return $1844c8e2cd764c3b$export$5085b122b817cee; });

var $dpUQY = parcelRequire("dpUQY");
function $1844c8e2cd764c3b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1844c8e2cd764c3b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1844c8e2cd764c3b$var$_typeof(obj);
}
function $1844c8e2cd764c3b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1844c8e2cd764c3b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1844c8e2cd764c3b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1844c8e2cd764c3b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1844c8e2cd764c3b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1844c8e2cd764c3b$var$_defineProperty(obj, key, value) {
    key = $1844c8e2cd764c3b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1844c8e2cd764c3b$var$_toPropertyKey(arg) {
    var key = $1844c8e2cd764c3b$var$_toPrimitive(arg, "string");
    return $1844c8e2cd764c3b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1844c8e2cd764c3b$var$_toPrimitive(input, hint) {
    if ($1844c8e2cd764c3b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1844c8e2cd764c3b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1844c8e2cd764c3b$export$5085b122b817cee(_ref) {
    var store = _ref.store;
    var setActiveItemId = function setActiveItemId(value) {
        store.dispatch("setActiveItemId", value);
    };
    var setQuery = function setQuery(value) {
        store.dispatch("setQuery", value);
    };
    var setCollections = function setCollections(rawValue) {
        var baseItemId = 0;
        var value = rawValue.map(function(collection) {
            return $1844c8e2cd764c3b$var$_objectSpread($1844c8e2cd764c3b$var$_objectSpread({}, collection), {}, {
                // We flatten the stored items to support calling `getAlgoliaResults`
                // from the source itself.
                items: (0, $dpUQY.flatten)(collection.items).map(function(item) {
                    return $1844c8e2cd764c3b$var$_objectSpread($1844c8e2cd764c3b$var$_objectSpread({}, item), {}, {
                        __autocomplete_id: baseItemId++
                    });
                })
            });
        });
        store.dispatch("setCollections", value);
    };
    var setIsOpen = function setIsOpen(value) {
        store.dispatch("setIsOpen", value);
    };
    var setStatus = function setStatus(value) {
        store.dispatch("setStatus", value);
    };
    var setContext = function setContext(value) {
        store.dispatch("setContext", value);
    };
    return {
        setActiveItemId: setActiveItemId,
        setQuery: setQuery,
        setCollections: setCollections,
        setIsOpen: setIsOpen,
        setStatus: setStatus,
        setContext: setContext
    };
}

});
parcelRegister("dpUQY", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $9c49b60a7e0da368$export$bffa455ba8c619a6; });
function $9c49b60a7e0da368$export$bffa455ba8c619a6(values) {
    return values.reduce(function(a, b) {
        return a.concat(b);
    }, []);
}

});


parcelRegister("3se9r", function(module, exports) {

$parcel$export(module.exports, "getDefaultProps", function () { return $283ef6c796075f1e$export$61b94149aeb1f59; });

var $dpUQY = parcelRequire("dpUQY");
var $7gd6r = parcelRequire("7gd6r");
var $1O2Aa = parcelRequire("1O2Aa");

var $2NIII = parcelRequire("2NIII");
function $283ef6c796075f1e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $283ef6c796075f1e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $283ef6c796075f1e$var$_typeof(obj);
}
function $283ef6c796075f1e$var$_toConsumableArray(arr) {
    return $283ef6c796075f1e$var$_arrayWithoutHoles(arr) || $283ef6c796075f1e$var$_iterableToArray(arr) || $283ef6c796075f1e$var$_unsupportedIterableToArray(arr) || $283ef6c796075f1e$var$_nonIterableSpread();
}
function $283ef6c796075f1e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $283ef6c796075f1e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $283ef6c796075f1e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $283ef6c796075f1e$var$_arrayLikeToArray(o, minLen);
}
function $283ef6c796075f1e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $283ef6c796075f1e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $283ef6c796075f1e$var$_arrayLikeToArray(arr);
}
function $283ef6c796075f1e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $283ef6c796075f1e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $283ef6c796075f1e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $283ef6c796075f1e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $283ef6c796075f1e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $283ef6c796075f1e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $283ef6c796075f1e$var$_defineProperty(obj, key, value) {
    key = $283ef6c796075f1e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $283ef6c796075f1e$var$_toPropertyKey(arg) {
    var key = $283ef6c796075f1e$var$_toPrimitive(arg, "string");
    return $283ef6c796075f1e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $283ef6c796075f1e$var$_toPrimitive(input, hint) {
    if ($283ef6c796075f1e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($283ef6c796075f1e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $283ef6c796075f1e$export$61b94149aeb1f59(props, pluginSubscribers) {
    var _props$id;
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== "undefined" ? window : {};
    /* eslint-enable no-restricted-globals */ var plugins = props.plugins || [];
    return $283ef6c796075f1e$var$_objectSpread($283ef6c796075f1e$var$_objectSpread({
        debug: false,
        openOnFocus: false,
        enterKeyHint: undefined,
        ignoreCompositionEvents: false,
        placeholder: "",
        autoFocus: false,
        defaultActiveItemId: null,
        stallThreshold: 300,
        insights: undefined,
        environment: environment,
        shouldPanelOpen: function shouldPanelOpen(_ref) {
            var state = _ref.state;
            return (0, $1O2Aa.getItemsCount)(state) > 0;
        },
        reshape: function reshape(_ref2) {
            var sources = _ref2.sources;
            return sources;
        }
    }, props), {}, {
        // Since `generateAutocompleteId` triggers a side effect (it increments
        // an internal counter), we don't want to execute it if unnecessary.
        id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, $7gd6r.generateAutocompleteId)(),
        plugins: plugins,
        // The following props need to be deeply defaulted.
        initialState: $283ef6c796075f1e$var$_objectSpread({
            activeItemId: null,
            query: "",
            completion: null,
            collections: [],
            isOpen: false,
            status: "idle",
            context: {}
        }, props.initialState),
        onStateChange: function onStateChange(params) {
            var _props$onStateChange;
            (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 || _props$onStateChange.call(props, params);
            plugins.forEach(function(x) {
                var _x$onStateChange;
                return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
            });
        },
        onSubmit: function onSubmit(params) {
            var _props$onSubmit;
            (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props, params);
            plugins.forEach(function(x) {
                var _x$onSubmit;
                return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
            });
        },
        onReset: function onReset(params) {
            var _props$onReset;
            (_props$onReset = props.onReset) === null || _props$onReset === void 0 || _props$onReset.call(props, params);
            plugins.forEach(function(x) {
                var _x$onReset;
                return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
            });
        },
        getSources: function getSources(params) {
            return Promise.all([].concat($283ef6c796075f1e$var$_toConsumableArray(plugins.map(function(plugin) {
                return plugin.getSources;
            })), [
                props.getSources
            ]).filter(Boolean).map(function(getSources) {
                return (0, $2NIII.getNormalizedSources)(getSources, params);
            })).then(function(nested) {
                return (0, $dpUQY.flatten)(nested);
            }).then(function(sources) {
                return sources.map(function(source) {
                    return $283ef6c796075f1e$var$_objectSpread($283ef6c796075f1e$var$_objectSpread({}, source), {}, {
                        onSelect: function onSelect(params) {
                            source.onSelect(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onSelect;
                                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
                            });
                        },
                        onActive: function onActive(params) {
                            source.onActive(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onActive;
                                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
                            });
                        },
                        onResolve: function onResolve(params) {
                            source.onResolve(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onResolve;
                                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
                            });
                        }
                    });
                });
            });
        },
        navigator: $283ef6c796075f1e$var$_objectSpread({
            navigate: function navigate(_ref3) {
                var itemUrl = _ref3.itemUrl;
                environment.location.assign(itemUrl);
            },
            navigateNewTab: function navigateNewTab(_ref4) {
                var itemUrl = _ref4.itemUrl;
                var windowReference = environment.open(itemUrl, "_blank", "noopener");
                windowReference === null || windowReference === void 0 || windowReference.focus();
            },
            navigateNewWindow: function navigateNewWindow(_ref5) {
                var itemUrl = _ref5.itemUrl;
                environment.open(itemUrl, "_blank", "noopener");
            }
        }, props.navigator)
    });
}

});
parcelRegister("7gd6r", function(module, exports) {

$parcel$export(module.exports, "generateAutocompleteId", function () { return $549430f70fd93aaa$export$46ae397d8484b6c2; });
var $549430f70fd93aaa$var$autocompleteId = 0;
function $549430f70fd93aaa$export$46ae397d8484b6c2() {
    return "autocomplete-".concat($549430f70fd93aaa$var$autocompleteId++);
}

});

parcelRegister("1O2Aa", function(module, exports) {

$parcel$export(module.exports, "getItemsCount", function () { return $150c76c51a82d1b8$export$dd01a43948d7de86; });
function $150c76c51a82d1b8$export$dd01a43948d7de86(state) {
    if (state.collections.length === 0) return 0;
    return state.collections.reduce(function(sum, collection) {
        return sum + collection.items.length;
    }, 0);
}

});

parcelRegister("2NIII", function(module, exports) {

$parcel$export(module.exports, "getNormalizedSources", function () { return $20a2d8dbc603927c$export$c7afda361f77b571; });

var $1N7Aj = parcelRequire("1N7Aj");
var $lIndL = parcelRequire("lIndL");
var $3aBnI = parcelRequire("3aBnI");
function $20a2d8dbc603927c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20a2d8dbc603927c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $20a2d8dbc603927c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $20a2d8dbc603927c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $20a2d8dbc603927c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20a2d8dbc603927c$var$_defineProperty(obj, key, value) {
    key = $20a2d8dbc603927c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20a2d8dbc603927c$var$_toPropertyKey(arg) {
    var key = $20a2d8dbc603927c$var$_toPrimitive(arg, "string");
    return $20a2d8dbc603927c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $20a2d8dbc603927c$var$_toPrimitive(input, hint) {
    if ($20a2d8dbc603927c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($20a2d8dbc603927c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $20a2d8dbc603927c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $20a2d8dbc603927c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $20a2d8dbc603927c$var$_typeof(obj);
}
function $20a2d8dbc603927c$export$c7afda361f77b571(getSources, params) {
    var seenSourceIds = [];
    return Promise.resolve(getSources(params)).then(function(sources) {
        (0, $lIndL.invariant)(Array.isArray(sources), function() {
            return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify($20a2d8dbc603927c$var$_typeof(sources)), ":\n\n").concat(JSON.stringify((0, $1N7Aj.decycle)(sources), null, 2));
        });
        return Promise.all(sources// We allow `undefined` and `false` sources to allow users to use
        // `Boolean(query) && source` (=> `false`).
        // We need to remove these values at this point.
        .filter(function(maybeSource) {
            return Boolean(maybeSource);
        }).map(function(source) {
            (0, $lIndL.invariant)(typeof source.sourceId === "string", "A source must provide a `sourceId` string.");
            if (seenSourceIds.includes(source.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
            seenSourceIds.push(source.sourceId);
            var defaultSource = {
                getItemInputValue: function getItemInputValue(_ref) {
                    var state = _ref.state;
                    return state.query;
                },
                getItemUrl: function getItemUrl() {
                    return undefined;
                },
                onSelect: function onSelect(_ref2) {
                    var setIsOpen = _ref2.setIsOpen;
                    setIsOpen(false);
                },
                onActive: (0, $3aBnI.noop),
                onResolve: (0, $3aBnI.noop)
            };
            Object.keys(defaultSource).forEach(function(key) {
                defaultSource[key].__default = true;
            });
            var normalizedSource = $20a2d8dbc603927c$var$_objectSpread($20a2d8dbc603927c$var$_objectSpread({}, defaultSource), source);
            return Promise.resolve(normalizedSource);
        }));
    });
}

});
parcelRegister("1N7Aj", function(module, exports) {

$parcel$export(module.exports, "decycle", function () { return $14e04033a3c28ac1$export$ed3e2bdb532b061f; });
function $14e04033a3c28ac1$var$_slicedToArray(arr, i) {
    return $14e04033a3c28ac1$var$_arrayWithHoles(arr) || $14e04033a3c28ac1$var$_iterableToArrayLimit(arr, i) || $14e04033a3c28ac1$var$_unsupportedIterableToArray(arr, i) || $14e04033a3c28ac1$var$_nonIterableRest();
}
function $14e04033a3c28ac1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $14e04033a3c28ac1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $14e04033a3c28ac1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $14e04033a3c28ac1$var$_arrayLikeToArray(o, minLen);
}
function $14e04033a3c28ac1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $14e04033a3c28ac1$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $14e04033a3c28ac1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $14e04033a3c28ac1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $14e04033a3c28ac1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $14e04033a3c28ac1$var$_typeof(obj);
}
function $14e04033a3c28ac1$export$ed3e2bdb532b061f(obj) {
    var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var newSeen;
    return obj;
}

});

parcelRegister("lIndL", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $fcefb842e07c89eb$export$f5708dca728d7177; });
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $fcefb842e07c89eb$export$f5708dca728d7177(condition, message) {
    return;
}

});



parcelRegister("dQrVz", function(module, exports) {

$parcel$export(module.exports, "getPropGetters", function () { return $a145cb84851361f4$export$a4b47c9a40a3a795; });

var $3aBnI = parcelRequire("3aBnI");

var $jD7hK = parcelRequire("jD7hK");

var $3mcYn = parcelRequire("3mcYn");

var $4HZsj = parcelRequire("4HZsj");
var $46SKZ = parcelRequire("46SKZ");
var $47Cqc = parcelRequire("47Cqc");
var $fsI1g = parcelRequire("fsI1g");
var $66E2j = parcelRequire("66E2j");
function $a145cb84851361f4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a145cb84851361f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a145cb84851361f4$var$_typeof(obj);
}
var $a145cb84851361f4$var$_excluded = [
    "props",
    "refresh",
    "store"
], $a145cb84851361f4$var$_excluded2 = [
    "inputElement",
    "formElement",
    "panelElement"
], $a145cb84851361f4$var$_excluded3 = [
    "inputElement"
], $a145cb84851361f4$var$_excluded4 = [
    "inputElement",
    "maxLength"
], $a145cb84851361f4$var$_excluded5 = [
    "source"
], $a145cb84851361f4$var$_excluded6 = [
    "item",
    "source"
];
function $a145cb84851361f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a145cb84851361f4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a145cb84851361f4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a145cb84851361f4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a145cb84851361f4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a145cb84851361f4$var$_defineProperty(obj, key, value) {
    key = $a145cb84851361f4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a145cb84851361f4$var$_toPropertyKey(arg) {
    var key = $a145cb84851361f4$var$_toPrimitive(arg, "string");
    return $a145cb84851361f4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a145cb84851361f4$var$_toPrimitive(input, hint) {
    if ($a145cb84851361f4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a145cb84851361f4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a145cb84851361f4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a145cb84851361f4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a145cb84851361f4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a145cb84851361f4$export$a4b47c9a40a3a795(_ref) {
    var props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $a145cb84851361f4$var$_objectWithoutProperties(_ref, $a145cb84851361f4$var$_excluded);
    var getEnvironmentProps = function getEnvironmentProps(providedProps) {
        var inputElement = providedProps.inputElement, formElement = providedProps.formElement, panelElement = providedProps.panelElement, rest = $a145cb84851361f4$var$_objectWithoutProperties(providedProps, $a145cb84851361f4$var$_excluded2);
        function onMouseDownOrTouchStart(event) {
            // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
            // handler when it's not an interaction with Autocomplete.
            // We detect it with the following heuristics:
            // - the panel is closed AND there are no pending requests
            //   (no interaction with the autocomplete, no future state updates)
            // - OR the touched target is the input element (should open the panel)
            var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();
            if (!isAutocompleteInteraction || event.target === inputElement) return;
            // @TODO: support cases where there are multiple Autocomplete instances.
            // Right now, a second instance makes this computation return false.
            var isTargetWithinAutocomplete = [
                formElement,
                panelElement
            ].some(function(contextNode) {
                return (0, $fsI1g.isOrContainsNode)(contextNode, event.target);
            });
            if (isTargetWithinAutocomplete === false) {
                store.dispatch("blur", null);
                // If requests are still pending when the user closes the panel, they
                // could reopen the panel once they resolve.
                // We want to prevent any subsequent query from reopening the panel
                // because it would result in an unsolicited UI behavior.
                if (!props.debug) store.pendingRequests.cancelAll();
            }
        }
        return $a145cb84851361f4$var$_objectSpread({
            // We do not rely on the native `blur` event of the input to close the
            // panel, but rather on a custom `touchstart`/`mousedown` event outside
            // of the autocomplete elements.
            // This ensures we don't mistakenly interpret interactions within the
            // autocomplete (but outside of the input) as a signal to close the panel.
            // For example, clicking reset button causes an input blur, but if
            // `openOnFocus=true`, it shouldn't close the panel.
            // On touch devices, scrolling results (`touchmove`) causes an input blur
            // but shouldn't close the panel.
            onTouchStart: onMouseDownOrTouchStart,
            onMouseDown: onMouseDownOrTouchStart,
            // When scrolling on touch devices (mobiles, tablets, etc.), we want to
            // mimic the native platform behavior where the input is blurred to
            // hide the virtual keyboard. This gives more vertical space to
            // discover all the suggestions showing up in the panel.
            onTouchMove: function onTouchMove(event) {
                if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) return;
                inputElement.blur();
            }
        }, rest);
    };
    var getRootProps = function getRootProps(rest) {
        return $a145cb84851361f4$var$_objectSpread({
            role: "combobox",
            "aria-expanded": store.getState().isOpen,
            "aria-haspopup": "listbox",
            "aria-controls": store.getState().isOpen ? store.getState().collections.map(function(_ref2) {
                var source = _ref2.source;
                return (0, $46SKZ.getAutocompleteElementId)(props.id, "list", source);
            }).join(" ") : undefined,
            "aria-labelledby": (0, $46SKZ.getAutocompleteElementId)(props.id, "label")
        }, rest);
    };
    var getFormProps = function getFormProps(providedProps) {
        var inputElement = providedProps.inputElement, rest = $a145cb84851361f4$var$_objectWithoutProperties(providedProps, $a145cb84851361f4$var$_excluded3);
        return $a145cb84851361f4$var$_objectSpread({
            action: "",
            noValidate: true,
            role: "search",
            onSubmit: function onSubmit(event) {
                var _providedProps$inputE;
                event.preventDefault();
                props.onSubmit($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch("submit", null);
                (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 || _providedProps$inputE.blur();
            },
            onReset: function onReset(event) {
                var _providedProps$inputE2;
                event.preventDefault();
                props.onReset($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch("reset", null);
                (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 || _providedProps$inputE2.focus();
            }
        }, rest);
    };
    var getInputProps = function getInputProps(providedProps) {
        var _props$environment$na;
        function onFocus(event) {
            // We want to trigger a query when `openOnFocus` is true
            // because the panel should open with the current query.
            if (props.openOnFocus || Boolean(store.getState().query)) (0, $jD7hK.onInput)($a145cb84851361f4$var$_objectSpread({
                event: event,
                props: props,
                query: store.getState().completion || store.getState().query,
                refresh: refresh,
                store: store
            }, setters));
            store.dispatch("focus", null);
        }
        var _ref3 = providedProps || {}, inputElement = _ref3.inputElement, _ref3$maxLength = _ref3.maxLength, maxLength = _ref3$maxLength === void 0 ? 512 : _ref3$maxLength, rest = $a145cb84851361f4$var$_objectWithoutProperties(_ref3, $a145cb84851361f4$var$_excluded4);
        var activeItem = (0, $4HZsj.getActiveItem)(store.getState());
        var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || "";
        var shouldFallbackKeyHint = (0, $66E2j.isSamsung)(userAgent);
        var enterKeyHint = props.enterKeyHint || (activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? "go" : "search");
        return $a145cb84851361f4$var$_objectSpread({
            "aria-autocomplete": "both",
            "aria-activedescendant": store.getState().isOpen && store.getState().activeItemId !== null ? (0, $46SKZ.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), activeItem === null || activeItem === void 0 ? void 0 : activeItem.source) : undefined,
            "aria-controls": store.getState().isOpen ? store.getState().collections.map(function(_ref4) {
                var source = _ref4.source;
                return (0, $46SKZ.getAutocompleteElementId)(props.id, "list", source);
            }).join(" ") : undefined,
            "aria-labelledby": (0, $46SKZ.getAutocompleteElementId)(props.id, "label"),
            value: store.getState().completion || store.getState().query,
            id: (0, $46SKZ.getAutocompleteElementId)(props.id, "input"),
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            enterKeyHint: enterKeyHint,
            spellCheck: "false",
            autoFocus: props.autoFocus,
            placeholder: props.placeholder,
            maxLength: maxLength,
            type: "search",
            onChange: function onChange(event) {
                var value = event.currentTarget.value;
                if (props.ignoreCompositionEvents && (0, $47Cqc.getNativeEvent)(event).isComposing) {
                    setters.setQuery(value);
                    return;
                }
                (0, $jD7hK.onInput)($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    props: props,
                    query: value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onCompositionEnd: function onCompositionEnd(event) {
                (0, $jD7hK.onInput)($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    props: props,
                    query: event.currentTarget.value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onKeyDown: function onKeyDown(event) {
                if ((0, $47Cqc.getNativeEvent)(event).isComposing) return;
                (0, $3mcYn.onKeyDown)($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    props: props,
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onFocus: onFocus,
            // We don't rely on the `blur` event.
            // See explanation in `onTouchStart`/`onMouseDown`.
            // @MAJOR See if we need to keep this handler.
            onBlur: (0, $3aBnI.noop),
            onClick: function onClick(event) {
                // When the panel is closed and you click on the input while
                // the input is focused, the `onFocus` event is not triggered
                // (default browser behavior).
                // In an autocomplete context, it makes sense to open the panel in this
                // case.
                // We mimic this event by catching the `onClick` event which
                // triggers the `onFocus` for the panel to open.
                if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) onFocus(event);
            }
        }, rest);
    };
    var getLabelProps = function getLabelProps(rest) {
        return $a145cb84851361f4$var$_objectSpread({
            htmlFor: (0, $46SKZ.getAutocompleteElementId)(props.id, "input"),
            id: (0, $46SKZ.getAutocompleteElementId)(props.id, "label")
        }, rest);
    };
    var getListProps = function getListProps(providedProps) {
        var _ref5 = providedProps || {}, source = _ref5.source, rest = $a145cb84851361f4$var$_objectWithoutProperties(_ref5, $a145cb84851361f4$var$_excluded5);
        return $a145cb84851361f4$var$_objectSpread({
            role: "listbox",
            "aria-labelledby": (0, $46SKZ.getAutocompleteElementId)(props.id, "label"),
            id: (0, $46SKZ.getAutocompleteElementId)(props.id, "list", source)
        }, rest);
    };
    var getPanelProps = function getPanelProps(rest) {
        return $a145cb84851361f4$var$_objectSpread({
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the panel so
                // that the blur event is not triggered, otherwise it closes the
                // panel.
                event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
                store.dispatch("mouseleave", null);
            }
        }, rest);
    };
    var getItemProps = function getItemProps(providedProps) {
        var item = providedProps.item, source = providedProps.source, rest = $a145cb84851361f4$var$_objectWithoutProperties(providedProps, $a145cb84851361f4$var$_excluded6);
        return $a145cb84851361f4$var$_objectSpread({
            id: (0, $46SKZ.getAutocompleteElementId)(props.id, "item-".concat(item.__autocomplete_id), source),
            role: "option",
            "aria-selected": store.getState().activeItemId === item.__autocomplete_id,
            onMouseMove: function onMouseMove(event) {
                if (item.__autocomplete_id === store.getState().activeItemId) return;
                store.dispatch("mousemove", item.__autocomplete_id);
                var activeItem = (0, $4HZsj.getActiveItem)(store.getState());
                if (store.getState().activeItemId !== null && activeItem) {
                    var _item = activeItem.item, itemInputValue = activeItem.itemInputValue, itemUrl = activeItem.itemUrl, _source = activeItem.source;
                    _source.onActive($a145cb84851361f4$var$_objectSpread({
                        event: event,
                        item: _item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: _source,
                        state: store.getState()
                    }, setters));
                }
            },
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the item so it
                // can remain with the current `activeElement`.
                event.preventDefault();
            },
            onClick: function onClick(event) {
                var itemInputValue = source.getItemInputValue({
                    item: item,
                    state: store.getState()
                });
                var itemUrl = source.getItemUrl({
                    item: item,
                    state: store.getState()
                });
                // If `getItemUrl` is provided, it means that the suggestion
                // is a link, not plain text that aims at updating the query.
                // We can therefore skip the state change because it will update
                // the `activeItemId`, resulting in a UI flash, especially
                // noticeable on mobile.
                var runPreCommand = itemUrl ? Promise.resolve() : (0, $jD7hK.onInput)($a145cb84851361f4$var$_objectSpread({
                    event: event,
                    nextState: {
                        isOpen: false
                    },
                    props: props,
                    query: itemInputValue,
                    refresh: refresh,
                    store: store
                }, setters));
                runPreCommand.then(function() {
                    source.onSelect($a145cb84851361f4$var$_objectSpread({
                        event: event,
                        item: item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: source,
                        state: store.getState()
                    }, setters));
                });
            }
        }, rest);
    };
    return {
        getEnvironmentProps: getEnvironmentProps,
        getRootProps: getRootProps,
        getFormProps: getFormProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getPanelProps: getPanelProps,
        getListProps: getListProps,
        getItemProps: getItemProps
    };
}

});
parcelRegister("jD7hK", function(module, exports) {

$parcel$export(module.exports, "onInput", function () { return $e4a74f90a2a92c79$export$7fbc06d7c1beb512; });

var $8zDZg = parcelRequire("8zDZg");

var $it1Zm = parcelRequire("it1Zm");

var $ISYTH = parcelRequire("ISYTH");
var $itFUn = parcelRequire("itFUn");
var $4HZsj = parcelRequire("4HZsj");
function $e4a74f90a2a92c79$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e4a74f90a2a92c79$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e4a74f90a2a92c79$var$_typeof(obj);
}
var $e4a74f90a2a92c79$var$_excluded = [
    "event",
    "nextState",
    "props",
    "query",
    "refresh",
    "store"
];
function $e4a74f90a2a92c79$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4a74f90a2a92c79$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e4a74f90a2a92c79$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e4a74f90a2a92c79$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e4a74f90a2a92c79$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4a74f90a2a92c79$var$_defineProperty(obj, key, value) {
    key = $e4a74f90a2a92c79$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4a74f90a2a92c79$var$_toPropertyKey(arg) {
    var key = $e4a74f90a2a92c79$var$_toPrimitive(arg, "string");
    return $e4a74f90a2a92c79$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e4a74f90a2a92c79$var$_toPrimitive(input, hint) {
    if ($e4a74f90a2a92c79$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e4a74f90a2a92c79$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e4a74f90a2a92c79$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e4a74f90a2a92c79$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e4a74f90a2a92c79$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e4a74f90a2a92c79$var$lastStalledId = null;
var $e4a74f90a2a92c79$var$runConcurrentSafePromise = (0, $itFUn.createConcurrentSafePromise)();
function $e4a74f90a2a92c79$export$7fbc06d7c1beb512(_ref) {
    var event = _ref.event, _ref$nextState = _ref.nextState, nextState = _ref$nextState === void 0 ? {} : _ref$nextState, props = _ref.props, query = _ref.query, refresh = _ref.refresh, store = _ref.store, setters = $e4a74f90a2a92c79$var$_objectWithoutProperties(_ref, $e4a74f90a2a92c79$var$_excluded);
    if ($e4a74f90a2a92c79$var$lastStalledId) props.environment.clearTimeout($e4a74f90a2a92c79$var$lastStalledId);
    var setCollections = setters.setCollections, setIsOpen = setters.setIsOpen, setQuery = setters.setQuery, setActiveItemId = setters.setActiveItemId, setStatus = setters.setStatus, setContext = setters.setContext;
    setQuery(query);
    setActiveItemId(props.defaultActiveItemId);
    if (!query && props.openOnFocus === false) {
        var _nextState$isOpen;
        var collections = store.getState().collections.map(function(collection) {
            return $e4a74f90a2a92c79$var$_objectSpread($e4a74f90a2a92c79$var$_objectSpread({}, collection), {}, {
                items: []
            });
        });
        setStatus("idle");
        setCollections(collections);
        setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
            state: store.getState()
        }));
        // We make sure to update the latest resolved value of the tracked
        // promises to keep late resolving promises from "cancelling" the state
        // updates performed in this code path.
        // We chain with a void promise to respect `onInput`'s expected return type.
        var _request = (0, $ISYTH.cancelable)($e4a74f90a2a92c79$var$runConcurrentSafePromise(collections).then(function() {
            return Promise.resolve();
        }));
        return store.pendingRequests.add(_request);
    }
    setStatus("loading");
    $e4a74f90a2a92c79$var$lastStalledId = props.environment.setTimeout(function() {
        setStatus("stalled");
    }, props.stallThreshold);
    // We track the entire promise chain triggered by `onInput` before mutating
    // the Autocomplete state to make sure that any state manipulation is based on
    // fresh data regardless of when promises individually resolve.
    // We don't track nested promises and only rely on the full chain resolution,
    // meaning we should only ever manipulate the state once this concurrent-safe
    // promise is resolved.
    var request = (0, $ISYTH.cancelable)($e4a74f90a2a92c79$var$runConcurrentSafePromise(props.getSources($e4a74f90a2a92c79$var$_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
    }, setters)).then(function(sources) {
        return Promise.all(sources.map(function(source) {
            return Promise.resolve(source.getItems($e4a74f90a2a92c79$var$_objectSpread({
                query: query,
                refresh: refresh,
                state: store.getState()
            }, setters))).then(function(itemsOrDescription) {
                return (0, $it1Zm.preResolve)(itemsOrDescription, source.sourceId, store.getState());
            });
        })).then((0, $it1Zm.resolve)).then(function(responses) {
            var __automaticInsights = responses.some(function(_ref2) {
                var items = _ref2.items;
                return $e4a74f90a2a92c79$var$isSearchResponseWithAutomaticInsightsFlag(items);
            });
            // No need to pollute the context if `__automaticInsights=false`
            if (__automaticInsights) {
                var _store$getState$conte;
                setContext({
                    algoliaInsightsPlugin: $e4a74f90a2a92c79$var$_objectSpread($e4a74f90a2a92c79$var$_objectSpread({}, ((_store$getState$conte = store.getState().context) === null || _store$getState$conte === void 0 ? void 0 : _store$getState$conte.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: __automaticInsights
                    })
                });
            }
            return (0, $it1Zm.postResolve)(responses, sources, store);
        }).then(function(collections) {
            return (0, $8zDZg.reshape)({
                collections: collections,
                props: props,
                state: store.getState()
            });
        });
    }))).then(function(collections) {
        var _nextState$isOpen2;
        // Parameters passed to `onInput` could be stale when the following code
        // executes, because `onInput` calls may not resolve in order.
        // If it becomes a problem we'll need to save the last passed parameters.
        // See: https://codesandbox.io/s/agitated-cookies-y290z
        setStatus("idle");
        setCollections(collections);
        var isPanelOpen = props.shouldPanelOpen({
            state: store.getState()
        });
        setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
        var highlightedItem = (0, $4HZsj.getActiveItem)(store.getState());
        if (store.getState().activeItemId !== null && highlightedItem) {
            var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
            source.onActive($e4a74f90a2a92c79$var$_objectSpread({
                event: event,
                item: item,
                itemInputValue: itemInputValue,
                itemUrl: itemUrl,
                refresh: refresh,
                source: source,
                state: store.getState()
            }, setters));
        }
    }).finally(function() {
        setStatus("idle");
        if ($e4a74f90a2a92c79$var$lastStalledId) props.environment.clearTimeout($e4a74f90a2a92c79$var$lastStalledId);
    });
    return store.pendingRequests.add(request);
}
function $e4a74f90a2a92c79$var$isSearchResponseWithAutomaticInsightsFlag(items) {
    return !Array.isArray(items) && Boolean(items === null || items === void 0 ? void 0 : items._automaticInsights);
}

});
parcelRegister("8zDZg", function(module, exports) {

$parcel$export(module.exports, "reshape", function () { return $63e09c35e3385a2e$export$9eaad88cf88cee2b; });

var $dpUQY = parcelRequire("dpUQY");
function $63e09c35e3385a2e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $63e09c35e3385a2e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $63e09c35e3385a2e$var$_typeof(obj);
}
function $63e09c35e3385a2e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $63e09c35e3385a2e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $63e09c35e3385a2e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $63e09c35e3385a2e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $63e09c35e3385a2e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $63e09c35e3385a2e$var$_defineProperty(obj, key, value) {
    key = $63e09c35e3385a2e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $63e09c35e3385a2e$var$_toPropertyKey(arg) {
    var key = $63e09c35e3385a2e$var$_toPrimitive(arg, "string");
    return $63e09c35e3385a2e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $63e09c35e3385a2e$var$_toPrimitive(input, hint) {
    if ($63e09c35e3385a2e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($63e09c35e3385a2e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $63e09c35e3385a2e$export$9eaad88cf88cee2b(_ref) {
    var collections = _ref.collections, props = _ref.props, state = _ref.state;
    // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
    // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
    var originalSourcesBySourceId = collections.reduce(function(acc, collection) {
        return $63e09c35e3385a2e$var$_objectSpread($63e09c35e3385a2e$var$_objectSpread({}, acc), {}, $63e09c35e3385a2e$var$_defineProperty({}, collection.source.sourceId, $63e09c35e3385a2e$var$_objectSpread($63e09c35e3385a2e$var$_objectSpread({}, collection.source), {}, {
            getItems: function getItems() {
                // We provide the resolved items from the collection to the `reshape` prop.
                return (0, $dpUQY.flatten)(collection.items);
            }
        })));
    }, {});
    var _props$plugins$reduce = props.plugins.reduce(function(acc, plugin) {
        if (plugin.reshape) return plugin.reshape(acc);
        return acc;
    }, {
        sourcesBySourceId: originalSourcesBySourceId,
        state: state
    }), sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;
    var reshapeSources = props.reshape({
        sourcesBySourceId: sourcesBySourceId,
        sources: Object.values(sourcesBySourceId),
        state: state
    });
    // We reconstruct the collections with the items modified by the `reshape` prop.
    return (0, $dpUQY.flatten)(reshapeSources).filter(Boolean).map(function(source) {
        return {
            source: source,
            items: source.getItems()
        };
    });
}

});

parcelRegister("it1Zm", function(module, exports) {

$parcel$export(module.exports, "preResolve", function () { return $d71c7a5da788fef4$export$ae3cd3529c74e69e; });
$parcel$export(module.exports, "resolve", function () { return $d71c7a5da788fef4$export$f7ad0328861e2f03; });
$parcel$export(module.exports, "postResolve", function () { return $d71c7a5da788fef4$export$c1b3edf5a28f586; });

var $1N7Aj = parcelRequire("1N7Aj");
var $dpUQY = parcelRequire("dpUQY");
var $lIndL = parcelRequire("lIndL");

var $8bunU = parcelRequire("8bunU");
function $d71c7a5da788fef4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d71c7a5da788fef4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d71c7a5da788fef4$var$_typeof(obj);
}
function $d71c7a5da788fef4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d71c7a5da788fef4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d71c7a5da788fef4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d71c7a5da788fef4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d71c7a5da788fef4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d71c7a5da788fef4$var$_defineProperty(obj, key, value) {
    key = $d71c7a5da788fef4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d71c7a5da788fef4$var$_toPropertyKey(arg) {
    var key = $d71c7a5da788fef4$var$_toPrimitive(arg, "string");
    return $d71c7a5da788fef4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d71c7a5da788fef4$var$_toPrimitive(input, hint) {
    if ($d71c7a5da788fef4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d71c7a5da788fef4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d71c7a5da788fef4$var$_toConsumableArray(arr) {
    return $d71c7a5da788fef4$var$_arrayWithoutHoles(arr) || $d71c7a5da788fef4$var$_iterableToArray(arr) || $d71c7a5da788fef4$var$_unsupportedIterableToArray(arr) || $d71c7a5da788fef4$var$_nonIterableSpread();
}
function $d71c7a5da788fef4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d71c7a5da788fef4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d71c7a5da788fef4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d71c7a5da788fef4$var$_arrayLikeToArray(o, minLen);
}
function $d71c7a5da788fef4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d71c7a5da788fef4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d71c7a5da788fef4$var$_arrayLikeToArray(arr);
}
function $d71c7a5da788fef4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d71c7a5da788fef4$var$isDescription(item) {
    return Boolean(item.execute);
}
function $d71c7a5da788fef4$var$isRequesterDescription(description) {
    return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}
function $d71c7a5da788fef4$export$ae3cd3529c74e69e(itemsOrDescription, sourceId, state) {
    if ($d71c7a5da788fef4$var$isRequesterDescription(itemsOrDescription)) {
        var contextParameters = itemsOrDescription.requesterId === "algolia" ? Object.assign.apply(Object, [
            {}
        ].concat($d71c7a5da788fef4$var$_toConsumableArray(Object.keys(state.context).map(function(key) {
            var _state$context$key;
            return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
        })))) : {};
        return $d71c7a5da788fef4$var$_objectSpread($d71c7a5da788fef4$var$_objectSpread({}, itemsOrDescription), {}, {
            requests: itemsOrDescription.queries.map(function(query) {
                return {
                    query: itemsOrDescription.requesterId === "algolia" ? $d71c7a5da788fef4$var$_objectSpread($d71c7a5da788fef4$var$_objectSpread({}, query), {}, {
                        params: $d71c7a5da788fef4$var$_objectSpread($d71c7a5da788fef4$var$_objectSpread({}, contextParameters), query.params)
                    }) : query,
                    sourceId: sourceId,
                    transformResponse: itemsOrDescription.transformResponse
                };
            })
        });
    }
    return {
        items: itemsOrDescription,
        sourceId: sourceId
    };
}
function $d71c7a5da788fef4$export$f7ad0328861e2f03(items) {
    var packed = items.reduce(function(acc, current) {
        if (!$d71c7a5da788fef4$var$isDescription(current)) {
            acc.push(current);
            return acc;
        }
        var searchClient = current.searchClient, execute = current.execute, requesterId = current.requesterId, requests = current.requests;
        var container = acc.find(function(item) {
            return $d71c7a5da788fef4$var$isDescription(current) && $d71c7a5da788fef4$var$isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
        });
        if (container) {
            var _container$items;
            (_container$items = container.items).push.apply(_container$items, $d71c7a5da788fef4$var$_toConsumableArray(requests));
        } else {
            var request = {
                execute: execute,
                requesterId: requesterId,
                items: requests,
                searchClient: searchClient
            };
            acc.push(request);
        }
        return acc;
    }, []);
    var values = packed.map(function(maybeDescription) {
        if (!$d71c7a5da788fef4$var$isDescription(maybeDescription)) return Promise.resolve(maybeDescription);
        var _ref = maybeDescription, execute = _ref.execute, items = _ref.items, searchClient = _ref.searchClient;
        return execute({
            searchClient: searchClient,
            requests: items
        });
    });
    return Promise.all(values).then(function(responses) {
        return (0, $dpUQY.flatten)(responses);
    });
}
function $d71c7a5da788fef4$export$c1b3edf5a28f586(responses, sources, store) {
    return sources.map(function(source) {
        var matches = responses.filter(function(response) {
            return response.sourceId === source.sourceId;
        });
        var results = matches.map(function(_ref2) {
            var items = _ref2.items;
            return items;
        });
        var transform = matches[0].transformResponse;
        var items = transform ? transform((0, $8bunU.mapToAlgoliaResponse)(results)) : results;
        source.onResolve({
            source: source,
            results: results,
            items: items,
            state: store.getState()
        });
        (0, $lIndL.invariant)(Array.isArray(items), function() {
            return 'The `getItems` function from source "'.concat(source.sourceId, '" must return an array of items but returned type ').concat(JSON.stringify($d71c7a5da788fef4$var$_typeof(items)), ":\n\n").concat(JSON.stringify((0, $1N7Aj.decycle)(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
        });
        (0, $lIndL.invariant)(items.every(Boolean), 'The `getItems` function from source "'.concat(source.sourceId, '" must return an array of items but returned ').concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
        return {
            source: source,
            items: items
        };
    });
}

});
parcelRegister("8bunU", function(module, exports) {

$parcel$export(module.exports, "mapToAlgoliaResponse", function () { return $5f56eb93c36bdec5$export$23042d7bd0b8d14b; });
function $5f56eb93c36bdec5$export$23042d7bd0b8d14b(rawResults) {
    return {
        results: rawResults,
        hits: rawResults.map(function(result) {
            return result.hits;
        }).filter(Boolean),
        facetHits: rawResults.map(function(result) {
            var _facetHits;
            return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function(facetHit) {
                // Bring support for the highlighting components.
                return {
                    label: facetHit.value,
                    count: facetHit.count,
                    _highlightResult: {
                        label: {
                            value: facetHit.highlighted
                        }
                    }
                };
            });
        }).filter(Boolean)
    };
}

});


parcelRegister("ISYTH", function(module, exports) {

$parcel$export(module.exports, "cancelable", function () { return $086ec24caa2f8d2d$export$95ff25b64c2b7c9d; });
function $086ec24caa2f8d2d$var$createInternalCancelablePromise(promise, initialState) {
    var state = initialState;
    return {
        then: function then(onfulfilled, onrejected) {
            return $086ec24caa2f8d2d$var$createInternalCancelablePromise(promise.then($086ec24caa2f8d2d$var$createCallback(onfulfilled, state, promise), $086ec24caa2f8d2d$var$createCallback(onrejected, state, promise)), state);
        },
        catch: function _catch(onrejected) {
            return $086ec24caa2f8d2d$var$createInternalCancelablePromise(promise.catch($086ec24caa2f8d2d$var$createCallback(onrejected, state, promise)), state);
        },
        finally: function _finally(onfinally) {
            if (onfinally) state.onCancelList.push(onfinally);
            return $086ec24caa2f8d2d$var$createInternalCancelablePromise(promise.finally($086ec24caa2f8d2d$var$createCallback(onfinally && function() {
                state.onCancelList = [];
                return onfinally();
            }, state, promise)), state);
        },
        cancel: function cancel() {
            state.isCanceled = true;
            var callbacks = state.onCancelList;
            state.onCancelList = [];
            callbacks.forEach(function(callback) {
                callback();
            });
        },
        isCanceled: function isCanceled() {
            return state.isCanceled === true;
        }
    };
}
function $086ec24caa2f8d2d$export$72af18a8b033265c(executor) {
    return $086ec24caa2f8d2d$var$createInternalCancelablePromise(new Promise(function(resolve, reject) {
        return executor(resolve, reject);
    }), {
        isCanceled: false,
        onCancelList: []
    });
}
$086ec24caa2f8d2d$export$72af18a8b033265c.resolve = function(value) {
    return $086ec24caa2f8d2d$export$95ff25b64c2b7c9d(Promise.resolve(value));
};
$086ec24caa2f8d2d$export$72af18a8b033265c.reject = function(reason) {
    return $086ec24caa2f8d2d$export$95ff25b64c2b7c9d(Promise.reject(reason));
};
function $086ec24caa2f8d2d$export$95ff25b64c2b7c9d(promise) {
    return $086ec24caa2f8d2d$var$createInternalCancelablePromise(promise, {
        isCanceled: false,
        onCancelList: []
    });
}
function $086ec24caa2f8d2d$var$createCallback(onResult, state, fallback) {
    if (!onResult) return fallback;
    return function callback(arg) {
        if (state.isCanceled) return arg;
        return onResult(arg);
    };
}

});

parcelRegister("itFUn", function(module, exports) {

$parcel$export(module.exports, "createConcurrentSafePromise", function () { return $d73b7186744e6cb3$export$8829b68d73f73d13; });
/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */ function $d73b7186744e6cb3$export$8829b68d73f73d13() {
    var basePromiseId = -1;
    var latestResolvedId = -1;
    var latestResolvedValue = undefined;
    return function runConcurrentSafePromise(promise) {
        basePromiseId++;
        var currentPromiseId = basePromiseId;
        return Promise.resolve(promise).then(function(x) {
            // The promise might take too long to resolve and get outdated. This would
            // result in resolving stale values.
            // When this happens, we ignore the promise value and return the one
            // coming from the latest resolved value.
            //
            // +----------------------------------+
            // |        100ms                     |
            // | run(1) +--->  R1                 |
            // |        300ms                     |
            // | run(2) +-------------> R2 (SKIP) |
            // |        200ms                     |
            // | run(3) +--------> R3             |
            // +----------------------------------+
            if (latestResolvedValue && currentPromiseId < latestResolvedId) return latestResolvedValue;
            latestResolvedId = currentPromiseId;
            latestResolvedValue = x;
            return x;
        });
    };
}

});

parcelRegister("4HZsj", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", function () { return $36dad95d361cc67d$export$f0f14253205ef68f; });
// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function $36dad95d361cc67d$var$getCollectionFromActiveItemId(state) {
    // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
    // We want to get the accumulated counts:
    // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
    var accumulatedCollectionsCount = state.collections.map(function(collections) {
        return collections.items.length;
    }).reduce(function(acc, collectionsCount, index) {
        var previousValue = acc[index - 1] || 0;
        var nextValue = previousValue + collectionsCount;
        acc.push(nextValue);
        return acc;
    }, []);
    // Based on the accumulated counts, we can infer the index of the suggestion.
    var collectionIndex = accumulatedCollectionsCount.reduce(function(acc, current) {
        if (current <= state.activeItemId) return acc + 1;
        return acc;
    }, 0);
    return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */ function $36dad95d361cc67d$var$getRelativeActiveItemId(_ref) {
    var state = _ref.state, collection = _ref.collection;
    var isOffsetFound = false;
    var counter = 0;
    var previousItemsOffset = 0;
    while(isOffsetFound === false){
        var currentCollection = state.collections[counter];
        if (currentCollection === collection) {
            isOffsetFound = true;
            break;
        }
        previousItemsOffset += currentCollection.items.length;
        counter++;
    }
    return state.activeItemId - previousItemsOffset;
}
function $36dad95d361cc67d$export$f0f14253205ef68f(state) {
    var collection = $36dad95d361cc67d$var$getCollectionFromActiveItemId(state);
    if (!collection) return null;
    var item = collection.items[$36dad95d361cc67d$var$getRelativeActiveItemId({
        state: state,
        collection: collection
    })];
    var source = collection.source;
    var itemInputValue = source.getItemInputValue({
        item: item,
        state: state
    });
    var itemUrl = source.getItemUrl({
        item: item,
        state: state
    });
    return {
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        source: source
    };
}

});


parcelRegister("3mcYn", function(module, exports) {

$parcel$export(module.exports, "onKeyDown", function () { return $271d7d4a8f3e3000$export$de8e1b1372cdb41b; });

var $jD7hK = parcelRequire("jD7hK");

var $4HZsj = parcelRequire("4HZsj");
var $46SKZ = parcelRequire("46SKZ");
function $271d7d4a8f3e3000$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $271d7d4a8f3e3000$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $271d7d4a8f3e3000$var$_typeof(obj);
}
var $271d7d4a8f3e3000$var$_excluded = [
    "event",
    "props",
    "refresh",
    "store"
];
function $271d7d4a8f3e3000$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $271d7d4a8f3e3000$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $271d7d4a8f3e3000$var$ownKeys(Object(source), !0).forEach(function(key) {
            $271d7d4a8f3e3000$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $271d7d4a8f3e3000$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $271d7d4a8f3e3000$var$_defineProperty(obj, key, value) {
    key = $271d7d4a8f3e3000$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $271d7d4a8f3e3000$var$_toPropertyKey(arg) {
    var key = $271d7d4a8f3e3000$var$_toPrimitive(arg, "string");
    return $271d7d4a8f3e3000$var$_typeof(key) === "symbol" ? key : String(key);
}
function $271d7d4a8f3e3000$var$_toPrimitive(input, hint) {
    if ($271d7d4a8f3e3000$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($271d7d4a8f3e3000$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $271d7d4a8f3e3000$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $271d7d4a8f3e3000$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $271d7d4a8f3e3000$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $271d7d4a8f3e3000$export$de8e1b1372cdb41b(_ref) {
    var event = _ref.event, props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $271d7d4a8f3e3000$var$_objectWithoutProperties(_ref, $271d7d4a8f3e3000$var$_excluded);
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        // eslint-disable-next-line no-inner-declarations
        var triggerScrollIntoView = function triggerScrollIntoView() {
            var highlightedItem = (0, $4HZsj.getActiveItem)(store.getState());
            var nodeItem = props.environment.document.getElementById((0, $46SKZ.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.source));
            if (nodeItem) {
                if (nodeItem.scrollIntoViewIfNeeded) nodeItem.scrollIntoViewIfNeeded(false);
                else nodeItem.scrollIntoView(false);
            }
        }; // eslint-disable-next-line no-inner-declarations
        var triggerOnActive = function triggerOnActive() {
            var highlightedItem = (0, $4HZsj.getActiveItem)(store.getState());
            if (store.getState().activeItemId !== null && highlightedItem) {
                var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
                source.onActive($271d7d4a8f3e3000$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            }
        }; // Default browser behavior changes the caret placement on ArrowUp and
        // ArrowDown.
        event.preventDefault();
        // When re-opening the panel, we need to split the logic to keep the actions
        // synchronized as `onInput` returns a promise.
        if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) (0, $jD7hK.onInput)($271d7d4a8f3e3000$var$_objectSpread({
            event: event,
            props: props,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters)).then(function() {
            store.dispatch(event.key, {
                nextActiveItemId: props.defaultActiveItemId
            });
            triggerOnActive();
            // Since we rely on the DOM, we need to wait for all the micro tasks to
            // finish (which include re-opening the panel) to make sure all the
            // elements are available.
            setTimeout(triggerScrollIntoView, 0);
        });
        else {
            store.dispatch(event.key, {});
            triggerOnActive();
            triggerScrollIntoView();
        }
    } else if (event.key === "Escape") {
        // This prevents the default browser behavior on `input[type="search"]`
        // from removing the query right away because we first want to close the
        // panel.
        event.preventDefault();
        store.dispatch(event.key, null);
        // Hitting the `Escape` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === "Tab") {
        store.dispatch("blur", null);
        // Hitting the `Tab` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === "Enter") {
        // No active item, so we let the browser handle the native `onSubmit` form
        // event.
        if (store.getState().activeItemId === null || store.getState().collections.every(function(collection) {
            return collection.items.length === 0;
        })) {
            // If requests are still pending when the panel closes, they could reopen
            // the panel once they resolve.
            // We want to prevent any subsequent query from reopening the panel
            // because it would result in an unsolicited UI behavior.
            if (!props.debug) store.pendingRequests.cancelAll();
            return;
        }
        // This prevents the `onSubmit` event to be sent because an item is
        // highlighted.
        event.preventDefault();
        var _ref2 = (0, $4HZsj.getActiveItem)(store.getState()), item = _ref2.item, itemInputValue = _ref2.itemInputValue, itemUrl = _ref2.itemUrl, source = _ref2.source;
        if (event.metaKey || event.ctrlKey) {
            if (itemUrl !== undefined) {
                source.onSelect($271d7d4a8f3e3000$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewTab({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.shiftKey) {
            if (itemUrl !== undefined) {
                source.onSelect($271d7d4a8f3e3000$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewWindow({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.altKey) ;
        else {
            if (itemUrl !== undefined) {
                source.onSelect($271d7d4a8f3e3000$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigate({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
                return;
            }
            (0, $jD7hK.onInput)($271d7d4a8f3e3000$var$_objectSpread({
                event: event,
                nextState: {
                    isOpen: false
                },
                props: props,
                query: itemInputValue,
                refresh: refresh,
                store: store
            }, setters)).then(function() {
                source.onSelect($271d7d4a8f3e3000$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            });
        }
    }
}

});
parcelRegister("46SKZ", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteElementId", function () { return $2fe2328d8d6034ec$export$17f5bb35a44b3f03; });
/**
 * Returns a full element id for an autocomplete element.
 *
 * @param autocompleteInstanceId The id of the autocomplete instance
 * @param elementId The specific element id
 * @param source The source of the element, when it needs to be scoped
 */ function $2fe2328d8d6034ec$export$17f5bb35a44b3f03(autocompleteInstanceId, elementId, source) {
    return [
        autocompleteInstanceId,
        source === null || source === void 0 ? void 0 : source.sourceId,
        elementId
    ].filter(Boolean).join("-").replace(/\s/g, "");
}

});


parcelRegister("47Cqc", function(module, exports) {

$parcel$export(module.exports, "getNativeEvent", function () { return $30059e91d4a068f4$export$4abe0e945399ac1d; });
function $30059e91d4a068f4$export$4abe0e945399ac1d(event) {
    return event.nativeEvent || event;
}

});

parcelRegister("fsI1g", function(module, exports) {

$parcel$export(module.exports, "isOrContainsNode", function () { return $b41b9de5c0d6600f$export$428954767edfafa7; });
function $b41b9de5c0d6600f$export$428954767edfafa7(parent, child) {
    return parent === child || parent.contains(child);
}

});

parcelRegister("66E2j", function(module, exports) {

$parcel$export(module.exports, "isSamsung", function () { return $47225bf8ce91ea9a$export$838732a363f40fc6; });
var $47225bf8ce91ea9a$var$regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function $47225bf8ce91ea9a$export$838732a363f40fc6(userAgent) {
    return Boolean(userAgent && userAgent.match($47225bf8ce91ea9a$var$regex));
}

});


parcelRegister("laf3I", function(module, exports) {

$parcel$export(module.exports, "getMetadata", function () { return $f686368c5d9310eb$export$8548546c0aa631e6; });
$parcel$export(module.exports, "injectMetadata", function () { return $f686368c5d9310eb$export$404feeb97c870f44; });

var $jHQu4 = parcelRequire("jHQu4");
function $f686368c5d9310eb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f686368c5d9310eb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f686368c5d9310eb$var$_typeof(obj);
}
function $f686368c5d9310eb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f686368c5d9310eb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f686368c5d9310eb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f686368c5d9310eb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f686368c5d9310eb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f686368c5d9310eb$var$_defineProperty(obj, key, value) {
    key = $f686368c5d9310eb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f686368c5d9310eb$var$_toPropertyKey(arg) {
    var key = $f686368c5d9310eb$var$_toPrimitive(arg, "string");
    return $f686368c5d9310eb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f686368c5d9310eb$var$_toPrimitive(input, hint) {
    if ($f686368c5d9310eb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f686368c5d9310eb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f686368c5d9310eb$export$8548546c0aa631e6(_ref) {
    var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;
    var plugins = _ref.plugins, options = _ref.options;
    var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
    var extraOptions = optionsKey ? $f686368c5d9310eb$var$_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
    return {
        plugins: plugins.map(function(plugin) {
            return {
                name: plugin.name,
                options: Object.keys(plugin.__autocomplete_pluginOptions || [])
            };
        }),
        options: $f686368c5d9310eb$var$_objectSpread({
            "autocomplete-core": Object.keys(options)
        }, extraOptions),
        ua: (0, $jHQu4.userAgents).concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
    };
}
function $f686368c5d9310eb$export$404feeb97c870f44(_ref3) {
    var _environment$navigato, _environment$navigato2;
    var metadata = _ref3.metadata, environment = _ref3.environment;
    var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes("Algolia Crawler");
    if (isMetadataEnabled) {
        var metadataContainer = environment.document.createElement("meta");
        var headRef = environment.document.querySelector("head");
        metadataContainer.name = "algolia:metadata";
        setTimeout(function() {
            metadataContainer.content = JSON.stringify(metadata);
            headRef.appendChild(metadataContainer);
        }, 0);
    }
}

});
parcelRegister("jHQu4", function(module, exports) {

$parcel$export(module.exports, "userAgents", function () { return $e58abeb9fafdc8d7$export$9536ea83a4cbd560; });

var $7I2J7 = parcelRequire("7I2J7");
var $e58abeb9fafdc8d7$export$9536ea83a4cbd560 = [
    {
        segment: "autocomplete-core",
        version: (0, $7I2J7.version)
    }
];

});
parcelRegister("7I2J7", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $59cec1f144249644$export$83d89fbfd8236492; });
var $59cec1f144249644$export$83d89fbfd8236492 = "1.18.0";

});



parcelRegister("garUZ", function(module, exports) {

$parcel$export(module.exports, "stateReducer", function () { return $bc533c7f4e5ba347$export$ca8ebd435faad836; });

var $1O2Aa = parcelRequire("1O2Aa");
var $lIndL = parcelRequire("lIndL");

var $d4VGT = parcelRequire("d4VGT");

var $9hBNB = parcelRequire("9hBNB");
function $bc533c7f4e5ba347$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bc533c7f4e5ba347$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bc533c7f4e5ba347$var$_typeof(obj);
}
function $bc533c7f4e5ba347$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bc533c7f4e5ba347$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bc533c7f4e5ba347$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bc533c7f4e5ba347$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bc533c7f4e5ba347$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bc533c7f4e5ba347$var$_defineProperty(obj, key, value) {
    key = $bc533c7f4e5ba347$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc533c7f4e5ba347$var$_toPropertyKey(arg) {
    var key = $bc533c7f4e5ba347$var$_toPrimitive(arg, "string");
    return $bc533c7f4e5ba347$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bc533c7f4e5ba347$var$_toPrimitive(input, hint) {
    if ($bc533c7f4e5ba347$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bc533c7f4e5ba347$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bc533c7f4e5ba347$export$ca8ebd435faad836 = function stateReducer(state, action) {
    switch(action.type){
        case "setActiveItemId":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case "setQuery":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                query: action.payload,
                completion: null
            });
        case "setCollections":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                collections: action.payload
            });
        case "setIsOpen":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                isOpen: action.payload
            });
        case "setStatus":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                status: action.payload
            });
        case "setContext":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                context: $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state.context), action.payload)
            });
        case "ArrowDown":
            var nextState = $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload.hasOwnProperty("nextActiveItemId") ? action.payload.nextActiveItemId : (0, $9hBNB.getNextActiveItemId)(1, state.activeItemId, (0, $1O2Aa.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, nextState), {}, {
                completion: (0, $d4VGT.getCompletion)({
                    state: nextState
                })
            });
        case "ArrowUp":
            var _nextState = $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: (0, $9hBNB.getNextActiveItemId)(-1, state.activeItemId, (0, $1O2Aa.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, _nextState), {}, {
                completion: (0, $d4VGT.getCompletion)({
                    state: _nextState
                })
            });
        case "Escape":
            if (state.isOpen) return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                completion: null
            });
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                query: "",
                status: "idle",
                collections: []
            });
        case "submit":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                status: "idle"
            });
        case "reset":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: // Since we open the panel on reset when openOnFocus=true
                // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
                // Since we close the panel when openOnFocus=false
                // we lose track of the highlighted index. (Query-suggestions use-case)
                action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
                status: "idle",
                completion: null,
                query: ""
            });
        case "focus":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId,
                isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
                    state: state
                })
            });
        case "blur":
            if (action.props.debug) return state;
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                isOpen: false,
                activeItemId: null
            });
        case "mousemove":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case "mouseleave":
            return $bc533c7f4e5ba347$var$_objectSpread($bc533c7f4e5ba347$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId
            });
        default:
            (0, $lIndL.invariant)(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
            return state;
    }
};

});
parcelRegister("d4VGT", function(module, exports) {

$parcel$export(module.exports, "getCompletion", function () { return $9858664ca61ca402$export$6c69e642446172b6; });

var $4HZsj = parcelRequire("4HZsj");
function $9858664ca61ca402$export$6c69e642446172b6(_ref) {
    var _getActiveItem;
    var state = _ref.state;
    if (state.isOpen === false || state.activeItemId === null) return null;
    return ((_getActiveItem = (0, $4HZsj.getActiveItem)(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}

});

parcelRegister("9hBNB", function(module, exports) {

$parcel$export(module.exports, "getNextActiveItemId", function () { return $6c2305b079c72952$export$9e353209669d8620; });
/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */ function $6c2305b079c72952$export$9e353209669d8620(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
    if (!itemCount) return null;
    if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) return itemCount + moveAmount;
    var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;
    if (numericIndex <= -1 || numericIndex >= itemCount) return defaultActiveItemId === null ? null : 0;
    return numericIndex;
}

});



parcelRegister("l2iop", function(module, exports) {

$parcel$export(module.exports, "getAlgoliaResults", function () { return $f5080d48be109c45$export$d82b34328f310205; });

var $lIndL = parcelRequire("lIndL");

var $i3FDx = parcelRequire("i3FDx");
function $f5080d48be109c45$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f5080d48be109c45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f5080d48be109c45$var$_typeof(obj);
}
function $f5080d48be109c45$export$d82b34328f310205(requestParams) {
    (0, $lIndL.invariant)($f5080d48be109c45$var$_typeof(requestParams.searchClient) === "object", "The `searchClient` parameter is required for getAlgoliaResults({ searchClient }).");
    var requester = (0, $i3FDx.createAlgoliaRequester)({
        transformResponse: function transformResponse(response) {
            return response.hits;
        }
    });
    return requester(requestParams);
}

});
parcelRegister("i3FDx", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaRequester", function () { return $d258cdf831b50100$export$9f082baead25d83b; });

var $gjxX1 = parcelRequire("gjxX1");

var $3CKZR = parcelRequire("3CKZR");
var $d258cdf831b50100$export$9f082baead25d83b = (0, $3CKZR.createRequester)((0, $gjxX1.fetchAlgoliaResults), "algolia");

});
parcelRegister("gjxX1", function(module, exports) {

$parcel$export(module.exports, "fetchAlgoliaResults", function () { return $be08c1a9d2417d3f$export$9e16a9ccc61ab625; });

var $lIndL = parcelRequire("lIndL");
var $jHQu4 = parcelRequire("jHQu4");

var $4Xtx9Y = parcelRequire("4Xtx9Y");

var $iH8QG = parcelRequire("iH8QG");
function $be08c1a9d2417d3f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $be08c1a9d2417d3f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $be08c1a9d2417d3f$var$_typeof(obj);
}
var $be08c1a9d2417d3f$var$_excluded = [
    "params"
];
function $be08c1a9d2417d3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $be08c1a9d2417d3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $be08c1a9d2417d3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $be08c1a9d2417d3f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $be08c1a9d2417d3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $be08c1a9d2417d3f$var$_defineProperty(obj, key, value) {
    key = $be08c1a9d2417d3f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be08c1a9d2417d3f$var$_toPropertyKey(arg) {
    var key = $be08c1a9d2417d3f$var$_toPrimitive(arg, "string");
    return $be08c1a9d2417d3f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $be08c1a9d2417d3f$var$_toPrimitive(input, hint) {
    if ($be08c1a9d2417d3f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($be08c1a9d2417d3f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $be08c1a9d2417d3f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $be08c1a9d2417d3f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $be08c1a9d2417d3f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $be08c1a9d2417d3f$var$_toConsumableArray(arr) {
    return $be08c1a9d2417d3f$var$_arrayWithoutHoles(arr) || $be08c1a9d2417d3f$var$_iterableToArray(arr) || $be08c1a9d2417d3f$var$_unsupportedIterableToArray(arr) || $be08c1a9d2417d3f$var$_nonIterableSpread();
}
function $be08c1a9d2417d3f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be08c1a9d2417d3f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $be08c1a9d2417d3f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $be08c1a9d2417d3f$var$_arrayLikeToArray(o, minLen);
}
function $be08c1a9d2417d3f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $be08c1a9d2417d3f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $be08c1a9d2417d3f$var$_arrayLikeToArray(arr);
}
function $be08c1a9d2417d3f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $be08c1a9d2417d3f$export$9e16a9ccc61ab625(_ref) {
    var searchClient = _ref.searchClient, queries = _ref.queries, _ref$userAgents = _ref.userAgents, userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;
    if (typeof searchClient.addAlgoliaAgent === "function") {
        var algoliaAgents = [].concat($be08c1a9d2417d3f$var$_toConsumableArray((0, $jHQu4.userAgents)), $be08c1a9d2417d3f$var$_toConsumableArray(userAgents));
        algoliaAgents.forEach(function(_ref2) {
            var segment = _ref2.segment, version = _ref2.version;
            searchClient.addAlgoliaAgent(segment, version);
        });
    }
    var _getAppIdAndApiKey = (0, $iH8QG.getAppIdAndApiKey)(searchClient), appId = _getAppIdAndApiKey.appId, apiKey = _getAppIdAndApiKey.apiKey;
    (0, $lIndL.invariant)(Boolean(appId), "The Algolia `appId` was not accessible from the searchClient passed.");
    (0, $lIndL.invariant)(Boolean(apiKey), "The Algolia `apiKey` was not accessible from the searchClient passed.");
    return searchClient.search(queries.map(function(searchParameters) {
        var params = searchParameters.params, headers = $be08c1a9d2417d3f$var$_objectWithoutProperties(searchParameters, $be08c1a9d2417d3f$var$_excluded);
        return $be08c1a9d2417d3f$var$_objectSpread($be08c1a9d2417d3f$var$_objectSpread({}, headers), {}, {
            params: $be08c1a9d2417d3f$var$_objectSpread({
                hitsPerPage: 5,
                highlightPreTag: (0, $4Xtx9Y.HIGHLIGHT_PRE_TAG),
                highlightPostTag: (0, $4Xtx9Y.HIGHLIGHT_POST_TAG)
            }, params)
        });
    })).then(function(response) {
        return response.results.map(function(result, resultIndex) {
            var _result$hits;
            return $be08c1a9d2417d3f$var$_objectSpread($be08c1a9d2417d3f$var$_objectSpread({}, result), {}, {
                hits: (_result$hits = result.hits) === null || _result$hits === void 0 ? void 0 : _result$hits.map(function(hit) {
                    return $be08c1a9d2417d3f$var$_objectSpread($be08c1a9d2417d3f$var$_objectSpread({}, hit), {}, {
                        // Bring support for the Insights plugin.
                        __autocomplete_indexName: result.index || queries[resultIndex].indexName,
                        __autocomplete_queryID: result.queryID,
                        __autocomplete_algoliaCredentials: {
                            appId: appId,
                            apiKey: apiKey
                        }
                    });
                })
            });
        });
    });
}

});
parcelRegister("iH8QG", function(module, exports) {

$parcel$export(module.exports, "getAppIdAndApiKey", function () { return $d9c31b539f2fcefa$export$58f35ab8a1251bc0; });
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $d9c31b539f2fcefa$export$58f35ab8a1251bc0(searchClient) {
    var transporter = searchClient.transporter || {};
    var headers = transporter.headers || transporter.baseHeaders || {};
    var queryParameters = transporter.queryParameters || transporter.baseQueryParameters || {};
    var APP_ID = "x-algolia-application-id";
    var API_KEY = "x-algolia-api-key";
    var appId = headers[APP_ID] || queryParameters[APP_ID];
    var apiKey = headers[API_KEY] || queryParameters[API_KEY];
    return {
        appId: appId,
        apiKey: apiKey
    };
}

});


parcelRegister("3CKZR", function(module, exports) {

$parcel$export(module.exports, "createRequester", function () { return $2a396047109c76a6$export$8d54726fdbf08e0a; });
function $2a396047109c76a6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2a396047109c76a6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2a396047109c76a6$var$_typeof(obj);
}
function $2a396047109c76a6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2a396047109c76a6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2a396047109c76a6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2a396047109c76a6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2a396047109c76a6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2a396047109c76a6$var$_defineProperty(obj, key, value) {
    key = $2a396047109c76a6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a396047109c76a6$var$_toPropertyKey(arg) {
    var key = $2a396047109c76a6$var$_toPrimitive(arg, "string");
    return $2a396047109c76a6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2a396047109c76a6$var$_toPrimitive(input, hint) {
    if ($2a396047109c76a6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2a396047109c76a6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2a396047109c76a6$export$8d54726fdbf08e0a(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map(function(x) {
                return x.query;
            })
        }).then(function(responses) {
            return responses.map(function(response, index) {
                var _fetcherParams$reques = fetcherParams.requests[index], sourceId = _fetcherParams$reques.sourceId, transformResponse = _fetcherParams$reques.transformResponse;
                return {
                    items: response,
                    sourceId: sourceId,
                    transformResponse: transformResponse
                };
            });
        });
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return $2a396047109c76a6$var$_objectSpread($2a396047109c76a6$var$_objectSpread({
                requesterId: requesterId,
                execute: execute
            }, requesterParams), requestParams);
        };
    };
}

});



parcelRegister("fpzRv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b385023cc9b3f0bb$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");
function $b385023cc9b3f0bb$var$createBrowserLocalStorageCache(options) {
    const namespaceKey = `algoliasearch-client-js-${options.key}`;
    // eslint-disable-next-line functional/no-let
    let storage;
    const getStorage = ()=>{
        if (storage === undefined) storage = options.localStorage || window.localStorage;
        return storage;
    };
    const getNamespace = ()=>{
        return JSON.parse(getStorage().getItem(namespaceKey) || "{}");
    };
    const setNamespace = (namespace)=>{
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    };
    const removeOutdatedCacheItems = ()=>{
        const timeToLive = options.timeToLive ? options.timeToLive * 1000 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== undefined;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    };
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                const keyAsString = JSON.stringify(key);
                return getNamespace()[keyAsString];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== undefined
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                // eslint-disable-next-line functional/immutable-data
                namespace[JSON.stringify(key)] = {
                    timestamp: new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                // eslint-disable-next-line functional/immutable-data
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
// @todo Add logger on options to debug when caches go wrong.
function $b385023cc9b3f0bb$var$createFallbackableCache(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift(); // eslint-disable-line functional/immutable-data
    if (current === undefined) return $b385023cc9b3f0bb$var$createNullCache();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $b385023cc9b3f0bb$var$createFallbackableCache({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $b385023cc9b3f0bb$var$createFallbackableCache({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $b385023cc9b3f0bb$var$createFallbackableCache({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $b385023cc9b3f0bb$var$createFallbackableCache({
                    caches: caches
                }).clear();
            });
        }
    };
}
function $b385023cc9b3f0bb$var$createNullCache() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
function $b385023cc9b3f0bb$var$createInMemoryCache(options = {
    serializable: true
}) {
    // eslint-disable-next-line functional/no-let
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            const miss = events && events.miss || (()=>Promise.resolve());
            return promise.then((value)=>miss(value)).then(()=>promise);
        },
        set (key, value) {
            // eslint-disable-next-line functional/immutable-data
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            // eslint-disable-next-line functional/immutable-data
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
function $b385023cc9b3f0bb$var$createAuth(authMode, appId, apiKey) {
    const credentials = {
        "x-algolia-api-key": apiKey,
        "x-algolia-application-id": appId
    };
    return {
        headers () {
            return authMode === $b385023cc9b3f0bb$var$AuthMode.WithinHeaders ? credentials : {};
        },
        queryParameters () {
            return authMode === $b385023cc9b3f0bb$var$AuthMode.WithinQueryParameters ? credentials : {};
        }
    };
}
// eslint-disable-next-line functional/prefer-readonly-type
function $b385023cc9b3f0bb$var$shuffle(array) {
    let c = array.length - 1; // eslint-disable-line functional/no-let
    // eslint-disable-next-line functional/no-loop-statement
    for(c; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        array[c] = array[b]; // eslint-disable-line functional/immutable-data, no-param-reassign
        array[b] = a; // eslint-disable-line functional/immutable-data, no-param-reassign
    }
    return array;
}
function $b385023cc9b3f0bb$var$addMethods(base, methods) {
    if (!methods) return base;
    Object.keys(methods).forEach((key)=>{
        // eslint-disable-next-line functional/immutable-data, no-param-reassign
        base[key] = methods[key](base);
    });
    return base;
}
function $b385023cc9b3f0bb$var$encode(format, ...args) {
    // eslint-disable-next-line functional/no-let
    let i = 0;
    return format.replace(/%s/g, ()=>encodeURIComponent(args[i++]));
}
const $b385023cc9b3f0bb$var$version = "4.24.0";
const $b385023cc9b3f0bb$var$AuthMode = {
    /**
     * If auth credentials should be in query parameters.
     */ WithinQueryParameters: 0,
    /**
     * If auth credentials should be in headers.
     */ WithinHeaders: 1
};
function $b385023cc9b3f0bb$var$createMappedRequestOptions(requestOptions, timeout) {
    const options = requestOptions || {};
    const data = options.data || {};
    Object.keys(options).forEach((key)=>{
        if ([
            "timeout",
            "headers",
            "queryParameters",
            "data",
            "cacheable"
        ].indexOf(key) === -1) data[key] = options[key]; // eslint-disable-line functional/immutable-data
    });
    return {
        data: Object.entries(data).length > 0 ? data : undefined,
        timeout: options.timeout || timeout,
        headers: options.headers || {},
        queryParameters: options.queryParameters || {},
        cacheable: options.cacheable
    };
}
const $b385023cc9b3f0bb$var$CallEnum = {
    /**
     * If the host is read only.
     */ Read: 1,
    /**
     * If the host is write only.
     */ Write: 2,
    /**
     * If the host is both read and write.
     */ Any: 3
};
const $b385023cc9b3f0bb$var$HostStatusEnum = {
    Up: 1,
    Down: 2,
    Timeouted: 3
};
// By default, API Clients at Algolia have expiration delay
// of 5 mins. In the JavaScript client, we have 2 mins.
const $b385023cc9b3f0bb$var$EXPIRATION_DELAY = 120000;
function $b385023cc9b3f0bb$var$createStatefulHost(host, status = $b385023cc9b3f0bb$var$HostStatusEnum.Up) {
    return (0, $6iHNw._)((0, $7Knp0._)({}, host), {
        status: status,
        lastUpdate: Date.now()
    });
}
function $b385023cc9b3f0bb$var$isStatefulHostUp(host) {
    return host.status === $b385023cc9b3f0bb$var$HostStatusEnum.Up || Date.now() - host.lastUpdate > $b385023cc9b3f0bb$var$EXPIRATION_DELAY;
}
function $b385023cc9b3f0bb$var$isStatefulHostTimeouted(host) {
    return host.status === $b385023cc9b3f0bb$var$HostStatusEnum.Timeouted && Date.now() - host.lastUpdate <= $b385023cc9b3f0bb$var$EXPIRATION_DELAY;
}
function $b385023cc9b3f0bb$var$createStatelessHost(options) {
    if (typeof options === "string") return {
        protocol: "https",
        url: options,
        accept: $b385023cc9b3f0bb$var$CallEnum.Any
    };
    return {
        protocol: options.protocol || "https",
        url: options.url,
        accept: options.accept || $b385023cc9b3f0bb$var$CallEnum.Any
    };
}
const $b385023cc9b3f0bb$var$MethodEnum = {
    Delete: "DELETE",
    Get: "GET",
    Post: "POST",
    Put: "PUT"
};
function $b385023cc9b3f0bb$var$createRetryableOptions(hostsCache, statelessHosts) {
    return Promise.all(statelessHosts.map((statelessHost)=>{
        return hostsCache.get(statelessHost, ()=>{
            return Promise.resolve($b385023cc9b3f0bb$var$createStatefulHost(statelessHost));
        });
    })).then((statefulHosts)=>{
        const hostsUp = statefulHosts.filter((host)=>$b385023cc9b3f0bb$var$isStatefulHostUp(host));
        const hostsTimeouted = statefulHosts.filter((host)=>$b385023cc9b3f0bb$var$isStatefulHostTimeouted(host));
        /**
         * Note, we put the hosts that previously timeouted on the end of the list.
         */ const hostsAvailable = [
            ...hostsUp,
            ...hostsTimeouted
        ];
        const statelessHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable.map((host)=>$b385023cc9b3f0bb$var$createStatelessHost(host)) : statelessHosts;
        return {
            getTimeout (timeoutsCount, baseTimeout) {
                /**
                 * Imagine that you have 4 hosts, if timeouts will increase
                 * on the following way: 1 (timeouted) > 4 (timeouted) > 5 (200)
                 *
                 * Note that, the very next request, we start from the previous timeout
                 *
                 *  5 (timeouted) > 6 (timeouted) > 7 ...
                 *
                 * This strategy may need to be reviewed, but is the strategy on the our
                 * current v3 version.
                 */ const timeoutMultiplier = hostsTimeouted.length === 0 && timeoutsCount === 0 ? 1 : hostsTimeouted.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            },
            statelessHosts: statelessHostsAvailable
        };
    });
}
const $b385023cc9b3f0bb$var$isNetworkError = ({ isTimedOut: isTimedOut, status: status })=>{
    return !isTimedOut && ~~status === 0;
};
const $b385023cc9b3f0bb$var$isRetryable = (response)=>{
    const status = response.status;
    const isTimedOut = response.isTimedOut;
    return isTimedOut || $b385023cc9b3f0bb$var$isNetworkError(response) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
};
const $b385023cc9b3f0bb$var$isSuccess = ({ status: status })=>{
    return ~~(status / 100) === 2;
};
const $b385023cc9b3f0bb$var$retryDecision = (response, outcomes)=>{
    if ($b385023cc9b3f0bb$var$isRetryable(response)) return outcomes.onRetry(response);
    if ($b385023cc9b3f0bb$var$isSuccess(response)) return outcomes.onSuccess(response);
    return outcomes.onFail(response);
};
function $b385023cc9b3f0bb$var$retryableRequest(transporter, statelessHosts, request, requestOptions) {
    const stackTrace = []; // eslint-disable-line functional/prefer-readonly-type
    /**
     * First we prepare the payload that do not depend from hosts.
     */ const data = $b385023cc9b3f0bb$var$serializeData(request, requestOptions);
    const headers = $b385023cc9b3f0bb$var$serializeHeaders(transporter, requestOptions);
    const method = request.method;
    // On `GET`, the data is proxied to query parameters.
    const dataQueryParameters = request.method !== $b385023cc9b3f0bb$var$MethodEnum.Get ? {} : (0, $7Knp0._)({}, request.data, requestOptions.data);
    const queryParameters = (0, $7Knp0._)({
        "x-algolia-agent": transporter.userAgent.value
    }, transporter.queryParameters, dataQueryParameters, requestOptions.queryParameters);
    let timeoutsCount = 0; // eslint-disable-line functional/no-let
    const retry = (hosts, getTimeout)=>{
        /**
         * We iterate on each host, until there is no host left.
         */ const host = hosts.pop(); // eslint-disable-line functional/immutable-data
        if (host === undefined) throw $b385023cc9b3f0bb$var$createRetryError($b385023cc9b3f0bb$var$stackTraceWithoutCredentials(stackTrace));
        const payload = {
            data: data,
            headers: headers,
            method: method,
            url: $b385023cc9b3f0bb$var$serializeUrl(host, request.path, queryParameters),
            connectTimeout: getTimeout(timeoutsCount, transporter.timeouts.connect),
            responseTimeout: getTimeout(timeoutsCount, requestOptions.timeout)
        };
        /**
         * The stackFrame is pushed to the stackTrace so we
         * can have information about onRetry and onFailure
         * decisions.
         */ const pushToStackTrace = (response)=>{
            const stackFrame = {
                request: payload,
                response: response,
                host: host,
                triesLeft: hosts.length
            };
            // eslint-disable-next-line functional/immutable-data
            stackTrace.push(stackFrame);
            return stackFrame;
        };
        const decisions = {
            onSuccess: (response)=>$b385023cc9b3f0bb$var$deserializeSuccess(response),
            onRetry (response) {
                const stackFrame = pushToStackTrace(response);
                /**
                 * If response is a timeout, we increaset the number of
                 * timeouts so we can increase the timeout later.
                 */ if (response.isTimedOut) timeoutsCount++;
                return Promise.all([
                    /**
                     * Failures are individually send the logger, allowing
                     * the end user to debug / store stack frames even
                     * when a retry error does not happen.
                     */ transporter.logger.info("Retryable failure", $b385023cc9b3f0bb$var$stackFrameWithoutCredentials(stackFrame)),
                    /**
                     * We also store the state of the host in failure cases. If the host, is
                     * down it will remain down for the next 2 minutes. In a timeout situation,
                     * this host will be added end of the list of hosts on the next request.
                     */ transporter.hostsCache.set(host, $b385023cc9b3f0bb$var$createStatefulHost(host, response.isTimedOut ? $b385023cc9b3f0bb$var$HostStatusEnum.Timeouted : $b385023cc9b3f0bb$var$HostStatusEnum.Down))
                ]).then(()=>retry(hosts, getTimeout));
            },
            onFail (response) {
                pushToStackTrace(response);
                throw $b385023cc9b3f0bb$var$deserializeFailure(response, $b385023cc9b3f0bb$var$stackTraceWithoutCredentials(stackTrace));
            }
        };
        return transporter.requester.send(payload).then((response)=>{
            return $b385023cc9b3f0bb$var$retryDecision(response, decisions);
        });
    };
    /**
     * Finally, for each retryable host perform request until we got a non
     * retryable response. Some notes here:
     *
     * 1. The reverse here is applied so we can apply a `pop` later on => more performant.
     * 2. We also get from the retryable options a timeout multiplier that is tailored
     * for the current context.
     */ return $b385023cc9b3f0bb$var$createRetryableOptions(transporter.hostsCache, statelessHosts).then((options)=>{
        return retry([
            ...options.statelessHosts
        ].reverse(), options.getTimeout);
    });
}
function $b385023cc9b3f0bb$var$createTransporter(options) {
    const { hostsCache: hostsCache, logger: logger, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache, timeouts: timeouts, userAgent: userAgent, hosts: hosts, queryParameters: queryParameters, headers: headers } = options;
    const transporter = {
        hostsCache: hostsCache,
        logger: logger,
        requester: requester,
        requestsCache: requestsCache,
        responsesCache: responsesCache,
        timeouts: timeouts,
        userAgent: userAgent,
        headers: headers,
        queryParameters: queryParameters,
        hosts: hosts.map((host)=>$b385023cc9b3f0bb$var$createStatelessHost(host)),
        read (request, requestOptions) {
            /**
             * First, we compute the user request options. Now, keep in mind,
             * that using request options the user is able to modified the intire
             * payload of the request. Such as headers, query parameters, and others.
             */ const mappedRequestOptions = $b385023cc9b3f0bb$var$createMappedRequestOptions(requestOptions, transporter.timeouts.read);
            const createRetryableRequest = ()=>{
                /**
                 * Then, we prepare a function factory that contains the construction of
                 * the retryable request. At this point, we may *not* perform the actual
                 * request. But we want to have the function factory ready.
                 */ return $b385023cc9b3f0bb$var$retryableRequest(transporter, transporter.hosts.filter((host)=>(host.accept & $b385023cc9b3f0bb$var$CallEnum.Read) !== 0), request, mappedRequestOptions);
            };
            /**
             * Once we have the function factory ready, we need to determine of the
             * request is "cacheable" - should be cached. Note that, once again,
             * the user can force this option.
             */ const cacheable = mappedRequestOptions.cacheable !== undefined ? mappedRequestOptions.cacheable : request.cacheable;
            /**
             * If is not "cacheable", we immediatly trigger the retryable request, no
             * need to check cache implementations.
             */ if (cacheable !== true) return createRetryableRequest();
            /**
             * If the request is "cacheable", we need to first compute the key to ask
             * the cache implementations if this request is on progress or if the
             * response already exists on the cache.
             */ const key = {
                request: request,
                mappedRequestOptions: mappedRequestOptions,
                transporter: {
                    queryParameters: transporter.queryParameters,
                    headers: transporter.headers
                }
            };
            /**
             * With the computed key, we first ask the responses cache
             * implemention if this request was been resolved before.
             */ return transporter.responsesCache.get(key, ()=>{
                /**
                 * If the request has never resolved before, we actually ask if there
                 * is a current request with the same key on progress.
                 */ return transporter.requestsCache.get(key, ()=>{
                    return transporter.requestsCache/**
                         * Finally, if there is no request in progress with the same key,
                         * this `createRetryableRequest()` will actually trigger the
                         * retryable request.
                         */ .set(key, createRetryableRequest()).then((response)=>Promise.all([
                            transporter.requestsCache.delete(key),
                            response
                        ]), (err)=>Promise.all([
                            transporter.requestsCache.delete(key),
                            Promise.reject(err)
                        ])).then(([_, response])=>response);
                });
            }, {
                /**
                 * Of course, once we get this response back from the server, we
                 * tell response cache to actually store the received response
                 * to be used later.
                 */ miss: (response)=>transporter.responsesCache.set(key, response)
            });
        },
        write (request, requestOptions) {
            /**
             * On write requests, no cache mechanisms are applied, and we
             * proxy the request immediately to the requester.
             */ return $b385023cc9b3f0bb$var$retryableRequest(transporter, transporter.hosts.filter((host)=>(host.accept & $b385023cc9b3f0bb$var$CallEnum.Write) !== 0), request, $b385023cc9b3f0bb$var$createMappedRequestOptions(requestOptions, transporter.timeouts.write));
        }
    };
    return transporter;
}
function $b385023cc9b3f0bb$var$createUserAgent(version) {
    const userAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedUserAgent = `; ${options.segment}${options.version !== undefined ? ` (${options.version})` : ""}`;
            if (userAgent.value.indexOf(addedUserAgent) === -1) // eslint-disable-next-line functional/immutable-data
            userAgent.value = `${userAgent.value}${addedUserAgent}`;
            return userAgent;
        }
    };
    return userAgent;
}
function $b385023cc9b3f0bb$var$deserializeSuccess(response) {
    // eslint-disable-next-line functional/no-try-statement
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw $b385023cc9b3f0bb$var$createDeserializationError(e.message, response);
    }
}
function $b385023cc9b3f0bb$var$deserializeFailure({ content: content, status: status }, stackFrame) {
    // eslint-disable-next-line functional/no-let
    let message = content;
    // eslint-disable-next-line functional/no-try-statement
    try {
        message = JSON.parse(content).message;
    } catch (e) {
    // ..
    }
    return $b385023cc9b3f0bb$var$createApiError(message, status, stackFrame);
}
function $b385023cc9b3f0bb$var$serializeUrl(host, path, queryParameters) {
    const queryParametersAsString = $b385023cc9b3f0bb$var$serializeQueryParameters(queryParameters);
    // eslint-disable-next-line functional/no-let
    let url = `${host.protocol}://${host.url}/${path.charAt(0) === "/" ? path.substr(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $b385023cc9b3f0bb$var$serializeQueryParameters(parameters) {
    const isObjectOrArray = (value)=>Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    return Object.keys(parameters).map((key)=>$b385023cc9b3f0bb$var$encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key])).join("&");
}
function $b385023cc9b3f0bb$var$serializeData(request, requestOptions) {
    if (request.method === $b385023cc9b3f0bb$var$MethodEnum.Get || request.data === undefined && requestOptions.data === undefined) return undefined;
    const data = Array.isArray(request.data) ? request.data : (0, $7Knp0._)({}, request.data, requestOptions.data);
    return JSON.stringify(data);
}
function $b385023cc9b3f0bb$var$serializeHeaders(transporter, requestOptions) {
    const headers = (0, $7Knp0._)({}, transporter.headers, requestOptions.headers);
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        // @ts-ignore
        // eslint-disable-next-line functional/immutable-data
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $b385023cc9b3f0bb$var$stackTraceWithoutCredentials(stackTrace) {
    return stackTrace.map((stackFrame)=>$b385023cc9b3f0bb$var$stackFrameWithoutCredentials(stackFrame));
}
function $b385023cc9b3f0bb$var$stackFrameWithoutCredentials(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers["x-algolia-api-key"] ? {
        "x-algolia-api-key": "*****"
    } : {};
    return (0, $6iHNw._)((0, $7Knp0._)({}, stackFrame), {
        request: (0, $6iHNw._)((0, $7Knp0._)({}, stackFrame.request), {
            headers: (0, $7Knp0._)({}, stackFrame.request.headers, modifiedHeaders)
        })
    });
}
function $b385023cc9b3f0bb$var$createApiError(message, status, transporterStackTrace) {
    return {
        name: "ApiError",
        message: message,
        status: status,
        transporterStackTrace: transporterStackTrace
    };
}
function $b385023cc9b3f0bb$var$createDeserializationError(message, response) {
    return {
        name: "DeserializationError",
        message: message,
        response: response
    };
}
function $b385023cc9b3f0bb$var$createRetryError(transporterStackTrace) {
    return {
        name: "RetryError",
        message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .",
        transporterStackTrace: transporterStackTrace
    };
}
const $b385023cc9b3f0bb$var$createSearchClient = (options)=>{
    const appId = options.appId;
    const auth = $b385023cc9b3f0bb$var$createAuth(options.authMode !== undefined ? options.authMode : $b385023cc9b3f0bb$var$AuthMode.WithinHeaders, appId, options.apiKey);
    const transporter = $b385023cc9b3f0bb$var$createTransporter((0, $6iHNw._)((0, $7Knp0._)({
        hosts: [
            {
                url: `${appId}-dsn.algolia.net`,
                accept: $b385023cc9b3f0bb$var$CallEnum.Read
            },
            {
                url: `${appId}.algolia.net`,
                accept: $b385023cc9b3f0bb$var$CallEnum.Write
            }
        ].concat($b385023cc9b3f0bb$var$shuffle([
            {
                url: `${appId}-1.algolianet.com`
            },
            {
                url: `${appId}-2.algolianet.com`
            },
            {
                url: `${appId}-3.algolianet.com`
            }
        ]))
    }, options), {
        headers: (0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, auth.headers()), {
            "content-type": "application/x-www-form-urlencoded"
        }), options.headers),
        queryParameters: (0, $7Knp0._)({}, auth.queryParameters(), options.queryParameters)
    }));
    const base = {
        transporter: transporter,
        appId: appId,
        addAlgoliaAgent (segment, version) {
            transporter.userAgent.add({
                segment: segment,
                version: version
            });
        },
        clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>undefined);
        }
    };
    return $b385023cc9b3f0bb$var$addMethods(base, options.methods);
};
const $b385023cc9b3f0bb$var$customRequest = (base)=>{
    return (request, requestOptions)=>{
        if (request.method === $b385023cc9b3f0bb$var$MethodEnum.Get) return base.transporter.read(request, requestOptions);
        return base.transporter.write(request, requestOptions);
    };
};
const $b385023cc9b3f0bb$var$initIndex = (base)=>{
    return (indexName, options = {})=>{
        const searchIndex = {
            transporter: base.transporter,
            appId: base.appId,
            indexName: indexName
        };
        return $b385023cc9b3f0bb$var$addMethods(searchIndex, options.methods);
    };
};
const $b385023cc9b3f0bb$var$multipleQueries = (base)=>{
    return (queries, requestOptions)=>{
        const requests = queries.map((query)=>{
            return (0, $6iHNw._)((0, $7Knp0._)({}, query), {
                params: $b385023cc9b3f0bb$var$serializeQueryParameters(query.params || {})
            });
        });
        return base.transporter.read({
            method: $b385023cc9b3f0bb$var$MethodEnum.Post,
            path: "1/indexes/*/queries",
            data: {
                requests: requests
            },
            cacheable: true
        }, requestOptions);
    };
};
const $b385023cc9b3f0bb$var$multipleSearchForFacetValues = (base)=>{
    return (queries, requestOptions)=>{
        return Promise.all(queries.map((query)=>{
            const _query_params = query.params, { facetName: facetName, facetQuery: facetQuery } = _query_params, params = (0, $akGnX._)(_query_params, [
                "facetName",
                "facetQuery"
            ]);
            return $b385023cc9b3f0bb$var$initIndex(base)(query.indexName, {
                methods: {
                    searchForFacetValues: $b385023cc9b3f0bb$var$searchForFacetValues
                }
            }).searchForFacetValues(facetName, facetQuery, (0, $7Knp0._)({}, requestOptions, params));
        }));
    };
};
const $b385023cc9b3f0bb$var$findAnswers = (base)=>{
    return (query, queryLanguages, requestOptions)=>{
        return base.transporter.read({
            method: $b385023cc9b3f0bb$var$MethodEnum.Post,
            path: $b385023cc9b3f0bb$var$encode("1/answers/%s/prediction", base.indexName),
            data: {
                query: query,
                queryLanguages: queryLanguages
            },
            cacheable: true
        }, requestOptions);
    };
};
const $b385023cc9b3f0bb$var$search = (base)=>{
    return (query, requestOptions)=>{
        return base.transporter.read({
            method: $b385023cc9b3f0bb$var$MethodEnum.Post,
            path: $b385023cc9b3f0bb$var$encode("1/indexes/%s/query", base.indexName),
            data: {
                query: query
            },
            cacheable: true
        }, requestOptions);
    };
};
const $b385023cc9b3f0bb$var$searchForFacetValues = (base)=>{
    return (facetName, facetQuery, requestOptions)=>{
        return base.transporter.read({
            method: $b385023cc9b3f0bb$var$MethodEnum.Post,
            path: $b385023cc9b3f0bb$var$encode("1/indexes/%s/facets/%s/query", base.indexName, facetName),
            data: {
                facetQuery: facetQuery
            },
            cacheable: true
        }, requestOptions);
    };
};
const $b385023cc9b3f0bb$var$LogLevelEnum = {
    Debug: 1,
    Info: 2,
    Error: 3
};
/* eslint no-console: 0 */ function $b385023cc9b3f0bb$var$createConsoleLogger(logLevel) {
    return {
        debug (message, args) {
            if ($b385023cc9b3f0bb$var$LogLevelEnum.Debug >= logLevel) console.debug(message, args);
            return Promise.resolve();
        },
        info (message, args) {
            if ($b385023cc9b3f0bb$var$LogLevelEnum.Info >= logLevel) console.info(message, args);
            return Promise.resolve();
        },
        error (message, args) {
            console.error(message, args);
            return Promise.resolve();
        }
    };
}
const $b385023cc9b3f0bb$var$getRecommendations = (base)=>{
    return (queries, requestOptions)=>{
        const requests = queries.map((query)=>(0, $6iHNw._)((0, $7Knp0._)({}, query), {
                // The `threshold` param is required by the endpoint to make it easier
                // to provide a default value later, so we default it in the client
                // so that users don't have to provide a value.
                threshold: query.threshold || 0
            }));
        return base.transporter.read({
            method: $b385023cc9b3f0bb$var$MethodEnum.Post,
            path: "1/indexes/*/recommendations",
            data: {
                requests: requests
            },
            cacheable: true
        }, requestOptions);
    };
};
function $b385023cc9b3f0bb$var$createBrowserXhrRequester() {
    return {
        send (request) {
            return new Promise((resolve)=>{
                const baseRequester = new XMLHttpRequest();
                baseRequester.open(request.method, request.url, true);
                Object.keys(request.headers).forEach((key)=>baseRequester.setRequestHeader(key, request.headers[key]));
                const createTimeout = (timeout, content)=>{
                    return setTimeout(()=>{
                        baseRequester.abort();
                        resolve({
                            status: 0,
                            content: content,
                            isTimedOut: true
                        });
                    }, timeout * 1000);
                };
                const connectTimeout = createTimeout(request.connectTimeout, "Connection timeout");
                // eslint-disable-next-line functional/no-let
                let responseTimeout;
                // eslint-disable-next-line functional/immutable-data
                baseRequester.onreadystatechange = ()=>{
                    if (baseRequester.readyState > baseRequester.OPENED && responseTimeout === undefined) {
                        clearTimeout(connectTimeout);
                        responseTimeout = createTimeout(request.responseTimeout, "Socket timeout");
                    }
                };
                // eslint-disable-next-line functional/immutable-data
                baseRequester.onerror = ()=>{
                    // istanbul ignore next
                    if (baseRequester.status === 0) {
                        clearTimeout(connectTimeout);
                        clearTimeout(responseTimeout);
                        resolve({
                            content: baseRequester.responseText || "Network request failed",
                            status: baseRequester.status,
                            isTimedOut: false
                        });
                    }
                };
                //  eslint-disable-next-line functional/immutable-data
                baseRequester.onload = ()=>{
                    clearTimeout(connectTimeout);
                    clearTimeout(responseTimeout);
                    resolve({
                        content: baseRequester.responseText,
                        status: baseRequester.status,
                        isTimedOut: false
                    });
                };
                baseRequester.send(request.data);
            });
        }
    };
}
function $b385023cc9b3f0bb$var$algoliasearch(appId, apiKey, options) {
    const commonOptions = {
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1,
            read: 2,
            write: 30
        },
        requester: $b385023cc9b3f0bb$var$createBrowserXhrRequester(),
        logger: $b385023cc9b3f0bb$var$createConsoleLogger($b385023cc9b3f0bb$var$LogLevelEnum.Error),
        responsesCache: $b385023cc9b3f0bb$var$createInMemoryCache(),
        requestsCache: $b385023cc9b3f0bb$var$createInMemoryCache({
            serializable: false
        }),
        hostsCache: $b385023cc9b3f0bb$var$createFallbackableCache({
            caches: [
                $b385023cc9b3f0bb$var$createBrowserLocalStorageCache({
                    key: `${$b385023cc9b3f0bb$var$version}-${appId}`
                }),
                $b385023cc9b3f0bb$var$createInMemoryCache()
            ]
        }),
        userAgent: $b385023cc9b3f0bb$var$createUserAgent($b385023cc9b3f0bb$var$version).add({
            segment: "Browser",
            version: "lite"
        }),
        authMode: $b385023cc9b3f0bb$var$AuthMode.WithinQueryParameters
    };
    return $b385023cc9b3f0bb$var$createSearchClient((0, $6iHNw._)((0, $7Knp0._)({}, commonOptions, options), {
        methods: {
            search: $b385023cc9b3f0bb$var$multipleQueries,
            searchForFacetValues: $b385023cc9b3f0bb$var$multipleSearchForFacetValues,
            multipleQueries: $b385023cc9b3f0bb$var$multipleQueries,
            multipleSearchForFacetValues: $b385023cc9b3f0bb$var$multipleSearchForFacetValues,
            customRequest: $b385023cc9b3f0bb$var$customRequest,
            initIndex: (base)=>(indexName)=>{
                    return $b385023cc9b3f0bb$var$initIndex(base)(indexName, {
                        methods: {
                            search: $b385023cc9b3f0bb$var$search,
                            searchForFacetValues: $b385023cc9b3f0bb$var$searchForFacetValues,
                            findAnswers: $b385023cc9b3f0bb$var$findAnswers
                        }
                    });
                },
            getRecommendations: $b385023cc9b3f0bb$var$getRecommendations
        }
    }));
}
// eslint-disable-next-line functional/immutable-data
$b385023cc9b3f0bb$var$algoliasearch.version = $b385023cc9b3f0bb$var$version;
var $b385023cc9b3f0bb$export$2e2bcd8739ae039 = $b385023cc9b3f0bb$var$algoliasearch;

});



parcelRegister("9gWFG", function(module, exports) {

$parcel$export(module.exports, "ContactSalesCta", function () { return $6026a9a67d91c087$export$c816bec35c3748e1; });
/* contact-sales-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $gpl9P = parcelRequire("gpl9P");

var $g9kzu = parcelRequire("g9kzu");

var $dWbel = parcelRequire("dWbel");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");

var $DtoBz = parcelRequire("DtoBz");
const $6026a9a67d91c087$var$fullWidthStyles = null;
const $6026a9a67d91c087$export$c816bec35c3748e1 = ({ isFullWidth: isFullWidth })=>{
    const { accountId: accountId } = (0, $5wOn9.useLoggedInUser)(); // feature gate has configuration to only be enabled on specified page paths
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/wac_sales_inbound_leads
    const isFeatureGateEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacSalesInboundLeads);
    const [isSalesLead, setIsSalesLead] = (0, $iSvIT.useState)(false);
    (0, $iSvIT.useEffect)(()=>{
        if (!isFeatureGateEnabled || !accountId) return;
        const aggClient = new (0, $gpl9P.AGGClient)({
            gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
        });
        const isSMBSalesLead = async ()=>{
            (0, $DtoBz.getIsSMBSalesLead)({
                accountId: accountId,
                aggClient: aggClient
            }).then((response)=>{
                setIsSalesLead(!!response);
            }).catch(()=>{
                console.error("Error fetching GUPS user profile for SMB Sales lead");
            });
        };
        isSMBSalesLead();
    }, [
        accountId,
        isFeatureGateEnabled
    ]);
    if (!accountId || !isFeatureGateEnabled) return;
    return isSalesLead && /*#__PURE__*/ (0, $loA2J.jsx)($6026a9a67d91c087$var$CtaButtonRenderer, {
        isFullWidth: isFullWidth
    });
};
const $6026a9a67d91c087$var$CtaButtonRenderer = ({ isFullWidth: isFullWidth })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features");
    (0, $iSvIT.useEffect)(()=>{
        if (analyticsClient) createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "button",
            actionSubjectId: "contactSalesCta",
            source: "globalNav",
            attributes: {
                isMobile: !!isFullWidth
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent,
        isFullWidth
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iWJ8.ExperimentView), {
        experiment: (0, $9iWJ8.experiments).gwp8111SalesInboundLeadsCta,
        render: (cohort)=>{
            if (cohort === "test1") return /*#__PURE__*/ (0, $loA2J.jsx)($6026a9a67d91c087$var$CtaButton, {
                isFullWidth: isFullWidth,
                localizedHref: localizedHref,
                label: "Contact sales",
                buttonVariant: "primary_alt"
            });
            else if (cohort === "test2") return /*#__PURE__*/ (0, $loA2J.jsx)($6026a9a67d91c087$var$CtaButton, {
                isFullWidth: isFullWidth,
                localizedHref: localizedHref,
                label: "Contact us",
                buttonVariant: "primary_alt"
            });
            else return /*#__PURE__*/ (0, $loA2J.jsx)($6026a9a67d91c087$var$CtaButton, {
                isFullWidth: isFullWidth,
                localizedHref: localizedHref,
                label: "Questions?",
                buttonVariant: "secondary"
            });
        }
    });
};
const $6026a9a67d91c087$var$CtaButton = ({ isFullWidth: isFullWidth, localizedHref: localizedHref, label: label, buttonVariant: buttonVariant })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        variant: buttonVariant,
        href: localizedHref,
        className: (0, $esG4f.default)([
            isFullWidth && "_p12fglyw _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "global-nav.contact-sales-cta.label",
            defaultMessage: label
        })
    });

});
parcelRegister("DtoBz", function(module, exports) {

$parcel$export(module.exports, "getIsSMBSalesLead", function () { return $66666f816636fe44$export$7ff16243701dc0d3; });

var $gpl9P = parcelRequire("gpl9P");
const $66666f816636fe44$var$createQuery = (accountId)=>{
    return `#graphql
    query InboundSalesQuery {
        growthUnifiedProfile_getUnifiedProfile(accountId: "${accountId}"){
            userProfile{
                domainType
                smbUserVisitedPricingPages
            }
            sites{
                cloudId
                displayName
                products{
                    productKey
                    productName
                    productEdition
                }
            }
        }
    }
`;
};
const $66666f816636fe44$export$7ff16243701dc0d3 = async ({ accountId: accountId, aggClient: aggClient = new (0, $gpl9P.AGGClient)() })=>{
    var _data_growthUnifiedProfile_getUnifiedProfile_userProfile, _data_growthUnifiedProfile_getUnifiedProfile;
    const customHeaders = {
        "x-use-case": "sales-inbound"
    };
    const { data: data, errors: errors } = await aggClient.query($66666f816636fe44$var$createQuery(accountId), undefined, customHeaders);
    if (errors) {
        var _errors_, _errors_1;
        console.error(`GRS API failed`, (_errors_ = errors[0]) === null || _errors_ === void 0 ? void 0 : _errors_.message);
        throw new Error((_errors_1 = errors[0]) === null || _errors_1 === void 0 ? void 0 : _errors_1.message);
    }
    const isSMBSalesLead = data === null || data === void 0 ? void 0 : (_data_growthUnifiedProfile_getUnifiedProfile = data.growthUnifiedProfile_getUnifiedProfile) === null || _data_growthUnifiedProfile_getUnifiedProfile === void 0 ? void 0 : (_data_growthUnifiedProfile_getUnifiedProfile_userProfile = _data_growthUnifiedProfile_getUnifiedProfile.userProfile) === null || _data_growthUnifiedProfile_getUnifiedProfile_userProfile === void 0 ? void 0 : _data_growthUnifiedProfile_getUnifiedProfile_userProfile.smbUserVisitedPricingPages;
    return isSMBSalesLead;
};

});


parcelRegister("aoDWS", function(module, exports) {

$parcel$export(module.exports, "useMobileNavDisplay", function () { return $cd8c6bf8aa453dc2$export$5d09230d0dd28d47; });

var $iSvIT = parcelRequire("iSvIT");

var $5wOn9 = parcelRequire("5wOn9");
const $cd8c6bf8aa453dc2$export$5d09230d0dd28d47 = (isOpenSearch)=>{
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const [showMenu, setShowMenu] = (0, $iSvIT.useState)(false);
    const [isDisplayLoggedInUseDropdown, setIsDisplayLoggedInUseDropdown] = (0, $iSvIT.useState)(false);
    const [firstOpen, setFirstOpen] = (0, $iSvIT.useState)(false);
    const [menuPage, setMenuPage] = (0, $iSvIT.useState)("default");
    const handleToggleMenu = (showMenu)=>{
        setShowMenu(showMenu);
        if (isDisplayLoggedInUseDropdown) setIsDisplayLoggedInUseDropdown(false);
    };
    const handleFirstOpen = (firstOpen)=>{
        setFirstOpen(firstOpen);
    };
    const handleMenuPage = (menuPage)=>{
        setMenuPage(menuPage);
    };
    const handleClickAvatar = ()=>{
        if (!isDisplayLoggedInUseDropdown && showMenu) setIsDisplayLoggedInUseDropdown((isDisplayLoggedInUseDropdown)=>!isDisplayLoggedInUseDropdown);
        else {
            setIsDisplayLoggedInUseDropdown((isDisplayLoggedInUseDropdown)=>!isDisplayLoggedInUseDropdown);
            setShowMenu((showMenu)=>!showMenu);
        }
    };
    (0, $iSvIT.useEffect)(()=>{
        if (isOpenSearch) {
            setShowMenu(false);
            setFirstOpen(false);
            setIsDisplayLoggedInUseDropdown(false);
        }
    }, [
        isOpenSearch
    ]);
    return {
        userInfo: userInfo,
        showMenu: showMenu,
        isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown,
        firstOpen: firstOpen,
        menuPage: menuPage,
        handleToggleMenu: handleToggleMenu,
        handleFirstOpen: handleFirstOpen,
        handleMenuPage: handleMenuPage,
        handleClickAvatar: handleClickAvatar
    };
};

});

parcelRegister("9xKd9", function(module, exports) {

$parcel$export(module.exports, "SkipToContent", function () { return $031c9de99ce5ae13$export$917322b080de1474; });
/* skip-to-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $031c9de99ce5ae13$export$917322b080de1474 = ()=>{
    const intl = (0, $f6qj2.default)();
    const skipToContentStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: "#content",
        className: (0, $esG4f.default)([
            "_kqswstnw _1pby18h8 _1pfhv77o _18zrpxbi _1rjc19bv _bfhkcd5j _syaz1hlo _152t1osq _1e02xq2a _1axu1wug",
            "skip-to-content"
        ]),
        "data-testid": "skip-to-content" // needed so that the link is the first thing tabbed, but still positioned correctly
        ,
        // eslint-disable-next-line jsx-a11y/tabindex-no-positive
        tabIndex: 1,
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: intl.formatMessage({
            id: "nav.skipToContent",
            defaultMessage: "Skip to content"
        })
    });
};

});

parcelRegister("c5tR8", function(module, exports) {

$parcel$export(module.exports, "SolutionsSubnav", function () { return $669621ff8cd4c7d5$export$ab2c03c011111036; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $gAJUc = parcelRequire("gAJUc");

var $jomHK = parcelRequire("jomHK");

var $3XIdt = parcelRequire("3XIdt");

var $i11Zl = parcelRequire("i11Zl");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $669621ff8cd4c7d5$var$useNewSolutionLinks() {
    return {
        byUseCase: {
            id: "byUseCase",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.by-use-case",
                defaultMessage: "By Use Case"
            }),
            items: [
                {
                    id: "team-collaboration",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.team-collaboration",
                        defaultMessage: "Team collaboration"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/collections/teamwork")
                },
                {
                    id: "strategy-and-planning",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.strategy-and-planning",
                        defaultMessage: "Strategy and planning"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/collections/strategy")
                },
                {
                    id: "service-management",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.service-management",
                        defaultMessage: "Service management"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/collections/service")
                },
                {
                    id: "software-development",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.software-development",
                        defaultMessage: "Software development"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/collections/software")
                }
            ]
        },
        teamtype: {
            id: "teamtype",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.teamtype",
                defaultMessage: "By Team"
            }),
            items: [
                {
                    id: "software",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.software",
                        defaultMessage: "Software"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/collections/software")
                },
                {
                    id: "marketing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/marketing")
                },
                {
                    id: "it",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.it",
                        defaultMessage: "IT"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/it")
                }
            ]
        },
        byTeamSize: {
            id: "byTeamSize",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.by-team-size",
                defaultMessage: "By Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise")
                },
                {
                    id: "small-business",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.small-business",
                        defaultMessage: "Small Business"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/small-business")
                },
                {
                    id: "startup",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.startup",
                        defaultMessage: "Startup"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/startups")
                },
                {
                    id: "non-profit",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.non-profit",
                        defaultMessage: "Non-profit"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/nonprofits")
                }
            ]
        },
        byIndustry: {
            id: "byIndustry",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.by-industry",
                defaultMessage: "By Industry"
            }),
            items: [
                {
                    id: "retail",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.retail",
                        defaultMessage: "Retail"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/retail")
                },
                {
                    id: "telecommunications",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.telecommunications",
                        defaultMessage: "Telecommunications"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/telecom")
                },
                {
                    id: "professional-services",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.professional-services",
                        defaultMessage: "Professional Services"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/professional-services")
                },
                {
                    id: "government",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.government",
                        defaultMessage: "Government"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/government")
                }
            ]
        }
    };
}
function $669621ff8cd4c7d5$var$useSolutionsLinks() {
    return {
        teamtype: {
            id: "teamtype",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.teamtype",
                defaultMessage: "By Team Type"
            }),
            items: [
                {
                    id: "software",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.software",
                        defaultMessage: "Software"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/software-development")
                },
                {
                    id: "marketing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/marketing")
                },
                {
                    id: "it",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.it",
                        defaultMessage: "IT"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/it")
                }
            ]
        },
        solution: {
            id: "solution",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.solution",
                defaultMessage: "By Solution"
            }),
            items: [
                {
                    id: "it-service-management",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.it-service-management",
                        defaultMessage: "IT Service Management"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/solutions/itsm")
                },
                {
                    id: "agile-devops",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.agile-devops",
                        defaultMessage: "Agile & DevOps"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/software-development")
                }
            ]
        },
        byTeamSize: {
            id: "byTeamSize",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.by-team-size",
                defaultMessage: "By Team Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise")
                },
                {
                    id: "small-business",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.small-business",
                        defaultMessage: "Small Business"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/small-business")
                },
                {
                    id: "startup",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.startup",
                        defaultMessage: "Startup"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/startups")
                },
                {
                    id: "non-profit",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.non-profit",
                        defaultMessage: "Non-profit"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/teams/nonprofits")
                }
            ]
        },
        byIndustry: {
            id: "byIndustry",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.teams.links.column.by-industry",
                defaultMessage: "By Industry"
            }),
            items: [
                {
                    id: "retail",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.retail",
                        defaultMessage: "Retail"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/retail")
                },
                {
                    id: "telecommunications",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.telecommunications",
                        defaultMessage: "Telecommunications"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/telecom")
                },
                {
                    id: "professional-services",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.professional-services",
                        defaultMessage: "Professional services"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/industries/professional-services")
                },
                {
                    id: "government",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.teams.links.government",
                        defaultMessage: "Government"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/government")
                }
            ]
        }
    };
}
const $669621ff8cd4c7d5$export$ab2c03c011111036 = ({ productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const { direction: direction } = (0, $hbBKK.useGlobalNavContext)();
    const solutionsLinks = $669621ff8cd4c7d5$var$useSolutionsLinks();
    const newSolutionsLinks = $669621ff8cd4c7d5$var$useNewSolutionLinks();
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const linkColumns = Object.values(solutionsLinks);
    const newLinkColumns = Object.values(newSolutionsLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _12rrp2n4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _ect41pz4 _1wyboqnp _1p1dangw _18s8gx6n _1mjb1ule",
                            "mobile-label"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                        },
                        children: intl.formatMessage({
                            id: "GlobalNav.collections.solutions.mobilelabel",
                            defaultMessage: "Solutions"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $3XIdt.MotionContainer), {
                        direction: direction,
                        children: [
                            !gwp7850GlobalNavChangesForTeam25Eu && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulp1ejb _1yt41jfw _na0i1bp4 _6ssj12pl",
                                    "collections-solutions"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jomHK.CollectionTeamwork), {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jomHK.CollectionStrategy), {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _1bah1h6o _7y3mnqa1 _voou1w78 _1bwcu4vp _6ssjgx6n _17p3dv7i _19tboxwj"
                                        ]),
                                        style: {
                                            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: "inner-platform",
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                    className: (0, $esG4f.default)([
                                                        "_ngnbidpf _zap3idpf _1ie3idpf _1nv7idpf _1j7e1j6v",
                                                        "cloud-platform"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "GlobalNav.collections.solutions.atlassiancloudplatform.title",
                                                        defaultMessage: "Atlassian Cloud Platform"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_ngnbidpf _zap3idpf _1ie3idpf _1nv7idpf _1j7eoqnp",
                                                        "cloud-platform"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "GlobalNav.collections.solutions.atlassiancloudplatform.tagline",
                                                        defaultMessage: "The connected foundation of your system of work"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    href: "/platform",
                                                    text: intl.formatMessage({
                                                        id: "GlobalNav.collections.solutions.atlassiancloudplatform.cta",
                                                        defaultMessage: "Learn more"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_bfhk1rga _1e0c11p5 _yv0e1ajj _zulp1ejb _1yt41jfw _1ph4hkll _xc2ize3t _o517urp9 _13znn5oa _15tx8zq2 _q5ugidpf _7tld10j7 _14adidpf _4uro10j7 _uk5ucd5j",
                                    gwp7850GlobalNavChangesForTeam25Eu ? "new-solutions-bottom" : ""
                                ]),
                                style: {
                                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: (gwp7850GlobalNavChangesForTeam25Eu ? newLinkColumns : linkColumns).map((column)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                className: "nav-column-header",
                                                children: intl.formatMessage(column.title)
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1e0c11p5 _2z051wug"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                                                    className: (0, $esG4f.default)([
                                                        "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf _rv3811b3 _144to7ao"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: column.items.map((link)=>{
                                                        return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                                            className: (0, $esG4f.default)([
                                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                className: (0, $esG4f.default)([
                                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv17la _oxk417la _1byu17la _1o7v17la _1e0c1txw _4cvrh9n0"
                                                                ]),
                                                                style: {
                                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                                                },
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                                    type: "anchor",
                                                                    href: link.href,
                                                                    text: intl.formatMessage(link.text),
                                                                    ariaLabel: intl.formatMessage(link.text),
                                                                    dataEventProps: {
                                                                        "data-event": "clicked",
                                                                        "data-event-component": "linkButton",
                                                                        "data-event-container": "globalNavSubnav",
                                                                        "data-product-key": productKey
                                                                    }
                                                                })
                                                            }, link.id)
                                                        }, link.id);
                                                    })
                                                })
                                            })
                                        ]
                                    }, column.id);
                                })
                            }),
                            gwp7850GlobalNavChangesForTeam25Eu && /*#__PURE__*/ (0, $loA2J.jsx)((0, $i11Zl.RovoSection), {})
                        ]
                    })
                ]
            })
        })
    });
};
const $669621ff8cd4c7d5$var$SolutionsContainerCSS = null;
const $669621ff8cd4c7d5$var$CollectionsMobileLabelCSS = null;
const $669621ff8cd4c7d5$var$CollectionsCloudPlatformBlock = null;
const $669621ff8cd4c7d5$var$CollectionsCloudPlatformH5 = null;
const $669621ff8cd4c7d5$var$CollectionsCloudPlatformP = null;
const $669621ff8cd4c7d5$var$CollectionsSolutionsTopCSS = null;
const $669621ff8cd4c7d5$var$CollectionsSolutionsBottomCSS = null;

});
parcelRegister("jGfor", function(module, exports) {

$parcel$export(module.exports, "LinkColumn", function () { return $afd210b1074eb7ac$export$82633536c9b7c49a; });
/* subnav-link-columns.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $afd210b1074eb7ac$export$82633536c9b7c49a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4",
            "_oiwoidpf _1pssidpf _1hogidpf _1bliidpf _106iidpf _1h0cidpf _1rbiidpf _exjbidpf _ymruangw _new51hlo _1879oqnp _1igsbzd7 _1u7g1fw0 _ffd51j6v"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: children
    });
};
const $afd210b1074eb7ac$var$navColumnHeaderStyles = null;

});


parcelRegister("kQQu6", function(module, exports) {

$parcel$export(module.exports, "MobileNavLinksContainer", function () { return $b1f94fc59722ffa3$export$a789aef643e6e22a; });
$parcel$export(module.exports, "MobileNavLinks", function () { return $b1f94fc59722ffa3$export$eb036d214dd5e2d7; });
/* mobile-nav-links-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $ejJ2S = parcelRequire("ejJ2S");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $aPyfE = parcelRequire("aPyfE");

var $8fLqp = parcelRequire("8fLqp");

var $4What = parcelRequire("4What");

var $84Dka = parcelRequire("84Dka");
const $b1f94fc59722ffa3$var$linkContainerCss = null;
const $b1f94fc59722ffa3$var$signInContainerCss = null;
const $b1f94fc59722ffa3$var$returnToHomeStyle = null;
const $b1f94fc59722ffa3$var$getItFreeCss = null;
const $b1f94fc59722ffa3$var$atlassianArrowLinkContainerStyle = null;
const $b1f94fc59722ffa3$var$signInCss = null;
const $b1f94fc59722ffa3$export$a789aef643e6e22a = ({ handleMenuPage: handleMenuPage, mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps, isIncludeBottomDivider: isIncludeBottomDivider = true })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                className: (0, $esG4f.default)([
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3td1tcg _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1fw0 _1wybdlk8",
                    mobileLinkKey
                ]),
                children: mobileLinksProps.map((mobileLink, index)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: "nav-link",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $84Dka.MobileNavLink), (0, $7Knp0._)({
                            handleMenuPage: handleMenuPage
                        }, mobileLink))
                    }, `${mobileLink.globalLinksKey}-${index}`);
                })
            }),
            isIncludeBottomDivider && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {})
        ]
    });
};
const $b1f94fc59722ffa3$export$eb036d214dd5e2d7 = ({ isLoggedIn: isLoggedIn, handleMenuPage: handleMenuPage, mobileLinksSections: mobileLinksSections, productKey: productKey = "jira", isIncludeCTA: isIncludeCTA = false, ctaText: ctaText = "Get it free", ctaUrl: ctaUrl = "/software/jira/free", ctaOnClick: ctaOnClick, isIncludeAtlassianLogo: isIncludeAtlassianLogo = false, isShowSearchButton: isShowSearchButton = true })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + "/start/authredirect";
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    const homeHref = (0, $3FBn4.useLocalizedHref)("/");
    const signinLink = {
        text: intl.formatMessage({
            id: "globalnavv2.mobile.navlink.signin",
            defaultMessage: "Sign in"
        }),
        href: signInUrl
    };
    const onLogInClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.login",
            label: (0, $ejJ2S.analyticsLabels)["JoinSiteUserDropdown.logIn"]
        }).fire();
    }; // Mobile search improvements: hide search button (moved to top of menu)
    isShowSearchButton = false;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            isIncludeCTA && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1txw _ag851h6o _nssp1h6o _476dftgi _srwzftgi _tnru14no"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    className: "mobile-nav-dropdown-menu-cta",
                    variant: "primary",
                    href: ctaOnClick ? undefined : ctaUrl,
                    dataEventProps: {
                        "data-product-key": productKey,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "navbar",
                        "data-label": ctaText,
                        "data-label-english": "Get it free",
                        "data-track-event": `${productKey}.get-it-free-button-clicked`
                    },
                    style: {
                        width: "100%",
                        fontSize: "1rem",
                        lineHeight: "1.25rem"
                    },
                    onClick: ctaOnClick,
                    children: ctaText
                })
            }),
            mobileLinksSections.map(({ mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($b1f94fc59722ffa3$export$a789aef643e6e22a, {
                        mobileLinkKey: mobileLinkKey,
                        mobileLinksProps: mobileLinksProps,
                        handleMenuPage: handleMenuPage,
                        isIncludeBottomDivider: false
                    })
                }, index)),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {}),
            isIncludeAtlassianLogo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _1q51zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        className: "navigation-bar-atlas-icon",
                        href: homeHref,
                        "aria-label": intl.formatMessage({
                            id: "productPageNav.atlassian-logo-label",
                            defaultMessage: "Atlassian logo"
                        }),
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "productPageMobileNav",
                        "data-product-key": "home",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aPyfE.AtlassianLogoArrowLinkBrand), {
                            width: "311px",
                            height: "15.29px"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1q51ftgi _85i5ftgi _181nglyw"
                ]),
                children: [
                    isShowSearchButton && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8fLqp.default), {
                        buttonId: "global-nav-search-bar-icon-mobile",
                        onClick: (e)=>{
                            e.preventDefault();
                            handleMenuPage("search");
                            createAnalyticsEvent({
                                eventName: "searchOpen",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "searchButtonMobile",
                                source: "globalNav",
                                attributes: {
                                    product: "search"
                                }
                            }).fire();
                        }
                    }),
                    !isLoggedIn && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: signinLink.text,
                        href: signinLink.href,
                        type: "primary",
                        onClick: onLogInClick,
                        ariaLabel: intl.formatMessage({
                            id: "globalnavv2.mobile.navlink.signin.ariaLabel",
                            defaultMessage: "Sign in link"
                        }),
                        dataEventProps: {
                            "data-product-key": productKey,
                            "data-event-component": "linkButton",
                            "data-event-container": "navbarDropdown",
                            "data-label": signinLink.text,
                            "data-event": "clicked"
                        },
                        className: (0, $esG4f.default)([
                            "_1rjcxy5q _4cvr1h6o"
                        ])
                    }, signinLink.text)
                ]
            })
        ]
    });
};

});
parcelRegister("aPyfE", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogoArrowLinkBrand", function () { return $da5006047aa179c9$export$b793bf6d3c800d0e; });

var $loA2J = parcelRequire("loA2J");
const $da5006047aa179c9$export$b793bf6d3c800d0e = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 311 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_2380_3097)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M89.2393 7.06523C89.0084 6.81126 88.6621 6.83435 88.5004 7.1345L84.737 14.6384C84.5984 14.9385 84.8062 15.2848 85.1295 15.2848H90.3476C90.5092 15.2848 90.6708 15.1925 90.7401 15.0309C91.8945 12.6989 91.2018 9.16631 89.2393 7.06523Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M91.9879 0.231197C89.8869 3.55598 90.0254 7.22709 91.4107 9.99775C92.796 12.7684 93.8581 14.8695 93.9274 15.0311C93.9967 15.1927 94.1583 15.2851 94.3199 15.2851H99.538C99.8612 15.2851 100.092 14.9387 99.9305 14.6386C99.9305 14.6386 92.9115 0.600617 92.7268 0.254285C92.5882 -0.0689573 92.1957 -0.0920461 91.9879 0.231197Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M162.826 10.2168C162.826 8.02338 161.649 6.98439 158.37 6.26863C156.546 5.87612 156.107 5.46053 156.107 4.88331C156.107 4.16756 156.754 3.84431 157.954 3.84431C159.409 3.84431 160.841 4.283 162.203 4.9064V2.0203C161.256 1.53544 159.779 1.16602 158.047 1.16602C154.791 1.16602 153.106 2.57443 153.106 4.9064C153.106 6.7535 153.96 8.23118 157.331 8.87767C159.34 9.29326 159.755 9.61651 159.755 10.2861C159.755 10.9326 159.34 11.3482 157.908 11.3482C156.269 11.3482 154.306 10.794 153.037 10.0321V13.0567C154.052 13.5647 155.392 14.1188 157.885 14.1188C161.418 14.1188 162.826 12.5488 162.826 10.2168Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M198.337 1.35076V13.9341H201.016V4.3523L202.147 6.89206L205.934 13.9341H209.305V1.35076H206.626V9.478L205.61 7.12295L202.563 1.35076H198.337Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M181.321 1.35076H178.389V13.911H181.321V1.35076Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M174.994 10.2168C174.994 8.02338 173.817 6.98439 170.538 6.26863C168.714 5.87612 168.275 5.46053 168.275 4.88331C168.275 4.16756 168.922 3.84431 170.122 3.84431C171.577 3.84431 173.008 4.283 174.371 4.9064V2.0203C173.424 1.53544 171.946 1.16602 170.215 1.16602C166.959 1.16602 165.274 2.57443 165.274 4.9064C165.274 6.7535 166.128 8.23118 169.499 8.87767C171.508 9.29326 171.923 9.61651 171.923 10.2861C171.923 10.9326 171.508 11.3482 170.076 11.3482C168.437 11.3482 166.474 10.794 165.204 10.0321V13.0567C166.22 13.5647 167.559 14.1188 170.053 14.1188C173.609 14.1188 174.994 12.5488 174.994 10.2168Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M130.387 1.35076V13.9341H136.39L137.337 11.2097H133.319V1.35076H130.387Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M118.497 1.35085V4.07532H121.752V13.9342H124.684V4.07532H128.171V1.35085H118.497Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M114.225 1.35068H110.369L105.982 13.9341H109.33L109.954 11.8099C110.693 12.0177 111.478 12.1562 112.309 12.1562C113.117 12.1562 113.902 12.0408 114.664 11.8099L115.287 13.9341H118.635L114.225 1.35068ZM112.286 9.54719C111.732 9.54719 111.177 9.45484 110.669 9.3163L112.286 3.82118L113.902 9.3163C113.394 9.45484 112.863 9.54719 112.286 9.54719Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M146.78 1.35073H142.924L138.537 13.911H141.885L142.508 11.7869C143.247 11.9947 144.032 12.1332 144.864 12.1332C145.672 12.1332 146.457 12.0177 147.219 11.7869L147.842 13.911H151.19L146.78 1.35073ZM144.84 9.54724C144.286 9.54724 143.732 9.45489 143.224 9.31635L144.84 3.82123L146.457 9.31635C145.949 9.45489 145.395 9.54724 144.84 9.54724Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M191.849 1.35073H187.993L183.607 13.911H186.954L187.578 11.7869C188.317 11.9947 189.102 12.1332 189.933 12.1332C190.741 12.1332 191.526 12.0177 192.288 11.7869L192.911 13.911H196.259L191.849 1.35073ZM189.933 9.54724C189.379 9.54724 188.825 9.45489 188.317 9.31635L189.933 3.82123L191.549 9.31635C191.018 9.45489 190.487 9.54724 189.933 9.54724Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M222.713 3.64258L221.633 4.84467L223.383 6.79227H216.068C215.647 6.79227 215.305 7.17296 215.305 7.64201C215.305 8.11107 215.647 8.49175 216.068 8.49175H223.383L221.633 10.4405L222.713 11.6426L226.305 7.64201L222.713 3.64258Z",
                        fill: "#0065FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_2380_3097",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "141.612",
                        height: "15.2851",
                        fill: "white",
                        transform: "translate(84.6934)"
                    })
                })
            })
        ]
    });

});

parcelRegister("8fLqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e01666cf3783030d$export$2e2bcd8739ae039; });
/* search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $iSjV6 = parcelRequire("iSjV6");

var $5ohHq = parcelRequire("5ohHq");

var $f7hB9 = parcelRequire("f7hB9");
const $e01666cf3783030d$var$searchIconStyle = null;
const $e01666cf3783030d$var$searchIconStyleAI = null;
const $e01666cf3783030d$var$svgStyle = null;
const $e01666cf3783030d$var$tooltipStyle = null;
const $e01666cf3783030d$var$popoutBackgroundStyle = null;
const $e01666cf3783030d$var$expandBackgroundStyle = null;
const $e01666cf3783030d$var$fadeInKeyframes = null;
const $e01666cf3783030d$var$fadeOutKeyframes = null;
const $e01666cf3783030d$var$popOutTextStyle = null;
const $e01666cf3783030d$var$popInTextStyle = null;
let $e01666cf3783030d$var$hasPlayedPopoutAnimation = false;
const $e01666cf3783030d$var$SearchButton = (props)=>{
    const intl = (0, $f6qj2.default)();
    const [showSearchPopout, setShowSearchPopout] = (0, $iSvIT.useState)(false);
    const translated = {
        searchLabel: intl.formatMessage({
            id: "globalnav.v2.search.label",
            defaultMessage: "Search"
        })
    };
    const tooltipText = props.aiEnabled ? intl.formatMessage({
        id: "globalnav.v2.search-bar.ai-enabled.tooltip",
        defaultMessage: "Search or ask anything"
    }) : null;
    (0, $iSvIT.useEffect)(()=>{
        if (props.aiEnabled && !showSearchPopout && !$e01666cf3783030d$var$hasPlayedPopoutAnimation) {
            const timeout = setTimeout(()=>{
                setShowSearchPopout(true);
                setTimeout(()=>{
                    $e01666cf3783030d$var$hasPlayedPopoutAnimation = true;
                    setShowSearchPopout(false);
                }, 2500);
            }, 3000);
            return ()=>clearTimeout(timeout);
        }
        return undefined;
    }, [
        props.aiEnabled,
        showSearchPopout
    ]); // Debug: Log when aiEnabled changes to help debug transition issues
    (0, $iSvIT.useEffect)(()=>{
        console.log("SearchButton: aiEnabled changed to:", props.aiEnabled);
    }, [
        props.aiEnabled
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("search", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            props.aiEnabled && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _rjxpidpf _bfhk1rga _syaz1io3 _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _2rko1ylp _1wyb1crf _k48pbfng _o5721q9c _1bsb1ylp _4t3i1ylp _1pby1mrw _lcxvglyw _v5641xr4",
                    showSearchPopout && "_1bsbnxnw"
                ]),
                style: {
                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
                    "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_y44v1cnn",
                        showSearchPopout && "",
                        showSearchPopout && "_y44v1nqr"
                    ]),
                    children: showSearchPopout && "Search"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
                content: tooltipText,
                className: (0, $esG4f.default)([
                    "_11q718q9 _syaz15cr _1wyb1crf _zg8l4jg8 _k48pni7l _ca0qyh40 _u5f3ftgi _n3tdyh40 _19bvftgi _zulpv77o"
                ]),
                style: {
                    "--_nmjf06": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.navy"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    onClick: props.onClick,
                    id: props.buttonId,
                    "aria-label": String(translated.searchLabel).toLowerCase(),
                    "data-testid": "global-nav-search-icon",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "globalNavWac",
                    "data-product-key": "jiraSoftware",
                    "data-ai-enabled": props.aiEnabled,
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _19itidpf _80omtlke",
                        props.aiEnabled && "_1bahesu3 _kqswh2mm _2rko1ylp _v564eq78 _1pbycs5v _ahbq1a70 _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi"
                    ]),
                    children: props.aiEnabled ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $f7hB9.default), {
                        className: (0, $esG4f.default)([
                            "_1pby11wp"
                        ])
                    }) : /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                        width: "23",
                        height: "25",
                        viewBox: "0 0 23 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: (0, $esG4f.default)([
                            "_1bsb1tcg _4t3i1tcg _1pbykb7n _1otx1io3 _1tin17la"
                        ]),
                        style: {
                            "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M17.0918 18.5623L20.2497 21.7201",
                                stroke: "#101214",
                                strokeWidth: "2.75",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M10.8417 19.1316C15.289 19.1316 18.8943 15.5263 18.8943 11.079C18.8943 6.63165 15.289 3.02637 10.8417 3.02637C6.39435 3.02637 2.78906 6.63165 2.78906 11.079C2.78906 15.5263 6.39435 19.1316 10.8417 19.1316Z",
                                stroke: "#101214",
                                strokeWidth: "2.25"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $e01666cf3783030d$export$2e2bcd8739ae039 = $e01666cf3783030d$var$SearchButton;

});

parcelRegister("4What", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $ca23c68eb656e01e$export$2e0a83ec2e27ecbb; });

var $loA2J = parcelRequire("loA2J");
const $ca23c68eb656e01e$export$2e0a83ec2e27ecbb = ({ width: width = "100%" })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        style: {
            display: "block"
        },
        width: width,
        height: "2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("line", {
            x1: "0.5",
            y1: "1.19824",
            x2: width,
            y2: "1.19824",
            stroke: "#DDDEE1",
            strokeLinecap: "round",
            strokeDasharray: "0.5 4"
        })
    });

});

parcelRegister("84Dka", function(module, exports) {

$parcel$export(module.exports, "MobileNavLink", function () { return $8c2fa0ecf5dc81f8$export$99526554844bced1; });
/* mobile-nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $3Bf61 = parcelRequire("3Bf61");

var $3FBn4 = parcelRequire("3FBn4");
const $8c2fa0ecf5dc81f8$var$containerCss = null;
const $8c2fa0ecf5dc81f8$var$headerCss = null;
const $8c2fa0ecf5dc81f8$var$hrefCss = null;
const $8c2fa0ecf5dc81f8$var$chevronCss = null;
const $8c2fa0ecf5dc81f8$var$LinkContent = ({ linkText: linkText, hasSubnav: hasSubnav, href: href })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _1rjcpxbi",
            !hasSubnav && !href && "_1p1dangw _k48p1nn1 _1wyb1crf _vwz4gktf _1rjc1crf",
            href && "_1rjcpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: linkText
            }),
            hasSubnav && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_195g1a1m"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                    label: "",
                    size: "medium"
                })
            })
        ]
    });
};
const $8c2fa0ecf5dc81f8$export$99526554844bced1 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: props.href ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: props.href,
            target: (0, $3FBn4.isLocalizableHref)(props.href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(props.href) ? "" : "noreferrer",
            "aria-label": props.linkText,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "navbarDropdown",
            children: /*#__PURE__*/ (0, $loA2J.jsx)($8c2fa0ecf5dc81f8$var$LinkContent, (0, $7Knp0._)({}, props))
        }) : props.hasSubnav ? /*#__PURE__*/ (0, $loA2J.jsx)("button", {
            style: {
                all: "unset",
                width: "100%",
                cursor: "pointer"
            },
            onClick: (e)=>{
                e.preventDefault();
                if (props.dropdownType !== undefined) props.handleMenuPage(props.dropdownType);
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)($8c2fa0ecf5dc81f8$var$LinkContent, (0, $7Knp0._)({}, props))
        }) : /*#__PURE__*/ (0, $loA2J.jsx)($8c2fa0ecf5dc81f8$var$LinkContent, (0, $7Knp0._)({}, props))
    });
};

});


parcelRegister("4w2cS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27cc823ebf4c239$export$2e2bcd8739ae039; });
/* mobile-nav-logged-in-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $3Oabj = parcelRequire("3Oabj");
var $c3HvU = parcelRequire("c3HvU");

var $awNxQ = parcelRequire("awNxQ");

var $5ohHq = parcelRequire("5ohHq");
const $a27cc823ebf4c239$var$emailStyle = null;
const $a27cc823ebf4c239$var$displayNameStyle = null;
const $a27cc823ebf4c239$var$userInfoStyle = null;
const $a27cc823ebf4c239$var$MobileLoggedInUseDropdown = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "mobile-logged-in-user-container",
        "data-testid": "global-nav-mobile-user-profile-container-user-loggedin",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $c3HvU.default), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    isDisabled: true,
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1q517vkz _85i57vkz",
                            "global-nav-userinfo"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_syaz1yg0 _1pfhftgi _6rthftgi",
                                    "global-nav-userinfo-displayName"
                                ]),
                                style: {
                                    "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                },
                                children: userInfo.displayName
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_syaz1hlo _k48p1fw0 _1pfhftgi _6rthftgi",
                                    "global-nav-userinfo-email"
                                ]),
                                style: {
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: userInfo.email
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    onClick: onSwitchAccountClick,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).switchAccount))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    onClick: onManageProfileClick,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).profile))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    onClick: onManageLicensesClick,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).licenses))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    onClick: onLogOutClick,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).logOut))
                })
            ]
        })
    });
};
var $a27cc823ebf4c239$export$2e2bcd8739ae039 = $a27cc823ebf4c239$var$MobileLoggedInUseDropdown;

});

parcelRegister("66jxs", function(module, exports) {

$parcel$export(module.exports, "MobileNavProductBusinessTeams", function () { return $3926425231769a66$export$6a303a69999cf50c; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $QFBkP = parcelRequire("QFBkP");
const $3926425231769a66$export$6a303a69999cf50c = ()=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const businessTeamsProducts = productsByTag[(0, $5vh4Q.ProductCategory).BusinessTeams] || [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage((0, $5vh4Q.categories)[(0, $5vh4Q.ProductCategory).BusinessTeams].title)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductGrid), {
                children: businessTeamsProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            })
        ]
    });
};

});

parcelRegister("9aBMY", function(module, exports) {

$parcel$export(module.exports, "MobileNavProductDevelopers", function () { return $18fc1aac7513fa6d$export$d2e2cabc7ee48967; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $QFBkP = parcelRequire("QFBkP");
const $18fc1aac7513fa6d$export$d2e2cabc7ee48967 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const developersProducts = productsByTag[(0, $5vh4Q.ProductCategory).Developers] || [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage((0, $5vh4Q.categories)[(0, $5vh4Q.ProductCategory).Developers].title)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductGrid), {
                children: developersProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            })
        ]
    });
};

});

parcelRegister("iLuov", function(module, exports) {

$parcel$export(module.exports, "MobileNavProductITProfessionals", function () { return $8b0157b59b8ade61$export$a00033f672d28a41; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $QFBkP = parcelRequire("QFBkP");
const $8b0157b59b8ade61$export$a00033f672d28a41 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const itProfessionalsProducts = productsByTag[(0, $5vh4Q.ProductCategory).ITProfessionals] || [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage((0, $5vh4Q.categories)[(0, $5vh4Q.ProductCategory).ITProfessionals].title)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductGrid), {
                children: itProfessionalsProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            })
        ]
    });
};

});

parcelRegister("vuw44", function(module, exports) {

$parcel$export(module.exports, "MobileNavProductLeadershipTeams", function () { return $29b0e3a32bc496ed$export$8f7556a31a879079; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $QFBkP = parcelRequire("QFBkP");
const $29b0e3a32bc496ed$export$8f7556a31a879079 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const leadershipTeamsProducts = productsByTag[(0, $5vh4Q.ProductCategory).LeadershipTeams] || [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage((0, $5vh4Q.categories)[(0, $5vh4Q.ProductCategory).LeadershipTeams].title)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductGrid), {
                children: leadershipTeamsProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            })
        ]
    });
};

});

parcelRegister("ey4yR", function(module, exports) {

$parcel$export(module.exports, "MobileNavProductProductManagers", function () { return $a8d64e2049f27a3e$export$8bcbf0310429d54d; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5vh4Q = parcelRequire("5vh4Q");

var $QFBkP = parcelRequire("QFBkP");
const $a8d64e2049f27a3e$export$8bcbf0310429d54d = ()=>{
    const intl = (0, $f6qj2.default)();
    const { productsByTag: productsByTag } = (0, $5vh4Q.useProductData)();
    const productManagersProducts = productsByTag[(0, $5vh4Q.ProductCategory).ProductManagers] || [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage((0, $5vh4Q.categories)[(0, $5vh4Q.ProductCategory).ProductManagers].title)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductGrid), {
                children: productManagersProducts.map((product)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.ProductItem), (0, $7Knp0._)({}, product), product.id))
            })
        ]
    });
};

});

parcelRegister("hEweY", function(module, exports) {

$parcel$export(module.exports, "MobileNavResources", function () { return $abff550758495ff7$export$83bd5439901f0f7f; });
/* mobile-nav-resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $jGxBG = parcelRequire("jGxBG");

var $dAXtI = parcelRequire("dAXtI");

var $QFBkP = parcelRequire("QFBkP");
const $abff550758495ff7$var$mobileLinkListCss = null;
const $abff550758495ff7$export$83bd5439901f0f7f = ({ productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const resourcesData = (0, $dAXtI.useResourcesData)();
    const resourcesLinks = (0, $dAXtI.useResourcesLinks)();
    const linkColumns = Object.values(resourcesLinks);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage({
                    id: "globalnav.v2.resources.title",
                    defaultMessage: "Resources"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: resourcesData.map((_param)=>/*#__PURE__*/ {
                    var { id: id, title: title, content: content } = _param, rest = (0, $akGnX._)(_param, [
                        "id",
                        "title",
                        "content"
                    ]);
                    return (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGxBG.TitleCard), (0, $7Knp0._)({
                            title: intl.formatMessage(title),
                            content: intl.formatMessage(content),
                            productKey: productKey
                        }, rest))
                    }, id);
                })
            }),
            linkColumns.map((section)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_11q71rga _18s8urp9 _1yt4xy5q"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            style: {
                                margin: 0,
                                textTransform: "uppercase",
                                fontSize: "0.75rem"
                            },
                            children: intl.formatMessage(section.title)
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _e3ub1bpf"
                            ]),
                            children: section.items.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        type: "anchor",
                                        href: link.href,
                                        text: intl.formatMessage(link.text),
                                        ariaLabel: intl.formatMessage(link.text),
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "globalNavSubnav",
                                            "data-product-key": productKey
                                        }
                                    })
                                }, link.id))
                        })
                    ]
                }, section.id))
        ]
    });
};

});
parcelRegister("jGxBG", function(module, exports) {

$parcel$export(module.exports, "TitleCard", function () { return $60088b7c5691a661$export$b39c77b32b32f068; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $5vh4Q = parcelRequire("5vh4Q");
const $60088b7c5691a661$var$cardStyles = null;
const $60088b7c5691a661$var$hoverIconStyles = null;
const $60088b7c5691a661$var$CardTitleCardContentStyle = null;
const $60088b7c5691a661$var$CardTitleAnchorLinkStyle = null;
const $60088b7c5691a661$var$subNavTitleStyles = null;
const $60088b7c5691a661$var$iconContainerStyles = null;
const $60088b7c5691a661$var$iconStyles = null;
const $60088b7c5691a661$export$b39c77b32b32f068 = ({ title: title, icon: icon, content: content, href: href, productKey: productKey = "home", isNew: isNew })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bsbvlwb _1s4p1osq _6ssjzu5n _kbawglyw _1x381ule"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _syaz1yg0 _1e0c1ule _10531kw7 _f8pj17la _30l317la _l8kux7w3",
                "title-card-link"
            ]),
            href: href,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": `${title}: ${content}`,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavSubnav",
            "data-product-key": productKey,
            style: {
                "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800")),
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
            },
            children: [
                !!icon && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_6rth1mvu"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "default-icon"
                            ]),
                            children: icon.normal
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "_1e0cglyw",
                                "hover-icon"
                            ]),
                            children: icon.hover
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo _k48p1fw0 _10531kw7 _f8pj17la _30l317la _1wyb1j6v _1dyz18hd _p7r1116y _tiur19bv _1v7x19bv _1aaynkob _cli0yu22 _9p8e1fw0 _1s16angw",
                        "titleCard-title"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    },
                    children: [
                        title,
                        isNew && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5vh4Q.Pill), {
                            children: "New"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybjosm _vwz44jg8 _syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1dyzidpf",
                        "titleCard-content"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                    },
                    children: content
                })
            ]
        })
    });
};
const $60088b7c5691a661$var$linkCardStyles = null;
const $60088b7c5691a661$export$2c381a86421d5abf = ({ href: href, text: text, productKey: productKey = "home" })=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19it1xhx _2rko1j6v _43ds1hlo _19tboxwj _1df31hlo"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: localizedHref,
            text: text,
            ariaLabel: text,
            type: "primary",
            dataEventProps: {
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "globalNavSubnav",
                "data-product-key": productKey
            }
        })
    });
};

});

parcelRegister("dAXtI", function(module, exports) {

$parcel$export(module.exports, "useResourcesData", function () { return $2d01b25411b124e1$export$33143093180b06fc; });
$parcel$export(module.exports, "useResourcesLinks", function () { return $2d01b25411b124e1$export$d033c7ddb6c3fb52; });
$parcel$export(module.exports, "ResourcesSubnav", function () { return $2d01b25411b124e1$export$b2bf60c56801ea36; });
/* resources-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $9iZsm = parcelRequire("9iZsm");

var $4XrxY = parcelRequire("4XrxY");

var $jGxBG = parcelRequire("jGxBG");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $2d01b25411b124e1$export$33143093180b06fc() {
    return [
        {
            id: "resources.customer-support",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.customer-support.title",
                defaultMessage: "Customer Support"
            }),
            content: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.customer-support.content",
                defaultMessage: "Ask questions, report bugs & give us feedback"
            }),
            href: "//support.atlassian.com/"
        },
        {
            id: "resources.find-partners",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.find-partners.title",
                defaultMessage: "Find Partners"
            }),
            content: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.find-partners.content",
                defaultMessage: "Consulting, training & product customization support"
            }),
            href: (0, $9iZsm.useLocalizedPartnerdirectory)()
        },
        {
            id: "resources.migration-program",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.migration-program.title",
                defaultMessage: "Atlassian Ascend"
            }),
            content: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.migration-program.content",
                defaultMessage: "Resources and support for your transformation"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/migration")
        },
        {
            id: "resources.community",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.community.title",
                defaultMessage: "Community"
            }),
            content: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.community.content",
                defaultMessage: "Learn, connect and grow with the Atlassian Community"
            }),
            href: "//community.atlassian.com/"
        }
    ];
}
function $2d01b25411b124e1$export$d033c7ddb6c3fb52() {
    return {
        support: {
            id: "support",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.links.support",
                defaultMessage: "Support"
            }),
            items: [
                {
                    id: "general-inquiries",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.general-inquiries",
                        defaultMessage: "General Inquiries"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/company/contact/general-inquiries")
                },
                {
                    id: "technical-support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.technical-support",
                        defaultMessage: "Technical Support"
                    }),
                    href: "//support.atlassian.com/contact/"
                },
                {
                    id: "product-advice",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.product-advice",
                        defaultMessage: "Product Advice"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/company/contact/product-evaluator-advice")
                },
                {
                    id: "pricing-billing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.pricing-billing",
                        defaultMessage: "Pricing and Billing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/company/contact/purchasing-licensing")
                },
                {
                    id: "partner-support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.partner-support",
                        defaultMessage: "Partner Support"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/partners")
                },
                {
                    id: "developer-support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.developer-support",
                        defaultMessage: "Developer Support"
                    }),
                    href: "//developer.atlassian.com/"
                },
                {
                    id: "enterprise-support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.enterprise-support",
                        defaultMessage: "Enterprise Support"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise/services")
                },
                {
                    id: "purchasing-licensing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.purchasing-billing",
                        defaultMessage: "Purchasing and Licensing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/licensing/purchase-licensing")
                }
            ]
        },
        learn: {
            id: "resources",
            title: (0, $6x1qA.defineMessage)({
                id: "globalnavv2.subnav.resources.links.resources",
                defaultMessage: "Resources"
            }),
            items: [
                {
                    id: "project-management",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.project-management",
                        defaultMessage: "Project Management"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/project-management")
                },
                {
                    id: "project-collaboration",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.project-collaboration",
                        defaultMessage: "Project Collaboration"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/work-management/project-collaboration")
                },
                {
                    id: "agile",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.agile",
                        defaultMessage: "Agile"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/agile")
                },
                {
                    id: "team-playbook",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.team-playbook",
                        defaultMessage: "Team Playbook"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/team-playbook")
                },
                {
                    id: "learning",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.learning",
                        defaultMessage: "Atlassian Learning"
                    }),
                    href: "//community.atlassian.com/learning"
                },
                {
                    id: "product-documentation",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.product-documentation",
                        defaultMessage: "Product Documentation"
                    }),
                    href: "//confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation"
                },
                {
                    id: "get-started",
                    text: (0, $6x1qA.defineMessage)({
                        id: "globalnavv2.subnav.resources.links.get-started",
                        defaultMessage: "Get Started"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/get-started")
                }
            ]
        }
    };
}
const $2d01b25411b124e1$var$ResourcesGrid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
        numCols: 4,
        rowGap: "var(--ds-space-500, 40px)",
        columnGap: "var(--ds-space-400, 32px)",
        paddingBlock: "var(--ds-space-500, 40px)",
        paddingInline: "var(--ds-space-500, 40px)",
        children: children
    });
};
const $2d01b25411b124e1$export$b2bf60c56801ea36 = ({ productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const resourcesData = $2d01b25411b124e1$export$33143093180b06fc();
    const resourcesLinks = $2d01b25411b124e1$export$d033c7ddb6c3fb52();
    const linkColumns = Object.values(resourcesLinks);
    const { direction: direction } = (0, $hbBKK.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $3XIdt.MotionContainer), {
                direction: direction,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($2d01b25411b124e1$var$ResourcesGrid, {
                        children: resourcesData.map((_param)=>/*#__PURE__*/ {
                            var { id: id, title: title, content: content } = _param, rest = (0, $akGnX._)(_param, [
                                "id",
                                "title",
                                "content"
                            ]);
                            return (0, $loA2J.jsx)((0, $jGxBG.TitleCard), (0, $7Knp0._)({
                                title: intl.formatMessage(title),
                                content: intl.formatMessage(content),
                                productKey: productKey
                            }, rest), id);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_bfhk1rga"
                        ]),
                        style: {
                            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                            numCols: 2,
                            columnGap: "var(--ds-space-400, 32px)",
                            paddingBlock: "var(--ds-space-500, 40px)",
                            paddingInline: "var(--ds-space-500, 40px)",
                            children: linkColumns.map((column)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                            className: "nav-column-header",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, column.title))
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                                            className: (0, $esG4f.default)([
                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                                                numCols: 2,
                                                columnGap: "var(--ds-space-400, 32px)",
                                                numRows: 4,
                                                rowHeight: "var(--ds-space-500, 40px)",
                                                children: column.items.map((link)=>{
                                                    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                                        className: (0, $esG4f.default)([
                                                            "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                            className: (0, $esG4f.default)([
                                                                "_bpsp1nn1 _19tboxwj _1la11k8s _43ds1hlo _1e0c1txw _4cvrh9n0"
                                                            ]),
                                                            style: {
                                                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                            },
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                                type: "anchor",
                                                                href: link.href,
                                                                text: intl.formatMessage(link.text),
                                                                ariaLabel: intl.formatMessage(link.text),
                                                                dataEventProps: {
                                                                    "data-event": "clicked",
                                                                    "data-event-component": "linkButton",
                                                                    "data-event-container": "globalNavSubnav",
                                                                    "data-product-key": productKey
                                                                }
                                                            })
                                                        }, link.id)
                                                    }, link.id);
                                                })
                                            })
                                        })
                                    ]
                                }, column.id);
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("9iZsm", function(module, exports) {

$parcel$export(module.exports, "useLocalizedPartnerdirectory", function () { return $163c15383a8643c2$export$e8e649555cc9721a; });
$parcel$export(module.exports, "useLocalizedPartnerDirectoryHref", function () { return $163c15383a8643c2$export$ba1bcbad28261cae; });

var $kPoea = parcelRequire("kPoea");

var $2ceSC = parcelRequire("2ceSC");
const $163c15383a8643c2$var$localeMap = {
    [(0, $kPoea.DEFAULT_LOCALE)]: "",
    de: "de",
    es: "es",
    fr: "fr",
    it: "it",
    ko: "ko",
    nl: "nl",
    ja: "ja",
    pl: "pl",
    br: "br",
    ru: "ru",
    zh: "zh",
    ro: "ro",
    cs: "cs",
    hu: "hu",
    fi: "fi",
    xx: "xx",
    zz: "zz"
};
function $163c15383a8643c2$export$e8e649555cc9721a() {
    const locale = (0, $2ceSC.useLocale)();
    return `//partnerdirectory.atlassian.com/${$163c15383a8643c2$var$localeMap[locale] || $163c15383a8643c2$var$localeMap[0, $kPoea.DEFAULT_LOCALE]}`;
}
function $163c15383a8643c2$export$265340d886a0f5c7(url) {
    return url.includes("//partnerdirectory.atlassian.com/");
}
function $163c15383a8643c2$export$ba1bcbad28261cae(url) {
    const localizedPartnerDirectoryUrl = $163c15383a8643c2$export$e8e649555cc9721a();
    const locale = (0, $2ceSC.useLocale)();
    if ($163c15383a8643c2$export$265340d886a0f5c7(url) && locale !== (0, $kPoea.DEFAULT_LOCALE)) return url.replace("//partnerdirectory.atlassian.com/", `${localizedPartnerDirectoryUrl}/`);
    return url;
}

});

parcelRegister("baj2f", function(module, exports) {

$parcel$export(module.exports, "RowGrid", function () { return $b45976d2317681b4$export$29ae18f9ecc70243; });
/* row-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $b45976d2317681b4$export$29ae18f9ecc70243 = ({ children: children, numCols: numCols, colWidth: colWidth, numRows: numRows, rowHeight: rowHeight, rowGap: rowGap, columnGap: columnGap, paddingInline: paddingInline, paddingBlock: paddingBlock, marginInline: marginInline, marginBlock: marginBlock })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            gridTemplateColumns: `${(colWidth ? `${colWidth} ` : "1fr ").repeat(numCols)}`,
            gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : "1fr ").repeat(numRows)}`,
            rowGap: rowGap,
            columnGap: columnGap,
            paddingInline: paddingInline,
            paddingBlock: paddingBlock,
            marginInline: marginInline,
            marginBlock: marginBlock
        },
        className: (0, $esG4f.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};

});



parcelRegister("lzGov", function(module, exports) {

$parcel$export(module.exports, "MobileNavTop", function () { return $a33428313ee02706$export$c2b4db2d88a6ed62; });
/* mobile-nav-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");

var $htmh8 = parcelRequire("htmh8");

var $kBVJZ = parcelRequire("kBVJZ");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $83L5e = parcelRequire("83L5e");

var $4sElO = parcelRequire("4sElO");

var $gas7J = parcelRequire("gas7J");

var $dq15U = parcelRequire("dq15U");
const $a33428313ee02706$var$mobileLogoCss = null;
const $a33428313ee02706$var$tabletLogoCss = null;
const $a33428313ee02706$var$productPageLogoCss = null;
const $a33428313ee02706$var$logoCss = null;
const $a33428313ee02706$var$backButtonCss = null;
const $a33428313ee02706$var$chevronCss = null;
const $a33428313ee02706$var$profileAndMenuButtonCss = null;
const $a33428313ee02706$var$mobileNavUserProfileCss = null;
const $a33428313ee02706$var$mobileIconContainerCss = null;
const $a33428313ee02706$var$mobileDropdownMenuCss = null;
const $a33428313ee02706$var$tabletIconContainerCss = null;
const $a33428313ee02706$var$profileCss = null;
const $a33428313ee02706$var$DefaultAtlassianLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
    brand: "atlassian",
    type: "logo",
    appearance: "brand",
    height: 20,
    width: 156
}); // eslint-disable-next-line complexity
const $a33428313ee02706$export$c2b4db2d88a6ed62 = ({ productKey: productKey, isLoggedIn: isLoggedIn, userName: userName, picture: picture, handleClickAvatar: handleClickAvatar, showMenu: showMenu, handleToggleMenu: handleToggleMenu, menuPage: menuPage, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLogo: mobileLogo = $a33428313ee02706$var$DefaultAtlassianLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = "Atlassian logo", mobileLogoHref: mobileLogoHref = "/", mobileLogoDataEventContainer: mobileLogoDataEventContainer = "globalNavWacV2", isShowSearchButton: isShowSearchButton = true, isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, tabletDropdownMenu: tabletDropdownMenu, isProductPage: isProductPage = false, isShowTryNowLink: isShowTryNowLink = false, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl, navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, isShowAppSwitcher: isShowAppSwitcher = true, isShowTabletDropdown: isShowTabletDropdown = true, navType: navType = "globalNav" })=>{
    const intl = (0, $f6qj2.default)();
    const searchAndProfileRef = (0, $iSvIT.useRef)(null);
    const atlasUrl = (0, $3FBn4.useLocalizedHref)("/");
    const [mobileDropdownMenu, setMobileDropdownMenu] = (0, $iSvIT.useState)(null);
    const handleClickOutside = (0, $iSvIT.useCallback)((event)=>{
        const path = event.composedPath && event.composedPath();
        if (mobileDropdownMenu) {
            const style = window.getComputedStyle(mobileDropdownMenu);
            const insideTabletMobileDropdownMenu = Array.prototype.includes.call(Array.prototype.map.call(path, (el)=>{
                return el.id === "nav-tablet-mobile-dropdown-menu-button";
            }), true);
            if (!insideTabletMobileDropdownMenu && style.display !== "none") {
                handleToggleMenu(false);
                handleMenuPage("default");
                handleFirstOpen(false);
            }
        }
    }, [
        mobileDropdownMenu,
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen
    ]);
    const handleKeydown = (0, $iSvIT.useCallback)((event)=>{
        if (event.code == "Escape" && showMenu) {
            handleToggleMenu(false);
            handleMenuPage("default");
            handleFirstOpen(false);
        }
    }, [
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen,
        showMenu
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const element = document.getElementById("nav-tablet-mobile-dropdown-menu-button");
        setMobileDropdownMenu(element);
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleKeydown);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [
        handleClickOutside,
        handleKeydown
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _181nglyw",
                    "mobile-nav-company-logo"
                ]),
                children: menuPage === "default" || !showMenu || menuPage === "search" || menuPage === "resources" || menuPage === "product-everyone" || menuPage === "product-developer" || menuPage === "product-product-managers" || menuPage === "product-it-professionals" || menuPage === "product-business-teams" || menuPage === "product-leadership-teams" || menuPage === "solutions" || menuPage === "why-atlassian" ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $esG4f.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    style: {
                        all: "unset",
                        width: "100%"
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        handleMenuPage("default");
                        handleFirstOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1wyboxwj _syazaqb7 _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1mou1pzu _1752f6fq _w8l5f6fq"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: intl.formatMessage({
                                    id: "globalnavv2.menu-back",
                                    defaultMessage: "Back"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o",
                    isProductPage && "_zulp10yn",
                    "tablet-nav-company-logo"
                ]),
                children: [
                    isProductPage && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i88uy _1bsb88uy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1ep1",
                            "productpage-subnav-atlas-icon"
                        ]),
                        style: {
                            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            className: (0, $esG4f.default)([
                                "_4t3i8vuz _1bsb8vuz _1e0c1txw _1bah1h6o _4cvr1h6o",
                                "navigation-bar-atlas-icon"
                            ]),
                            href: atlasUrl,
                            "aria-label": intl.formatMessage({
                                id: "productPageNav.logo-label",
                                defaultMessage: "Atlassian logo"
                            }),
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "productPageSubNav",
                            "data-product-key": "home",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $htmh8.AtlassianIcon), {
                                size: "large",
                                appearance: "inverse"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: mobileLogoHref,
                        "aria-label": mobileLogoAriaLabel,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": mobileLogoDataEventContainer,
                        "data-product-key": productKey,
                        className: (0, $esG4f.default)([
                            "_4t3i183y"
                        ]),
                        children: mobileLogo
                    })
                ]
            }),
            isOpenSearch ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4sElO.default), {
                isOpenSearch: isOpenSearch,
                setIsOpenSearch: setIsOpenSearch,
                isMobile: true
            }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulppxbi _ae4v1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _181n1txw _1lp7vrvc _q8t51h6o",
                            "mobile-nav-user-profile"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $83L5e.default), {
                                isShowTryNowLink: isShowTryNowLink,
                                productKey: productKey,
                                isShowSearchButton: isShowSearchButton,
                                navigationTrynowCtaText: navigationTrynowCtaText,
                                navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                                navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                                setIsOpenSearch: setIsOpenSearch,
                                searchAndProfileRef: searchAndProfileRef,
                                isDisplayDivider: false,
                                isShowAppSwitcher: isShowAppSwitcher,
                                navType: navType
                            }),
                            isShowTabletDropdown && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_191w1k0a _1bsbt94y _4t3i1tcg _ahbqu2gc _12l2u2gc",
                                    "navigation-switcher-divider"
                                ]),
                                style: {
                                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                }
                            })
                        ]
                    }),
                    isLoggedIn && userName && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _181nglyw",
                            "mobile-nav-profile-avatar"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            style: {
                                all: "unset"
                            },
                            "aria-label": intl.formatMessage({
                                id: "globalnavv2.menu-icon.toggle",
                                defaultMessage: "Toggle Menu"
                            }),
                            onClick: (e)=>{
                                e.preventDefault();
                                handleClickAvatar();
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBVJZ.WACAvatar), {
                                name: userName,
                                src: picture,
                                size: "medium"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1ylp _1e0c1txw _4cvr1h6o _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            style: {
                                all: "unset"
                            },
                            "aria-label": intl.formatMessage({
                                id: "globalnavv2.menu-icon.toggle",
                                defaultMessage: "Toggle Menu"
                            }),
                            className: "globalnavV2ToggleMenu",
                            onClick: (e)=>{
                                e.preventDefault();
                                handleToggleMenu(!showMenu);
                                handleMenuPage("default");
                                handleFirstOpen(!showMenu);
                            },
                            children: showMenu ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gas7J.CloseIcon), {
                                label: intl.formatMessage({
                                    id: "globalnavv2.menu-icon.close",
                                    defaultMessage: "Close Menu"
                                })
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq15U.MenuIcon), {
                                label: intl.formatMessage({
                                    id: "globalnavv2.menu-icon.open",
                                    defaultMessage: "Open Menu"
                                })
                            })
                        })
                    }),
                    isShowTabletDropdown && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        id: "nav-tablet-mobile-dropdown-menu-button",
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _181n1txw _q8t51h6o _1rqih2mm"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: "mobile-dropdown-menu-button",
                                style: {
                                    all: "unset",
                                    width: "35px",
                                    height: "35px"
                                },
                                "aria-label": intl.formatMessage({
                                    id: "globalnavv2.menu-icon.toggle",
                                    defaultMessage: "Toggle Menu"
                                }),
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleToggleMenu(!showMenu);
                                    handleMenuPage("default");
                                    handleFirstOpen(!showMenu);
                                },
                                children: showMenu ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gas7J.CloseIcon), {
                                    label: intl.formatMessage({
                                        id: "globalnavv2.menu-icon.close",
                                        defaultMessage: "Close Menu"
                                    })
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq15U.MenuIcon), {
                                    label: intl.formatMessage({
                                        id: "globalnavv2.menu-icon.open",
                                        defaultMessage: "Open Menu"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0cglyw _1lpykb7n _e7o81dj1 _12ho1osq _1yd3xncg _1d2yxilx _14b51ris _1rqistnw _1xlo1j15 _sfejpt1k _dwk3usvi _nv391wug _1bv01wug _1kkmgktf _19d9edjr _nxbczf9h _6o24b4wl _1jb3cd5j _1ocvidpf _1cac122b _1gw0zo7u _164f1ur6",
                                    showMenu && "_181n1ule",
                                    "mobile-dropdown-menu"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_ahbq1ejb _1pfhftgi _6rthftgi _1e0cglyw _1bah1y6m _4cvr1h6o",
                                            menuPage !== "default" && "_1e0c1txw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                            style: {
                                                all: "unset"
                                            },
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                handleMenuPage("default");
                                                handleFirstOpen(false);
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1wyboxwj _syazaqb7 _1e0c1txw _4cvr1h6o"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_1mou1pzu _1752f6fq _w8l5f6fq"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                                            label: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                        children: intl.formatMessage({
                                                            id: "globalnavv2.menu-back",
                                                            defaultMessage: "Back"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    tabletDropdownMenu
                                ]
                            })
                        ]
                    }),
                    showMenu && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                            "overlay"
                        ])
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("83L5e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $869df35b5729b6ad$export$2e2bcd8739ae039; });
/* nav-search-and-profile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $9gh2a = parcelRequire("9gh2a");

var $ejJ2S = parcelRequire("ejJ2S");

var $Erp3T = parcelRequire("Erp3T");

var $dhmEV = parcelRequire("dhmEV");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $9p8HK = parcelRequire("9p8HK");

var $kr4yf = parcelRequire("kr4yf");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $gFK1O = parcelRequire("gFK1O");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");

var $9gWFG = parcelRequire("9gWFG");

var $8fLqp = parcelRequire("8fLqp");
const $869df35b5729b6ad$var$dropdownStyles = null;
const $869df35b5729b6ad$var$displayFlex = null;
const $869df35b5729b6ad$var$dropdownItemStyles = null;
const $869df35b5729b6ad$var$productTextLayout = null;
const $869df35b5729b6ad$var$productSummaryTextStyles = null;
const $869df35b5729b6ad$var$productTitleTextStyles = null;
const $869df35b5729b6ad$var$productMarkStyles = null;
const $869df35b5729b6ad$var$tryNowContainerStyles = null;
const $869df35b5729b6ad$var$openOverlayStyles = null;
const $869df35b5729b6ad$var$closedOverlayStyles = null;
const $869df35b5729b6ad$var$fadeOutKeyframes = null;
const $869df35b5729b6ad$var$fadeOutAnimation = null;
const $869df35b5729b6ad$var$fadeInKeyframes = null;
const $869df35b5729b6ad$var$fadeInAnimation = null;
const $869df35b5729b6ad$var$rotate180deg = null;
const $869df35b5729b6ad$var$seeAllProductsStyles = null;
const $869df35b5729b6ad$var$caretStyles = null;
const $869df35b5729b6ad$var$dividerStyle = null;
const $869df35b5729b6ad$var$appSwitcherContainerStyle = null;
const $869df35b5729b6ad$var$navigationActionStyle = null;
const $869df35b5729b6ad$var$navigationActionLinkStyle = null;

const $869df35b5729b6ad$var$WacAppSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>// without the line ts-ignored below TSC throws this error:
    // "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '../../../components/global-nav/app-switcher/src/index.js'?"
    // the file of course ends in .tsx, when you try to add that there is a different error:
    // "An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled."
    // @ts-ignore
    (parcelRequire("jMB8i")).then((module)=>({
            default: module.WacAppSwitcher
        })));
const $869df35b5729b6ad$var$ComprehensiveProductData = ()=>{
    const intl = (0, $f6qj2.default)();
    return [
        {
            productKey: "jira",
            productName: "Jira",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira"),
            signupHref: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free"),
            subtitle: intl.formatMessage({
                id: "globalnav.v2.try-now-jira-subtitle",
                defaultMessage: "Flexible project management"
            }),
            productMark: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "jira",
                type: "mark",
                appearance: "brand"
            })
        },
        {
            productKey: "jsm",
            productName: "Jira Service Management",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management"),
            signupHref: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management&edition=free"),
            subtitle: intl.formatMessage({
                id: "globalnav.v2.try-now-jsm-subtitle",
                defaultMessage: "High-velocity service delivery"
            }),
            productMark: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "jiraservicemanagement",
                type: "mark",
                appearance: "brand",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ady _4t3i1ady _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _bfhk1ret _2rko1y44 _12l21crf _w8l5zwfg _1752zwfg"
                ])
            })
        },
        {
            productKey: "confluence",
            productName: "Confluence",
            href: (0, $3FBn4.useLocalizedHref)("/software/confluence"),
            signupHref: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=confluence&edition=free"),
            subtitle: intl.formatMessage({
                id: "globalnav.v2.try-now-connie-subtitle",
                defaultMessage: "Knowledge all in one place"
            }),
            productMark: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "confluence",
                type: "mark",
                appearance: "brand"
            })
        },
        {
            productKey: "jpd",
            productName: "Jira Product Discovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery"),
            signupHref: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery"),
            subtitle: intl.formatMessage({
                id: "globalnav.v2.try-now-jpd-subtitle",
                defaultMessage: "Capture & prioritize ideas"
            }),
            productMark: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "jiraproductdiscovery",
                type: "mark",
                appearance: "brand"
            })
        },
        // Uncomment the following block when the respective products are available in GUPs
        // {
        //     productKey: "rovo",
        //     productName: "Rovo",
        //     href: useLocalizedHref("/software/rovo"),
        //     signupHref: useLocalizedHref("/software/rovo/start"),
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-rovo-subtitle",
        //         defaultMessage: "Transform teamwork with AI"
        //     }),
        //     productMark: <LogoV3 brand="rovo" type="mark" appearance="brand" />
        // },
        // {
        //     productKey: "loom",
        //     productName: "Loom",
        //     href: useLocalizedHref("/software/loom"),
        //     signupHref: "https://www.loom.com/signup",
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-loom-subtitle",
        //         defaultMessage: "Quick, async video updates"
        //     }),
        //     productMark: <LogoV3 brand="loom" type="mark" appearance="brand" />
        // },
        // {
        //     productKey: "guard",
        //     productName: "Guard",
        //     href: useLocalizedHref("/software/access"),
        //     signupHref: "https://admin.atlassian.com/atlassian-access",
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-guard-subtitle",
        //         defaultMessage: "Enhanced cloud security"
        //     }),
        //     productMark: <LogoV3 brand="guard" type="mark" appearance="brand" />
        // },
        {
            productKey: "compass",
            productName: "Compass",
            href: (0, $3FBn4.useLocalizedHref)("/software/compass"),
            signupHref: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass"),
            subtitle: intl.formatMessage({
                id: "globalnav.v2.try-now-compass-subtitle",
                defaultMessage: "Elevate your developer experience"
            }),
            productMark: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "compass",
                type: "mark",
                appearance: "brand"
            })
        }
    ];
};
let $869df35b5729b6ad$var$GupsDataProcessed = false;
const $869df35b5729b6ad$var$LoadingSpinnerStyles = null;
const $869df35b5729b6ad$var$LoadingSpinner = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
    className: (0, $esG4f.default)([
        "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq _1ul91svw _c71l1mcy _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _vchhusvi"
    ]),
    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
        interactionName: "load",
        label: "Loading",
        appearance: "inherit"
    })
});
const $869df35b5729b6ad$var$getAnonymousId = ()=>{
    const analyticsAnonymousId = (0, $gFK1O.Cookie).readCookie("ajs_anonymous_id");
    if (!analyticsAnonymousId) throw new Error("Failed to get anonymousId from Cookie");
    const decodedAnonymousId = decodeURIComponent(analyticsAnonymousId).replace(/['"]+/g, "");
    return decodedAnonymousId;
};
const $869df35b5729b6ad$export$8acaf5c5c3c3363e = async ()=>{
    if (!$869df35b5729b6ad$var$GupsDataProcessed) {
        const anonId = $869df35b5729b6ad$var$getAnonymousId();
        const client = new (0, $9p8HK.GrowthUnifiedProfileClient)();
        try {
            const { data: data, error: error } = await client.getProfile({
                anonymousId: anonId
            }, [
                (0, $kr4yf.OptionalFields).USER_FOOTPRINTS
            ]);
            if (error) throw new Error(`Failed to execute call to get profile: ${(error === null || error === void 0 ? void 0 : error.message) || error}`);
            return data;
        } catch (err) {
            console.error("An unexpected error occurred while getting the profile data:", err);
        }
    }
    return null;
};
const $869df35b5729b6ad$var$getExistingProductsList = (data)=>{
    var _data_userFootprints;
    const products = data === null || data === void 0 ? void 0 : (_data_userFootprints = data.userFootprints) === null || _data_userFootprints === void 0 ? void 0 : _data_userFootprints.products;
    return products;
};
const $869df35b5729b6ad$export$62df9bdd72f7e904 = (productData, existingProductNames)=>{
    const rankedProducts = [
        ...productData
    ];
    const filteredProductData = productData.filter((product)=>!existingProductNames.includes(product.productKey));
    if (filteredProductData.length >= 3) return filteredProductData.slice(0, 3);
    while(filteredProductData.length < 3){
        const currProduct = rankedProducts.shift();
        const currProductKey = currProduct === null || currProduct === void 0 ? void 0 : currProduct.productKey; // opposite logic to above as we are now adding duplicates to fill the 3 product slots
        if (currProductKey && existingProductNames.includes(currProductKey)) filteredProductData.push(currProduct);
    }
    return filteredProductData;
};
const $869df35b5729b6ad$export$5865ec32a0eba211 = ({ products: products, buttonText: buttonText })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $iSvIT.useState)(false);
    const [FilteredProductData, setFilteredProductData] = (0, $iSvIT.useState)(products.slice(0, 3));
    const [isLoading, setLoading] = (0, $iSvIT.useState)(!$869df35b5729b6ad$var$GupsDataProcessed);
    const tryLink = (0, $3FBn4.useLocalizedHref)("/try");
    const openDropdown = ()=>{
        if (isDropdownOpen) return;
        setIsDropdownOpen(true);
    };
    const closeDropdown = ()=>{
        if (!isDropdownOpen) return;
        setIsDropdownOpen(false);
    };
    const handleClick = ()=>{
        if (isDropdownOpen) closeDropdown();
        else openDropdown();
    };
    const getProductData = async ()=>{
        if (!$869df35b5729b6ad$var$GupsDataProcessed) try {
            const gupsData = await $869df35b5729b6ad$export$8acaf5c5c3c3363e();
            const existingProducts = $869df35b5729b6ad$var$getExistingProductsList(gupsData);
            const filteredData = $869df35b5729b6ad$export$62df9bdd72f7e904(products, existingProducts);
            setFilteredProductData(filteredData);
        } finally{
            $869df35b5729b6ad$var$GupsDataProcessed = true;
            setLoading(false);
        }
    };
    (0, $1MbAx.useFeatureExposed)("gwp-3947-try-now-cta-dropdown", "Test", {
        conditions: [
            isDropdownOpen
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseLeave: closeDropdown,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        onClick: async (e)=>{
            e.preventDefault();
            handleClick();
            await getProductData();
            createAnalyticsEvent({
                eventName: "buttonClicked",
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "globalNavCtaDropdownButtonClicked",
                source: "globalNav",
                attributes: {
                    product: "marketing"
                }
            }).fire();
        },
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1o8l _85i5dlk8 _1q51dlk8"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1UUq1.Button), {
                variant: "primary",
                size: "small",
                onMouseEnter: async ()=>{
                    openDropdown();
                    await getProductData();
                    createAnalyticsEvent({
                        eventName: "buttonHovered",
                        eventType: "ui",
                        action: "hovered",
                        actionSubject: "button",
                        actionSubjectId: "globalNavCtaDropdownButtonHovered",
                        source: "globalNav",
                        attributes: {
                            product: "marketing"
                        }
                    }).fire();
                },
                className: (0, $esG4f.default)([
                    "_syazcd5j _v564pw66 _1tke1ylp"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    buttonText,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ahbqftgi _v564bf4l _1e0c1o8l",
                            isDropdownOpen && "_t9ec1sub",
                            "caretStyles"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                            name: "caret",
                            size: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    isDropdownOpen && "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    !isDropdownOpen && "_kqsw1n9t _1e0cglyw _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    isDropdownOpen && "",
                    isDropdownOpen && "_y44v11aa",
                    !isDropdownOpen && "",
                    !isDropdownOpen && "_y44v1d5f"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kqswstnw _152t1osq _1e02qkx9 _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _1bah1y6m _4cvr1fhb _2rkogktf _11q7cd5j _1ul9r0r7 _16qsfl7y",
                    isDropdownOpen && "",
                    isDropdownOpen && "_y44v11aa",
                    !isDropdownOpen && "",
                    !isDropdownOpen && "_y44v1d5f",
                    isDropdownOpen && "_1e0c1txw",
                    "dropdown-menu"
                ]),
                onMouseLeave: closeDropdown,
                role: "menu",
                tabIndex: 0,
                onKeyDown: (e)=>{
                    if (e.key === "Escape") closeDropdown();
                },
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: isLoading ? $869df35b5729b6ad$var$LoadingSpinner : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        FilteredProductData.map((product)=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                                href: product.signupHref,
                                onClick: (e)=>e.stopPropagation(),
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter" || e.key === " ") e.stopPropagation();
                                },
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb3sup _4t3i12am _6rth7vkz _1w6b17la _1tpu150w"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ady _4t3i1ady _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _bfhk1ret _2rko1y44 _12l21crf _w8l5zwfg _1752zwfg",
                                            "product-mark"
                                        ]),
                                        children: product.productMark
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _zulpyh40"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1hlo _1wybwk7l _ect41kqr _zg8l4jg8 _k48p53lb _vwz41012 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                                    "product-title"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: product.productName
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1dyx _1wybmccc _ect48q0o _zg8l4jg8 _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: product.subtitle
                                            })
                                        ]
                                    })
                                ]
                            }, product.productName)),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage({
                                id: "globalnav.v2.try-now-dropdown-see-all-products",
                                defaultMessage: "See all products"
                            }),
                            href: tryLink,
                            type: "primary",
                            onClick: (e)=>e.stopPropagation(),
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx2vrvc _4cvresu3 _1bsb3sup _4t3izwfg _1wybdlk8 _vwz4gktf"
                            ])
                        })
                    ]
                })
            })
        ]
    });
}; // eslint-disable-next-line complexity
const $869df35b5729b6ad$var$SearchAndProfile = ({ isShowTryNowLink: // the "Try now" CTA in the global nav is meant to be shown by default, to hide it set isShowTryNowLink prop to false
// read more at https://hello.atlassian.net/wiki/spaces/~857563384/pages/3849594563/Re-introduce+the+global+nav+Try+now+button
isShowTryNowLink = true, productKey: productKey = "home", isShowSearchButton: isShowSearchButton = true, setIsOpenSearch: setIsOpenSearch, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl, navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, searchAndProfileRef: searchAndProfileRef, isDisplayDivider: isDisplayDivider = true, positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, navType: navType = "globalNav", aiEnabled: aiEnabled = false })=>{
    const intl = (0, $f6qj2.default)();
    const [isDisplayCTADropdownButton, setIsDisplayCTADropdownButton] = (0, $iSvIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { product: product, edition: edition } = (0, $Erp3T.useProductIntent)();
    const [isUseGeneralSigninPromptConfig, setIsUseGeneralSigninPromptConfig] = (0, $iSvIT.useState)(false); // feature gate has configuration to only be enabled on specified page paths
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/wac_sales_inbound_leads
    const isWacSalesInboundLeadsFeatureGateEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacSalesInboundLeads);
    const shouldRenderTryNowButton = !positionTryNowCtaOnRight && isShowTryNowLink; /* TODO: Implement setIsUserLoggedIn, user logged in status (in useEffect), once GWP-51 in implemented  */ 
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const defaultCTAUrl = (0, $3FBn4.useLocalizedHref)("/try");
    const buttonText = navigationTrynowCtaText !== null && navigationTrynowCtaText !== void 0 ? navigationTrynowCtaText : intl.formatMessage({
        id: "globalnav.v2.try-now-exp-button-label",
        defaultMessage: "Get it free"
    });
    const buttonUrl = navigationTrynowCtaUrl !== null && navigationTrynowCtaUrl !== void 0 ? navigationTrynowCtaUrl : defaultCTAUrl; // Experiment Config gwp8058GeneralSigninPromptExperimentCheck
    const gwp8058GeneralSigninPromptExperimentCheck = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp8058GeneralSigninPromptForExistingUsers);
    const isNewDay = (lastVisitDate)=>{
        const lastVisit = new Date(lastVisitDate);
        const today = new Date();
        return lastVisit.getDate() !== today.getDate() || lastVisit.getMonth() !== today.getMonth() || lastVisit.getFullYear() !== today.getFullYear();
    };
    (0, $iSvIT.useEffect)(()=>{
        let timeoutId = null;
        const consecutiveXClicks = Number(localStorage.getItem("general_signin_prompt_x_clicks") || "0");
        const lastVisitDate = localStorage.getItem("general_signin_prompt_last_visit_timestamp"); // If user has clicked X 2 times, never show again
        if (consecutiveXClicks >= 2) setIsUseGeneralSigninPromptConfig(false);
        else if ((!lastVisitDate || lastVisitDate && consecutiveXClicks > 0 && isNewDay(lastVisitDate)) && gwp8058GeneralSigninPromptExperimentCheck.type === "enrolled") {
            gwp8058GeneralSigninPromptExperimentCheck.fireExposure();
            setIsUseGeneralSigninPromptConfig(gwp8058GeneralSigninPromptExperimentCheck.value);
        } else if (lastVisitDate && consecutiveXClicks === 0 && gwp8058GeneralSigninPromptExperimentCheck.type === "enrolled") {
            gwp8058GeneralSigninPromptExperimentCheck.fireExposure(); // Delay showing the signin prompt by 3 seconds
            timeoutId = setTimeout(()=>{
                setIsUseGeneralSigninPromptConfig(gwp8058GeneralSigninPromptExperimentCheck.value);
            }, 3000);
        } else // catch statement for all other cases
        setIsUseGeneralSigninPromptConfig(false);
         // Cleanup timeout on unmount or effect re-run
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        gwp8058GeneralSigninPromptExperimentCheck
    ]); // End of Experiment Config gwp8058GeneralSigninPromptExperimentCheck
    const productLandingPagesData = $869df35b5729b6ad$var$ComprehensiveProductData();
    (0, $iSvIT.useEffect)(()=>{
        if (navType === "globalNav" && !isUserLoggedIn && !requestInProgress) setIsDisplayCTADropdownButton(true);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestInProgress,
        isUserLoggedIn
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: searchAndProfileRef,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _zulp7vkz"
        ]),
        children: [
            isWacSalesInboundLeadsFeatureGateEnabled && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gWFG.ContactSalesCta), {}) || shouldRenderTryNowButton && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.TryIntent), {
                intentType: "button",
                containerId: "navbar",
                productKey: product === null || product === void 0 ? void 0 : product.key,
                edition: edition,
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1o8l _85i5dlk8 _1q51dlk8"
                    ]),
                    children: isDisplayCTADropdownButton ? // if the dropdown exp is enabled, show dropdown version of button with the try now/get it free variation,
                    // else show the regular button with the existing experiment conditions
                    /*#__PURE__*/ (0, $loA2J.jsx)($869df35b5729b6ad$export$5865ec32a0eba211, {
                        products: productLandingPagesData,
                        buttonText: buttonText,
                        productKey: productKey
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                        variant: "primary",
                        size: "small",
                        href: buttonUrl,
                        dataEventProps: {
                            "data-product-key": productKey,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "navbar",
                            "data-label": buttonText,
                            "data-label-english": "Get it free",
                            "data-track-event": `${productKey}.get-it-free-button-clicked`
                        },
                        onClick: (e)=>{
                            if (navigationTrynowCtaOnClick) navigationTrynowCtaOnClick(e);
                            else if (buttonUrl) window.location.href = buttonUrl;
                        },
                        className: (0, $esG4f.default)([
                            "_1tke1ylp"
                        ]),
                        children: buttonText
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: isShowSearchButton && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8fLqp.default), {
                    buttonId: "global-nav-search-bar-icon-desktop",
                    aiEnabled: aiEnabled,
                    onClick: (e)=>{
                        e.preventDefault();
                        setIsOpenSearch(true);
                        createAnalyticsEvent({
                            eventName: "searchOpen",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "searchButtonDesktop",
                            source: "globalNav",
                            attributes: {
                                product: "search",
                                pageUrl: window.location.href,
                                pagePath: window.location.pathname,
                                aiEnabled: aiEnabled
                            }
                        }).fire();
                    }
                })
            }),
            isDisplayDivider ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_191w1k0a _1bsbt94y _4t3i1tcg _1wpz1h6o"
                ]),
                style: {
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                }
            }) : null,
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _2lx2vrvc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _2lx2vrvc"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                            children: isUserLoggedIn && isShowAppSwitcher && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_12l27vkz"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($869df35b5729b6ad$var$WacAppSwitcher // @ts-ignore
                                , {
                                    allowJoinSitesProvider: true,
                                    appSwitcherLabel: "",
                                    appSwitcherIconPrimaryColor: "#42526e",
                                    isUseV2AppSwitcherStyle: true,
                                    isDisplayBorderAndHoverEffect: false
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _2lx2vrvc"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ejJ2S.GlobalNavUserProfile), {
                            isUseNewLoggedInUserDropdown: true,
                            isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
                            setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig,
                            positionTryNowCtaOnRight: positionTryNowCtaOnRight
                        })
                    }),
                    positionTryNowCtaOnRight && isShowTryNowLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.TryIntent), {
                        intentType: "button",
                        containerId: "navbar",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1h6o _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                variant: "primary",
                                size: "small",
                                href: buttonUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "navbar",
                                    "data-label": buttonText,
                                    "data-label-english": "Get it free",
                                    "data-track-event": `${productKey}.get-it-free-button-clicked`
                                },
                                onClick: (e)=>{
                                    if (navigationTrynowCtaOnClick) navigationTrynowCtaOnClick(e);
                                    else if (buttonUrl) window.location.href = buttonUrl;
                                },
                                className: (0, $esG4f.default)([
                                    "_1tke1ylp"
                                ]),
                                children: buttonText
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $869df35b5729b6ad$export$2e2bcd8739ae039 = $869df35b5729b6ad$var$SearchAndProfile;

});
parcelRegister("jMB8i", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("bVPXk")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("7MAYM")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1Csux")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("2ALIQ")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9Qmeo"))
]).then(()=>parcelRequire("kg7l8"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});



parcelRegister("4sElO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0b4ea7add4cd0a$export$2e2bcd8739ae039; });
/* search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $cLl4w = parcelRequire("cLl4w");
const $5d0b4ea7add4cd0a$var$mobileSearchBarStyle = null;
const $5d0b4ea7add4cd0a$var$productNavSearchBarStyle = null;
const $5d0b4ea7add4cd0a$var$globalNavSearchBarStyle = null;
const $5d0b4ea7add4cd0a$var$SearchBar = ({ isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, isMobile: isMobile = false, parentType: parentType = "GlobalNav", aiEnabled: aiEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleEscKeyEvent = (0, $iSvIT.useCallback)((event)=>{
        if (event.key === "Escape") {
            setIsOpenSearch(false);
            createAnalyticsEvent({
                eventName: "searchClose",
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "searchBarEscapeKey",
                source: "globalNav",
                attributes: {
                    product: "search",
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname
                }
            }).fire();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("keydown", handleEscKeyEvent, false); // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("keydown", handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ahbq10yn _12l210yn _1bsb1osq",
            isMobile && "_ahbq10yn _12l210yn _1bsb1osq",
            parentType === "ProductNav" ? "_1bsb1osq _b8yqtfvk" : "_ahbq10yn _12l210yn _1bsb1osq",
            "search-bar"
        ]),
        "data-testid": "search-bar",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cLl4w.default), {
            isOpenSearch: isOpenSearch,
            setIsOpenSearch: setIsOpenSearch,
            aiEnabled: aiEnabled,
            parentType: parentType
        })
    });
};
var $5d0b4ea7add4cd0a$export$2e2bcd8739ae039 = $5d0b4ea7add4cd0a$var$SearchBar;

});

parcelRegister("gas7J", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", function () { return $240449f608c5c97a$export$cae179f078f4b4a4; });
/* close.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $240449f608c5c97a$export$cae179f078f4b4a4 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb183y _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "35",
            viewBox: "0 0 17 35",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M15 26L2.27208 13.2721",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2 26L14.7279 13.2721",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            ]
        })
    });

});

parcelRegister("dq15U", function(module, exports) {

$parcel$export(module.exports, "MenuIcon", function () { return $5b6d1c67c2131b50$export$46e1d66043f363e6; });
/* menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $5b6d1c67c2131b50$export$46e1d66043f363e6 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb183y _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            })
        ]
    });

});


parcelRegister("bxxMG", function(module, exports) {

$parcel$export(module.exports, "MobileNavWhyAtlassian", function () { return $29efffd71274d704$export$15a36ea830bd3411; });
/* mobile-nav-why-atlassian.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $jGxBG = parcelRequire("jGxBG");

var $eOKmG = parcelRequire("eOKmG");

var $QFBkP = parcelRequire("QFBkP");
const $29efffd71274d704$var$mobileWhyAtlassianGridCss = null;
const $29efffd71274d704$export$15a36ea830bd3411 = ({ productKey: productKey = "home" })=>{
    const intl = (0, $f6qj2.default)();
    const whyAtlassianData = (0, $eOKmG.useWhyAtlassianData)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $QFBkP.MobileNavTitle), {
                title: intl.formatMessage({
                    id: "globalnav.v2.whyatlassian.title",
                    defaultMessage: "Why Atlassian"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: whyAtlassianData.map((_param)=>/*#__PURE__*/ {
                    var { title: title } = _param, rest = (0, $akGnX._)(_param, [
                        "title"
                    ]);
                    return (0, $loA2J.jsx)((0, $jGxBG.TitleCard), (0, $6iHNw._)((0, $7Knp0._)({
                        title: title
                    }, rest), {
                        productKey: productKey
                    }), title);
                })
            })
        ]
    });
};

});
parcelRegister("eOKmG", function(module, exports) {

$parcel$export(module.exports, "useWhyAtlassianData", function () { return $df0a0d17acef237a$export$e75d7d5034191e1; });
$parcel$export(module.exports, "WhyAtlassianSubnav", function () { return $df0a0d17acef237a$export$52af0cda3e870a58; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $kwHar = parcelRequire("kwHar");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $jGxBG = parcelRequire("jGxBG");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $hbBKK = parcelRequire("hbBKK");
function $df0a0d17acef237a$export$e75d7d5034191e1() {
    const intl = (0, $f6qj2.default)();
    return [
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.systemofwork.title",
                defaultMessage: "System of Work"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.systemofwork.content",
                defaultMessage: "Atlassian's blueprint for how teams work together"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/system-of-work"),
            isNew: true
        },
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.integrations.title",
                defaultMessage: "Marketplace"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.integrations.content",
                defaultMessage: "Connect thousands of apps to your Atlassian products"
            }),
            href: "//marketplace.atlassian.com/"
        },
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.customers.title",
                defaultMessage: "Customers"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.customers.content",
                defaultMessage: "Case studies & stories powered by teamwork"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/customers")
        },
        {
            title: "FedRAMP",
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.fedramp.content",
                defaultMessage: "Compliant solutions for the public sector"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/trust/compliance/resources/fedramp")
        },
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.resilience.title",
                defaultMessage: "Resilience"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.resilience.content",
                defaultMessage: "Enterprise-grade & highly performant infrastructure"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/trust/resilience")
        },
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.platform.title",
                defaultMessage: "Platform"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.platform.content",
                defaultMessage: "Our deeply integrated, reliable & secure platform"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/platform")
        },
        {
            title: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.trustcenter.title",
                defaultMessage: "Trust center"
            }),
            content: intl.formatMessage({
                id: "globalnavv2.subnav.whyatlassian.trustcenter.content",
                defaultMessage: "Ensure your data's security, compliance & availability"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/trust")
        }
    ];
}
const $df0a0d17acef237a$var$WhyAtlassianGrid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
        numCols: 4,
        rowGap: (0, $kwHar.default)("space.500"),
        columnGap: (0, $kwHar.default)("space.400"),
        paddingBlock: (0, $kwHar.default)("space.500"),
        paddingInline: (0, $kwHar.default)("space.500"),
        children: children
    });
};
const $df0a0d17acef237a$export$52af0cda3e870a58 = ({ productKey: productKey = "home" })=>{
    const teamsData = $df0a0d17acef237a$export$e75d7d5034191e1();
    const { direction: direction } = (0, $hbBKK.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: direction,
                children: /*#__PURE__*/ (0, $loA2J.jsx)($df0a0d17acef237a$var$WhyAtlassianGrid, {
                    children: teamsData.map((_param)=>/*#__PURE__*/ {
                        var { title: title } = _param, rest = (0, $akGnX._)(_param, [
                            "title"
                        ]);
                        return (0, $loA2J.jsx)((0, $jGxBG.TitleCard), (0, $6iHNw._)((0, $7Knp0._)({
                            title: title
                        }, rest), {
                            productKey: productKey
                        }), title);
                    })
                })
            })
        })
    });
};

});



parcelRegister("lu2Dx", function(module, exports) {

$parcel$export(module.exports, "CompoundSubNav", function () { return $2b96e9f4a0d27f42$export$2e7b57b2b3287680; });
/* nav-global-compound-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4What = parcelRequire("4What");

var $hbBKK = parcelRequire("hbBKK");
const $2b96e9f4a0d27f42$var$compoundSubNavPadding = "var(--ds-space-100, 8px)";
const $2b96e9f4a0d27f42$var$linkableCompoundSubNavTitleStyle = null;
const $2b96e9f4a0d27f42$export$2e7b57b2b3287680 = ({ compoundSubNavTitle: compoundSubNavTitle, compoundSubNavLinksProps: compoundSubNavLinksProps, isShowCta: isShowCta, ctaButtonText: ctaButtonText, ctaButtonVariant: ctaButtonVariant, ctaUrl: ctaUrl, productKey: productKey = "home", optionalClassName: optionalClassName = "", compoundSubNavTitleHref: compoundSubNavTitleHref = "" })=>{
    const compoundSubNavStyle = null;
    const compoundSubNavBarStyle = null;
    const compoundSubNavTitleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _bfhkcd5j _4t3i88uy _18zru2gc _owpuidpf _xtn71wqb _15ijpxbi _1jnupxbi _1mh0pxbi _qc27idpf _rbmhaooq",
            `compoundSubNav ${optionalClassName}`
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _1bah1yb4 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _kqswh2mm _1bsb1osq _p12ftfvk _18zru2gc _owpuidpf",
                "compoundSubNavBar"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48p1fw0 _1wybgktf _vwz4gktf _bozgu2gc _d2ikidpf",
                        "compoundSubNavTitle"
                    ]),
                    children: [
                        compoundSubNavTitleHref && /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: compoundSubNavTitleHref,
                            className: (0, $esG4f.default)([
                                "_f8pj17la _30l317la _1ien17la _n0fx17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: compoundSubNavTitle
                        }),
                        compoundSubNavTitleHref.length === 0 && compoundSubNavTitle
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($2b96e9f4a0d27f42$var$CompoundSubNavLinksAndCta, {
                    compoundSubNavLinksProps: compoundSubNavLinksProps,
                    isShowCta: isShowCta,
                    ctaButtonText: ctaButtonText,
                    ctaButtonVariant: ctaButtonVariant,
                    ctaUrl: ctaUrl,
                    productKey: productKey
                })
            ]
        })
    });
};
$2b96e9f4a0d27f42$export$2e7b57b2b3287680.displayName = "CompoundSubNav";
const $2b96e9f4a0d27f42$var$CompoundSubNavLinksAndCta = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, isShowCta: isShowCta = false, ctaButtonText: ctaButtonText, ctaButtonVariant: ctaButtonVariant = "primary", ctaUrl: ctaUrl = "#", productKey: productKey = "home" })=>{
    const ctaButtonDefaultText = (0, $f6qj2.default)().formatMessage({
        id: "compoundSubNav.defaultCta.contactSales",
        defaultMessage: "Contact Sales"
    });
    ctaButtonText = ctaButtonText || ctaButtonDefaultText;
    const ctaButtonUrl = (0, $3FBn4.useLocalizedHref)(ctaUrl);
    const buttonProps = {
        variant: ctaButtonVariant,
        href: ctaButtonUrl,
        size: "small",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "navbar"
        }
    };
    const linksAndCtaContainerStyle = null;
    const linksContainerStyle = null;
    const ctaStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq _4t3i1osq _kqswh2mm _4cvr1h6o _1bahesu3 _msup1yb4",
            "compoundSubNavLinksAndCtaContainer"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3i1osq _bozgu2gc _1e0cglyw _dm251ule",
                    "compoundSubNavLinks"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.default), {
                    globalLinksProps: compoundSubNavLinksProps,
                    isSubnav: true
                })
            }),
            isShowCta && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _181n1ule",
                    "compoundSubNavCta"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
                    children: ctaButtonText
                }))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($2b96e9f4a0d27f42$var$CompoundSubNavDropdownLinksAndCta, {
                compoundSubNavLinksProps: compoundSubNavLinksProps,
                isShowCta: isShowCta,
                ctaButtonText: ctaButtonText,
                ctaButtonVariant: ctaButtonVariant,
                ctaUrl: ctaUrl
            })
        ]
    });
};
const $2b96e9f4a0d27f42$var$CompoundSubNavDropdownLinksAndCta = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, isShowCta: isShowCta, ctaButtonText: ctaButtonText, ctaButtonVariant: ctaButtonVariant, ctaUrl: ctaUrl })=>{
    const dropdownContentStyle = null;
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const [onCaretButton, setOnCaretButton] = (0, $iSvIT.useState)(false);
    const dropdownRef = (0, $iSvIT.useRef)(null);
    const handleEscKeyEvent = (0, $iSvIT.useCallback)((event)=>{
        if (event.key === "Escape") setIsOpen(false);
    }, []);
    const handleClickOutside = (0, $iSvIT.useCallback)((event)=>{
        var _dropdownRef_current;
        if (isOpen && !((_dropdownRef_current = dropdownRef.current) === null || _dropdownRef_current === void 0 ? void 0 : _dropdownRef_current.contains(event.target)) && !onCaretButton) setIsOpen(false);
    }, [
        isOpen,
        onCaretButton
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscKeyEvent, false); // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent,
        handleClickOutside
    ]);
    const linkClickAction = (e)=>{
        e.preventDefault();
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    };
    const rotate180deg = null;
    const fadeOutKeyframes = null;
    const fadeOutAnimation = null;
    const tabletDropdownGap = "var(--ds-space-100, 8px)";
    const tabletDropdownHeight = `calc(100vh - 68px - 52.5px - (2 * ${tabletDropdownGap}))`; // 68px is the height of the compoundSubNav, 52.5px is the height of the tablet nav, the gaps account for the space between the nav and top of the dropdown, and bottom of the dropdown and screen bottom
    const dropdownContainerStyle = null;
    const mobileCtaButtonStyle = null;
    const localizedCtaUrl = (0, $3FBn4.useLocalizedHref)(ctaUrl);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1ule _bozgxy5q _y4ti1b66 _15vtpxbi _dm25glyw _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf",
            "compoundSubNavDropdownLinks"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                onClick: linkClickAction,
                onMouseEnter: ()=>{
                    setOnCaretButton(true);
                },
                onMouseLeave: ()=>{
                    setOnCaretButton(false);
                },
                "aria-label": "Open dropdown",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "headerDropdownLink",
                "data-testid": "compoundSubNavDropdownLinksCaretButton",
                className: (0, $esG4f.default)([
                    "_bfhk1j28 _19itglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1ule _vwz4idpf _v5641doz",
                        isOpen && "_t9ec1sub",
                        "chevron-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "10",
                        viewBox: "0 0 15 10",
                        fill: "none",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M0.571934 1.12105C0.441394 1.25145 0.337835 1.40629 0.267179 1.57674C0.196524 1.74718 0.160156 1.92988 0.160156 2.11439C0.160156 2.2989 0.196524 2.48159 0.267179 2.65204C0.337835 2.82248 0.441394 2.97733 0.571934 3.10772L6.6346 9.18372C6.75846 9.30789 6.90559 9.4064 7.06758 9.47362C7.22956 9.54084 7.40322 9.57544 7.5786 9.57544C7.75398 9.57544 7.92764 9.54084 8.08962 9.47362C8.25161 9.4064 8.39874 9.30789 8.5226 9.18372L14.5893 3.10639C14.8524 2.84329 15.0002 2.48646 15.0002 2.11439C15.0002 1.74232 14.8524 1.38548 14.5893 1.12239C14.3262 0.859292 13.9693 0.711487 13.5973 0.711487C13.2252 0.711487 12.8684 0.859292 12.6053 1.12239L7.5786 6.15705L2.5546 1.12239C2.42446 0.992129 2.26992 0.888796 2.09982 0.818295C1.92972 0.747793 1.7474 0.711505 1.56327 0.711505C1.37914 0.711505 1.19681 0.747793 1.02671 0.818295C0.856613 0.888796 0.702076 0.992129 0.571934 1.12239V1.12105Z",
                            fill: (0, $5ohHq.wacToken)("color.primary.black")
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: dropdownRef,
                "aria-hidden": !isOpen,
                className: (0, $esG4f.default)([
                    "_1e0cglyw _tzy4kb7n _1rjcpxbi _18zr1ejb _rjxp1qka _152t1osq _1bsb8hk1 _4t3i1w9h _kqswstnw _1f49b4wl _bfhkcd5j _v564122b _1pbyzo7u _zulputpp _1d2yncxg _14b51ris _kiyau2gc _1xlo70o6 _1kkmo7ao _z21jglyw _nxbc1cd0",
                    isOpen && "_1e0c1txw _2lx21bp4",
                    !isOpen && "",
                    !isOpen && "_y44v1d5f"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _kzvi1ule _em6n1n9t _1vxpa740 _mmgkidpf _12rrauwl _1vkh1osq _18ooglyw _195y12a9 _1d0q6vh0 _4ik01mrw"
                        ])
                    }),
                    isShowCta && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bsb1osq _181nglyw _1puj1osq _a87v1wug"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                            variant: ctaButtonVariant,
                            href: ctaUrl ? localizedCtaUrl : ctaUrl,
                            size: "small",
                            className: "ctaButton",
                            children: ctaButtonText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: compoundSubNavLinksProps.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1bsb1osq"
                                ]),
                                children: link.hasSubnav ? $2b96e9f4a0d27f42$var$CompoundNavDropdownLinkWithSubnav(link) : $2b96e9f4a0d27f42$var$CompoundNavDropdownLink(link)
                            }, link.globalLinksKey))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {})
                    })
                ]
            })
        ]
    });
};
const $2b96e9f4a0d27f42$var$dropdownLinkStyle = null;
const $2b96e9f4a0d27f42$var$CompoundNavDropdownLink = (link)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $3FBn4.useLocalizedHref)(link.href),
        className: (0, $esG4f.default)([
            "_ect4bzd7 _1wybdlk8 _k48p1fw0 _syaz1hlo _vwz4gktf _4t3igktf _30l317la",
            "_1e0c1o8l _1bsb1osq"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: link.linkText
    });
};
const $2b96e9f4a0d27f42$var$CompoundNavDropdownLinkWithSubnav = ({ linkText: linkText })=>{
    const subNavDropdownLinkStyle = null;
    const subNavCaretInDropdown = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "6",
        height: "10",
        viewBox: "0 0 6 10",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M1.36328 1L4.99964 5L1.36328 9",
            stroke: (0, $5ohHq.wacToken)("color.primary.black"),
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }); // todo: add click action and dropdown for subnav. might be able to use mobile-nav-link.tsx (below is just placeholder) GWP-5521
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button" // onClick={subnavLinkClickAction}
    , {
        className: (0, $esG4f.default)([
            "_80omtlke _1e0c1txw _1bsb1osq _1bah1yb4 _4cvr1h6o _4t3igktf _vwz4gktf _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect4bzd7 _1wybdlk8 _k48p1fw0 _syaz1hlo _vwz4gktf _4t3igktf _30l317la"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                },
                children: linkText
            }),
            subNavCaretInDropdown
        ]
    });
};

});


parcelRegister("jPdYj", function(module, exports) {

$parcel$export(module.exports, "ProductPageSubNav", function () { return $5bff6fd87ccf62f9$export$4f0322cadbe6a886; });
/* nav-product-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $htmh8 = parcelRequire("htmh8");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $9iWJ8 = parcelRequire("9iWJ8");

var $6KyF0 = parcelRequire("6KyF0");

var $iBJCa = parcelRequire("iBJCa");

var $hbBKK = parcelRequire("hbBKK");

var $83L5e = parcelRequire("83L5e");

var $4sElO = parcelRequire("4sElO");

var $9xKd9 = parcelRequire("9xKd9");
const $5bff6fd87ccf62f9$var$mobileWrapperCss = null;
const $5bff6fd87ccf62f9$var$productPageMobileNav = null;
const $5bff6fd87ccf62f9$var$atlasIconContainerStyle = null;
const $5bff6fd87ccf62f9$var$atlasIconStyle = null;
const $5bff6fd87ccf62f9$var$productPageSubNavStyle = null;
const $5bff6fd87ccf62f9$var$productpageSubnavBar = null;
const $5bff6fd87ccf62f9$var$wideProductPageSubnavBar = null;
const $5bff6fd87ccf62f9$var$productpageSubnavLogoAndLinksContainer = null;
const $5bff6fd87ccf62f9$var$productpageSubnavProductLogo = null;
const $5bff6fd87ccf62f9$var$aNavBarLogoLink = null;
const $5bff6fd87ccf62f9$var$productpageSearchBar = null; // GALILEO-1972
// The following are used to fit the 'Templates' tab in the nav as part of this experiment:
// https://hello.atlassian.net/wiki/spaces/Growth/pages/4077753200/Templates+tab+in+WAC+header+iteration+GRW-1175
const $5bff6fd87ccf62f9$var$getBuffer = (isTemplatesTabInHeader)=>isTemplatesTabInHeader ? 2 : undefined;
const $5bff6fd87ccf62f9$var$smallerJsmLogoStyle = null; // GALILEO-1972
const $5bff6fd87ccf62f9$var$ProductPageSubNavLinks = ({ productLogo: productLogo, productLogoUrl: productLogoUrl, productLogoAriaLabel: productLogoAriaLabel, productKey: productKey, productPageNavLinks: productPageNavLinks, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = true, tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor, isShowSearchButton: isShowSearchButton = true, isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, navigationTrynowCtaText: navigationTrynowCtaText = "Get it free", navigationTrynowCtaUrl: navigationTrynowCtaUrl = "/try", navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, isTemplatesTabInHeader: isTemplatesTabInHeader })=>{
    const linksRef = (0, $iSvIT.useRef)(null);
    const searchAndProfileRef = (0, $iSvIT.useRef)(null);
    const hasMounted = (0, $iSvIT.useRef)(false);
    const { showMoreItems: showMoreItems, shouldShowMoreItems: shouldShowMoreItems, maxItems: maxItems } = (0, $6KyF0.useMore)({
        leftElementRef: linksRef,
        rightElementRef: searchAndProfileRef,
        initialMaxItems: productPageNavLinks.length,
        buffer: $5bff6fd87ccf62f9$var$getBuffer(isTemplatesTabInHeader)
    }); // Focus the search button when the search bar is closed
    (0, $iSvIT.useEffect)(()=>{
        if (hasMounted.current) {
            const searchButton = document.getElementById("global-nav-search-bar-icon-desktop");
            if (searchButton) searchButton.focus();
        } else hasMounted.current = true;
    }, [
        isOpenSearch
    ]);
    const wacAISearchSummaryExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).wacAISearchSummary);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment && wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1h6o _4t3i1osq _bozg7r4f _y4ti1wqb _1nnkx0bf _wborftgi _uuzvx0bf _ib4didpf"
        ]),
        style: {
            "--_e2gyky": (0, $43MIc.default)(isTemplatesTabInHeader ? "18px" : "24px")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1bah1h6o _4cvr1h6o _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _b8yqtfvk",
                isTemplatesTabInHeader && "_b8yq3v0s",
                "productpage-subnav-bar"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug",
                        "productpage-subnav-logo-and-links-container"
                    ]),
                    style: {
                        alignItems: isOpenSearch ? "center" : "flex-end",
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9xKd9.SkipToContent), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1q511l7b _1e0c1txw _1bah1h6o _4cvr1h6o",
                                "productpage-subnav-product-logo"
                            ]),
                            style: {
                                alignSelf: "center",
                                paddingInlineEnd: "var(--ds-space-200, 16px)"
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1bah1h6o _4cvrh9n0 _4t3i1ou6 _1xjx1ou6",
                                    isTemplatesTabInHeader && "_17521tcg",
                                    "navigation-bar-logo-link"
                                ]),
                                href: productLogoUrl,
                                "aria-label": productLogoAriaLabel,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "productPageNav",
                                "data-product-key": productKey !== null && productKey !== void 0 ? productKey : "jira",
                                children: productLogo
                            })
                        }),
                        isOpenSearch ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4sElO.default), {
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            parentType: "ProductNav",
                            aiEnabled: isAISearchSummaryEnabled,
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _b8yqtfvk"
                            ])
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.default), {
                            globalLinksProps: productPageNavLinks,
                            globalLinksRef: linksRef,
                            showMore: shouldShowMoreItems,
                            setShowMore: showMoreItems,
                            maxLinks: maxItems
                        })
                    ]
                }),
                !isOpenSearch && isShowSearchBarAndProfileContainer && !shouldShowMoreItems && /*#__PURE__*/ (0, $loA2J.jsx)((0, $83L5e.default), {
                    isShowTryNowLink: isShowTryNowLink,
                    ctaButtonColor: tryNowCTAButtonBackgroundColor,
                    productKey: productKey,
                    isShowSearchButton: isShowSearchButton,
                    setIsOpenSearch: setIsOpenSearch,
                    navigationTrynowCtaText: navigationTrynowCtaText,
                    navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                    navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                    searchAndProfileRef: searchAndProfileRef,
                    positionTryNowCtaOnRight: positionTryNowCtaOnRight,
                    isShowAppSwitcher: isShowAppSwitcher,
                    navType: "productNav",
                    aiEnabled: isAISearchSummaryEnabled
                })
            ]
        })
    });
};
const $5bff6fd87ccf62f9$export$4f0322cadbe6a886 = ({ productLogo: productLogo, productLogoUrl: productLogoUrl, productLogoAriaLabel: productLogoAriaLabel, productKey: productKey, productPageNavLinks: productPageNavLinks, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = true, tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor, isShowSearchButton: isShowSearchButton = true, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl = "/try", navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, mobileLogo: mobileLogo, mobileLinksSections: mobileLinksSections, isIncludeMobileCTA: isIncludeMobileCTA = true, mobileCtaText: mobileCtaText, mobileCtaUrl: mobileCtaUrl = "/software/jira/free", mobileCtaOnClick: mobileCtaOnClick, isIncludeMobileAtlassianLogo: isIncludeMobileAtlassianLogo = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, isShowTabletDropdown: isShowTabletDropdown = true, isTemplatesTabInHeader: isTemplatesTabInHeader })=>{
    const intl = (0, $f6qj2.default)();
    const [isOpenSearch, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const defaultCtaText = intl.formatMessage({
        id: "productpagesubnav.try-now-button-label",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
        globalNavItemKeys: productPageNavLinks.map((link)=>link.globalLinksKey),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("header", {
            className: (0, $esG4f.default)([
                "_1e0c1ule _kqsw1if8 _152tidpf _1pbyqfx8 _1pvkglyw _qcqz1ule",
                "product-page-nav-container"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1y6m _kqswh2mm _4cvr1h6o _bfhkcd5j _16jlkb7n _1o9zkb7n _i0dlf1ug _1pbyqfx8 _1bsb1osq _4t3i88uy",
                        "product-page-desktop-nav"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3i88uy _1bsb88uy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkjk2v"
                            ]),
                            style: {
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: (0, $3FBn4.useLocalizedHref)("/"),
                                "aria-label": intl.formatMessage({
                                    id: "productPageNav.logo-label",
                                    defaultMessage: "Atlassian logo"
                                }),
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "productPageSubNav",
                                "data-product-key": "home",
                                className: (0, $esG4f.default)([
                                    "_4t3i8vuz _1bsb8vuz _1e0c1txw _1bah1h6o _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $htmh8.AtlassianIcon), {
                                    size: "medium",
                                    appearance: "inverse"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5bff6fd87ccf62f9$var$ProductPageSubNavLinks, {
                            productLogo: productLogo,
                            productLogoUrl: productLogoUrl,
                            productLogoAriaLabel: productLogoAriaLabel,
                            productKey: productKey,
                            productPageNavLinks: productPageNavLinks,
                            isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer,
                            isShowTryNowLink: isShowTryNowLink,
                            tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor,
                            isShowSearchButton: isShowSearchButton,
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            navigationTrynowCtaText: navigationTrynowCtaText !== null && navigationTrynowCtaText !== void 0 ? navigationTrynowCtaText : defaultCtaText,
                            navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                            navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                            positionTryNowCtaOnRight: positionTryNowCtaOnRight,
                            isShowAppSwitcher: isShowAppSwitcher,
                            isTemplatesTabInHeader: isTemplatesTabInHeader
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0cglyw",
                        "product-page-mobile-nav"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBJCa.MobileProductPageNav), {
                        productKey: productKey,
                        mobileLogo: mobileLogo,
                        mobileLogoAriaLabel: productLogoAriaLabel,
                        mobileLogoHref: productLogoUrl,
                        mobileLogoDataEventContainer: "productPageNavLogo",
                        mobileLinksSections: mobileLinksSections,
                        isIncludeCTA: isIncludeMobileCTA,
                        ctaText: mobileCtaText !== null && mobileCtaText !== void 0 ? mobileCtaText : defaultCtaText,
                        ctaUrl: mobileCtaUrl,
                        ctaOnClick: mobileCtaOnClick,
                        isIncludeAtlassianLogo: isIncludeMobileAtlassianLogo,
                        isShowTryNowLink: isShowTryNowLink,
                        additionalMenuPageObjectsArray: additionalMenuPageObjectsArray,
                        isShowSearchButton: isShowSearchButton,
                        isShowAppSwitcher: isShowAppSwitcher,
                        isShowTabletDropdown: isShowTabletDropdown,
                        navType: "productNav"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("iBJCa", function(module, exports) {

$parcel$export(module.exports, "MobileProductPageNav", function () { return $ed14bf6a39a2994a$export$50f88648a05b2bef; });
/* mobile-product-page-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $d0cJX = parcelRequire("d0cJX");

var $cdfGl = parcelRequire("cdfGl");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $cLl4w = parcelRequire("cLl4w");

var $aoDWS = parcelRequire("aoDWS");

var $4What = parcelRequire("4What");

var $kQQu6 = parcelRequire("kQQu6");

var $4w2cS = parcelRequire("4w2cS");

var $lzGov = parcelRequire("lzGov");

var $9tPDi = parcelRequire("9tPDi");
const $ed14bf6a39a2994a$var$containerCss = null;
const $ed14bf6a39a2994a$var$shownInnerMobileDropdownMenuStyle = null;
const $ed14bf6a39a2994a$var$hiddenInnerMobileDropdownMenuStyle = null;
const $ed14bf6a39a2994a$var$containerClosedCss = null;
const $ed14bf6a39a2994a$var$containerOpenCss = null;
const $ed14bf6a39a2994a$var$navBarClosedCss = null;
const $ed14bf6a39a2994a$var$navBarOpenCss = null;
const $ed14bf6a39a2994a$var$menuContentStyle = null;
const $ed14bf6a39a2994a$var$slideInLeft = null;
const $ed14bf6a39a2994a$var$slideInDown = null;
const $ed14bf6a39a2994a$var$slideInUp = null;
const $ed14bf6a39a2994a$var$slideInLeftCss = null;
const $ed14bf6a39a2994a$var$slideInUpCss = null;
const $ed14bf6a39a2994a$var$slideInDownCss = null;
const $ed14bf6a39a2994a$var$MobileNavProductPageDropdownMenu = ({ isUserLoggedIn: isUserLoggedIn, menuPage: menuPage = "default", firstOpen: firstOpen, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLinksSections: mobileLinksSections, productKey: productKey, isIncludeCTA: isIncludeCTA = true, ctaText: ctaText = "Get it free", ctaUrl: ctaUrl = "/software/jira/free", ctaOnClick: ctaOnClick, isIncludeAtlassianLogo: isIncludeAtlassianLogo = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], isShowSearchButton: isShowSearchButton = true })=>{
    const MobileNavLinksMenuPage = /*#__PURE__*/ (0, $loA2J.jsx)((0, $kQQu6.MobileNavLinks), {
        isLoggedIn: isUserLoggedIn,
        handleMenuPage: handleMenuPage,
        mobileLinksSections: mobileLinksSections,
        productKey: productKey,
        isIncludeCTA: isIncludeCTA,
        ctaText: ctaText,
        ctaUrl: ctaUrl,
        ctaOnClick: ctaOnClick,
        isIncludeAtlassianLogo: isIncludeAtlassianLogo,
        isShowSearchButton: isShowSearchButton
    });
    const menuPages = [
        {
            pageKey: "default",
            content: MobileNavLinksMenuPage
        }
    ];
    const intl = (0, $f6qj2.default)();
    const isNavigatingBackRef = (0, $iSvIT.useRef)(false);
    if (additionalMenuPageObjectsArray.length > 0) for (const additionalMenuPageObject of additionalMenuPageObjectsArray){
        const { menuPageKey: menuPageKey, menuPageObjects: menuPageObjects } = additionalMenuPageObject;
        menuPages.push({
            pageKey: menuPageKey,
            content: menuPageObjects
        });
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            menuPage === "default" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    isNavigatingBackRef.current && "",
                    isNavigatingBackRef.current && "_tzy4idpf _y44v1bo6"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1bsb1osq _bozg7vkz _y4ti7vkz _1q511tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cLl4w.default), {
                        isMobileView: true,
                        readOnly: true,
                        parentType: "ProductNav",
                        menuPage: menuPage,
                        onFocus: ()=>{
                            if (!isNavigatingBackRef.current) handleMenuPage("search");
                            createAnalyticsEvent({
                                eventName: "searchOpen",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "searchButtonMobileV2",
                                source: "productNav",
                                attributes: {
                                    product: "marketing",
                                    pageUrl: window.location.href,
                                    pagePath: window.location.pathname
                                }
                            }).fire();
                        }
                    }, "default-search-bar")
                })
            }),
            menuPages.map(({ pageKey: pageKey, content: content }, index)=>{
                const isDefault = menuPage === "default";
                const isVisible = menuPage === pageKey;
                return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                isDefault && !firstOpen && "",
                                isDefault && !firstOpen && "_tzy4idpf _y44v1bo6",
                                !isDefault && "",
                                !isDefault && "_tzy4idpf _y44vm8zv",
                                isVisible ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                                "inner-mobile-dropdown-menu"
                            ]),
                            children: content
                        }, pageKey),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9tPDi.MobileProductPageNavDropdowns), {
                            productKey: productKey,
                            menuPage: menuPage
                        })
                    ]
                }, index);
            }),
            menuPage === "search" && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "searchinnermenu inner-mobile-dropdown-menu"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        style: {
                            all: "unset",
                            width: "fit-content"
                        },
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            isNavigatingBackRef.current = true;
                            handleFirstOpen(false);
                            handleMenuPage("default"); // reset the flag after navigation
                            setTimeout(()=>{
                                isNavigatingBackRef.current = false;
                            }, 100);
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_tzy4idpf _y44vm8zv",
                                "_syazaqb7 _1e0c1txw _4cvr1h6o _1q511tcg"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1mou1pzu"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                        label: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    children: intl.formatMessage({
                                        id: "globalnavv2.menu-back",
                                        defaultMessage: "Back"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_tzy4idpf _y44v1e70",
                            "_1bsb1osq _kqswh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cLl4w.default), {
                            isMobileView: true,
                            parentType: "ProductNav",
                            menuPage: menuPage
                        })
                    })
                ]
            })
        ]
    });
};
const $ed14bf6a39a2994a$var$defaultJiraLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
    brand: "jira",
    type: "logo",
    appearance: "brand",
    height: "25.6px",
    width: "60px"
}); // eslint-disable-next-line complexity
const $ed14bf6a39a2994a$export$50f88648a05b2bef = ({ productKey: productKey, mobileLogo: mobileLogo = $ed14bf6a39a2994a$var$defaultJiraLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = "Jira logo", mobileLogoHref: mobileLogoHref = "/", mobileLogoDataEventContainer: mobileLogoDataEventContainer = "ProductPageNavJiraV2", mobileLinksSections: mobileLinksSections, isIncludeCTA: isIncludeCTA = true, ctaText: ctaText = "Get it free", ctaUrl: ctaUrl = "/software/jira/free", ctaOnClick: ctaOnClick, isIncludeAtlassianLogo: isIncludeAtlassianLogo = true, isShowTryNowLink: isShowTryNowLink = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], isShowSearchButton: isShowSearchButton = true, isShowAppSwitcher: isShowAppSwitcher = true, isShowTabletDropdown: isShowTabletDropdown = true, navType: navType = "productNav" })=>{
    const [isOpenSearch, setIsOpenSearch] = (0, $iSvIT.useState)(false);
    const { userInfo: userInfo, showMenu: showMenu, isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage, handleClickAvatar: handleClickAvatar } = (0, $aoDWS.useMobileNavDisplay)(isOpenSearch);
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick } = (0, $cdfGl.useGlobalNavUserProfileClickActions)({
        email: userInfo.email
    });
    const mobileGlobalNavDropdownMenu = ()=>/*#__PURE__*/ (0, $loA2J.jsx)($ed14bf6a39a2994a$var$MobileNavProductPageDropdownMenu, {
            isUserLoggedIn: userInfo.isUserLoggedIn,
            menuPage: menuPage,
            firstOpen: firstOpen,
            handleMenuPage: handleMenuPage,
            handleFirstOpen: handleFirstOpen,
            mobileLinksSections: mobileLinksSections,
            productKey: productKey,
            isIncludeCTA: isIncludeCTA,
            ctaText: ctaText,
            ctaUrl: ctaUrl,
            ctaOnClick: ctaOnClick,
            isIncludeAtlassianLogo: isIncludeAtlassianLogo,
            additionalMenuPageObjectsArray: additionalMenuPageObjectsArray,
            isShowSearchButton: isShowSearchButton
        });
    var _userInfo_name, _userInfo_picture;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
        className: (0, $esG4f.default)([
            "_11q7cd5j _1e0c1txw _2lx21bp4 _zulputpp",
            showMenu ? "_tnru1kxc _1rfm1osq _1o831wug _98bk1wug _13zm1n9t _xaejidpf _1kmxftgi _1ggm1tcg _1ykz1tcg _1mae1tcg _2rfoqfx8 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    showMenu ? "_1wfqidpf _15vtpxbi _1e0c1txw _4cvr1h6o _1bah1yb4" : "_18zrpxbi _1wfqidpf _15vtpxbi _1e0c1txw _4cvr1h6o _1bah1yb4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lzGov.MobileNavTop), {
                    productKey: productKey,
                    isLoggedIn: userInfo.isUserLoggedIn,
                    userName: (_userInfo_name = userInfo.name) !== null && _userInfo_name !== void 0 ? _userInfo_name : "",
                    picture: (_userInfo_picture = userInfo.picture) !== null && _userInfo_picture !== void 0 ? _userInfo_picture : "",
                    handleClickAvatar: handleClickAvatar,
                    showMenu: showMenu,
                    handleToggleMenu: handleToggleMenu,
                    menuPage: menuPage,
                    handleMenuPage: handleMenuPage,
                    handleFirstOpen: handleFirstOpen,
                    mobileLogo: mobileLogo,
                    mobileLogoAriaLabel: mobileLogoAriaLabel,
                    mobileLogoHref: mobileLogoHref,
                    mobileLogoDataEventContainer: mobileLogoDataEventContainer,
                    isOpenSearch: isOpenSearch,
                    setIsOpenSearch: setIsOpenSearch,
                    tabletDropdownMenu: mobileGlobalNavDropdownMenu(),
                    isProductPage: true,
                    isShowTryNowLink: isShowTryNowLink,
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: ctaUrl,
                    navigationTrynowCtaOnClick: ctaOnClick,
                    isShowSearchButton: isShowSearchButton,
                    isShowAppSwitcher: isShowAppSwitcher,
                    isShowTabletDropdown: isShowTabletDropdown,
                    navType: navType
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $esG4f.default)([
                    "_1e0cglyw _1bsb1wug _181nglyw",
                    showMenu && "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {})
                    }),
                    isDisplayLoggedInUseDropdown ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4w2cS.default), {
                        userInfo: {
                            displayName: userInfo.name || "",
                            email: userInfo.email || "",
                            avatar: userInfo.picture || ""
                        },
                        onLogOutClick: onLogOutClick,
                        onManageLicensesClick: onManageLicensesClick,
                        onManageProfileClick: onManageProfileClick,
                        onSwitchAccountClick: onSwitchAccountClick
                    }) : mobileGlobalNavDropdownMenu()
                ]
            })
        ]
    });
};

});
parcelRegister("9tPDi", function(module, exports) {

$parcel$export(module.exports, "MobileProductPageNavDropdowns", function () { return $668a90db8de6b344$export$775cfc571e018bea; });
/* mobile-product-page-nav-dropdowns.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiQDa = parcelRequire("aiQDa");
const $668a90db8de6b344$var$slideInRight = null;
const $668a90db8de6b344$var$slideInRightCss = null;
const $668a90db8de6b344$var$shownInnerMobileDropdownMenuStyle = null;
const $668a90db8de6b344$var$hiddenInnerMobileDropdownMenuStyle = null;
const $668a90db8de6b344$export$998b37ddcfb0e866 = ({ menuPage: menuPage, productKey: productKey })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_tzy4idpf _y44vydmd",
            menuPage === "why-bitbucket" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
            "inner-mobile-dropdown-menu"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiQDa.MobileNavWhyBitbucket), {
            productKey: productKey
        })
    });
};
const $668a90db8de6b344$export$775cfc571e018bea = ({ productKey: productKey, menuPage: menuPage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: productKey === "bitbucket" && /*#__PURE__*/ (0, $loA2J.jsx)($668a90db8de6b344$export$998b37ddcfb0e866, {
            productKey: productKey,
            menuPage: menuPage
        })
    });
};

});
parcelRegister("aiQDa", function(module, exports) {

$parcel$export(module.exports, "MobileNavWhyBitbucket", function () { return $eb39b9b50ab853d7$export$6cee6a43a16688f9; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $fCtxL = parcelRequire("fCtxL");
const $eb39b9b50ab853d7$export$6cee6a43a16688f9 = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $f6qj2.default)();
    function useWhyBitbucketLinks() {
        return [
            {
                key: "features",
                name: intl.formatMessage((0, $6x1qA.defineMessage)({
                    id: "globalnavv2.subnav.whybitbucket.links.features",
                    defaultMessage: "Features"
                })),
                links: [
                    {
                        key: "ci-cd",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.ci-cd",
                            defaultMessage: "CI/CD"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/pipelines")
                    },
                    {
                        key: "cloud-security",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.it-service-management",
                            defaultMessage: "Cloud Security"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                    },
                    {
                        key: "dev-sec-ops",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.dev-sec-ops",
                            defaultMessage: "DevSecOps"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/devsecops")
                    },
                    {
                        key: "code-review",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.code-review",
                            defaultMessage: "Code Review"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/code-review")
                    },
                    {
                        key: "jira-integrations",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.jira-integrations",
                            defaultMessage: "Jira Integrations"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/jira/bitbucket-integration")
                    }
                ]
            },
            {
                key: "Plans",
                name: intl.formatMessage((0, $6x1qA.defineMessage)({
                    id: "globalnavv2.subnav.whybitbucket.links.plans",
                    defaultMessage: "Plans"
                })),
                links: [
                    {
                        key: "bitbucket-cloud-premium",
                        text: intl.formatMessage((0, $6x1qA.defineMessage)({
                            id: "globalnavv2.subnav.whybitbucket.links.bitbucket-cloud-premium",
                            defaultMessage: "Bitbucket Cloud Premium"
                        })),
                        href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/premium")
                    }
                ]
            }
        ];
    }
    const whyBitbucketLinks = useWhyBitbucketLinks();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fCtxL.MobileNavMenuPage), {
        pageLabel: intl.formatMessage({
            id: "globalnav.v2.whybitbucket.title",
            defaultMessage: "Why Bitbucket"
        }),
        cards: [],
        linksSections: whyBitbucketLinks,
        productKey: productKey
    });
};

});
parcelRegister("fCtxL", function(module, exports) {

$parcel$export(module.exports, "MobileNavMenuPage", function () { return $07dbc48f511c0d09$export$eb971653a31a8e4d; });
/* mobile-nav-menu-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");

var $i11Zl = parcelRequire("i11Zl");
parcelRequire("iAJua");
var $kxbRO = parcelRequire("kxbRO");

var $4wGZc = parcelRequire("4wGZc");

var $4What = parcelRequire("4What");

var $QFBkP = parcelRequire("QFBkP");
const $07dbc48f511c0d09$var$topLinksContainerCss = null;
const $07dbc48f511c0d09$var$labelCss = null;
const $07dbc48f511c0d09$var$pageLabelCss = null;
const $07dbc48f511c0d09$var$sectionLabelCss = null;
const $07dbc48f511c0d09$var$bottomContainerCss = null;
const $07dbc48f511c0d09$var$linkContainerCss = null;
const $07dbc48f511c0d09$var$SubnavLink = ({ href: href, text: text, productKey: productKey = "home" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1rjcpxbi _ect48q0o _1wybdlk8 _k48p1fw0 _vwz41343"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            type: "anchor",
            href: href,
            text: text,
            ariaLabel: text,
            dataEventProps: {
                "data-product-key": productKey,
                "data-event-component": "linkButton",
                "data-event-container": "globalNavWacDropdownContainer",
                "data-event": "clicked"
            }
        })
    });
};
const $07dbc48f511c0d09$export$eb971653a31a8e4d = ({ pageLabel: pageLabel, cards: cards, linksSections: linksSections, productKey: productKey = "home" })=>{
    const { shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations, mobileNavPageLabelFeaturedProducts: mobileNavPageLabelFeaturedProducts, fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView } = (0, $iSvIT.useContext)((0, $4wGZc.NavProductRecommendationsContext));
    const containerRef = (0, $iSvIT.useRef)(null); // Observe the container to fire the event screen when it's in view
    (0, $iSvIT.useLayoutEffect)(()=>{
        // Check if IntersectionObserver is supported
        if (typeof IntersectionObserver === "undefined") return;
        if (pageLabel !== mobileNavPageLabelFeaturedProducts) return;
        const currentContainer = containerRef.current; // Check if container is currently in view
        const observer = new IntersectionObserver(([entry])=>{
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) fireGlobalNavProductRecoEventsWhenInView({
                isMobile: true
            });
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        });
        if (currentContainer) observer.observe(currentContainer);
        return ()=>{
            if (currentContainer) observer.unobserve(currentContainer);
        };
    }, [
        fireGlobalNavProductRecoEventsWhenInView,
        mobileNavPageLabelFeaturedProducts,
        pageLabel
    ]);
    const gwp7850GlobalNavChangesForTeam25Eu = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: containerRef,
                className: (0, $esG4f.default)([
                    "_85i51tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _1p1dangw _ect48q0o _1wybw1gv",
                            "_1rjcutpp _vwz41dkv"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: pageLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: pageLabel === mobileNavPageLabelFeaturedProducts && shouldShowGlobalNavProductRecommendations ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $kxbRO.GlobalNavProductRecommendations), {
                            isMobile: true
                        }) : cards.map((_param)=>/*#__PURE__*/ {
                            var { key: key } = _param, rest = (0, $akGnX._)(_param, [
                                "key"
                            ]);
                            return (0, $loA2J.jsx)((0, $QFBkP.MobileNavCard), (0, $7Knp0._)({
                                productKey: productKey
                            }, rest), key);
                        })
                    }),
                    gwp7850GlobalNavChangesForTeam25Eu && /*#__PURE__*/ (0, $loA2J.jsx)((0, $i11Zl.RovoSection), {})
                ]
            }),
            linksSections && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_bfhk150w _18s8xi3e _1yt41hnh"
                ]),
                style: {
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                },
                children: linksSections === null || linksSections === void 0 ? void 0 : linksSections.map(({ key: key, name: name, links: links }, numSection)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            numSection !== 0 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_syaz1hlo _1p1dangw _ect48q0o _1wybw1gv",
                                    "_1rjc1kz8 _vwz419xd _k48pbfng"
                                ]),
                                style: {
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    children: name
                                })
                            }),
                            links.map((_param)=>/*#__PURE__*/ {
                                var { key: key } = _param, rest = (0, $akGnX._)(_param, [
                                    "key"
                                ]);
                                return (0, $loA2J.jsx)($07dbc48f511c0d09$var$SubnavLink, (0, $7Knp0._)({
                                    productKey: productKey
                                }, rest), key);
                            })
                        ]
                    }, `section-${key}`))
            })
        ]
    });
};

});







//# sourceMappingURL=404.5b92fa53.js.map
